"use client";
var Hx = Object.defineProperty;
var Ux = (e, t, n) => t in e ? Hx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ee = (e, t, n) => Ux(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as h, jsxs as L, Fragment as ke } from "react/jsx-runtime";
import * as p from "react";
import G, { useState as he, createContext as je, useContext as Se, useLayoutEffect as hr, useRef as ae, useEffect as me, useCallback as Ie, useMemo as ve, useId as Yx, Fragment as $s, createElement as Fe, useInsertionEffect as ap, forwardRef as Ke, Component as Gx, Children as Zn, isValidElement as ss, cloneElement as Gc, useReducer as Kx } from "react";
import { Loader2 as Xx, X as Kc, Loader2Icon as lp, ChevronDown as cp, ChevronUp as qx, CircleMinusIcon as Zx, CirclePlusIcon as Qx, MinusIcon as Jx, Check as Xc, SearchCheckIcon as eC, SearchIcon as Dl, ArrowUpDown as tC, ArrowDown as nC, ArrowUp as rC, TriangleAlertIcon as oC, EyeOffIcon as iC, MoveRightIcon as sC, MoveLeftIcon as aC, DotIcon as Jd, MoveUpIcon as lC, MoveDownIcon as cC, LockIcon as uC, LockOpenIcon as dC, ChevronRightIcon as jr, FilterIcon as fC, GripVertical as hC, FileUpIcon as mC, ChevronRight as pC, ChevronLeft as gC, Calendar as qc, CalendarIcon as vC, Search as yC, ChevronLeftIcon as Fo } from "lucide-react";
import * as ti from "react-dom";
import up, { flushSync as Zc } from "react-dom";
import { escape as Fr, op as as, from as dp } from "arquero";
const bC = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: t,
  minimumFractionDigits: t
}).format(e), wC = [
  // Percentage mask x 100
  {
    mask: /100#\.[#0]+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e, e *= 100;
      const n = t.match(/100#\.([#0]+)%$/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Percentage mask
  {
    mask: /#\.[#0]+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/#\.([#0]+)%/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Dollar mask
  {
    mask: /\$#(\.[#0]*)?$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/\$#(\.([#0]*))?$/)[2], r = n ? n.length : 0;
      return bC(e, r);
    }
  },
  // Millions mask,
  {
    mask: /#\.[#0]+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.match(/#\.([#0]+)M$/)[1], r = n.length;
        e = Number(e);
        let o = (e / 1e6).toFixed(r);
        if (!n.includes("0")) {
          const i = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
          o = o.replace(i, ""), o.includes(".") || (o = o.concat(".0"));
        }
        return o.concat(" M");
      }
      return "";
    }
  },
  // TODO: Validate this
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e12).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" T");
      }
      return "";
    }
  },
  // Thousands mask,
  {
    mask: /#\.[#0]+K$/,
    apply: (e, t) => {
      if (e) {
        const n = t.match(/#\.([#0]+)K$/)[1], r = n.length;
        e = Number(e);
        let o = (e / 1e3).toFixed(r);
        if (!n.includes("0")) {
          const i = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
          o = o.replace(i, ""), o.includes(".") || (o = o.concat(".0"));
        }
        return o.concat(" K");
      }
      return "";
    }
  },
  // Standard format: full number with commas as thousands separators
  {
    mask: /^#\.[#0]+$/,
    apply: (e, t) => {
      if (e !== "" && e !== null && e !== void 0) {
        e = Number(e);
        const n = t.split("."), r = n && n[1] ? n[1].length : 0;
        return new Intl.NumberFormat("en-US", {
          maximumFractionDigits: r,
          minimumFractionDigits: r
        }).format(e);
      }
      return "";
    }
  },
  {
    mask: ["#"],
    apply: (e) => e !== "" && e !== null && e !== void 0 ? (e = Number(e), new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(e)) : ""
  },
  {
    mask: ["#th"],
    // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    apply: (e, t) => {
      e = Number(e);
      const n = e % 10, r = e % 100;
      return n === 1 && r !== 11 ? e + "st" : n === 2 && r !== 12 ? e + "nd" : n === 3 && r !== 13 ? e + "rd" : e + "th";
    }
  }
];
function Rl(e, t) {
  const n = wC.find(
    (r) => Array.isArray(r.mask) && r.mask.includes(t) || !Array.isArray(r.mask) && t.match(r.mask)
  );
  return n ? n.apply(e, t) : "Invalid Mask";
}
const nW = (e) => e >= 1e6 ? `${(e / 1e6).toFixed(0)}M` : e >= 1e3 ? `${(e / 1e3).toFixed(0)}k` : e.toString(), xC = (e, t = 0) => {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
};
function fp(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = fp(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ze() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = fp(e)) && (r && (r += " "), r += t);
  return r;
}
const Qc = "-", CC = (e) => {
  const t = TC(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(Qc);
      return a[0] === "" && a.length !== 1 && a.shift(), hp(a, t) || SC(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const l = n[s] || [];
      return a && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, hp = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? hp(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Qc);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}, ef = /^\[(.+)\]$/, SC = (e) => {
  if (ef.test(e)) {
    const t = ef.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, TC = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return PC(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    Ml(s, r, i, t);
  }), r;
}, Ml = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : tf(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (EC(o)) {
        Ml(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      Ml(s, tf(t, i), n, r);
    });
  });
}, tf = (e, t) => {
  let n = e;
  return t.split(Qc).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, EC = (e) => e.isThemeGetter, PC = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
  return [n, o];
}) : e, kC = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, mp = "!", DC = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, s = (a) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let y = 0; y < a.length; y++) {
      let b = a[y];
      if (c === 0) {
        if (b === o && (r || a.slice(y, y + i) === t)) {
          l.push(a.slice(u, y)), u = y + i;
          continue;
        }
        if (b === "/") {
          d = y;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const f = l.length === 0 ? a : a.substring(u), m = f.startsWith(mp), v = m ? f.substring(1) : f, g = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: v,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, RC = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, MC = (e) => ({
  cache: kC(e.cacheSize),
  parseClassName: DC(e),
  ...CC(e)
}), NC = /\s+/, AC = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(NC);
  let a = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const c = s[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: m
    } = n(c);
    let v = !!m, g = r(v ? f.substring(0, m) : f);
    if (!g) {
      if (!v) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (g = r(f), !g) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      v = !1;
    }
    const y = RC(u).join(":"), b = d ? y + mp : y, x = b + g;
    if (i.includes(x))
      continue;
    i.push(x);
    const w = o(g, v);
    for (let C = 0; C < w.length; ++C) {
      const E = w[C];
      i.push(b + E);
    }
    a = c + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function _C() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = pp(t)) && (r && (r += " "), r += n);
  return r;
}
const pp = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = pp(e[r])) && (n && (n += " "), n += t);
  return n;
};
function OC(e, ...t) {
  let n, r, o, i = s;
  function s(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = MC(c), r = n.cache.get, o = n.cache.set, i = a, a(l);
  }
  function a(l) {
    const c = r(l);
    if (c)
      return c;
    const u = AC(l, n);
    return o(l, u), u;
  }
  return function() {
    return i(_C.apply(null, arguments));
  };
}
const Be = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, gp = /^\[(?:([a-z-]+):)?(.+)\]$/i, IC = /^\d+\/\d+$/, LC = /* @__PURE__ */ new Set(["px", "full", "screen"]), $C = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, FC = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, VC = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, BC = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, WC = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, gn = (e) => Vr(e) || LC.has(e) || IC.test(e), En = (e) => eo(e, "length", XC), Vr = (e) => !!e && !Number.isNaN(Number(e)), ka = (e) => eo(e, "number", Vr), ho = (e) => !!e && Number.isInteger(Number(e)), zC = (e) => e.endsWith("%") && Vr(e.slice(0, -1)), ge = (e) => gp.test(e), Pn = (e) => $C.test(e), jC = /* @__PURE__ */ new Set(["length", "size", "percentage"]), HC = (e) => eo(e, jC, vp), UC = (e) => eo(e, "position", vp), YC = /* @__PURE__ */ new Set(["image", "url"]), GC = (e) => eo(e, YC, ZC), KC = (e) => eo(e, "", qC), mo = () => !0, eo = (e, t, n) => {
  const r = gp.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, XC = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  FC.test(e) && !VC.test(e)
), vp = () => !1, qC = (e) => BC.test(e), ZC = (e) => WC.test(e), QC = () => {
  const e = Be("colors"), t = Be("spacing"), n = Be("blur"), r = Be("brightness"), o = Be("borderColor"), i = Be("borderRadius"), s = Be("borderSpacing"), a = Be("borderWidth"), l = Be("contrast"), c = Be("grayscale"), u = Be("hueRotate"), d = Be("invert"), f = Be("gap"), m = Be("gradientColorStops"), v = Be("gradientColorStopPositions"), g = Be("inset"), y = Be("margin"), b = Be("opacity"), x = Be("padding"), w = Be("saturate"), C = Be("scale"), E = Be("sepia"), S = Be("skew"), T = Be("space"), P = Be("translate"), D = () => ["auto", "contain", "none"], k = () => ["auto", "hidden", "clip", "visible", "scroll"], R = () => ["auto", ge, t], A = () => [ge, t], F = () => ["", gn, En], I = () => ["auto", Vr, ge], B = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], V = () => ["solid", "dashed", "dotted", "double", "none"], N = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], M = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], _ = () => ["", "0", ge], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], te = () => [Vr, ge];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [mo],
      spacing: [gn, En],
      blur: ["none", "", Pn, ge],
      brightness: te(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Pn, ge],
      borderSpacing: A(),
      borderWidth: F(),
      contrast: te(),
      grayscale: _(),
      hueRotate: te(),
      invert: _(),
      gap: A(),
      gradientColorStops: [e],
      gradientColorStopPositions: [zC, En],
      inset: R(),
      margin: R(),
      opacity: te(),
      padding: A(),
      saturate: te(),
      scale: te(),
      sepia: _(),
      skew: te(),
      space: A(),
      translate: A()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ge]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Pn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...B(), ge]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ho, ge]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: R()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ge]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: _()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: _()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ho, ge]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [mo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ho, ge]
        }, ge]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": I()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": I()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [mo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ho, ge]
        }, ge]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": I()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": I()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ge]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ge]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...M()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...M(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...M(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [T]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [T]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ge, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ge, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ge, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Pn]
        }, Pn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ge, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ge, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ge, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ge, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Pn, En]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ka]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [mo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ge]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Vr, ka]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", gn, ge]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ge]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ge]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...V(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", gn, En]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", gn, ge]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: A()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ge]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ge]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...B(), UC]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", HC]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, GC]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...V(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: V()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...V()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [gn, ge]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [gn, En]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: F()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [gn, En]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Pn, KC]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [mo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...N(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": N()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Pn, ge]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [E]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [E]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ge]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: te()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ge]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: te()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ge]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ho, ge]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ge]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ge]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": A()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": A()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": A()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": A()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": A()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": A()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": A()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": A()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": A()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": A()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": A()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": A()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": A()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": A()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": A()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": A()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": A()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": A()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ge]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [gn, En, ka]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, JC = /* @__PURE__ */ OC(QC);
function X(...e) {
  return JC(ze(e));
}
function nf(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function eS(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = nf(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : nf(e[o], null);
        }
      };
  };
}
var tS = Symbol.for("react.lazy"), ls = p[" use ".trim().toString()];
function nS(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function yp(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === tS && "_payload" in e && nS(e._payload);
}
// @__NO_SIDE_EFFECTS__
function rS(e) {
  const t = /* @__PURE__ */ iS(e), n = p.forwardRef((r, o) => {
    let { children: i, ...s } = r;
    yp(i) && typeof ls == "function" && (i = ls(i._payload));
    const a = p.Children.toArray(i), l = a.find(aS);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? p.Children.count(c) > 1 ? p.Children.only(null) : p.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ h(t, { ...s, ref: o, children: p.isValidElement(c) ? p.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var oS = /* @__PURE__ */ rS("Slot");
// @__NO_SIDE_EFFECTS__
function iS(e) {
  const t = p.forwardRef((n, r) => {
    let { children: o, ...i } = n;
    if (yp(o) && typeof ls == "function" && (o = ls(o._payload)), p.isValidElement(o)) {
      const s = cS(o), a = lS(i, o.props);
      return o.type !== p.Fragment && (a.ref = r ? eS(r, s) : s), p.cloneElement(o, a);
    }
    return p.Children.count(o) > 1 ? p.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var sS = Symbol("radix.slottable");
function aS(e) {
  return p.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === sS;
}
function lS(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const l = i(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function cS(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const rf = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, of = ze, mr = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return of(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null) return null;
    const f = rf(u) || rf(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...m } = u;
    return Object.entries(m).every((v) => {
      let [g, y] = v;
      return Array.isArray(y) ? y.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === y;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return of(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Nl = mr(
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm text-bold ring-offset-background transition-colors h-fit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-100",
  {
    variants: {
      variant: {
        default: "border border-button-primary-bg text-button-primary-txt bg-button-primary-bg hover:bg-button-primary-hover hover:border-button-primary-hover active:bg-button-primary-active active:border-button-primary-active disabled:bg-button-primary-disabled disabled:border-button-primary-disabled disabled:text-button-primary-disabled-txt",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        danger: "bg-red-500 text-button-primary-txt hover:bg-red-600",
        warning: "bg-yellow-500 text-button-primary-txt hover:bg-yellow-600",
        outline: "border border-button-primary-outline-default text-button-primary-outline-default bg-button-primary-outline-bg hover:border-button-primary-outline-hover hover:text-button-primary-outline-hover active:border-button-primary-outline-active active:text-button-primary-outline-active disabled:border-button-primary-outline-disabled disabled:text-button-primary-outline-disabled",
        minimal: "border border-transparent text-button-primary-outline-default bg-transparent hover:text-button-primary-outline-hover active:text-button-primary-outline-active disabled:text-button-primary-outline-disabled",
        secondary: "border border-button-secondary-bg text-button-secondary-txt bg-button-secondary-bg hover:bg-button-secondary-hover hover:border-button-secondary-hover active:bg-button-secondary-active active:border-button-secondary-active disabled:bg-button-secondary-disabled disabled:border-button-secondary-disabled disabled:text-button-secondary-disabled-txt",
        secondaryOutline: "border border-button-secondary-outline-default text-button-secondary-outline-default bg-button-secondary-outline-bg hover:border-button-secondary-outline-hover hover:text-button-secondary-outline-hover active:border-button-secondary-outline-active active:text-button-secondary-outline-active disabled:border-button-secondary-outline-disabled disabled:text-button-secondary-outline-disabled",
        secondaryMinimal: "border border-transparent text-button-secondary-outline-default bg-transparent hover:text-button-secondary-outline-hover active:text-button-secondary-outline-active disabled:text-button-secondary-outline-disabled",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        // link: 'text-primary underline-offset-4 hover:underline',
        link: "text-primary"
      },
      size: {
        default: "control rounded-md",
        // xxs: 'control-xxs',
        xs: "control-xs",
        sm: "control-sm",
        md: "control-md rounded-lg",
        lg: "control-lg rounded-lg"
        // icon: 'h-10 w-10',
        // input: 'min-h-10 px-3 py-2',
        // 'icon-sm': 'h-6 w-6 p-1',
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ee = p.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, children: o, loading: i, ...s }, a) => {
    const l = r ? oS : "button";
    return s.type = s.type || "button", /* @__PURE__ */ L(l, { className: X("relative", Nl({ variant: t, size: n, className: e })), ref: a, ...s, children: [
      i && /* @__PURE__ */ h(
        "div",
        {
          className: X(
            "absolute top-0 bottom-0 left-0 right-0 flex justify-center",
            "items-center bg-button-primary-disabled/50 rounded-md"
          ),
          children: /* @__PURE__ */ h(Xx, { className: "animate-spin size-6" })
        }
      ),
      o
    ] });
  }
);
Ee.displayName = "Button";
const rW = () => /* @__PURE__ */ h(Ee, { children: "Btn!" });
function j(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function sf(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ni(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = sf(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : sf(e[o], null);
        }
      };
  };
}
function ye(...e) {
  return p.useCallback(ni(...e), e);
}
function uS(e, t) {
  const n = p.createContext(t), r = (i) => {
    const { children: s, ...a } = i, l = p.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ h(n.Provider, { value: l, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = p.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Bt(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = p.createContext(s), l = n.length;
    n = [...n, s];
    const c = (d) => {
      var b;
      const { scope: f, children: m, ...v } = d, g = ((b = f == null ? void 0 : f[e]) == null ? void 0 : b[l]) || a, y = p.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ h(g.Provider, { value: y, children: m });
    };
    c.displayName = i + "Provider";
    function u(d, f) {
      var g;
      const m = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[l]) || a, v = p.useContext(m);
      if (v) return v;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((s) => p.createContext(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = e, [r, dS(o, ...t)];
}
function dS(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var it = globalThis != null && globalThis.document ? p.useLayoutEffect : () => {
}, fS = p[" useId ".trim().toString()] || (() => {
}), hS = 0;
function bn(e) {
  const [t, n] = p.useState(fS());
  return it(() => {
    n((r) => r ?? String(hS++));
  }, [e]), t ? `radix-${t}` : "";
}
var mS = p[" useInsertionEffect ".trim().toString()] || it;
function _n({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, s] = pS({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, l = a ? e : o;
  {
    const u = p.useRef(e !== void 0);
    p.useEffect(() => {
      const d = u.current;
      d !== a && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, r]);
  }
  const c = p.useCallback(
    (u) => {
      var d;
      if (a) {
        const f = gS(u) ? u(e) : u;
        f !== e && ((d = s.current) == null || d.call(s, f));
      } else
        i(u);
    },
    [a, e, i, s]
  );
  return [l, c];
}
function pS({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = p.useState(e), o = p.useRef(n), i = p.useRef(t);
  return mS(() => {
    i.current = t;
  }, [t]), p.useEffect(() => {
    var s;
    o.current !== n && ((s = i.current) == null || s.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function gS(e) {
  return typeof e == "function";
}
// @__NO_SIDE_EFFECTS__
function er(e) {
  const t = /* @__PURE__ */ vS(e), n = p.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = p.Children.toArray(i), l = a.find(bS);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? p.Children.count(c) > 1 ? p.Children.only(null) : p.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ h(t, { ...s, ref: o, children: p.isValidElement(c) ? p.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function vS(e) {
  const t = p.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (p.isValidElement(o)) {
      const s = xS(o), a = wS(i, o.props);
      return o.type !== p.Fragment && (a.ref = r ? ni(r, s) : s), p.cloneElement(o, a);
    }
    return p.Children.count(o) > 1 ? p.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var bp = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function yS(e) {
  const t = ({ children: n }) => /* @__PURE__ */ h(ke, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = bp, t;
}
function bS(e) {
  return p.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === bp;
}
function wS(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const l = i(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xS(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var CS = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], le = CS.reduce((e, t) => {
  const n = /* @__PURE__ */ er(`Primitive.${t}`), r = p.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Jc(e, t) {
  e && ti.flushSync(() => e.dispatchEvent(t));
}
function Qe(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function SS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e);
  p.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var TS = "DismissableLayer", Al = "dismissableLayer.update", ES = "dismissableLayer.pointerDownOutside", PS = "dismissableLayer.focusOutside", af, wp = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), pr = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...l
    } = e, c = p.useContext(wp), [u, d] = p.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = p.useState({}), v = ye(t, (T) => d(T)), g = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(y), x = u ? g.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= b, E = DS((T) => {
      const P = T.target, D = [...c.branches].some((k) => k.contains(P));
      !C || D || (o == null || o(T), s == null || s(T), T.defaultPrevented || a == null || a());
    }, f), S = RS((T) => {
      const P = T.target;
      [...c.branches].some((k) => k.contains(P)) || (i == null || i(T), s == null || s(T), T.defaultPrevented || a == null || a());
    }, f);
    return SS((T) => {
      x === c.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && a && (T.preventDefault(), a()));
    }, f), p.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (af = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), lf(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = af);
        };
    }, [u, f, n, c]), p.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), lf());
    }, [u, c]), p.useEffect(() => {
      const T = () => m({});
      return document.addEventListener(Al, T), () => document.removeEventListener(Al, T);
    }, []), /* @__PURE__ */ h(
      le.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: w ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: j(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: j(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: j(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
pr.displayName = TS;
var kS = "DismissableLayerBranch", xp = p.forwardRef((e, t) => {
  const n = p.useContext(wp), r = p.useRef(null), o = ye(t, r);
  return p.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ h(le.div, { ...e, ref: o });
});
xp.displayName = kS;
function DS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e), r = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          Cp(
            ES,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function RS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e), r = p.useRef(!1);
  return p.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Cp(PS, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function lf() {
  const e = new CustomEvent(Al);
  document.dispatchEvent(e);
}
function Cp(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Jc(o, i) : o.dispatchEvent(i);
}
var MS = pr, NS = xp, Da = "focusScope.autoFocusOnMount", Ra = "focusScope.autoFocusOnUnmount", cf = { bubbles: !1, cancelable: !0 }, AS = "FocusScope", ri = p.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, l] = p.useState(null), c = Qe(o), u = Qe(i), d = p.useRef(null), f = ye(t, (g) => l(g)), m = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (r) {
      let g = function(w) {
        if (m.paused || !a) return;
        const C = w.target;
        a.contains(C) ? d.current = C : Dn(d.current, { select: !0 });
      }, y = function(w) {
        if (m.paused || !a) return;
        const C = w.relatedTarget;
        C !== null && (a.contains(C) || Dn(d.current, { select: !0 }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const E of w)
            E.removedNodes.length > 0 && Dn(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const x = new MutationObserver(b);
      return a && x.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [r, a, m.paused]), p.useEffect(() => {
    if (a) {
      df.add(m);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(Da, cf);
        a.addEventListener(Da, c), a.dispatchEvent(b), b.defaultPrevented || (_S(FS(Sp(a)), { select: !0 }), document.activeElement === g && Dn(a));
      }
      return () => {
        a.removeEventListener(Da, c), setTimeout(() => {
          const b = new CustomEvent(Ra, cf);
          a.addEventListener(Ra, u), a.dispatchEvent(b), b.defaultPrevented || Dn(g ?? document.body, { select: !0 }), a.removeEventListener(Ra, u), df.remove(m);
        }, 0);
      };
    }
  }, [a, c, u, m]);
  const v = p.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (y && b) {
        const x = g.currentTarget, [w, C] = OS(x);
        w && C ? !g.shiftKey && b === C ? (g.preventDefault(), n && Dn(w, { select: !0 })) : g.shiftKey && b === w && (g.preventDefault(), n && Dn(C, { select: !0 })) : b === x && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ h(le.div, { tabIndex: -1, ...s, ref: f, onKeyDown: v });
});
ri.displayName = AS;
function _S(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Dn(r, { select: t }), document.activeElement !== n) return;
}
function OS(e) {
  const t = Sp(e), n = uf(t, e), r = uf(t.reverse(), e);
  return [n, r];
}
function Sp(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function uf(e, t) {
  for (const n of e)
    if (!IS(n, { upTo: t })) return n;
}
function IS(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function LS(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Dn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && LS(e) && t && e.select();
  }
}
var df = $S();
function $S() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ff(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ff(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function ff(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function FS(e) {
  return e.filter((t) => t.tagName !== "A");
}
var VS = "Portal", to = p.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = p.useState(!1);
  it(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? up.createPortal(/* @__PURE__ */ h(le.div, { ...r, ref: t }), s) : null;
});
to.displayName = VS;
function BS(e, t) {
  return p.useReducer((n, r) => t[n][r] ?? n, e);
}
var ft = (e) => {
  const { present: t, children: n } = e, r = WS(t), o = typeof n == "function" ? n({ present: r.isPresent }) : p.Children.only(n), i = ye(r.ref, zS(o));
  return typeof n == "function" || r.isPresent ? p.cloneElement(o, { ref: i }) : null;
};
ft.displayName = "Presence";
function WS(e) {
  const [t, n] = p.useState(), r = p.useRef(null), o = p.useRef(e), i = p.useRef("none"), s = e ? "mounted" : "unmounted", [a, l] = BS(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const c = Ri(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [a]), it(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = i.current, m = Ri(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), it(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (m) => {
        const g = Ri(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, f = (m) => {
        m.target === t && (i.current = Ri(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: p.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Ri(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function zS(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ma = 0;
function Fs() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? hf()), document.body.insertAdjacentElement("beforeend", e[1] ?? hf()), Ma++, () => {
      Ma === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ma--;
    };
  }, []);
}
function hf() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ht = function() {
  return ht = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ht.apply(this, arguments);
};
function eu(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Tp(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Do = "right-scroll-bar-position", Ro = "width-before-scroll-bar", jS = "with-scroll-bars-hidden", HS = "--removed-body-scroll-bar-size";
function Na(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function US(e, t) {
  var n = he(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var YS = typeof window < "u" ? p.useLayoutEffect : p.useEffect, mf = /* @__PURE__ */ new WeakMap();
function Ep(e, t) {
  var n = US(null, function(r) {
    return e.forEach(function(o) {
      return Na(o, r);
    });
  });
  return YS(function() {
    var r = mf.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || Na(a, null);
      }), i.forEach(function(a) {
        o.has(a) || Na(a, s);
      });
    }
    mf.set(n, e);
  }, [e]), n;
}
function GS(e) {
  return e;
}
function KS(e, t) {
  t === void 0 && (t = GS);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function Pp(e) {
  e === void 0 && (e = {});
  var t = KS(null);
  return t.options = ht({ async: !0, ssr: !1 }, e), t;
}
var kp = function(e) {
  var t = e.sideCar, n = eu(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return p.createElement(r, ht({}, n));
};
kp.isSideCarExport = !0;
function Dp(e, t) {
  return e.useMedium(t), kp;
}
var Rp = Pp(), Aa = function() {
}, Vs = p.forwardRef(function(e, t) {
  var n = p.useRef(null), r = p.useState({
    onScrollCapture: Aa,
    onWheelCapture: Aa,
    onTouchMoveCapture: Aa
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, m = e.noRelative, v = e.noIsolation, g = e.inert, y = e.allowPinchZoom, b = e.as, x = b === void 0 ? "div" : b, w = e.gapMode, C = eu(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = f, S = Ep([n, t]), T = ht(ht({}, C), o);
  return p.createElement(
    p.Fragment,
    null,
    u && p.createElement(E, { sideCar: Rp, removeScrollBar: c, shards: d, noRelative: m, noIsolation: v, inert: g, setCallbacks: i, allowPinchZoom: !!y, lockRef: n, gapMode: w }),
    s ? p.cloneElement(p.Children.only(a), ht(ht({}, T), { ref: S })) : p.createElement(x, ht({}, T, { className: l, ref: S }), a)
  );
});
Vs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Vs.classNames = {
  fullWidth: Ro,
  zeroRight: Do
};
var XS = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function qS() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = XS();
  return t && e.setAttribute("nonce", t), e;
}
function ZS(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function QS(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var JS = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = qS()) && (ZS(t, n), QS(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, eT = function() {
  var e = JS();
  return function(t, n) {
    p.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, tu = function() {
  var e = eT(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, tT = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _a = function(e) {
  return parseInt(e || "", 10) || 0;
}, nT = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_a(n), _a(r), _a(o)];
}, rT = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return tT;
  var t = nT(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, oT = tu(), Br = "data-scroll-locked", iT = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(jS, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(Br, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Do, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Ro, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Do, " .").concat(Do, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ro, " .").concat(Ro, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Br, `] {
    `).concat(HS, ": ").concat(a, `px;
  }
`);
}, pf = function() {
  var e = parseInt(document.body.getAttribute(Br) || "0", 10);
  return isFinite(e) ? e : 0;
}, sT = function() {
  p.useEffect(function() {
    return document.body.setAttribute(Br, (pf() + 1).toString()), function() {
      var e = pf() - 1;
      e <= 0 ? document.body.removeAttribute(Br) : document.body.setAttribute(Br, e.toString());
    };
  }, []);
}, Mp = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  sT();
  var i = p.useMemo(function() {
    return rT(o);
  }, [o]);
  return p.createElement(oT, { styles: iT(i, !t, o, n ? "" : "!important") });
}, _l = !1;
if (typeof window < "u")
  try {
    var Mi = Object.defineProperty({}, "passive", {
      get: function() {
        return _l = !0, !0;
      }
    });
    window.addEventListener("test", Mi, Mi), window.removeEventListener("test", Mi, Mi);
  } catch {
    _l = !1;
  }
var Sr = _l ? { passive: !1 } : !1, aT = function(e) {
  return e.tagName === "TEXTAREA";
}, Np = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !aT(e) && n[t] === "visible")
  );
}, lT = function(e) {
  return Np(e, "overflowY");
}, cT = function(e) {
  return Np(e, "overflowX");
}, gf = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Ap(e, r);
    if (o) {
      var i = _p(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, uT = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, dT = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Ap = function(e, t) {
  return e === "v" ? lT(t) : cT(t);
}, _p = function(e, t) {
  return e === "v" ? uT(t) : dT(t);
}, fT = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, hT = function(e, t, n, r, o) {
  var i = fT(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    if (!a)
      break;
    var m = _p(e, a), v = m[0], g = m[1], y = m[2], b = g - y - i * v;
    (v || b) && Ap(e, a) && (d += b, f += v);
    var x = a.parentNode;
    a = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, Ni = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, vf = function(e) {
  return [e.deltaX, e.deltaY];
}, yf = function(e) {
  return e && "current" in e ? e.current : e;
}, mT = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, pT = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, gT = 0, Tr = [];
function vT(e) {
  var t = p.useRef([]), n = p.useRef([0, 0]), r = p.useRef(), o = p.useState(gT++)[0], i = p.useState(tu)[0], s = p.useRef(e);
  p.useEffect(function() {
    s.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = Tp([e.lockRef.current], (e.shards || []).map(yf), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = p.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var b = Ni(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - b[0], C = "deltaY" in g ? g.deltaY : x[1] - b[1], E, S = g.target, T = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && T === "h" && S.type === "range")
      return !1;
    var P = window.getSelection(), D = P && P.anchorNode, k = D ? D === S || D.contains(S) : !1;
    if (k)
      return !1;
    var R = gf(T, S);
    if (!R)
      return !0;
    if (R ? E = T : (E = T === "v" ? "h" : "v", R = gf(T, S)), !R)
      return !1;
    if (!r.current && "changedTouches" in g && (w || C) && (r.current = E), !E)
      return !0;
    var A = r.current || E;
    return hT(A, y, g, A === "h" ? w : C);
  }, []), l = p.useCallback(function(g) {
    var y = g;
    if (!(!Tr.length || Tr[Tr.length - 1] !== i)) {
      var b = "deltaY" in y ? vf(y) : Ni(y), x = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && mT(E.delta, b);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(yf).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), C = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        C && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = p.useCallback(function(g, y, b, x) {
    var w = { name: g, delta: y, target: b, should: x, shadowParent: yT(b) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), u = p.useCallback(function(g) {
    n.current = Ni(g), r.current = void 0;
  }, []), d = p.useCallback(function(g) {
    c(g.type, vf(g), g.target, a(g, e.lockRef.current));
  }, []), f = p.useCallback(function(g) {
    c(g.type, Ni(g), g.target, a(g, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return Tr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Sr), document.addEventListener("touchmove", l, Sr), document.addEventListener("touchstart", u, Sr), function() {
      Tr = Tr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Sr), document.removeEventListener("touchmove", l, Sr), document.removeEventListener("touchstart", u, Sr);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    v ? p.createElement(i, { styles: pT(o) }) : null,
    m ? p.createElement(Mp, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function yT(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const bT = Dp(Rp, vT);
var oi = p.forwardRef(function(e, t) {
  return p.createElement(Vs, ht({}, e, { ref: t, sideCar: bT }));
});
oi.classNames = Vs.classNames;
var wT = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Er = /* @__PURE__ */ new WeakMap(), Ai = /* @__PURE__ */ new WeakMap(), _i = {}, Oa = 0, Op = function(e) {
  return e && (e.host || Op(e.parentNode));
}, xT = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Op(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, CT = function(e, t, n, r) {
  var o = xT(t, Array.isArray(e) ? e : [e]);
  _i[n] || (_i[n] = /* @__PURE__ */ new WeakMap());
  var i = _i[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var m = f.getAttribute(r), v = m !== null && m !== "false", g = (Er.get(f) || 0) + 1, y = (i.get(f) || 0) + 1;
          Er.set(f, g), i.set(f, y), s.push(f), g === 1 && v && Ai.set(f, !0), y === 1 && f.setAttribute(n, "true"), v || f.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return u(t), a.clear(), Oa++, function() {
    s.forEach(function(d) {
      var f = Er.get(d) - 1, m = i.get(d) - 1;
      Er.set(d, f), i.set(d, m), f || (Ai.has(d) || d.removeAttribute(r), Ai.delete(d)), m || d.removeAttribute(n);
    }), Oa--, Oa || (Er = /* @__PURE__ */ new WeakMap(), Er = /* @__PURE__ */ new WeakMap(), Ai = /* @__PURE__ */ new WeakMap(), _i = {});
  };
}, ii = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = wT(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), CT(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Bs = "Dialog", [Ip] = Bt(Bs), [ST, Qt] = Ip(Bs), Lp = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = p.useRef(null), l = p.useRef(null), [c, u] = _n({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Bs
  });
  return /* @__PURE__ */ h(
    ST,
    {
      scope: t,
      triggerRef: a,
      contentRef: l,
      contentId: bn(),
      titleId: bn(),
      descriptionId: bn(),
      open: c,
      onOpenChange: u,
      onOpenToggle: p.useCallback(() => u((d) => !d), [u]),
      modal: s,
      children: n
    }
  );
};
Lp.displayName = Bs;
var $p = "DialogTrigger", Fp = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Qt($p, n), i = ye(t, o.triggerRef);
    return /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": ou(o.open),
        ...r,
        ref: i,
        onClick: j(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Fp.displayName = $p;
var nu = "DialogPortal", [TT, Vp] = Ip(nu, {
  forceMount: void 0
}), Bp = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Qt(nu, t);
  return /* @__PURE__ */ h(TT, { scope: t, forceMount: n, children: p.Children.map(r, (s) => /* @__PURE__ */ h(ft, { present: n || i.open, children: /* @__PURE__ */ h(to, { asChild: !0, container: o, children: s }) })) });
};
Bp.displayName = nu;
var cs = "DialogOverlay", Wp = p.forwardRef(
  (e, t) => {
    const n = Vp(cs, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Qt(cs, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ h(ft, { present: r || i.open, children: /* @__PURE__ */ h(PT, { ...o, ref: t }) }) : null;
  }
);
Wp.displayName = cs;
var ET = /* @__PURE__ */ er("DialogOverlay.RemoveScroll"), PT = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Qt(cs, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ h(oi, { as: ET, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ h(
        le.div,
        {
          "data-state": ou(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), tr = "DialogContent", zp = p.forwardRef(
  (e, t) => {
    const n = Vp(tr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Qt(tr, e.__scopeDialog);
    return /* @__PURE__ */ h(ft, { present: r || i.open, children: i.modal ? /* @__PURE__ */ h(kT, { ...o, ref: t }) : /* @__PURE__ */ h(DT, { ...o, ref: t }) });
  }
);
zp.displayName = tr;
var kT = p.forwardRef(
  (e, t) => {
    const n = Qt(tr, e.__scopeDialog), r = p.useRef(null), o = ye(t, n.contentRef, r);
    return p.useEffect(() => {
      const i = r.current;
      if (i) return ii(i);
    }, []), /* @__PURE__ */ h(
      jp,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: j(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: j(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: j(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), DT = p.forwardRef(
  (e, t) => {
    const n = Qt(tr, e.__scopeDialog), r = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ h(
      jp,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), jp = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = Qt(tr, n), l = p.useRef(null), c = ye(t, l);
    return Fs(), /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ h(
        ri,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ h(
            pr,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": ou(a.open),
              ...s,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ L(ke, { children: [
        /* @__PURE__ */ h(RT, { titleId: a.titleId }),
        /* @__PURE__ */ h(NT, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), ru = "DialogTitle", Hp = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Qt(ru, n);
    return /* @__PURE__ */ h(le.h2, { id: o.titleId, ...r, ref: t });
  }
);
Hp.displayName = ru;
var Up = "DialogDescription", Yp = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Qt(Up, n);
    return /* @__PURE__ */ h(le.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Yp.displayName = Up;
var Gp = "DialogClose", Kp = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Qt(Gp, n);
    return /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: j(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Kp.displayName = Gp;
function ou(e) {
  return e ? "open" : "closed";
}
var Xp = "DialogTitleWarning", [oW, qp] = uS(Xp, {
  contentName: tr,
  titleName: ru,
  docsSlug: "dialog"
}), RT = ({ titleId: e }) => {
  const t = qp(Xp), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return p.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, MT = "DialogDescriptionWarning", NT = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${qp(MT).contentName}}.`;
  return p.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Zp = Lp, Qp = Fp, Jp = Bp, iu = Wp, su = zp, au = Hp, lu = Yp, cu = Kp;
const eg = Zp, iW = Qp, AT = Jp, sW = cu, tg = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  iu,
  {
    ref: n,
    className: X(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
tg.displayName = iu.displayName;
const uu = p.forwardRef(({ className: e, children: t, showCloseButton: n = !0, ...r }, o) => /* @__PURE__ */ L(AT, { children: [
  /* @__PURE__ */ h(tg, {}),
  /* @__PURE__ */ L(
    su,
    {
      ref: o,
      className: X(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-4 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        n && /* @__PURE__ */ L(cu, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ h(Kc, { className: "h-4 w-4" }),
          /* @__PURE__ */ h("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
uu.displayName = su.displayName;
const _T = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: X("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
_T.displayName = "DialogHeader";
const ng = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: X("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e), ...t });
ng.displayName = "DialogFooter";
const rg = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  au,
  {
    ref: n,
    className: X("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
rg.displayName = au.displayName;
const OT = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(lu, { ref: n, className: X("text-sm text-muted-foreground", e), ...t }));
OT.displayName = lu.displayName;
function nr({ transparent: e, className: t, cover: n, iconSize: r }) {
  return /* @__PURE__ */ h(
    "div",
    {
      className: ze(
        "w-full h-full flex justify-center items-center",
        t,
        n && "absolute top-0 left-0 right-0 bottom-0 rounded-lg ",
        !e && "bg-neutral-container/75"
      ),
      children: /* @__PURE__ */ h(lp, { className: ze("animate-spin text-button-primary-bg", !r && "h-10 w-10 "), size: r })
    }
  );
}
const og = je(void 0), aW = () => {
  const e = Se(og);
  if (!e)
    throw new Error("useConfirmationModal must be used within a ConfirmationModalProvider");
  return e;
}, lW = ({ children: e }) => {
  const [t, n] = he(!1), [r, o] = he(!1), [i, s] = he(null), a = () => {
    setTimeout(() => {
      s(null);
    }, 500);
  }, l = (m) => {
    s(m), n(!0);
  }, c = (m) => {
    s((v) => v ? { ...v, message: m } : null);
  }, u = async () => {
    o(!0);
    try {
      i != null && i.onConfirm && await i.onConfirm();
    } finally {
      n(!1), a(), o(!1);
    }
  }, d = () => {
    i != null && i.onCancel && i.onCancel(), n(!1), a();
  }, f = (m) => {
    i != null && i.isCancelDisabled || (!m && (i != null && i.onCancel) && (i == null || i.onCancel()), n(m), a());
  };
  return /* @__PURE__ */ L(og.Provider, { value: { showConfirmation: l, updateMessage: c }, children: [
    e,
    /* @__PURE__ */ h(eg, { open: t, onOpenChange: f, children: /* @__PURE__ */ L(uu, { onEscapeKeyDown: d, showCloseButton: i == null ? void 0 : i.showCloseButton, children: [
      /* @__PURE__ */ h(rg, { children: i == null ? void 0 : i.title }),
      r && /* @__PURE__ */ h(nr, { cover: !0 }),
      i == null ? void 0 : i.message,
      /* @__PURE__ */ L(ng, { children: [
        !(i != null && i.hideCancelButton) && /* @__PURE__ */ h(Ee, { onClick: d, variant: "outline", disabled: (i == null ? void 0 : i.isCancelDisabled) || r, children: (i == null ? void 0 : i.cancelText) || "Cancel" }),
        /* @__PURE__ */ h(
          Ee,
          {
            onClick: u,
            variant: i == null ? void 0 : i.variant,
            autoFocus: !0,
            disabled: (i == null ? void 0 : i.isConfirmDisabled) || r,
            children: (i == null ? void 0 : i.confirmText) || "Confirm"
          }
        )
      ] })
    ] }) })
  ] });
};
var IT = Symbol.for("react.lazy"), us = p[" use ".trim().toString()];
function LT(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function ig(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === IT && "_payload" in e && LT(e._payload);
}
// @__NO_SIDE_EFFECTS__
function $T(e) {
  const t = /* @__PURE__ */ FT(e), n = p.forwardRef((r, o) => {
    let { children: i, ...s } = r;
    ig(i) && typeof us == "function" && (i = us(i._payload));
    const a = p.Children.toArray(i), l = a.find(BT);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? p.Children.count(c) > 1 ? p.Children.only(null) : p.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ h(t, { ...s, ref: o, children: p.isValidElement(c) ? p.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function FT(e) {
  const t = p.forwardRef((n, r) => {
    let { children: o, ...i } = n;
    if (ig(o) && typeof us == "function" && (o = us(o._payload)), p.isValidElement(o)) {
      const s = zT(o), a = WT(i, o.props);
      return o.type !== p.Fragment && (a.ref = r ? ni(r, s) : s), p.cloneElement(o, a);
    }
    return p.Children.count(o) > 1 ? p.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var VT = Symbol("radix.slottable");
function BT(e) {
  return p.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === VT;
}
function WT(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const l = i(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function zT(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var jT = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], sg = jT.reduce((e, t) => {
  const n = /* @__PURE__ */ $T(`Primitive.${t}`), r = p.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(l, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), HT = "Separator", bf = "horizontal", UT = ["horizontal", "vertical"], ag = p.forwardRef((e, t) => {
  const { decorative: n, orientation: r = bf, ...o } = e, i = YT(r) ? r : bf, a = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ h(
    sg.div,
    {
      "data-orientation": i,
      ...a,
      ...o,
      ref: t
    }
  );
});
ag.displayName = HT;
function YT(e) {
  return UT.includes(e);
}
var lg = ag;
const Vo = p.forwardRef(({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ h(
  lg,
  {
    ref: o,
    decorative: n,
    orientation: t,
    className: X(
      "shrink-0 bg-neutral-borders",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...r
  }
));
Vo.displayName = lg.displayName;
const Ia = "grow min-w-8", La = "overflow-hidden text-ellipsis", GT = ({
  datatableHooks: e,
  expandAll: t,
  contractAll: n,
  filters: r,
  clearFilters: o,
  colapsableTable: i
}) => {
  const s = r ? Object.values(r).flat().length : 0, a = !!((s || !i) && o);
  return /* @__PURE__ */ L(
    "div",
    {
      className: ze(
        "flex shrink flex-row  text-button-primary-outline-default space-x-1 text-sm justify-end ml-4 overflow-hidden",
        a ? "min-w-48" : "min-w-32"
      ),
      children: [
        i && /* @__PURE__ */ L(ke, { children: [
          /* @__PURE__ */ h(Ee, { variant: "ghost", onClick: t || (e == null ? void 0 : e.expandAllGroups), size: "sm", className: Ia, children: /* @__PURE__ */ h("span", { className: La, children: "Expand all" }) }),
          /* @__PURE__ */ h(Vo, { orientation: "vertical", className: "h-auto" }),
          /* @__PURE__ */ h(Ee, { variant: "ghost", onClick: n || (e == null ? void 0 : e.contractAllGroups), size: "sm", className: Ia, children: /* @__PURE__ */ h("span", { className: La, children: "Collapse all" }) })
        ] }),
        a ? /* @__PURE__ */ L(ke, { children: [
          i && /* @__PURE__ */ h(Vo, { orientation: "vertical", className: "h-auto" }),
          /* @__PURE__ */ h(Ee, { variant: "ghost", onClick: o, size: "sm", className: Ia, disabled: !s, children: /* @__PURE__ */ h("span", { className: La, children: " Clear filters" }) })
        ] }) : void 0
      ]
    }
  );
};
function gr(e) {
  const { negativeFormat: t = "brackets" } = e.column;
  let n, r;
  return e.value === 1 / 0 || e.value === -1 / 0 ? n = "" : e.column.lookup ? e.value === null || e.value === void 0 || e.value === "" ? n = "-" : typeof e.column.lookup == "function" ? n = e.column.lookup(`${e.value}`, e.record) || `${e.value}` : n = e.column.lookup[`${e.value}`] || `${e.value}` : (n = e.value, r = e.column.dataType === "number" ? e.value && e.value < 0 : !1, e.value ? e.column.conditionalMask && (typeof e.value == "number" || typeof e.value == "string") && n !== "-" ? n = Rl(
    Math.abs(+e.value),
    e.column.conditionalMask(e.column.key, e.column.name, e.record)
  ) : e.column.mask && (typeof e.value == "number" || typeof e.value == "string") && n !== "-" && (n = Rl(Math.abs(+e.value), e.column.mask), n = `${e.column.prefix ?? ""}${n}${e.column.suffix ?? ""}`) : n = "-", t === "brackets" && r && n !== "-" && (n = `(${n})`), t === "minus" && r && n !== "-" && (n = `-${n}`)), /* @__PURE__ */ h("div", { className: ze("overflow-x-hidden text-ellipsis grow w-0", r && "text-red-500"), children: n });
}
const KT = ["top", "right", "bottom", "left"], On = Math.min, kt = Math.max, ds = Math.round, Oi = Math.floor, un = (e) => ({
  x: e,
  y: e
}), XT = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ol(e, t, n) {
  return kt(e, On(t, n));
}
function wn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function xn(e) {
  return e.split("-")[0];
}
function no(e) {
  return e.split("-")[1];
}
function du(e) {
  return e === "x" ? "y" : "x";
}
function fu(e) {
  return e === "y" ? "height" : "width";
}
function ln(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function hu(e) {
  return du(ln(e));
}
function qT(e, t, n) {
  n === void 0 && (n = !1);
  const r = no(e), o = hu(e), i = fu(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = fs(s)), [s, fs(s)];
}
function ZT(e) {
  const t = fs(e);
  return [Il(e), t, Il(t)];
}
function Il(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const wf = ["left", "right"], xf = ["right", "left"], QT = ["top", "bottom"], JT = ["bottom", "top"];
function eE(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? xf : wf : t ? wf : xf;
    case "left":
    case "right":
      return t ? QT : JT;
    default:
      return [];
  }
}
function tE(e, t, n, r) {
  const o = no(e);
  let i = eE(xn(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Il)))), i;
}
function fs(e) {
  const t = xn(e);
  return XT[t] + e.slice(t.length);
}
function nE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function cg(e) {
  return typeof e != "number" ? nE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function hs(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Cf(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = ln(t), s = hu(t), a = fu(s), l = xn(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (no(t)) {
    case "start":
      m[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      m[s] += f * (n && c ? -1 : 1);
      break;
  }
  return m;
}
async function rE(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = wn(t, e), v = cg(m), y = a[f ? d === "floating" ? "reference" : "floating" : d], b = hs(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(y))) == null || n ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), C = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = hs(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (b.top - E.top + v.top) / C.y,
    bottom: (E.bottom - b.bottom + v.bottom) / C.y,
    left: (b.left - E.left + v.left) / C.x,
    right: (E.right - b.right + v.right) / C.x
  };
}
const oE = 50, iE = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = s.detectOverflow ? s : {
    ...s,
    detectOverflow: rE
  }, l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = Cf(c, r, l), f = r, m = 0;
  const v = {};
  for (let g = 0; g < i.length; g++) {
    const y = i[g];
    if (!y)
      continue;
    const {
      name: b,
      fn: x
    } = y, {
      x: w,
      y: C,
      data: E,
      reset: S
    } = await x({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: v,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, d = C ?? d, v[b] = {
      ...v[b],
      ...E
    }, S && m < oE && (m++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: u,
      y: d
    } = Cf(c, f, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: v
  };
}, sE = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = wn(e, t) || {};
    if (c == null)
      return {};
    const d = cg(u), f = {
      x: n,
      y: r
    }, m = hu(o), v = fu(m), g = await s.getDimensions(c), y = m === "y", b = y ? "top" : "left", x = y ? "bottom" : "right", w = y ? "clientHeight" : "clientWidth", C = i.reference[v] + i.reference[m] - f[m] - i.floating[v], E = f[m] - i.reference[m], S = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let T = S ? S[w] : 0;
    (!T || !await (s.isElement == null ? void 0 : s.isElement(S))) && (T = a.floating[w] || i.floating[v]);
    const P = C / 2 - E / 2, D = T / 2 - g[v] / 2 - 1, k = On(d[b], D), R = On(d[x], D), A = k, F = T - g[v] - R, I = T / 2 - g[v] / 2 + P, B = Ol(A, I, F), V = !l.arrow && no(o) != null && I !== B && i.reference[v] / 2 - (I < A ? k : R) - g[v] / 2 < 0, N = V ? I < A ? I - A : I - F : 0;
    return {
      [m]: f[m] + N,
      data: {
        [m]: B,
        centerOffset: I - B - N,
        ...V && {
          alignmentOffset: N
        }
      },
      reset: V
    };
  }
}), aE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: g = !0,
        ...y
      } = wn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = xn(o), x = ln(a), w = xn(a) === a, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), E = f || (w || !g ? [fs(a)] : ZT(a)), S = v !== "none";
      !f && S && E.push(...tE(a, g, v, C));
      const T = [a, ...E], P = await l.detectOverflow(t, y), D = [];
      let k = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && D.push(P[b]), d) {
        const I = qT(o, s, C);
        D.push(P[I[0]], P[I[1]]);
      }
      if (k = [...k, {
        placement: o,
        overflows: D
      }], !D.every((I) => I <= 0)) {
        var R, A;
        const I = (((R = i.flip) == null ? void 0 : R.index) || 0) + 1, B = T[I];
        if (B && (!(d === "alignment" ? x !== ln(B) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        k.every((M) => ln(M.placement) === x ? M.overflows[0] > 0 : !0)))
          return {
            data: {
              index: I,
              overflows: k
            },
            reset: {
              placement: B
            }
          };
        let V = (A = k.filter((N) => N.overflows[0] <= 0).sort((N, M) => N.overflows[1] - M.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!V)
          switch (m) {
            case "bestFit": {
              var F;
              const N = (F = k.filter((M) => {
                if (S) {
                  const _ = ln(M.placement);
                  return _ === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  _ === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((_) => _ > 0).reduce((_, W) => _ + W, 0)]).sort((M, _) => M[1] - _[1])[0]) == null ? void 0 : F[0];
              N && (V = N);
              break;
            }
            case "initialPlacement":
              V = a;
              break;
          }
        if (o !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function Sf(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Tf(e) {
  return KT.some((t) => e[t] >= 0);
}
const lE = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = wn(e, t);
      switch (o) {
        case "referenceHidden": {
          const s = await r.detectOverflow(t, {
            ...i,
            elementContext: "reference"
          }), a = Sf(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Tf(a)
            }
          };
        }
        case "escaped": {
          const s = await r.detectOverflow(t, {
            ...i,
            altBoundary: !0
          }), a = Sf(s, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Tf(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, ug = /* @__PURE__ */ new Set(["left", "top"]);
async function cE(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = xn(n), a = no(n), l = ln(n) === "y", c = ug.has(s) ? -1 : 1, u = i && l ? -1 : 1, d = wn(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof v == "number" && (m = a === "end" ? v * -1 : v), l ? {
    x: m * u,
    y: f * c
  } : {
    x: f * c,
    y: m * u
  };
}
const uE = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await cE(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, dE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: i
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (b) => {
            let {
              x,
              y: w
            } = b;
            return {
              x,
              y: w
            };
          }
        },
        ...c
      } = wn(e, t), u = {
        x: n,
        y: r
      }, d = await i.detectOverflow(t, c), f = ln(xn(o)), m = du(f);
      let v = u[m], g = u[f];
      if (s) {
        const b = m === "y" ? "top" : "left", x = m === "y" ? "bottom" : "right", w = v + d[b], C = v - d[x];
        v = Ol(w, v, C);
      }
      if (a) {
        const b = f === "y" ? "top" : "left", x = f === "y" ? "bottom" : "right", w = g + d[b], C = g - d[x];
        g = Ol(w, g, C);
      }
      const y = l.fn({
        ...t,
        [m]: v,
        [f]: g
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - r,
          enabled: {
            [m]: s,
            [f]: a
          }
        }
      };
    }
  };
}, fE = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = wn(e, t), u = {
        x: n,
        y: r
      }, d = ln(o), f = du(d);
      let m = u[f], v = u[d];
      const g = wn(a, t), y = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const w = f === "y" ? "height" : "width", C = i.reference[f] - i.floating[w] + y.mainAxis, E = i.reference[f] + i.reference[w] - y.mainAxis;
        m < C ? m = C : m > E && (m = E);
      }
      if (c) {
        var b, x;
        const w = f === "y" ? "width" : "height", C = ug.has(xn(o)), E = i.reference[d] - i.floating[w] + (C && ((b = s.offset) == null ? void 0 : b[d]) || 0) + (C ? 0 : y.crossAxis), S = i.reference[d] + i.reference[w] + (C ? 0 : ((x = s.offset) == null ? void 0 : x[d]) || 0) - (C ? y.crossAxis : 0);
        v < E ? v = E : v > S && (v = S);
      }
      return {
        [f]: m,
        [d]: v
      };
    }
  };
}, hE = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...c
      } = wn(e, t), u = await s.detectOverflow(t, c), d = xn(o), f = no(o), m = ln(o) === "y", {
        width: v,
        height: g
      } = i.floating;
      let y, b;
      d === "top" || d === "bottom" ? (y = d, b = f === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = d, y = f === "end" ? "top" : "bottom");
      const x = g - u.top - u.bottom, w = v - u.left - u.right, C = On(g - u[y], x), E = On(v - u[b], w), S = !t.middlewareData.shift;
      let T = C, P = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (P = w), (r = t.middlewareData.shift) != null && r.enabled.y && (T = x), S && !f) {
        const k = kt(u.left, 0), R = kt(u.right, 0), A = kt(u.top, 0), F = kt(u.bottom, 0);
        m ? P = v - 2 * (k !== 0 || R !== 0 ? k + R : kt(u.left, u.right)) : T = g - 2 * (A !== 0 || F !== 0 ? A + F : kt(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: P,
        availableHeight: T
      });
      const D = await s.getDimensions(a.floating);
      return v !== D.width || g !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ws() {
  return typeof window < "u";
}
function ro(e) {
  return dg(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Rt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function hn(e) {
  var t;
  return (t = (dg(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function dg(e) {
  return Ws() ? e instanceof Node || e instanceof Rt(e).Node : !1;
}
function Kt(e) {
  return Ws() ? e instanceof Element || e instanceof Rt(e).Element : !1;
}
function Tn(e) {
  return Ws() ? e instanceof HTMLElement || e instanceof Rt(e).HTMLElement : !1;
}
function Ef(e) {
  return !Ws() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Rt(e).ShadowRoot;
}
function si(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Xt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function mE(e) {
  return /^(table|td|th)$/.test(ro(e));
}
function zs(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const pE = /transform|translate|scale|rotate|perspective|filter/, gE = /paint|layout|strict|content/, zn = (e) => !!e && e !== "none";
let $a;
function mu(e) {
  const t = Kt(e) ? Xt(e) : e;
  return zn(t.transform) || zn(t.translate) || zn(t.scale) || zn(t.rotate) || zn(t.perspective) || !pu() && (zn(t.backdropFilter) || zn(t.filter)) || pE.test(t.willChange || "") || gE.test(t.contain || "");
}
function vE(e) {
  let t = In(e);
  for (; Tn(t) && !Hr(t); ) {
    if (mu(t))
      return t;
    if (zs(t))
      return null;
    t = In(t);
  }
  return null;
}
function pu() {
  return $a == null && ($a = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), $a;
}
function Hr(e) {
  return /^(html|body|#document)$/.test(ro(e));
}
function Xt(e) {
  return Rt(e).getComputedStyle(e);
}
function js(e) {
  return Kt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function In(e) {
  if (ro(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ef(e) && e.host || // Fallback.
    hn(e)
  );
  return Ef(t) ? t.host : t;
}
function fg(e) {
  const t = In(e);
  return Hr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Tn(t) && si(t) ? t : fg(t);
}
function Bo(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = fg(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Rt(o);
  if (i) {
    const a = Ll(s);
    return t.concat(s, s.visualViewport || [], si(o) ? o : [], a && n ? Bo(a) : []);
  } else
    return t.concat(o, Bo(o, [], n));
}
function Ll(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hg(e) {
  const t = Xt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Tn(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = ds(n) !== i || ds(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function gu(e) {
  return Kt(e) ? e : e.contextElement;
}
function Wr(e) {
  const t = gu(e);
  if (!Tn(t))
    return un(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = hg(t);
  let s = (i ? ds(n.width) : n.width) / r, a = (i ? ds(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const yE = /* @__PURE__ */ un(0);
function mg(e) {
  const t = Rt(e);
  return !pu() || !t.visualViewport ? yE : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function bE(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Rt(e) ? !1 : t;
}
function rr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = gu(e);
  let s = un(1);
  t && (r ? Kt(r) && (s = Wr(r)) : s = Wr(e));
  const a = bE(i, n, r) ? mg(i) : un(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = Rt(i), m = r && Kt(r) ? Rt(r) : r;
    let v = f, g = Ll(v);
    for (; g && r && m !== v; ) {
      const y = Wr(g), b = g.getBoundingClientRect(), x = Xt(g), w = b.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, C = b.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += w, c += C, v = Rt(g), g = Ll(v);
    }
  }
  return hs({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Hs(e, t) {
  const n = js(e).scrollLeft;
  return t ? t.left + n : rr(hn(e)).left + n;
}
function pg(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Hs(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function wE(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = hn(r), a = t ? zs(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = un(1);
  const u = un(0), d = Tn(r);
  if ((d || !d && !i) && ((ro(r) !== "body" || si(s)) && (l = js(r)), d)) {
    const m = rr(r);
    c = Wr(r), u.x = m.x + r.clientLeft, u.y = m.y + r.clientTop;
  }
  const f = s && !d && !i ? pg(s, l) : un(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function xE(e) {
  return Array.from(e.getClientRects());
}
function CE(e) {
  const t = hn(e), n = js(e), r = e.ownerDocument.body, o = kt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = kt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Hs(e);
  const a = -n.scrollTop;
  return Xt(r).direction === "rtl" && (s += kt(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
const Pf = 25;
function SE(e, t) {
  const n = Rt(e), r = hn(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const u = pu();
    (!u || u && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  const c = Hs(r);
  if (c <= 0) {
    const u = r.ownerDocument, d = u.body, f = getComputedStyle(d), m = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, v = Math.abs(r.clientWidth - d.clientWidth - m);
    v <= Pf && (i -= v);
  } else c <= Pf && (i += c);
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function TE(e, t) {
  const n = rr(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Tn(e) ? Wr(e) : un(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function kf(e, t, n) {
  let r;
  if (t === "viewport")
    r = SE(e, n);
  else if (t === "document")
    r = CE(hn(e));
  else if (Kt(t))
    r = TE(t, n);
  else {
    const o = mg(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return hs(r);
}
function gg(e, t) {
  const n = In(e);
  return n === t || !Kt(n) || Hr(n) ? !1 : Xt(n).position === "fixed" || gg(n, t);
}
function EE(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Bo(e, [], !1).filter((a) => Kt(a) && ro(a) !== "body"), o = null;
  const i = Xt(e).position === "fixed";
  let s = i ? In(e) : e;
  for (; Kt(s) && !Hr(s); ) {
    const a = Xt(s), l = mu(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || si(s) && !l && gg(e, s)) ? r = r.filter((u) => u !== s) : o = a, s = In(s);
  }
  return t.set(e, r), r;
}
function PE(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? zs(t) ? [] : EE(t, this._c) : [].concat(n), r], a = kf(t, s[0], o);
  let l = a.top, c = a.right, u = a.bottom, d = a.left;
  for (let f = 1; f < s.length; f++) {
    const m = kf(t, s[f], o);
    l = kt(m.top, l), c = On(m.right, c), u = On(m.bottom, u), d = kt(m.left, d);
  }
  return {
    width: c - d,
    height: u - l,
    x: d,
    y: l
  };
}
function kE(e) {
  const {
    width: t,
    height: n
  } = hg(e);
  return {
    width: t,
    height: n
  };
}
function DE(e, t, n) {
  const r = Tn(t), o = hn(t), i = n === "fixed", s = rr(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = un(0);
  function c() {
    l.x = Hs(o);
  }
  if (r || !r && !i)
    if ((ro(t) !== "body" || si(o)) && (a = js(t)), r) {
      const m = rr(t, !0, i, t);
      l.x = m.x + t.clientLeft, l.y = m.y + t.clientTop;
    } else o && c();
  i && !r && o && c();
  const u = o && !r && !i ? pg(o, a) : un(0), d = s.left + a.scrollLeft - l.x - u.x, f = s.top + a.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Fa(e) {
  return Xt(e).position === "static";
}
function Df(e, t) {
  if (!Tn(e) || Xt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return hn(e) === n && (n = n.ownerDocument.body), n;
}
function vg(e, t) {
  const n = Rt(e);
  if (zs(e))
    return n;
  if (!Tn(e)) {
    let o = In(e);
    for (; o && !Hr(o); ) {
      if (Kt(o) && !Fa(o))
        return o;
      o = In(o);
    }
    return n;
  }
  let r = Df(e, t);
  for (; r && mE(r) && Fa(r); )
    r = Df(r, t);
  return r && Hr(r) && Fa(r) && !mu(r) ? n : r || vE(e) || n;
}
const RE = async function(e) {
  const t = this.getOffsetParent || vg, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: DE(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function ME(e) {
  return Xt(e).direction === "rtl";
}
const NE = {
  convertOffsetParentRelativeRectToViewportRelativeRect: wE,
  getDocumentElement: hn,
  getClippingRect: PE,
  getOffsetParent: vg,
  getElementRects: RE,
  getClientRects: xE,
  getDimensions: kE,
  getScale: Wr,
  isElement: Kt,
  isRTL: ME
};
function yg(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function AE(e, t) {
  let n = null, r;
  const o = hn(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: m
    } = c;
    if (a || t(), !f || !m)
      return;
    const v = Oi(d), g = Oi(o.clientWidth - (u + f)), y = Oi(o.clientHeight - (d + m)), b = Oi(u), w = {
      rootMargin: -v + "px " + -g + "px " + -y + "px " + -b + "px",
      threshold: kt(0, On(1, l)) || 1
    };
    let C = !0;
    function E(S) {
      const T = S[0].intersectionRatio;
      if (T !== l) {
        if (!C)
          return s();
        T ? s(!1, T) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !yg(c, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, w);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function _E(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = gu(e), u = o || i ? [...c ? Bo(c) : [], ...t ? Bo(t) : []] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const d = c && a ? AE(c, n) : null;
  let f = -1, m = null;
  s && (m = new ResizeObserver((b) => {
    let [x] = b;
    x && x.target === c && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(t);
    })), n();
  }), c && !l && m.observe(c), t && m.observe(t));
  let v, g = l ? rr(e) : null;
  l && y();
  function y() {
    const b = rr(e);
    g && !yg(g, b) && n(), g = b, v = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    u.forEach((x) => {
      o && x.removeEventListener("scroll", n), i && x.removeEventListener("resize", n);
    }), d == null || d(), (b = m) == null || b.disconnect(), m = null, l && cancelAnimationFrame(v);
  };
}
const OE = uE, IE = dE, LE = aE, $E = hE, FE = lE, Rf = sE, VE = fE, BE = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: NE,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return iE(e, t, {
    ...o,
    platform: i
  });
};
var WE = typeof document < "u", zE = function() {
}, Xi = WE ? hr : zE;
function ms(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!ms(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !ms(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function bg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Mf(e, t) {
  const n = bg(e);
  return Math.round(t * n) / n;
}
function Va(e) {
  const t = p.useRef(e);
  return Xi(() => {
    t.current = e;
  }), t;
}
function jE(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = p.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, m] = p.useState(r);
  ms(f, r) || m(r);
  const [v, g] = p.useState(null), [y, b] = p.useState(null), x = p.useCallback((M) => {
    M !== S.current && (S.current = M, g(M));
  }, []), w = p.useCallback((M) => {
    M !== T.current && (T.current = M, b(M));
  }, []), C = i || v, E = s || y, S = p.useRef(null), T = p.useRef(null), P = p.useRef(u), D = l != null, k = Va(l), R = Va(o), A = Va(c), F = p.useCallback(() => {
    if (!S.current || !T.current)
      return;
    const M = {
      placement: t,
      strategy: n,
      middleware: f
    };
    R.current && (M.platform = R.current), BE(S.current, T.current, M).then((_) => {
      const W = {
        ..._,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: A.current !== !1
      };
      I.current && !ms(P.current, W) && (P.current = W, ti.flushSync(() => {
        d(W);
      }));
    });
  }, [f, t, n, R, A]);
  Xi(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [c]);
  const I = p.useRef(!1);
  Xi(() => (I.current = !0, () => {
    I.current = !1;
  }), []), Xi(() => {
    if (C && (S.current = C), E && (T.current = E), C && E) {
      if (k.current)
        return k.current(C, E, F);
      F();
    }
  }, [C, E, F, k, D]);
  const B = p.useMemo(() => ({
    reference: S,
    floating: T,
    setReference: x,
    setFloating: w
  }), [x, w]), V = p.useMemo(() => ({
    reference: C,
    floating: E
  }), [C, E]), N = p.useMemo(() => {
    const M = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return M;
    const _ = Mf(V.floating, u.x), W = Mf(V.floating, u.y);
    return a ? {
      ...M,
      transform: "translate(" + _ + "px, " + W + "px)",
      ...bg(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: _,
      top: W
    };
  }, [n, a, V.floating, u.x, u.y]);
  return p.useMemo(() => ({
    ...u,
    update: F,
    refs: B,
    elements: V,
    floatingStyles: N
  }), [u, F, B, V, N]);
}
const HE = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Rf({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Rf({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, UE = (e, t) => {
  const n = OE(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, YE = (e, t) => {
  const n = IE(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, GE = (e, t) => ({
  fn: VE(e).fn,
  options: [e, t]
}), KE = (e, t) => {
  const n = LE(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, XE = (e, t) => {
  const n = $E(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, qE = (e, t) => {
  const n = FE(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, ZE = (e, t) => {
  const n = HE(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var QE = "Arrow", wg = p.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ h(
    le.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ h("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
wg.displayName = QE;
var JE = wg;
function xg(e) {
  const [t, n] = p.useState(void 0);
  return it(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var vu = "Popper", [Cg, $n] = Bt(vu), [eP, Sg] = Cg(vu), Tg = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = p.useState(null);
  return /* @__PURE__ */ h(eP, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Tg.displayName = vu;
var Eg = "PopperAnchor", Pg = p.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Sg(Eg, n), s = p.useRef(null), a = ye(t, s), l = p.useRef(null);
    return p.useEffect(() => {
      const c = l.current;
      l.current = (r == null ? void 0 : r.current) || s.current, c !== l.current && i.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ h(le.div, { ...o, ref: a });
  }
);
Pg.displayName = Eg;
var yu = "PopperContent", [tP, nP] = Cg(yu), kg = p.forwardRef(
  (e, t) => {
    var U, oe, q, ie, be, Ce;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: v,
      ...g
    } = e, y = Sg(yu, n), [b, x] = p.useState(null), w = ye(t, (re) => x(re)), [C, E] = p.useState(null), S = xg(C), T = (S == null ? void 0 : S.width) ?? 0, P = (S == null ? void 0 : S.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), k = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, R = Array.isArray(c) ? c : [c], A = R.length > 0, F = {
      padding: k,
      boundary: R.filter(oP),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: A
    }, { refs: I, floatingStyles: B, placement: V, isPositioned: N, middlewareData: M } = jE({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...re) => _E(...re, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        UE({ mainAxis: o + P, alignmentAxis: s }),
        l && YE({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? GE() : void 0,
          ...F
        }),
        l && KE({ ...F }),
        XE({
          ...F,
          apply: ({ elements: re, rects: st, availableWidth: Tt, availableHeight: _t }) => {
            const { width: en, height: xr } = st.reference, Et = re.floating.style;
            Et.setProperty("--radix-popper-available-width", `${Tt}px`), Et.setProperty("--radix-popper-available-height", `${_t}px`), Et.setProperty("--radix-popper-anchor-width", `${en}px`), Et.setProperty("--radix-popper-anchor-height", `${xr}px`);
          }
        }),
        C && ZE({ element: C, padding: a }),
        iP({ arrowWidth: T, arrowHeight: P }),
        f && qE({ strategy: "referenceHidden", ...F })
      ]
    }), [_, W] = Mg(V), te = Qe(v);
    it(() => {
      N && (te == null || te());
    }, [N, te]);
    const O = (U = M.arrow) == null ? void 0 : U.x, z = (oe = M.arrow) == null ? void 0 : oe.y, Q = ((q = M.arrow) == null ? void 0 : q.centerOffset) !== 0, [K, se] = p.useState();
    return it(() => {
      b && se(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ h(
      "div",
      {
        ref: I.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...B,
          transform: N ? B.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: K,
          "--radix-popper-transform-origin": [
            (ie = M.transformOrigin) == null ? void 0 : ie.x,
            (be = M.transformOrigin) == null ? void 0 : be.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ce = M.hide) == null ? void 0 : Ce.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ h(
          tP,
          {
            scope: n,
            placedSide: _,
            onArrowChange: E,
            arrowX: O,
            arrowY: z,
            shouldHideArrow: Q,
            children: /* @__PURE__ */ h(
              le.div,
              {
                "data-side": _,
                "data-align": W,
                ...g,
                ref: w,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: N ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
kg.displayName = yu;
var Dg = "PopperArrow", rP = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Rg = p.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = nP(Dg, r), s = rP[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ h(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ h(
          JE,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Rg.displayName = Dg;
function oP(e) {
  return e !== null;
}
var iP = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, b, x;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((y = o.arrow) == null ? void 0 : y.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [c, u] = Mg(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + a / 2, m = (((x = o.arrow) == null ? void 0 : x.y) ?? 0) + l / 2;
    let v = "", g = "";
    return c === "bottom" ? (v = s ? d : `${f}px`, g = `${-l}px`) : c === "top" ? (v = s ? d : `${f}px`, g = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, g = s ? d : `${m}px`) : c === "left" && (v = `${r.floating.width + l}px`, g = s ? d : `${m}px`), { data: { x: v, y: g } };
  }
});
function Mg(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var bu = Tg, ai = Pg, Us = kg, Ys = Rg, Ng = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), sP = "VisuallyHidden", Gs = p.forwardRef(
  (e, t) => /* @__PURE__ */ h(
    le.span,
    {
      ...e,
      ref: t,
      style: { ...Ng, ...e.style }
    }
  )
);
Gs.displayName = sP;
var aP = Gs, [Ks] = Bt("Tooltip", [
  $n
]), Xs = $n(), Ag = "TooltipProvider", lP = 700, $l = "tooltip.open", [cP, wu] = Ks(Ag), _g = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = lP,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, s = p.useRef(!0), a = p.useRef(!1), l = p.useRef(0);
  return p.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ h(
    cP,
    {
      scope: t,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: p.useCallback(() => {
        window.clearTimeout(l.current), s.current = !1;
      }, []),
      onClose: p.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: p.useCallback((c) => {
        a.current = c;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
_g.displayName = Ag;
var Wo = "Tooltip", [uP, li] = Ks(Wo), Og = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: a
  } = e, l = wu(Wo, e.__scopeTooltip), c = Xs(t), [u, d] = p.useState(null), f = bn(), m = p.useRef(0), v = s ?? l.disableHoverableContent, g = a ?? l.delayDuration, y = p.useRef(!1), [b, x] = _n({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (T) => {
      T ? (l.onOpen(), document.dispatchEvent(new CustomEvent($l))) : l.onClose(), i == null || i(T);
    },
    caller: Wo
  }), w = p.useMemo(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [b]), C = p.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, y.current = !1, x(!0);
  }, [x]), E = p.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, x(!1);
  }, [x]), S = p.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      y.current = !0, x(!0), m.current = 0;
    }, g);
  }, [g, x]);
  return p.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ h(bu, { ...c, children: /* @__PURE__ */ h(
    uP,
    {
      scope: t,
      contentId: f,
      open: b,
      stateAttribute: w,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: p.useCallback(() => {
        l.isOpenDelayedRef.current ? S() : C();
      }, [l.isOpenDelayedRef, S, C]),
      onTriggerLeave: p.useCallback(() => {
        v ? E() : (window.clearTimeout(m.current), m.current = 0);
      }, [E, v]),
      onOpen: C,
      onClose: E,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
Og.displayName = Wo;
var Fl = "TooltipTrigger", Ig = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = li(Fl, n), i = wu(Fl, n), s = Xs(n), a = p.useRef(null), l = ye(t, a, o.onTriggerChange), c = p.useRef(!1), u = p.useRef(!1), d = p.useCallback(() => c.current = !1, []);
    return p.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ h(ai, { asChild: !0, ...s, children: /* @__PURE__ */ h(
      le.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: j(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: j(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: j(e.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: j(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: j(e.onBlur, o.onClose),
        onClick: j(e.onClick, o.onClose)
      }
    ) });
  }
);
Ig.displayName = Fl;
var xu = "TooltipPortal", [dP, fP] = Ks(xu, {
  forceMount: void 0
}), Lg = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = li(xu, t);
  return /* @__PURE__ */ h(dP, { scope: t, forceMount: n, children: /* @__PURE__ */ h(ft, { present: n || i.open, children: /* @__PURE__ */ h(to, { asChild: !0, container: o, children: r }) }) });
};
Lg.displayName = xu;
var Ur = "TooltipContent", $g = p.forwardRef(
  (e, t) => {
    const n = fP(Ur, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, s = li(Ur, e.__scopeTooltip);
    return /* @__PURE__ */ h(ft, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ h(Fg, { side: o, ...i, ref: t }) : /* @__PURE__ */ h(hP, { side: o, ...i, ref: t }) });
  }
), hP = p.forwardRef((e, t) => {
  const n = li(Ur, e.__scopeTooltip), r = wu(Ur, e.__scopeTooltip), o = p.useRef(null), i = ye(t, o), [s, a] = p.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, f = p.useCallback(() => {
    a(null), d(!1);
  }, [d]), m = p.useCallback(
    (v, g) => {
      const y = v.currentTarget, b = { x: v.clientX, y: v.clientY }, x = yP(b, y.getBoundingClientRect()), w = bP(b, x), C = wP(g.getBoundingClientRect()), E = CP([...w, ...C]);
      a(E), d(!0);
    },
    [d]
  );
  return p.useEffect(() => () => f(), [f]), p.useEffect(() => {
    if (l && u) {
      const v = (y) => m(y, u), g = (y) => m(y, l);
      return l.addEventListener("pointerleave", v), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", v), u.removeEventListener("pointerleave", g);
      };
    }
  }, [l, u, m, f]), p.useEffect(() => {
    if (s) {
      const v = (g) => {
        const y = g.target, b = { x: g.clientX, y: g.clientY }, x = (l == null ? void 0 : l.contains(y)) || (u == null ? void 0 : u.contains(y)), w = !xP(b, s);
        x ? f() : w && (f(), c());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, u, s, c, f]), /* @__PURE__ */ h(Fg, { ...e, ref: i });
}), [mP, pP] = Ks(Wo, { isInside: !1 }), gP = /* @__PURE__ */ yS("TooltipContent"), Fg = p.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      ...a
    } = e, l = li(Ur, n), c = Xs(n), { onClose: u } = l;
    return p.useEffect(() => (document.addEventListener($l, u), () => document.removeEventListener($l, u)), [u]), p.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const m = f.target;
          m != null && m.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ h(
      pr,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ L(
          Us,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...a,
            ref: t,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ h(gP, { children: r }),
              /* @__PURE__ */ h(mP, { scope: n, isInside: !0, children: /* @__PURE__ */ h(aP, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
$g.displayName = Ur;
var Vg = "TooltipArrow", vP = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Xs(n);
    return pP(
      Vg,
      n
    ).isInside ? null : /* @__PURE__ */ h(Ys, { ...o, ...r, ref: t });
  }
);
vP.displayName = Vg;
function yP(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function bP(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function wP(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function xP(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], l = t[s], c = a.x, u = a.y, d = l.x, f = l.y;
    u > r != f > r && n < (d - c) * (r - u) / (f - u) + c && (o = !o);
  }
  return o;
}
function CP(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), SP(t);
}
function SP(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var TP = _g, EP = Og, PP = Ig, kP = Lg, Bg = $g;
const Cu = TP, qs = EP, Zs = PP, ci = p.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ h(
  Bg,
  {
    ref: r,
    sideOffset: t,
    className: X(
      "z-50 overflow-hidden rounded-lg border bg-neutral-bg px-2 py-0.5 text-xxs text-neutral-text-secondary shadow-sm animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
ci.displayName = Bg.displayName;
function Wg({ text: e, className: t = "" }) {
  const n = /* @__PURE__ */ h("span", { className: t, children: e });
  return e ? /* @__PURE__ */ L(qs, { children: [
    /* @__PURE__ */ h(Zs, { asChild: !0, children: n }),
    /* @__PURE__ */ h(kP, { children: /* @__PURE__ */ h(ci, { side: "top", className: "z-[9999] max-w-xs break-words text-xs dark:text-white", children: e }) })
  ] }) : n;
}
function DP(e, t, n) {
  return RP(e, { column: t, row: n });
}
function RP(e, t) {
  return !e || !t ? !1 : e.column === t.column && e.row === t.row;
}
const cW = () => ({
  split: !0
}), uW = (e) => ({
  split: !0,
  key: e,
  isLocked: !0
}), MP = (e, t) => {
  const n = `${e.map((r) => r.key).join("_").toLowerCase()}_${t}_group`;
  return {
    key: n,
    name: n,
    group: e,
    groupColumn: !0,
    _dfColIndex: -1
  };
};
function NP(e, t, n) {
  const r = new Array(e);
  return new Proxy(r, {
    get(o, i, s) {
      if (typeof i == "string") {
        const a = i.charCodeAt(0);
        if (a >= 48 && a <= 57) {
          const l = +i;
          if (Number.isInteger(l) && l >= 0 && l < e) {
            let c = o[l];
            if (!c) {
              const u = t[l * 2];
              c = o[l] = {
                index: l,
                key: n(l),
                start: u,
                size: t[l * 2 + 1],
                end: u + t[l * 2 + 1],
                lane: 0
              };
            }
            return c;
          }
        }
        if (i === "length") return e;
      }
      return Reflect.get(o, i, s);
    }
  });
}
function Pr(e, t, n) {
  let r = n.initialDeps ?? [], o, i = !0;
  function s() {
    var a;
    const l = process.env.NODE_ENV !== "production" && !!n.key && !!((a = n.debug) != null && a.call(n));
    let c = 0;
    l && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((m, v) => r[v] !== m)))
      return o;
    r = u;
    let f = 0;
    if (l && (f = Date.now()), o = t(...u), l) {
      const m = Math.round((Date.now() - c) * 100) / 100, v = Math.round((Date.now() - f) * 100) / 100, g = v / 16, y = (b, x) => {
        for (b = String(b); b.length < x; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${y(v, 5)} /${y(m, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return n != null && n.onChange && !(i && n.skipInitialOnChange) && n.onChange(o), i = !1, o;
  }
  return s.updateDeps = (a) => {
    r = a;
  }, s;
}
function Nf(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Af = (e, t) => Math.abs(e - t) < 1.01, AP = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
};
let po;
const _f = () => {
  if (po !== void 0) return po;
  if (typeof navigator > "u") return po = !1;
  if (/iP(hone|od|ad)/.test(navigator.userAgent)) return po = !0;
  const e = navigator.maxTouchPoints;
  return po = navigator.platform === "MacIntel" && e !== void 0 && e > 0;
}, Of = (e) => {
  const { offsetWidth: t, offsetHeight: n } = e;
  return { width: t, height: n };
}, _P = (e) => e, OP = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1) - t + 1, o = new Array(r);
  for (let i = 0; i < r; i++)
    o[i] = t + i;
  return o;
}, IP = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (s) => {
    const { width: a, height: l } = s;
    t({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(Of(n)), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((s) => {
    const a = () => {
      const l = s[0];
      if (l != null && l.borderBoxSize) {
        const c = l.borderBoxSize[0];
        if (c) {
          o({ width: c.inlineSize, height: c.blockSize });
          return;
        }
      }
      o(Of(n));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, ps = {
  passive: !0
}, LP = typeof window > "u" ? !0 : "onscrollend" in window, $P = (e, t, n) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const o = e.targetWindow;
  if (!o)
    return;
  const i = e.options.useScrollendEvent && LP;
  let s = 0;
  const a = i ? null : AP(
    o,
    () => t(s, !1),
    e.options.isScrollingResetDelay
  ), l = (d) => () => {
    s = n(r), a == null || a(), t(s, d);
  }, c = l(!0), u = l(!1);
  return r.addEventListener("scroll", c, ps), i && r.addEventListener("scrollend", u, ps), () => {
    r.removeEventListener("scroll", c), i && r.removeEventListener("scrollend", u);
  };
}, FP = (e, t) => $P(e, t, (n) => {
  const { horizontal: r, isRtl: o } = e.options;
  return r ? n.scrollLeft * (o && -1 || 1) : n.scrollTop;
}), VP = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[n.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, BP = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: e + t,
    behavior: n
  });
}, WP = BP;
class zP {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollState = null, this.measurementsCache = [], this._flatMeasurements = null, this.itemSizeCache = /* @__PURE__ */ new Map(), this.itemSizeCacheVersion = 0, this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMin = null, this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.pendingScrollAnchor = null, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this._iosDeferredAdjustment = 0, this._iosTouching = !1, this._iosJustTouchEnded = !1, this._iosTouchEndTimerId = null, this._intendedScrollOffset = null, this.elementsCache = /* @__PURE__ */ new Map(), this.now = () => {
      var n, r, o;
      return ((o = (r = (n = this.targetWindow) == null ? void 0 : n.performance) == null ? void 0 : r.now) == null ? void 0 : o.call(r)) ?? Date.now();
    }, this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          const s = () => {
            const a = i.target, l = this.indexFromElement(a);
            if (!a.isConnected) {
              this.observer.unobserve(a);
              for (const [c, u] of this.elementsCache)
                if (u === a) {
                  this.elementsCache.delete(c);
                  break;
                }
              return;
            }
            this.shouldMeasureDuringScroll(l) && this.resizeItem(
              l,
              this.options.measureElement(a, i, this)
            );
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      var r, o;
      const i = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: _P,
        rangeExtractor: OP,
        onChange: () => {
        },
        measureElement: VP,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        anchorTo: "start",
        followOnAppend: !1,
        scrollEndThreshold: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        laneAssignmentMode: "estimate"
      };
      for (const c in n) {
        const u = n[c];
        u !== void 0 && (i[c] = u);
      }
      const s = this.options;
      let a = null, l = null;
      if (s !== void 0 && s.enabled && i.enabled && i.anchorTo === "end" && this.scrollElement !== null) {
        const c = s.count, u = i.count, d = this.getMeasurements(), f = c > 0 ? ((r = d[0]) == null ? void 0 : r.key) ?? s.getItemKey(0) : null, m = c > 0 ? ((o = d[c - 1]) == null ? void 0 : o.key) ?? s.getItemKey(c - 1) : null;
        if (u !== c || c > 0 && u > 0 && (i.getItemKey(0) !== f || i.getItemKey(u - 1) !== m)) {
          const y = c > 0 ? this.getVirtualItemForOffset(this.getScrollOffset()) ?? d[0] : null;
          y && (a = [y.key, this.getScrollOffset() - y.start]);
          const b = i.followOnAppend === !0 ? "auto" : i.followOnAppend || null;
          b && u > c && this.isAtEnd(s.scrollEndThreshold) && (c === 0 || i.getItemKey(u - 1) !== m) && (l = b);
        }
      }
      this.options = i, (a || l) && (this.pendingScrollAnchor = [
        (a == null ? void 0 : a[0]) ?? null,
        (a == null ? void 0 : a[1]) ?? 0,
        l
      ]);
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = Pr(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.rafId != null && this.targetWindow && (this.targetWindow.cancelAnimationFrame(this.rafId), this.rafId = null), this.scrollState = null, this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        if (this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, s) => {
            this._intendedScrollOffset !== null && Math.abs(i - this._intendedScrollOffset) < 1.5 && (i = this._intendedScrollOffset), this._intendedScrollOffset = null, this.scrollAdjustments = 0, this.scrollDirection = s ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = s, this._flushIosDeferredIfReady(), this.scrollState && this.scheduleScrollReconcile(), this.maybeNotify();
          })
        ), "addEventListener" in this.scrollElement) {
          const i = this.scrollElement, s = () => {
            this._iosTouching = !0, this._iosJustTouchEnded = !1, this._iosTouchEndTimerId !== null && this.targetWindow != null && (this.targetWindow.clearTimeout(this._iosTouchEndTimerId), this._iosTouchEndTimerId = null);
          }, a = () => {
            this._iosTouching = !1, !(!_f() || this.targetWindow == null) && (this._iosJustTouchEnded = !0, this._iosTouchEndTimerId = this.targetWindow.setTimeout(() => {
              this._iosJustTouchEnded = !1, this._iosTouchEndTimerId = null, this._flushIosDeferredIfReady();
            }, 150));
          };
          i.addEventListener(
            "touchstart",
            s,
            ps
          ), i.addEventListener(
            "touchend",
            a,
            ps
          ), this.unsubs.push(() => {
            i.removeEventListener("touchstart", s), i.removeEventListener("touchend", a), this._iosTouchEndTimerId !== null && this.targetWindow != null && (this.targetWindow.clearTimeout(this._iosTouchEndTimerId), this._iosTouchEndTimerId = null);
          });
        }
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
      const o = this.pendingScrollAnchor;
      if (this.pendingScrollAnchor = null, o && this.scrollElement && this.options.enabled) {
        const [i, s, a] = o;
        if (i !== null) {
          const { count: l, getItemKey: c } = this.options;
          let u = 0;
          for (; u < l && c(u) !== i; )
            u++;
          const d = u < l ? this.getMeasurements()[u] : void 0;
          if (d) {
            const f = d.start + s - this.getScrollOffset();
            Af(f, 0) || this.applyScrollAdjustment(f);
          }
        }
        a && this.scrollToEnd({ behavior: a });
      }
    }, this._flushIosDeferredIfReady = () => {
      if (this._iosDeferredAdjustment === 0 || this.isScrolling || this._iosTouching || this._iosJustTouchEnded) return;
      const n = this.getScrollOffset(), r = this.getMaxScrollOffset();
      if (n < 0 || n > r) return;
      const o = this._iosDeferredAdjustment;
      this._iosDeferredAdjustment = 0, this._scrollToOffset(n, {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      });
    }, this.rafId = null, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (o.has(a.lane))
          continue;
        const l = i.get(
          a.lane
        );
        if (l == null || a.end > l.end ? i.set(a.lane, a) : a.end < l.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Pr(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes,
        this.options.laneAssignmentMode
      ],
      (n, r, o, i, s, a, l) => (this.prevLanes !== void 0 && this.prevLanes !== a && (this.lanesChangedFlag = !0), this.prevLanes = a, this.pendingMin = null, {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s,
        lanes: a,
        laneAssignmentMode: l
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Pr(
      () => [this.getMeasurementOptions(), this.itemSizeCacheVersion],
      ({
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s,
        lanes: a,
        laneAssignmentMode: l
      }, c) => {
        const u = this.itemSizeCache;
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > n)
          for (const v of this.laneAssignments.keys())
            v >= n && this.laneAssignments.delete(v);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMin = null), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((v) => {
          this.itemSizeCache.set(v.key, v.size);
        }));
        const d = this.lanesSettling ? 0 : this.pendingMin ?? 0;
        if (this.pendingMin = null, this.lanesSettling && this.measurementsCache.length === n && (this.lanesSettling = !1), a === 1) {
          const v = this.options.gap, g = n * 2;
          let y = this._flatMeasurements;
          if (!y || y.length < g) {
            const w = new Float64Array(g);
            y && d > 0 && w.set(y.subarray(0, d * 2)), y = w, this._flatMeasurements = y;
          }
          let b;
          if (d === 0)
            b = r + o;
          else {
            const w = d - 1;
            b = y[w * 2] + y[w * 2 + 1] + v;
          }
          for (let w = d; w < n; w++) {
            const C = i(w), E = u.get(C), S = typeof E == "number" ? E : this.options.estimateSize(w);
            y[w * 2] = b, y[w * 2 + 1] = S, b += S + v;
          }
          const x = NP(n, y, i);
          return this.measurementsCache = x, x;
        }
        const f = this.measurementsCache.slice(0, d), m = new Array(a).fill(
          void 0
        );
        for (let v = 0; v < d; v++) {
          const g = f[v];
          g && (m[g.lane] = v);
        }
        for (let v = d; v < n; v++) {
          const g = i(v), y = this.laneAssignments.get(v);
          let b, x;
          const w = l === "estimate" || u.has(g);
          if (y !== void 0 && this.options.lanes > 1) {
            b = y;
            const T = m[b], P = T !== void 0 ? f[T] : void 0;
            x = P ? P.end + this.options.gap : r + o;
          } else {
            const T = this.options.lanes === 1 ? f[v - 1] : this.getFurthestMeasurement(f, v);
            x = T ? T.end + this.options.gap : r + o, b = T ? T.lane : v % this.options.lanes, this.options.lanes > 1 && w && this.laneAssignments.set(v, b);
          }
          const C = u.get(g), E = typeof C == "number" ? C : this.options.estimateSize(v), S = x + E;
          f[v] = {
            index: v,
            start: x,
            size: E,
            end: S,
            key: g,
            lane: b
          }, m[b] = v;
        }
        return this.measurementsCache = f, f;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Pr(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, o, i) => this.range = n.length > 0 && r > 0 ? jP({
        measurements: n,
        outerSize: r,
        scrollOffset: o,
        lanes: i,
        // Pass the typed array so binary search + forward-walk can
        // read start/end directly from Float64Array, skipping the
        // Proxy traps that materialize a full VirtualItem per probe.
        flat: i === 1 && this._flatMeasurements != null ? this._flatMeasurements : null
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Pr(
      () => {
        let n = null, r = null;
        const o = this.calculateRange();
        return o && (n = o.startIndex, r = o.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, o, i, s) => i === null || s === null ? [] : n({
        startIndex: i,
        endIndex: s,
        overscan: r,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this.shouldMeasureDuringScroll = (n) => {
      var r;
      if (!this.scrollState || this.scrollState.behavior !== "smooth")
        return !0;
      const o = this.scrollState.index ?? ((r = this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)) == null ? void 0 : r.index);
      if (o !== void 0 && this.range) {
        const i = Math.max(
          this.options.overscan,
          Math.ceil((this.range.endIndex - this.range.startIndex) / 2)
        ), s = Math.max(0, o - i), a = Math.min(
          this.options.count - 1,
          o + i
        );
        return n >= s && n <= a;
      }
      return !0;
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((s, a) => {
          s.isConnected || (this.observer.unobserve(s), this.elementsCache.delete(a));
        });
        return;
      }
      const r = this.indexFromElement(n), o = this.options.getItemKey(r), i = this.elementsCache.get(o);
      i !== n && (i && this.observer.unobserve(i), this.observer.observe(n), this.elementsCache.set(o, n)), (!this.isScrolling || this.scrollState) && this.shouldMeasureDuringScroll(r) && this.resizeItem(r, this.options.measureElement(n, void 0, this));
    }, this.resizeItem = (n, r) => {
      var o, i;
      if (n < 0 || n >= this.options.count) return;
      let s, a, l;
      const c = this._flatMeasurements;
      if (this.options.lanes === 1 && c !== null)
        l = this.options.getItemKey(n), a = c[n * 2], s = c[n * 2 + 1];
      else {
        const f = this.measurementsCache[n];
        if (!f) return;
        l = f.key, a = f.start, s = f.size;
      }
      const u = this.itemSizeCache.get(l) ?? s, d = r - u;
      if (d !== 0) {
        const f = this.options.anchorTo === "end" && ((o = this.scrollState) == null ? void 0 : o.behavior) !== "smooth" && this.getVirtualDistanceFromEnd() <= this.options.scrollEndThreshold, m = f ? this.getTotalSize() : 0, v = ((i = this.scrollState) == null ? void 0 : i.behavior) !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(
          // The callback expects a VirtualItem; build one lazily only
          // when the consumer actually supplied a custom predicate.
          this.measurementsCache[n] ?? {
            index: n,
            key: l,
            start: a,
            size: s,
            end: a + s,
            lane: 0
          },
          d,
          this
        ) : (
          // Default: adjust scrollTop only when the resize is an above-
          // viewport item AND we're not actively scrolling backward.
          // Adjusting during backward scroll fights the user's scroll
          // direction and produces the "items jump while scrolling up"
          // jank reported across many issues. Users who want the old
          // behavior can pass shouldAdjustScrollPositionOnItemSizeChange.
          a < this.getScrollOffset() + this.scrollAdjustments && this.scrollDirection !== "backward"
        ));
        (this.pendingMin === null || n < this.pendingMin) && (this.pendingMin = n), this.itemSizeCache.set(l, r), this.itemSizeCacheVersion++, f ? this.applyScrollAdjustment(this.getTotalSize() - m) : v && this.applyScrollAdjustment(d), this.notify(!1);
      }
    }, this.getVirtualItems = Pr(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length === 0)
        return;
      const o = this._flatMeasurements, i = this.options.lanes === 1 && o != null, s = zg(
        0,
        r.length - 1,
        i ? (a) => o[a * 2] : (a) => Nf(r[a]).start,
        n
      );
      return Nf(r[s]);
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const n = this.scrollElement.document.documentElement;
        return this.options.horizontal ? n.scrollWidth - this.scrollElement.innerWidth : n.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getVirtualDistanceFromEnd = () => Math.max(
      this.getTotalSize() - this.getSize() - this.getScrollOffset(),
      0
    ), this.getDistanceFromEnd = () => Math.max(this.getMaxScrollOffset() - this.getScrollOffset(), 0), this.isAtEnd = (n = this.options.scrollEndThreshold) => this.getDistanceFromEnd() <= n, this.getOffsetForAlignment = (n, r, o = 0) => {
      if (!this.scrollElement) return 0;
      const i = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (r = n >= s + i ? "end" : "start"), r === "center" ? n += (o - i) / 2 : r === "end" && (n -= i);
      const a = this.getMaxScrollOffset();
      return Math.max(Math.min(a, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getSize(), i = this.getScrollOffset(), s = this.measurementsCache[n];
      if (!s) return;
      if (r === "auto")
        if (s.end >= i + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (s.start <= i + this.options.scrollPaddingStart)
          r = "start";
        else
          return [i, r];
      if (r === "end" && n === this.options.count - 1)
        return [this.getMaxScrollOffset(), r];
      const a = r === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(a, r, s.size),
        r
      ];
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o = "auto" } = {}) => {
      const i = this.getOffsetForAlignment(n, r), s = this.now();
      this.scrollState = {
        index: null,
        align: r,
        behavior: o,
        startedAt: s,
        lastTargetOffset: i,
        stableFrames: 0
      }, this._scrollToOffset(i, { adjustments: void 0, behavior: o }), this.scheduleScrollReconcile();
    }, this.scrollToIndex = (n, {
      align: r = "auto",
      behavior: o = "auto"
    } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const i = this.getOffsetForIndex(n, r);
      if (!i)
        return;
      const [s, a] = i, l = this.now();
      this.scrollState = {
        index: n,
        align: a,
        behavior: o,
        startedAt: l,
        lastTargetOffset: s,
        stableFrames: 0
      }, this._scrollToOffset(s, { adjustments: void 0, behavior: o }), this.scheduleScrollReconcile();
    }, this.scrollBy = (n, { behavior: r = "auto" } = {}) => {
      const o = this.getScrollOffset() + n, i = this.now();
      this.scrollState = {
        index: null,
        align: "start",
        behavior: r,
        startedAt: i,
        lastTargetOffset: o,
        stableFrames: 0
      }, this._scrollToOffset(o, { adjustments: void 0, behavior: r }), this.scheduleScrollReconcile();
    }, this.scrollToEnd = ({ behavior: n = "auto" } = {}) => {
      if (this.options.count > 0) {
        this.scrollToIndex(this.options.count - 1, {
          align: "end",
          behavior: n
        });
        return;
      }
      this.scrollToOffset(Math.max(this.getTotalSize() - this.getSize(), 0), {
        behavior: n
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      if (r.length === 0)
        o = this.options.paddingStart;
      else if (this.options.lanes === 1) {
        const i = r.length - 1, s = this._flatMeasurements;
        s != null ? o = s[i * 2] + s[i * 2 + 1] : o = ((n = r[i]) == null ? void 0 : n.end) ?? 0;
      } else {
        const i = Array(this.options.lanes).fill(null);
        let s = r.length - 1;
        for (; s >= 0 && i.some((a) => a === null); ) {
          const a = r[s];
          i[a.lane] === null && (i[a.lane] = a.end), s--;
        }
        o = Math.max(...i.filter((a) => a !== null));
      }
      return Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this.takeSnapshot = () => {
      const n = [];
      if (this.itemSizeCache.size === 0) return n;
      const r = this.getMeasurements();
      for (const o of r)
        o && this.itemSizeCache.has(o.key) && n.push({
          index: o.index,
          key: o.key,
          start: o.start,
          size: o.size,
          end: o.end,
          lane: o.lane
        });
      return n;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this._intendedScrollOffset = n + (r ?? 0), this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.pendingMin = null, this.itemSizeCache.clear(), this.laneAssignments.clear(), this.itemSizeCacheVersion++, this.notify(!1);
    }, this.setOptions(t);
  }
  applyScrollAdjustment(t, n) {
    t !== 0 && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", t), _f() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded) ? this._iosDeferredAdjustment += t : this._scrollToOffset(this.getScrollOffset(), {
      adjustments: this.scrollAdjustments += t,
      behavior: n
    }));
  }
  scheduleScrollReconcile() {
    if (!this.targetWindow) {
      this.scrollState = null;
      return;
    }
    this.rafId == null && (this.rafId = this.targetWindow.requestAnimationFrame(() => {
      this.rafId = null, this.reconcileScroll();
    }));
  }
  reconcileScroll() {
    if (!this.scrollState || !this.scrollElement) return;
    if (this.now() - this.scrollState.startedAt > 5e3) {
      this.scrollState = null;
      return;
    }
    const r = this.scrollState.index != null ? this.getOffsetForIndex(this.scrollState.index, this.scrollState.align) : void 0, o = r ? r[0] : this.scrollState.lastTargetOffset, i = 1, s = o !== this.scrollState.lastTargetOffset;
    if (!s && Af(o, this.getScrollOffset())) {
      if (this.scrollState.stableFrames++, this.scrollState.stableFrames >= i) {
        this.getScrollOffset() !== o && this._scrollToOffset(o, {
          adjustments: void 0,
          behavior: "auto"
        }), this.scrollState = null;
        return;
      }
    } else if (this.scrollState.stableFrames = 0, s) {
      const a = this.getSize() || 600, l = Math.abs(o - this.getScrollOffset()), c = this.scrollState.behavior === "smooth" && l > a;
      this.scrollState.lastTargetOffset = o, c || (this.scrollState.behavior = "auto"), this._scrollToOffset(o, {
        adjustments: void 0,
        behavior: c ? "smooth" : "auto"
      });
    }
    this.scheduleScrollReconcile();
  }
}
const zg = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function jP({
  measurements: e,
  outerSize: t,
  scrollOffset: n,
  lanes: r,
  flat: o
}) {
  const i = e.length - 1, s = o ? (u) => o[u * 2] : (u) => e[u].start, a = o ? (u) => o[u * 2] + o[u * 2 + 1] : (u) => e[u].end;
  if (e.length <= r)
    return {
      startIndex: 0,
      endIndex: i
    };
  let l = zg(0, i, s, n), c = l;
  if (r === 1)
    for (; c < i && a(c) < n + t; )
      c++;
  else if (r > 1) {
    const u = Array(r).fill(0);
    for (; c < i && u.some((f) => f < n + t); ) {
      const f = e[c];
      u[f.lane] = f.end, c++;
    }
    const d = Array(r).fill(n + t);
    for (; l >= 0 && d.some((f) => f >= n); ) {
      const f = e[l];
      d[f.lane] = f.start, l--;
    }
    l = Math.max(0, l - l % r), c = Math.min(i, c + (r - 1 - c % r));
  }
  return { startIndex: l, endIndex: c };
}
const If = typeof document < "u" ? p.useLayoutEffect : p.useEffect;
function HP({
  useFlushSync: e = !0,
  ...t
}) {
  const n = p.useReducer((i) => i + 1, 0)[1], r = {
    ...t,
    onChange: (i, s) => {
      var a;
      e && s ? Zc(n) : n(), (a = t.onChange) == null || a.call(t, i, s);
    }
  }, [o] = p.useState(
    () => new zP(r)
  );
  return o.setOptions(r), If(() => o._didMount(), []), If(() => o._willUpdate()), o;
}
function UP(e) {
  return HP({
    observeElementRect: IP,
    observeElementOffset: FP,
    scrollToFn: WP,
    ...e
  });
}
function YP({
  column: e,
  columns: t,
  id: n,
  children: r,
  state: o,
  hooks: i,
  aditionalClasses: s,
  topPosition: a,
  leftSection: l,
  rightSection: c,
  infoRow: u,
  showInfoRow: d,
  cfg: f,
  disableResize: m,
  hasActiveFilter: v
}) {
  const g = (x) => {
    if (m)
      return;
    const C = x.target.parentElement.getBoundingClientRect().x;
    x.preventDefault();
    const E = (T) => {
      const P = T.x - C + 6;
      i.changeColumnSize({ key: e.key, width: P });
    }, S = () => {
      document.removeEventListener("mouseup", S), document.removeEventListener("mousemove", E);
    };
    document.addEventListener("mouseup", S), document.addEventListener("mousemove", E);
  }, y = !!e.isLocked, b = {
    position: "sticky",
    top: `${a}px`,
    zIndex: 20
  };
  return y && (b.left = `${f.stickyOffsets[e.key]}px`, b.zIndex = 30), /* @__PURE__ */ h("th", { className: "relative", style: b, "attr-column-key": e.key, children: /* @__PURE__ */ L("div", { className: ze(s, v && "!bg-blue-100 dark:!bg-blue-900"), children: [
    /* @__PURE__ */ L("div", { className: "flex flex-col grow", children: [
      /* @__PURE__ */ h("div", { className: "flex grow", children: /* @__PURE__ */ L("div", { className: "overlay flex flex-row grow px-2 py-1 w-0 items-center justify-center", children: [
        l && /* @__PURE__ */ h("div", { children: l }),
        /* @__PURE__ */ h(
          Wg,
          {
            text: e.name,
            className: "overflow-hidden text-ellipsis whitespace-nowrap text-xs font-medium min-w-0"
          }
        ),
        c && /* @__PURE__ */ h("div", { children: c }),
        /* @__PURE__ */ h("div", { className: "th-controls", children: r })
      ] }) }),
      d && /* @__PURE__ */ h(
        "div",
        {
          className: ze(
            "bg-neutral-container border-y border-table-borders-header",
            " px-1 h-5 flex items-center whitespace-nowrap bg-table-bg-fixed font-bold text-neutral-text-secondary",
            e.dataType === "number" && "is-numeric"
          ),
          children: /* @__PURE__ */ h(gr, { column: e, record: {}, state: {}, value: u })
        }
      )
    ] }),
    !m && /* @__PURE__ */ h(
      "div",
      {
        className: "hover-handle",
        title: "Double-click to fit all columns",
        onMouseDown: (x) => g(x),
        onDoubleClick: (x) => i.autoSizeAllColumns(x.currentTarget)
      }
    )
  ] }) }, `${n}-column`);
}
function Vl(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Qs(e) {
  const t = e + "CollectionProvider", [n, r] = Bt(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: y, children: b } = g, x = G.useRef(null), w = G.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ h(o, { scope: y, itemMap: w, collectionRef: x, children: b });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", l = /* @__PURE__ */ er(a), c = G.forwardRef(
    (g, y) => {
      const { scope: b, children: x } = g, w = i(a, b), C = ye(y, w.collectionRef);
      return /* @__PURE__ */ h(l, { ref: C, children: x });
    }
  );
  c.displayName = a;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ er(u), m = G.forwardRef(
    (g, y) => {
      const { scope: b, children: x, ...w } = g, C = G.useRef(null), E = ye(y, C), S = i(u, b);
      return G.useEffect(() => (S.itemMap.set(C, { ref: C, ...w }), () => void S.itemMap.delete(C))), /* @__PURE__ */ h(f, { [d]: "", ref: E, children: x });
    }
  );
  m.displayName = u;
  function v(g) {
    const y = i(e + "CollectionConsumer", g);
    return G.useCallback(() => {
      const x = y.collectionRef.current;
      if (!x) return [];
      const w = Array.from(x.querySelectorAll(`[${d}]`));
      return Array.from(y.itemMap.values()).sort(
        (S, T) => w.indexOf(S.ref.current) - w.indexOf(T.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: m },
    v,
    r
  ];
}
var GP = p.createContext(void 0);
function Su(e) {
  const t = p.useContext(GP);
  return e || t || "ltr";
}
function jg(e) {
  const t = p.useRef({ value: e, previous: e });
  return p.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var KP = [" ", "Enter", "ArrowUp", "ArrowDown"], XP = [" ", "Enter"], or = "Select", [Js, ea, qP] = Qs(or), [oo] = Bt(or, [
  qP,
  $n
]), ta = $n(), [ZP, Fn] = oo(or), [QP, JP] = oo(or), Hg = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: s,
    defaultValue: a,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: m,
    form: v
  } = e, g = ta(t), [y, b] = p.useState(null), [x, w] = p.useState(null), [C, E] = p.useState(!1), S = Su(c), [T, P] = _n({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: or
  }), [D, k] = _n({
    prop: s,
    defaultProp: a,
    onChange: l,
    caller: or
  }), R = p.useRef(null), A = y ? v || !!y.closest("form") : !0, [F, I] = p.useState(/* @__PURE__ */ new Set()), B = Array.from(F).map((V) => V.props.value).join(";");
  return /* @__PURE__ */ h(bu, { ...g, children: /* @__PURE__ */ L(
    ZP,
    {
      required: m,
      scope: t,
      trigger: y,
      onTriggerChange: b,
      valueNode: x,
      onValueNodeChange: w,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: E,
      contentId: bn(),
      value: D,
      onValueChange: k,
      open: T,
      onOpenChange: P,
      dir: S,
      triggerPointerDownPosRef: R,
      disabled: f,
      children: [
        /* @__PURE__ */ h(Js.Provider, { scope: t, children: /* @__PURE__ */ h(
          QP,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: p.useCallback((V) => {
              I((N) => new Set(N).add(V));
            }, []),
            onNativeOptionRemove: p.useCallback((V) => {
              I((N) => {
                const M = new Set(N);
                return M.delete(V), M;
              });
            }, []),
            children: n
          }
        ) }),
        A ? /* @__PURE__ */ L(
          uv,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: D,
            onChange: (V) => k(V.target.value),
            disabled: f,
            form: v,
            children: [
              D === void 0 ? /* @__PURE__ */ h("option", { value: "" }) : null,
              Array.from(F)
            ]
          },
          B
        ) : null
      ]
    }
  ) });
};
Hg.displayName = or;
var Ug = "SelectTrigger", Tu = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = ta(n), s = Fn(Ug, n), a = s.disabled || r, l = ye(t, s.onTriggerChange), c = ea(n), u = p.useRef("touch"), [d, f, m] = fv((g) => {
      const y = c().filter((w) => !w.disabled), b = y.find((w) => w.value === s.value), x = hv(y, g, b);
      x !== void 0 && s.onValueChange(x.value);
    }), v = (g) => {
      a || (s.onOpenChange(!0), m()), g && (s.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ h(ai, { asChild: !0, ...i, children: /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": dv(s.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: j(o.onClick, (g) => {
          g.currentTarget.focus(), u.current !== "mouse" && v(g);
        }),
        onPointerDown: j(o.onPointerDown, (g) => {
          u.current = g.pointerType;
          const y = g.target;
          y.hasPointerCapture(g.pointerId) && y.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (v(g), g.preventDefault());
        }),
        onKeyDown: j(o.onKeyDown, (g) => {
          const y = d.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && f(g.key), !(y && g.key === " ") && KP.includes(g.key) && (v(), g.preventDefault());
        })
      }
    ) });
  }
);
Tu.displayName = Ug;
var Yg = "SelectValue", Eu = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: s = "", ...a } = e, l = Fn(Yg, n), { onValueNodeHasChildrenChange: c } = l, u = i !== void 0, d = ye(t, l.onValueNodeChange);
    return it(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ h(
      le.span,
      {
        ...a,
        ref: d,
        style: { pointerEvents: "none" },
        children: dv(l.value) ? /* @__PURE__ */ h(ke, { children: s }) : i
      }
    );
  }
);
Eu.displayName = Yg;
var e1 = "SelectIcon", Gg = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ h(le.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
Gg.displayName = e1;
var t1 = "SelectPortal", Kg = (e) => /* @__PURE__ */ h(to, { asChild: !0, ...e });
Kg.displayName = t1;
var ir = "SelectContent", Pu = p.forwardRef(
  (e, t) => {
    const n = Fn(ir, e.__scopeSelect), [r, o] = p.useState();
    if (it(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? ti.createPortal(
        /* @__PURE__ */ h(Xg, { scope: e.__scopeSelect, children: /* @__PURE__ */ h(Js.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ h("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ h(qg, { ...e, ref: t });
  }
);
Pu.displayName = ir;
var Ut = 10, [Xg, Vn] = oo(ir), n1 = "SelectContentImpl", r1 = /* @__PURE__ */ er("SelectContent.RemoveScroll"), qg = p.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: m,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: y,
      //
      ...b
    } = e, x = Fn(ir, n), [w, C] = p.useState(null), [E, S] = p.useState(null), T = ye(t, (U) => C(U)), [P, D] = p.useState(null), [k, R] = p.useState(
      null
    ), A = ea(n), [F, I] = p.useState(!1), B = p.useRef(!1);
    p.useEffect(() => {
      if (w) return ii(w);
    }, [w]), Fs();
    const V = p.useCallback(
      (U) => {
        const [oe, ...q] = A().map((Ce) => Ce.ref.current), [ie] = q.slice(-1), be = document.activeElement;
        for (const Ce of U)
          if (Ce === be || (Ce == null || Ce.scrollIntoView({ block: "nearest" }), Ce === oe && E && (E.scrollTop = 0), Ce === ie && E && (E.scrollTop = E.scrollHeight), Ce == null || Ce.focus(), document.activeElement !== be)) return;
      },
      [A, E]
    ), N = p.useCallback(
      () => V([P, w]),
      [V, P, w]
    );
    p.useEffect(() => {
      F && N();
    }, [F, N]);
    const { onOpenChange: M, triggerPointerDownPosRef: _ } = x;
    p.useEffect(() => {
      if (w) {
        let U = { x: 0, y: 0 };
        const oe = (ie) => {
          var be, Ce;
          U = {
            x: Math.abs(Math.round(ie.pageX) - (((be = _.current) == null ? void 0 : be.x) ?? 0)),
            y: Math.abs(Math.round(ie.pageY) - (((Ce = _.current) == null ? void 0 : Ce.y) ?? 0))
          };
        }, q = (ie) => {
          U.x <= 10 && U.y <= 10 ? ie.preventDefault() : w.contains(ie.target) || M(!1), document.removeEventListener("pointermove", oe), _.current = null;
        };
        return _.current !== null && (document.addEventListener("pointermove", oe), document.addEventListener("pointerup", q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", oe), document.removeEventListener("pointerup", q, { capture: !0 });
        };
      }
    }, [w, M, _]), p.useEffect(() => {
      const U = () => M(!1);
      return window.addEventListener("blur", U), window.addEventListener("resize", U), () => {
        window.removeEventListener("blur", U), window.removeEventListener("resize", U);
      };
    }, [M]);
    const [W, te] = fv((U) => {
      const oe = A().filter((be) => !be.disabled), q = oe.find((be) => be.ref.current === document.activeElement), ie = hv(oe, U, q);
      ie && setTimeout(() => ie.ref.current.focus());
    }), O = p.useCallback(
      (U, oe, q) => {
        const ie = !B.current && !q;
        (x.value !== void 0 && x.value === oe || ie) && (D(U), ie && (B.current = !0));
      },
      [x.value]
    ), z = p.useCallback(() => w == null ? void 0 : w.focus(), [w]), Q = p.useCallback(
      (U, oe, q) => {
        const ie = !B.current && !q;
        (x.value !== void 0 && x.value === oe || ie) && R(U);
      },
      [x.value]
    ), K = r === "popper" ? Bl : Zg, se = K === Bl ? {
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: m,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ h(
      Xg,
      {
        scope: n,
        content: w,
        viewport: E,
        onViewportChange: S,
        itemRefCallback: O,
        selectedItem: P,
        onItemLeave: z,
        itemTextRefCallback: Q,
        focusSelectedItem: N,
        selectedItemText: k,
        position: r,
        isPositioned: F,
        searchRef: W,
        children: /* @__PURE__ */ h(oi, { as: r1, allowPinchZoom: !0, children: /* @__PURE__ */ h(
          ri,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (U) => {
              U.preventDefault();
            },
            onUnmountAutoFocus: j(o, (U) => {
              var oe;
              (oe = x.trigger) == null || oe.focus({ preventScroll: !0 }), U.preventDefault();
            }),
            children: /* @__PURE__ */ h(
              pr,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (U) => U.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ h(
                  K,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (U) => U.preventDefault(),
                    ...b,
                    ...se,
                    onPlaced: () => I(!0),
                    ref: T,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: j(b.onKeyDown, (U) => {
                      const oe = U.ctrlKey || U.altKey || U.metaKey;
                      if (U.key === "Tab" && U.preventDefault(), !oe && U.key.length === 1 && te(U.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(U.key)) {
                        let ie = A().filter((be) => !be.disabled).map((be) => be.ref.current);
                        if (["ArrowUp", "End"].includes(U.key) && (ie = ie.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(U.key)) {
                          const be = U.target, Ce = ie.indexOf(be);
                          ie = ie.slice(Ce + 1);
                        }
                        setTimeout(() => V(ie)), U.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
qg.displayName = n1;
var o1 = "SelectItemAlignedPosition", Zg = p.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = Fn(ir, n), s = Vn(ir, n), [a, l] = p.useState(null), [c, u] = p.useState(null), d = ye(t, (T) => u(T)), f = ea(n), m = p.useRef(!1), v = p.useRef(!0), { viewport: g, selectedItem: y, selectedItemText: b, focusSelectedItem: x } = s, w = p.useCallback(() => {
    if (i.trigger && i.valueNode && a && c && g && y && b) {
      const T = i.trigger.getBoundingClientRect(), P = c.getBoundingClientRect(), D = i.valueNode.getBoundingClientRect(), k = b.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const be = k.left - P.left, Ce = D.left - be, re = T.left - Ce, st = T.width + re, Tt = Math.max(st, P.width), _t = window.innerWidth - Ut, en = Vl(Ce, [
          Ut,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Ut, _t - Tt)
        ]);
        a.style.minWidth = st + "px", a.style.left = en + "px";
      } else {
        const be = P.right - k.right, Ce = window.innerWidth - D.right - be, re = window.innerWidth - T.right - Ce, st = T.width + re, Tt = Math.max(st, P.width), _t = window.innerWidth - Ut, en = Vl(Ce, [
          Ut,
          Math.max(Ut, _t - Tt)
        ]);
        a.style.minWidth = st + "px", a.style.right = en + "px";
      }
      const R = f(), A = window.innerHeight - Ut * 2, F = g.scrollHeight, I = window.getComputedStyle(c), B = parseInt(I.borderTopWidth, 10), V = parseInt(I.paddingTop, 10), N = parseInt(I.borderBottomWidth, 10), M = parseInt(I.paddingBottom, 10), _ = B + V + F + M + N, W = Math.min(y.offsetHeight * 5, _), te = window.getComputedStyle(g), O = parseInt(te.paddingTop, 10), z = parseInt(te.paddingBottom, 10), Q = T.top + T.height / 2 - Ut, K = A - Q, se = y.offsetHeight / 2, U = y.offsetTop + se, oe = B + V + U, q = _ - oe;
      if (oe <= Q) {
        const be = R.length > 0 && y === R[R.length - 1].ref.current;
        a.style.bottom = "0px";
        const Ce = c.clientHeight - g.offsetTop - g.offsetHeight, re = Math.max(
          K,
          se + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (be ? z : 0) + Ce + N
        ), st = oe + re;
        a.style.height = st + "px";
      } else {
        const be = R.length > 0 && y === R[0].ref.current;
        a.style.top = "0px";
        const re = Math.max(
          Q,
          B + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (be ? O : 0) + se
        ) + q;
        a.style.height = re + "px", g.scrollTop = oe - Q + g.offsetTop;
      }
      a.style.margin = `${Ut}px 0`, a.style.minHeight = W + "px", a.style.maxHeight = A + "px", r == null || r(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    f,
    i.trigger,
    i.valueNode,
    a,
    c,
    g,
    y,
    b,
    i.dir,
    r
  ]);
  it(() => w(), [w]);
  const [C, E] = p.useState();
  it(() => {
    c && E(window.getComputedStyle(c).zIndex);
  }, [c]);
  const S = p.useCallback(
    (T) => {
      T && v.current === !0 && (w(), x == null || x(), v.current = !1);
    },
    [w, x]
  );
  return /* @__PURE__ */ h(
    s1,
    {
      scope: n,
      contentWrapper: a,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ h(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ h(
            le.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Zg.displayName = o1;
var i1 = "SelectPopperPosition", Bl = p.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Ut,
    ...i
  } = e, s = ta(n);
  return /* @__PURE__ */ h(
    Us,
    {
      ...s,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Bl.displayName = i1;
var [s1, ku] = oo(ir, {}), Wl = "SelectViewport", Qg = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = Vn(Wl, n), s = ku(Wl, n), a = ye(t, i.onViewportChange), l = p.useRef(0);
    return /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ h(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ h(Js.Slot, { scope: n, children: /* @__PURE__ */ h(
        le.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: j(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = s;
            if (f != null && f.current && d) {
              const m = Math.abs(l.current - u.scrollTop);
              if (m > 0) {
                const v = window.innerHeight - Ut * 2, g = parseFloat(d.style.minHeight), y = parseFloat(d.style.height), b = Math.max(g, y);
                if (b < v) {
                  const x = b + m, w = Math.min(v, x), C = x - w;
                  d.style.height = w + "px", d.style.bottom === "0px" && (u.scrollTop = C > 0 ? C : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Qg.displayName = Wl;
var Jg = "SelectGroup", [a1, l1] = oo(Jg), ev = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = bn();
    return /* @__PURE__ */ h(a1, { scope: n, id: o, children: /* @__PURE__ */ h(le.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
ev.displayName = Jg;
var tv = "SelectLabel", nv = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = l1(tv, n);
    return /* @__PURE__ */ h(le.div, { id: o.id, ...r, ref: t });
  }
);
nv.displayName = tv;
var gs = "SelectItem", [c1, rv] = oo(gs), Du = p.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...s
    } = e, a = Fn(gs, n), l = Vn(gs, n), c = a.value === r, [u, d] = p.useState(i ?? ""), [f, m] = p.useState(!1), v = ye(
      t,
      (x) => {
        var w;
        return (w = l.itemRefCallback) == null ? void 0 : w.call(l, x, r, o);
      }
    ), g = bn(), y = p.useRef("touch"), b = () => {
      o || (a.onValueChange(r), a.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ h(
      c1,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: g,
        isSelected: c,
        onItemTextChange: p.useCallback((x) => {
          d((w) => w || ((x == null ? void 0 : x.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ h(
          Js.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ h(
              le.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: v,
                onFocus: j(s.onFocus, () => m(!0)),
                onBlur: j(s.onBlur, () => m(!1)),
                onClick: j(s.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: j(s.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: j(s.onPointerDown, (x) => {
                  y.current = x.pointerType;
                }),
                onPointerMove: j(s.onPointerMove, (x) => {
                  var w;
                  y.current = x.pointerType, o ? (w = l.onItemLeave) == null || w.call(l) : y.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: j(s.onPointerLeave, (x) => {
                  var w;
                  x.currentTarget === document.activeElement && ((w = l.onItemLeave) == null || w.call(l));
                }),
                onKeyDown: j(s.onKeyDown, (x) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && x.key === " " || (XP.includes(x.key) && b(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Du.displayName = gs;
var To = "SelectItemText", ov = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, s = Fn(To, n), a = Vn(To, n), l = rv(To, n), c = JP(To, n), [u, d] = p.useState(null), f = ye(
      t,
      (b) => d(b),
      l.onItemTextChange,
      (b) => {
        var x;
        return (x = a.itemTextRefCallback) == null ? void 0 : x.call(a, b, l.value, l.disabled);
      }
    ), m = u == null ? void 0 : u.textContent, v = p.useMemo(
      () => /* @__PURE__ */ h("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: y } = c;
    return it(() => (g(v), () => y(v)), [g, y, v]), /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ h(le.span, { id: l.textId, ...i, ref: f }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? ti.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
ov.displayName = To;
var iv = "SelectItemIndicator", u1 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return rv(iv, n).isSelected ? /* @__PURE__ */ h(le.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
u1.displayName = iv;
var zl = "SelectScrollUpButton", sv = p.forwardRef((e, t) => {
  const n = Vn(zl, e.__scopeSelect), r = ku(zl, e.__scopeSelect), [o, i] = p.useState(!1), s = ye(t, r.onScrollButtonChange);
  return it(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ h(
    lv,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
sv.displayName = zl;
var jl = "SelectScrollDownButton", av = p.forwardRef((e, t) => {
  const n = Vn(jl, e.__scopeSelect), r = ku(jl, e.__scopeSelect), [o, i] = p.useState(!1), s = ye(t, r.onScrollButtonChange);
  return it(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        i(u);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ h(
    lv,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
av.displayName = jl;
var lv = p.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = Vn("SelectScrollButton", n), s = p.useRef(null), a = ea(n), l = p.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return p.useEffect(() => () => l(), [l]), it(() => {
    var u;
    const c = a().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ h(
    le.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: j(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: j(o.onPointerMove, () => {
        var c;
        (c = i.onItemLeave) == null || c.call(i), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: j(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), d1 = "SelectSeparator", cv = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ h(le.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
cv.displayName = d1;
var Hl = "SelectArrow", f1 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = ta(n), i = Fn(Hl, n), s = Vn(Hl, n);
    return i.open && s.position === "popper" ? /* @__PURE__ */ h(Ys, { ...o, ...r, ref: t }) : null;
  }
);
f1.displayName = Hl;
var h1 = "SelectBubbleInput", uv = p.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = p.useRef(null), i = ye(r, o), s = jg(t);
    return p.useEffect(() => {
      const a = o.current;
      if (!a) return;
      const l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== t && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(a, t), a.dispatchEvent(d);
      }
    }, [s, t]), /* @__PURE__ */ h(
      le.select,
      {
        ...n,
        style: { ...Ng, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
uv.displayName = h1;
function dv(e) {
  return e === "" || e === void 0;
}
function fv(e) {
  const t = Qe(e), n = p.useRef(""), r = p.useRef(0), o = p.useCallback(
    (s) => {
      const a = n.current + s;
      t(a), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(a);
    },
    [t]
  ), i = p.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return p.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function hv(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = m1(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function m1(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var p1 = Hg, mv = Tu, g1 = Eu, v1 = Gg, y1 = Kg, pv = Pu, b1 = Qg, w1 = ev, gv = nv, vv = Du, x1 = ov, yv = sv, bv = av, wv = cv;
const na = p1, xv = w1, Ru = g1, ra = p.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(
  mv,
  {
    ref: r,
    className: X(
      "group input flex w-full items-center justify-between rounded-md border border-neutral-borders ring-offset-background data-[placeholder]:text-input-text-secondary focus:outline-none focus:ring-2 focus:ring-input-active focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 text-left",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ h(v1, { asChild: !0, children: /* @__PURE__ */ h(cp, { className: "h-4 w-4 text-input-active group-data-[state=open]:rotate-180 shrink-0" }) })
    ]
  }
));
ra.displayName = mv.displayName;
const Cv = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yv,
  {
    ref: n,
    className: X("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ h(qx, { className: "h-4 w-4" })
  }
));
Cv.displayName = yv.displayName;
const Sv = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  bv,
  {
    ref: n,
    className: X("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ h(cp, { className: "h-4 w-4" })
  }
));
Sv.displayName = bv.displayName;
const oa = p.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ h(y1, { children: /* @__PURE__ */ L(
  pv,
  {
    ref: o,
    align: "start",
    side: "bottom",
    className: X(
      "relative z-50 max-h-96 overflow-hidden rounded-md border bg-input-bg popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ h(Cv, { className: "text-input-active" }),
      /* @__PURE__ */ h(
        b1,
        {
          className: X(
            "p-0",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ h(Sv, { className: "text-input-active" })
    ]
  }
) }));
oa.displayName = pv.displayName;
const C1 = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(gv, { ref: n, className: X("py-1.5 px-2 text-sm font-semibold", e), ...t }));
C1.displayName = gv.displayName;
const ia = p.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ h(
  vv,
  {
    ref: r,
    className: X(
      "relative flex w-full cursor-default select-none border-b items-center control text-sm outline-none focus:bg-input-hover data-[state=checked]:bg-input-active data-[state=checked]:text-input-bg data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: /* @__PURE__ */ h(x1, { children: t })
  }
));
ia.displayName = vv.displayName;
const S1 = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(wv, { ref: n, className: X("-mx-1 my-1 h-px bg-muted", e), ...t }));
S1.displayName = wv.displayName;
function vs(e) {
  var i;
  const t = ae(null), n = typeof e.options == "function" ? e.options(e.record.key, e.column.key, e.record) : e.options, r = e.value ? (i = n.find((s) => s.key === e.value)) == null ? void 0 : i.label : "-", o = e.column.isLocked || !1;
  return me(() => (e.isEditing && t.current && t.current.click(), () => {
    var s;
    e.isEditing && ((s = e.stopEditing) == null || s.call(e));
  }), [e.isEditing]), e.isEditing ? /* @__PURE__ */ h("div", { className: "overflow-x-hidden text-ellipsis relative w-full flex", children: /* @__PURE__ */ L(
    na,
    {
      onValueChange: (s) => {
        e.onChange && e.onChange(s);
      },
      value: e.value || "",
      children: [
        /* @__PURE__ */ h(
          ra,
          {
            ref: t,
            className: ze(
              "text-xs min-h-0 h-4 w-full p-0 w-0 bg-transparent flex-1 rounded-none border-0 data-[state=open]:[&>svg]:text-red-500"
            ),
            children: /* @__PURE__ */ h(Ru, { placeholder: r })
          }
        ),
        /* @__PURE__ */ h(oa, { className: ze(o && "z-[100]"), children: /* @__PURE__ */ h(xv, { children: n.map((s) => /* @__PURE__ */ h(ia, { value: s.key, children: s.label }, s.key)) }) })
      ]
    }
  ) }) : /* @__PURE__ */ h(gr, { ...e, value: r });
}
function T1(e, t, n, r, o) {
  switch (!0) {
    case (!e && r === "error"):
      return "bg-red-200 dark:bg-red-900 !outline-red-500";
    case (!e && r === "warning"):
      return "bg-yellow-200 dark:bg-yellow-900 !outline-yellow-400";
    case (!e && r === "neutral" && !n):
      return "bg-gray-300 dark:bg-gray-800 !outline-gray-500";
    case (!e && r === "neutral" && n):
      return "bg-gray-400 dark:bg-gray-900 !outline-gray-600";
    case (!e && !t && n):
      return "bg-neutral-container";
    case (!e && !t && !n):
      return "bg-[#F2F2F2] dark:bg-[#312E2F]";
    case (!e && t):
      return "bg-violet-200 dark:bg-stone-700";
    case (e && t):
      return "bg-violet-200 dark:bg-stone-500";
    case (e && !t && n):
      return "bg-color-greys-100 dark:bg-color-greys-800";
    case (e && !t && !n):
      return "bg-table-bg-fixed";
    default:
      return "bg-table-bg-editable";
  }
}
function E1({
  rowIndex: e,
  columns: t,
  record: n,
  rowSize: r,
  state: o,
  visibleColumns: i,
  // onRowChange,
  onRowsCommit: s,
  onToggleEdit: a,
  onCellSelect: l,
  hooks: c,
  cellValidations: u,
  onDrag: d,
  editingCell: f,
  onChangeEditCellValue: m,
  selectedCells: v,
  dragBlock: g,
  cfg: y
}) {
  function b(S, T, P, D, k) {
    DP(o.editCellRef, D, k) || a(void 0);
    const R = S.currentTarget.getBoundingClientRect();
    d("start", R.x, R.y, R.width, R.height, {
      column: T.key,
      row: n.key,
      rowIndex: e
    });
  }
  function x(S, T, P, D, k) {
    const R = S.currentTarget.getBoundingClientRect();
    d("end", R.x, R.y, R.width, R.height, {
      column: T.key,
      row: n.key,
      rowIndex: e
    });
  }
  function w(S, T, P, D, k) {
    if (S.buttons === 1) {
      const R = S.currentTarget.getBoundingClientRect();
      d("drag", R.x, R.y, R.width, R.height, {
        column: T.key,
        row: n.key,
        rowIndex: e
      });
    }
  }
  function C(S, T, P, D, k) {
    T.readOnly || a({
      column: D,
      row: k,
      rowIndex: e,
      value: P[D]
    });
  }
  const E = (S, T) => {
    let P;
    (S.ctrlKey || S.metaKey) && (P = "ctrl"), l(
      {
        column: T,
        row: n.key,
        value: n[T],
        rowIndex: e
      },
      P
    );
  };
  return /* @__PURE__ */ h(
    "tr",
    {
      style: {
        height: `${r}px`
      },
      children: t.map((S, T) => {
        if (!y.disableColumnVirtualization) {
          if (i[T] >= 1)
            return /* @__PURE__ */ h("td", { colSpan: i[T] }, S.key);
          if (i[T] === 0)
            return;
        }
        const P = `${n.key}${S.key}`;
        if (S.groupColumn)
          return /* @__PURE__ */ h("td", { className: "td-group-path" }, P);
        const D = !!S.isLocked, k = D ? {
          position: "sticky",
          left: `${y.stickyOffsets[S.key]}px`,
          zIndex: 20
        } : {}, R = S._dfColIndex, A = (f == null ? void 0 : f.column) === S.key && (f == null ? void 0 : f.row) === n.key, F = n[S.key], I = v.some((q) => q.column === S.key && q.row === n.key), B = !!g && !S.split && !S.groupColumn && T >= g.minCol && T <= g.maxCol && e >= g.minRow && e <= g.maxRow, V = I || B, N = v.length > 0 && v.filter((q) => q.row === n.key).length === v.length, M = { ...S.componentProps || {} };
        M.nullable = S.nullable;
        let _ = T > 0 ? !!t[T - 1].readOnly && !S.split : !1, W = !1;
        T > 0 && t[T - 1].groupColumn && (_ = !0);
        const te = u[`${T - 1}-${e}`], O = u[`${T}-${e - 1}`];
        (te == null ? void 0 : te.type) === "disable" && (_ = !0), (O == null ? void 0 : O.type) === "disable" && (W = !0);
        const z = u[`${T}-${e}`];
        let Q = S.readOnly, K = !1;
        z && z.type === "disable" && (Q = !0, K = !0);
        let se = S.component, U = {};
        if (S.conditionalComponent) {
          const q = S.conditionalComponent(S.key, n);
          q && (se = q.component, U = q.props);
        }
        const oe = /* @__PURE__ */ h("div", { className: "flex w-full", children: /* @__PURE__ */ h(
          se,
          {
            cellRef: { column: R, row: e },
            record: n,
            column: S,
            value: A ? f.newValue : F,
            state: o,
            stopEditing: () => a(void 0),
            onChange: A ? (q) => m == null ? void 0 : m(q, se === vs) : void 0,
            ...M,
            ...U,
            isEditing: A
          }
        ) });
        return /* @__PURE__ */ L(
          "td",
          {
            className: ze(
              "overflow-hidden text-ellipsis whitespace-nowrap ",
              // Prevent native text selection while drag-selecting cells; otherwise
              // the browser highlights text and the drag breaks crossing the
              // sticky (fixed) <-> scrollable column boundary. Editing cells keep
              // normal text selection so the input works.
              !A && "select-none",
              S.split && "td-new-splitter bg-gradient-to-r from-neutral-container to-transparent",
              A && "is-editing",
              D ? "z-20 dark:text-white" : "relative",
              _ && "!border-l-table-borders-header",
              W && "!border-t-table-borders-header",
              Q ? "read-only" : "cursor-cell",
              K && (z == null ? void 0 : z.message) && "cursor-not-allowed",
              S.dataType === "number" && "is-numeric",
              !S.split && T1(
                !!Q,
                N,
                e % 2 === 0,
                z == null ? void 0 : z.type
              ),
              V && "outline outline-2 outline-blue-400 outline-offset-[-1px]",
              S.conditionalFormatter && S.conditionalFormatter(n.key, F, S.key, n, e)
            ),
            onMouseDown: (q) => !A && b(q, S, n, S.key, n.key),
            onMouseUp: (q) => !A && x(q, S, n, S.key, n.key),
            onMouseMove: (q) => w(q, S, n, S.key, n.key),
            onDoubleClick: (q) => !Q && C(q, S, n, S.key, n.key),
            onClick: (q) => {
              E(q, S.key), !Q && !A && se === vs && C(q, S, n, S.key, n.key);
            },
            style: k,
            "data-row-key": n.key,
            "data-col-key": S.key,
            children: [
              (z == null ? void 0 : z.type) === "note" && /* @__PURE__ */ h("div", { className: "absolute left-0 top-0 w-2 h-2 text-button-secondary-bg pointer-events-none", children: /* @__PURE__ */ h("svg", { viewBox: "0 0 1 1", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M0 0 L1 0 L0 1 Z" }) }) }),
              z != null && z.message ? /* @__PURE__ */ L(qs, { children: [
                /* @__PURE__ */ h(Zs, { asChild: !0, children: oe }),
                /* @__PURE__ */ h(ci, { children: /* @__PURE__ */ h("div", { className: "font-medium text-xs text-neutral-text-primary whitespace-pre-line text-left", children: z == null ? void 0 : z.message }) })
              ] }) : oe
            ]
          },
          P
        );
      })
    }
  );
}
function P1(e) {
  return e.children;
}
var Tv = Symbol.for("immer-nothing"), Lf = Symbol.for("immer-draftable"), Mt = Symbol.for("immer-state"), k1 = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function wt(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = k1[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var zo = Object.getPrototypeOf;
function Yr(e) {
  return !!e && !!e[Mt];
}
function sr(e) {
  var t;
  return e ? Ev(e) || Array.isArray(e) || !!e[Lf] || !!((t = e.constructor) != null && t[Lf]) || ui(e) || aa(e) : !1;
}
var D1 = Object.prototype.constructor.toString(), $f = /* @__PURE__ */ new WeakMap();
function Ev(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null || t === Object.prototype)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  if (n === Object)
    return !0;
  if (typeof n != "function")
    return !1;
  let r = $f.get(n);
  return r === void 0 && (r = Function.toString.call(n), $f.set(n, r)), r === D1;
}
function ys(e, t, n = !0) {
  sa(e) === 0 ? (n ? Reflect.ownKeys(e) : Object.keys(e)).forEach((o) => {
    t(o, e[o], e);
  }) : e.forEach((r, o) => t(o, r, e));
}
function sa(e) {
  const t = e[Mt];
  return t ? t.type_ : Array.isArray(e) ? 1 : ui(e) ? 2 : aa(e) ? 3 : 0;
}
function Ul(e, t) {
  return sa(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Pv(e, t, n) {
  const r = sa(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function R1(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function ui(e) {
  return e instanceof Map;
}
function aa(e) {
  return e instanceof Set;
}
function Un(e) {
  return e.copy_ || e.base_;
}
function Yl(e, t) {
  if (ui(e))
    return new Map(e);
  if (aa(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = Ev(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[Mt];
    let o = Reflect.ownKeys(r);
    for (let i = 0; i < o.length; i++) {
      const s = o[i], a = r[s];
      a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (r[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: a.enumerable,
        value: e[s]
      });
    }
    return Object.create(zo(e), r);
  } else {
    const r = zo(e);
    if (r !== null && n)
      return { ...e };
    const o = Object.create(r);
    return Object.assign(o, e);
  }
}
function Mu(e, t = !1) {
  return la(e) || Yr(e) || !sr(e) || (sa(e) > 1 && Object.defineProperties(e, {
    set: Ii,
    add: Ii,
    clear: Ii,
    delete: Ii
  }), Object.freeze(e), t && Object.values(e).forEach((n) => Mu(n, !0))), e;
}
function M1() {
  wt(2);
}
var Ii = {
  value: M1
};
function la(e) {
  return e === null || typeof e != "object" ? !0 : Object.isFrozen(e);
}
var N1 = {};
function ar(e) {
  const t = N1[e];
  return t || wt(0, e), t;
}
var jo;
function kv() {
  return jo;
}
function A1(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Ff(e, t) {
  t && (ar("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Gl(e) {
  Kl(e), e.drafts_.forEach(_1), e.drafts_ = null;
}
function Kl(e) {
  e === jo && (jo = e.parent_);
}
function Vf(e) {
  return jo = A1(jo, e);
}
function _1(e) {
  const t = e[Mt];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Bf(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Mt].modified_ && (Gl(t), wt(4)), sr(e) && (e = bs(t, e), t.parent_ || ws(t, e)), t.patches_ && ar("Patches").generateReplacementPatches_(
    n[Mt].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = bs(t, n, []), Gl(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Tv ? e : void 0;
}
function bs(e, t, n) {
  if (la(t))
    return t;
  const r = e.immer_.shouldUseStrictIteration(), o = t[Mt];
  if (!o)
    return ys(
      t,
      (i, s) => Wf(e, o, t, i, s, n),
      r
    ), t;
  if (o.scope_ !== e)
    return t;
  if (!o.modified_)
    return ws(e, o.base_, !0), o.base_;
  if (!o.finalized_) {
    o.finalized_ = !0, o.scope_.unfinalizedDrafts_--;
    const i = o.copy_;
    let s = i, a = !1;
    o.type_ === 3 && (s = new Set(i), i.clear(), a = !0), ys(
      s,
      (l, c) => Wf(
        e,
        o,
        i,
        l,
        c,
        n,
        a
      ),
      r
    ), ws(e, i, !1), n && e.patches_ && ar("Patches").generatePatches_(
      o,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return o.copy_;
}
function Wf(e, t, n, r, o, i, s) {
  if (o == null || typeof o != "object" && !s)
    return;
  const a = la(o);
  if (!(a && !s)) {
    if (process.env.NODE_ENV !== "production" && o === n && wt(5), Yr(o)) {
      const l = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
      !Ul(t.assigned_, r) ? i.concat(r) : void 0, c = bs(e, o, l);
      if (Pv(n, r, c), Yr(c))
        e.canAutoFreeze_ = !1;
      else
        return;
    } else s && n.add(o);
    if (sr(o) && !a) {
      if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[r] === o && a)
        return;
      bs(e, o), (!t || !t.scope_.parent_) && typeof r != "symbol" && (ui(n) ? n.has(r) : Object.prototype.propertyIsEnumerable.call(n, r)) && ws(e, o);
    }
  }
}
function ws(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Mu(t, n);
}
function O1(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : kv(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = Nu;
  n && (o = [r], i = Ho);
  const { revoke: s, proxy: a } = Proxy.revocable(o, i);
  return r.draft_ = a, r.revoke_ = s, a;
}
var Nu = {
  get(e, t) {
    if (t === Mt)
      return e;
    const n = Un(e);
    if (!Ul(n, t))
      return I1(e, n, t);
    const r = n[t];
    return e.finalized_ || !sr(r) ? r : r === Ba(e.base_, t) ? (Wa(e), e.copy_[t] = ql(r, e)) : r;
  },
  has(e, t) {
    return t in Un(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Un(e));
  },
  set(e, t, n) {
    const r = Dv(Un(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = Ba(Un(e), t), i = o == null ? void 0 : o[Mt];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (R1(n, o) && (n !== void 0 || Ul(e.base_, t)))
        return !0;
      Wa(e), Xl(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ba(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Wa(e), Xl(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = Un(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    wt(11);
  },
  getPrototypeOf(e) {
    return zo(e.base_);
  },
  setPrototypeOf() {
    wt(12);
  }
}, Ho = {};
ys(Nu, (e, t) => {
  Ho[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Ho.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && wt(13), Ho.set.call(this, e, t, void 0);
};
Ho.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && wt(14), Nu.set.call(this, e[0], t, n, e[0]);
};
function Ba(e, t) {
  const n = e[Mt];
  return (n ? Un(n) : e)[t];
}
function I1(e, t, n) {
  var o;
  const r = Dv(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function Dv(e, t) {
  if (!(t in e))
    return;
  let n = zo(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = zo(n);
  }
}
function Xl(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Xl(e.parent_));
}
function Wa(e) {
  e.copy_ || (e.copy_ = Yl(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var L1 = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const s = this;
        return function(l = i, ...c) {
          return s.produce(l, (u) => n.call(this, u, ...c));
        };
      }
      typeof n != "function" && wt(6), r !== void 0 && typeof r != "function" && wt(7);
      let o;
      if (sr(t)) {
        const i = Vf(this), s = ql(t, void 0);
        let a = !0;
        try {
          o = n(s), a = !1;
        } finally {
          a ? Gl(i) : Kl(i);
        }
        return Ff(i, r), Bf(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === Tv && (o = void 0), this.autoFreeze_ && Mu(o, !0), r) {
          const i = [], s = [];
          ar("Patches").generateReplacementPatches_(t, o, i, s), r(i, s);
        }
        return o;
      } else
        wt(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...a) => this.produceWithPatches(s, (l) => t(l, ...a));
      let r, o;
      return [this.produce(t, n, (s, a) => {
        r = s, o = a;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof (e == null ? void 0 : e.useStrictIteration) == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    sr(e) || wt(8), Yr(e) && (e = $1(e));
    const t = Vf(this), n = ql(e, void 0);
    return n[Mt].isManual_ = !0, Kl(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Mt];
    (!n || !n.isManual_) && wt(9);
    const { scope_: r } = n;
    return Ff(r, t), Bf(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = ar("Patches").applyPatches_;
    return Yr(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function ql(e, t) {
  const n = ui(e) ? ar("MapSet").proxyMap_(e, t) : aa(e) ? ar("MapSet").proxySet_(e, t) : O1(e, t);
  return (t ? t.scope_ : kv()).drafts_.push(n), n;
}
function $1(e) {
  return Yr(e) || wt(10, e), Rv(e);
}
function Rv(e) {
  if (!sr(e) || la(e))
    return e;
  const t = e[Mt];
  let n, r = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = Yl(e, t.scope_.immer_.useStrictShallowCopy_), r = t.scope_.immer_.shouldUseStrictIteration();
  } else
    n = Yl(e, !0);
  return ys(
    n,
    (o, i) => {
      Pv(n, o, Rv(i));
    },
    r
  ), t && (t.finalized_ = !1), n;
}
var F1 = new L1(), Dt = F1.produce, zf = function() {
}, Mv = typeof window < "u";
function V1(e, t) {
  var n = ae(!1), r = ae(), o = ae(e), i = Ie(function() {
    return n.current;
  }, []), s = Ie(function() {
    n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
      n.current = !0, o.current();
    }, t);
  }, [t]), a = Ie(function() {
    n.current = null, r.current && clearTimeout(r.current);
  }, []);
  return me(function() {
    o.current = e;
  }, [e]), me(function() {
    return s(), a;
  }, [t]), [i, a, s];
}
function B1(e, t, n) {
  n === void 0 && (n = []);
  var r = V1(e, t), o = r[0], i = r[1], s = r[2];
  return me(s, n), [o, i];
}
var jf = function(e, t, n) {
  if (!Mv)
    return [t, zf, zf];
  if (!e)
    throw new Error("useLocalStorage key may not be falsy");
  var r = JSON.parse, o = ae(function(u) {
    try {
      var d = n ? n.raw ? String : n.serializer : JSON.stringify, f = localStorage.getItem(u);
      return f !== null ? r(f) : (t && localStorage.setItem(u, d(t)), t);
    } catch {
      return t;
    }
  }), i = he(function() {
    return o.current(e);
  }), s = i[0], a = i[1];
  hr(function() {
    return a(o.current(e));
  }, [e]);
  var l = Ie(function(u) {
    try {
      var d = typeof u == "function" ? u(s) : u;
      if (typeof d > "u")
        return;
      var f = void 0;
      n || (f = JSON.stringify(d)), localStorage.setItem(e, f), a(r(f));
    } catch {
    }
  }, [e, a]), c = Ie(function() {
    try {
      localStorage.removeItem(e), a(void 0);
    } catch {
    }
  }, [e, a]);
  return [s, l, c];
}, Au = function(e, t, n) {
  if (!Mv)
    return [t, function() {
    }];
  var r = he(function() {
    try {
      var s = sessionStorage.getItem(e);
      return typeof s != "string" ? (sessionStorage.setItem(e, n ? String(t) : JSON.stringify(t)), t) : n ? s : JSON.parse(s || "null");
    } catch {
      return t;
    }
  }), o = r[0], i = r[1];
  return me(function() {
    try {
      var s = n ? String(o) : JSON.stringify(o);
      sessionStorage.setItem(e, s);
    } catch {
    }
  }), [o, i];
};
const W1 = 70, z1 = 1;
var j1 = /* @__PURE__ */ ((e) => (e.Move = "move", e.Escape = "escape", e.Enter = "enter", e))(j1 || {});
function dW(e = {}) {
  const [t, n] = he(e);
  function r(o, i) {
    n(
      Dt((s) => {
        s[o.name] = i;
      })
    );
  }
  return [t, r];
}
const H1 = (e, t) => {
  var r;
  const n = [];
  for (const o of e)
    if ((r = o.group) != null && r.length)
      for (let i = 1; i <= o.group.length; i++) {
        const s = o.group.slice(0, i);
        t && s[s.length - 1].uncollapsable || s[s.length - 1].label && n.push(s);
      }
  return n;
}, Hf = (e, t) => {
  const n = {}, r = H1(e, t);
  for (const o of r) {
    const i = o.map((s) => s.key).join("_");
    n[i] = !1;
  }
  return n;
}, Nv = (e, t) => {
  var o;
  if (!((o = e.group) != null && o.length)) return;
  const n = [...e.group], r = [n.shift()];
  for (; r.length <= e.group.length; ) {
    const i = r.map((s) => s.key).join("_");
    if (t.groupCollapsedStatus[i])
      return r;
    r.push(n.shift());
  }
}, U1 = (e, t) => !e || !t || e.length !== t.length ? !1 : e.every((n, r) => n.key === t[r].key), Y1 = (e, t, n) => {
  for (const r of t)
    if (r.group && r.group.length > e.length && e.every((o, i) => o.key === r.group[i].key)) {
      const o = r.group.slice(0, e.length + 1).map((i) => i.key).join("_");
      if (!n.groupCollapsedStatus[o])
        return !1;
    }
  return !0;
}, G1 = 6, K1 = (e) => {
  const t = {};
  return typeof document > "u" || !e || e.querySelectorAll("th[attr-column-key]").forEach((r) => {
    const o = r.getAttribute("attr-column-key"), i = r.querySelector('[class*="text-ellipsis"]') || r.querySelector("span");
    !o || !i || (t[o] = Math.max(0, Math.ceil(i.scrollWidth - i.clientWidth)));
  }), t;
}, Av = (e, t, n) => {
  var i;
  const r = ((i = e == null ? void 0 : e.name) == null ? void 0 : i.split(/[\s_]/).sort((s, a) => a.length - s.length)[0].length) || 0;
  let o = Math.max(12 + r * 12, t);
  return e.filterable && (o += 28), e.sortable && (o += 24), n !== void 0 && (o = Math.min(o, n)), o;
}, X1 = (e, t, n) => {
  const r = {};
  return e.forEach((o, i) => {
    if (!("split" in o)) {
      const s = n ? `column-${i}` : o.key;
      r[s] = Av(o, o.minWidth || t, o.maxWidth);
    }
  }), r;
};
function fW(e, t, n) {
  const r = {
    minColumnWidth: (n == null ? void 0 : n.minColumnWidth) || W1,
    usePositionalColumnSizing: (n == null ? void 0 : n.usePositionalColumnSizing) || !1,
    disableColumnVirtualization: (n == null ? void 0 : n.disableColumnVirtualization) || !1
  }, [o, i] = jf(
    `${e}-column-position-v2`,
    {}
  ), [s, a] = jf(`${e}-group-status`, {}), [l, c] = he({
    tableKey: e,
    columnPositions: o && Object.keys(o).length ? o : X1(t, r.minColumnWidth, r.usePositionalColumnSizing),
    // columnStickyOffset: {},
    editCellRef: null,
    lockedColumns: [],
    groupCollapsedStatus: s ?? Hf(t)
  });
  me(() => {
    const E = t.reduce(
      (S, T) => {
        const P = t.findIndex((k) => k.key === T.key), D = r.usePositionalColumnSizing ? `column-${P}` : T.key;
        return o && D in o ? S[D] = o[D] : S[D] = Av(T, T.minWidth || r.minColumnWidth, T.maxWidth), S;
      },
      {}
    );
    c({
      ...l,
      columnPositions: E
    });
  }, [t]);
  function u(E) {
    c((S) => {
      var k;
      const T = (k = t.find((R) => R.key === E.key)) == null ? void 0 : k.minWidth, P = r.usePositionalColumnSizing ? `column-${t.findIndex((R) => R.key === E.key)}` : E.key, D = {
        ...S.columnPositions,
        [P]: Math.max(E.width, T || r.minColumnWidth)
      };
      return i(D), {
        ...S,
        columnPositions: D
      };
    });
  }
  function d(E) {
    const S = (E == null ? void 0 : E.closest("table")) ?? null, T = K1(S);
    c((P) => {
      const D = { ...P.columnPositions };
      return t.forEach((k, R) => {
        if ("split" in k) return;
        const A = T[k.key];
        if (!A) return;
        const F = r.usePositionalColumnSizing ? `column-${R}` : k.key;
        let B = Math.max(P.columnPositions[F] || 0, k.minWidth || r.minColumnWidth) + A + G1;
        k.maxWidth !== void 0 && (B = Math.min(B, k.maxWidth)), D[F] = B;
      }), i(D), {
        ...P,
        columnPositions: D
      };
    });
  }
  function f(E, S) {
    let T = null;
    E !== null && S !== null && (T = { column: E, row: S }), c({
      ...l,
      editCellRef: T
    });
  }
  function m(E) {
    c(
      Dt(l, (S) => {
        E.forEach((T) => !S.lockedColumns.includes(T) && S.lockedColumns.push(T));
      })
    );
  }
  function v(E) {
    c(
      Dt(l, (S) => {
        S.lockedColumns = S.lockedColumns.filter((T) => !E.includes(T));
      })
    );
  }
  function g(E, S) {
    const T = E.map((k) => k.key).join("_"), P = S ?? (l.groupCollapsedStatus[T] || !1), D = {
      ...l,
      groupCollapsedStatus: {
        ...l.groupCollapsedStatus,
        [T]: !P
      }
    };
    c(D), a(D.groupCollapsedStatus);
  }
  const y = ve(() => {
    let E = 0;
    const S = {};
    return t.forEach((T, P) => {
      const D = !!Nv(T, l);
      if ((l.lockedColumns.includes(T.key) || T.isLocked) && !D) {
        const k = r.usePositionalColumnSizing ? `column-${P}` : T.key;
        S[T.key] = E, "split" in T ? E += 12 : E += Math.max(T.minWidth || r.minColumnWidth, l.columnPositions[k]);
      }
    }), S;
  }, [l.lockedColumns, l.columnPositions]), b = (E) => {
    const S = Hf(t, !0);
    Object.entries(S).forEach(([T]) => {
      S[T] = E;
    }), c({
      ...l,
      groupCollapsedStatus: S
    }), a(S);
  };
  function x() {
    return {
      ...r,
      stickyOffsets: y
    };
  }
  function w(E) {
    var T;
    const S = [];
    for (let P = 0; P < E.size; P++) {
      const D = E.object(P);
      for (const k of t) {
        if (!k.validate) continue;
        const R = Array.isArray(k.validate) ? (T = k.validate.map((A) => A(D[k.key], D))) == null ? void 0 : T.find((A) => A) : k.validate(D[k.key], D);
        R && S.push(R);
      }
    }
    return S.length ? S : void 0;
  }
  return [l, {
    validate: w,
    getDatatableConfig: x,
    expandAllGroups: () => b(!1),
    contractAllGroups: () => b(!0),
    onMouseDown: () => {
    },
    // noop
    onToggleEdit: f,
    changeColumnSize: u,
    autoSizeAllColumns: d,
    lockColumns: m,
    unlockColumns: v,
    // showColumns,
    // hideColumns,
    // reorderColumns,
    _setStateToBeRemoved: c,
    // changeColumnsStickyOffset,
    // hideGroups,
    // showGroups,
    toggleGroupCollapse: g
  }];
}
function q1({
  group: e,
  hooks: t,
  hidding: n = !0
}) {
  return /* @__PURE__ */ h(
    Ee,
    {
      variant: "ghost",
      size: "sm",
      className: "icon text-button-secondary-bg hover:bg-transparent align-middle shrink-0",
      onClick: () => t.toggleGroupCollapse(e),
      children: n ? /* @__PURE__ */ h(Zx, {}) : /* @__PURE__ */ h(Qx, {})
    }
  );
}
var ca = "Popover", [_v] = Bt(ca, [
  $n
]), di = $n(), [Z1, Bn] = _v(ca), Ov = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, a = di(t), l = p.useRef(null), [c, u] = p.useState(!1), [d, f] = _n({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: ca
  });
  return /* @__PURE__ */ h(bu, { ...a, children: /* @__PURE__ */ h(
    Z1,
    {
      scope: t,
      contentId: bn(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: p.useCallback(() => f((m) => !m), [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: p.useCallback(() => u(!0), []),
      onCustomAnchorRemove: p.useCallback(() => u(!1), []),
      modal: s,
      children: n
    }
  ) });
};
Ov.displayName = ca;
var Iv = "PopoverAnchor", io = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Bn(Iv, n), i = di(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = o;
    return p.useEffect(() => (s(), () => a()), [s, a]), /* @__PURE__ */ h(ai, { ...i, ...r, ref: t });
  }
);
io.displayName = Iv;
var Lv = "PopoverTrigger", $v = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Bn(Lv, n), i = di(n), s = ye(t, o.triggerRef), a = /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": zv(o.open),
        ...r,
        ref: s,
        onClick: j(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? a : /* @__PURE__ */ h(ai, { asChild: !0, ...i, children: a });
  }
);
$v.displayName = Lv;
var _u = "PopoverPortal", [Q1, J1] = _v(_u, {
  forceMount: void 0
}), Fv = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = Bn(_u, t);
  return /* @__PURE__ */ h(Q1, { scope: t, forceMount: n, children: /* @__PURE__ */ h(ft, { present: n || i.open, children: /* @__PURE__ */ h(to, { asChild: !0, container: o, children: r }) }) });
};
Fv.displayName = _u;
var Gr = "PopoverContent", Vv = p.forwardRef(
  (e, t) => {
    const n = J1(Gr, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = Bn(Gr, e.__scopePopover);
    return /* @__PURE__ */ h(ft, { present: r || i.open, children: i.modal ? /* @__PURE__ */ h(tk, { ...o, ref: t }) : /* @__PURE__ */ h(nk, { ...o, ref: t }) });
  }
);
Vv.displayName = Gr;
var ek = /* @__PURE__ */ er("PopoverContent.RemoveScroll"), tk = p.forwardRef(
  (e, t) => {
    const n = Bn(Gr, e.__scopePopover), r = p.useRef(null), o = ye(t, r), i = p.useRef(!1);
    return p.useEffect(() => {
      const s = r.current;
      if (s) return ii(s);
    }, []), /* @__PURE__ */ h(oi, { as: ek, allowPinchZoom: !0, children: /* @__PURE__ */ h(
      Bv,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: j(e.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), i.current || (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: j(
          e.onPointerDownOutside,
          (s) => {
            const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: j(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), nk = p.forwardRef(
  (e, t) => {
    const n = Bn(Gr, e.__scopePopover), r = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ h(
      Bv,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Bv = p.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = e, f = Bn(Gr, n), m = di(n);
    return Fs(), /* @__PURE__ */ h(
      ri,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ h(
          pr,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: u,
            onEscapeKeyDown: a,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ h(
              Us,
              {
                "data-state": zv(f.open),
                role: "dialog",
                id: f.contentId,
                ...m,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Wv = "PopoverClose", rk = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Bn(Wv, n);
    return /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: j(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
rk.displayName = Wv;
var ok = "PopoverArrow", ik = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = di(n);
    return /* @__PURE__ */ h(Ys, { ...o, ...r, ref: t });
  }
);
ik.displayName = ok;
function zv(e) {
  return e ? "open" : "closed";
}
var sk = Ov, ak = $v, lk = Fv, jv = Vv;
const lr = sk, so = ak, vr = p.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, renderOnBody: r = !0, ...o }, i) => {
  const s = r ? lk : p.Fragment;
  return /* @__PURE__ */ h(s, { children: /* @__PURE__ */ h(
    jv,
    {
      ref: i,
      align: t,
      sideOffset: n,
      className: X(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...o
    }
  ) });
});
vr.displayName = jv.displayName;
const ck = mr(
  "flex w-full rounded-md border-neutral-borders text-base ring-offset-background file:border-0 file:bg-transparent file:text-base font-normal placeholder:text-input-text-secondary text-input-text focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-[errormessage]:border-red-500 aria-[errormessage]:ring-red-500",
  {
    variants: {
      variant: {
        default: "input-md",
        sm: "input-sm"
      },
      borderless: {
        true: "border-0",
        false: "border"
      }
    },
    defaultVariants: {
      variant: "default",
      borderless: !1
    }
  }
), fi = p.forwardRef(
  ({ className: e, variant: t, borderless: n, type: r, ...o }, i) => /* @__PURE__ */ h("input", { type: r, className: X(ck({ variant: t, borderless: n, className: e })), ref: i, ...o })
);
fi.displayName = "Input";
var uk = "Label", Hv = p.forwardRef((e, t) => /* @__PURE__ */ h(
  sg.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Hv.displayName = uk;
var Uv = Hv;
const dk = mr("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), Yv = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(Uv, { ref: n, className: X(dk(), e), ...t }));
Yv.displayName = Uv.displayName;
const Ft = ({
  label: e,
  children: t,
  error: n,
  disabled: r,
  className: o,
  hideOverflow: i = !0
}) => /* @__PURE__ */ L("div", { className: o, children: [
  /* @__PURE__ */ L(
    "fieldset",
    {
      "aria-errormessage": n,
      "aria-disabled": r,
      className: X(
        i && "overflow-hidden",
        "labeled-container relative bg-input-bg rounded-md border border-neutral-borders ring-offset-background focus-within:outline-none  aria-[errormessage]:border-red-500 focus-within:ring-offset-2 aria-[disabled]:cursor-not-allowed aria-[disabled]:border-neutral-borders/50 aria-[errormessage]:aria-[disabled]:border-red-500/50 focus-within:!border-input-active"
      ),
      children: [
        e && /* @__PURE__ */ h(
          "legend",
          {
            "aria-errormessage": n,
            "aria-disabled": r,
            className: "relative z-10 px-0.5 ml-2 h-0 text-xs text-neutral-text-secondary aria-disabled:text-neutral-text-secondary/50 aria-[errormessage]:text-red-500 aria-[errormessage]:aria-disabled:text-red-500/50",
            children: /* @__PURE__ */ h("span", { className: "block -mt-2", children: e })
          }
        ),
        t
      ]
    }
  ),
  n && /* @__PURE__ */ h(
    Yv,
    {
      "aria-errormessage": n,
      "aria-disabled": r,
      className: "block z-10 text-xs text-red-500 aria-disabled:text-red-500/50",
      children: n
    }
  )
] }), fk = ({ content: e, children: t, tooltipContentProps: n, hide: r = !1 }) => r ? t : /* @__PURE__ */ h(Cu, { children: /* @__PURE__ */ L(qs, { children: [
  /* @__PURE__ */ h(Zs, { asChild: !0, children: t }),
  /* @__PURE__ */ h(ci, { ...n, children: e })
] }) }), Ou = ({ className: e, ...t }) => {
  var s;
  const n = { ...t };
  delete n.endIcon, delete n.starticon;
  const [r, o] = he(
    Number(t.maxLength) - ((s = t.value) == null ? void 0 : s.length)
  ), i = (a) => {
    console.log("handleOnChange");
    const l = a.target.value;
    t.maxLength && o(t.maxLength - l.length), t.onKeyUp && t.onKeyUp(a);
  };
  return /* @__PURE__ */ h(
    Ft,
    {
      label: t.label,
      error: t.error,
      disabled: t.disabled,
      className: X("-m-px", e),
      children: /* @__PURE__ */ L("div", { className: "flex items-center", children: [
        t.starticon && /* @__PURE__ */ h("div", { className: "pl-3", children: t.starticon }),
        /* @__PURE__ */ h(fi, { onKeyUp: i, type: "text", ...n, className: "w-full", borderless: !0 }),
        t.maxLength && /* @__PURE__ */ h(fk, { content: "Remaining Characters", children: /* @__PURE__ */ h("div", { className: X("pr-3 text-sm", r < 0 && "text-red-500"), children: r }) }),
        t.endIcon && /* @__PURE__ */ h("div", { className: "pr-3", children: t.endIcon })
      ] })
    }
  );
};
var ua = "Checkbox", [hk] = Bt(ua), [mk, Iu] = hk(ua);
function pk(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: i,
    form: s,
    name: a,
    onCheckedChange: l,
    required: c,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: d
  } = e, [f, m] = _n({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: ua
  }), [v, g] = p.useState(null), [y, b] = p.useState(null), x = p.useRef(!1), w = v ? !!s || !!v.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: f,
    disabled: i,
    setChecked: m,
    control: v,
    setControl: g,
    name: a,
    form: s,
    value: u,
    hasConsumerStoppedPropagationRef: x,
    required: c,
    defaultChecked: An(o) ? !1 : o,
    isFormControl: w,
    bubbleInput: y,
    setBubbleInput: b
  };
  return /* @__PURE__ */ h(
    mk,
    {
      scope: t,
      ...C,
      children: gk(d) ? d(C) : r
    }
  );
}
var Gv = "CheckboxTrigger", Kv = p.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: i,
      value: s,
      disabled: a,
      checked: l,
      required: c,
      setControl: u,
      setChecked: d,
      hasConsumerStoppedPropagationRef: f,
      isFormControl: m,
      bubbleInput: v
    } = Iu(Gv, e), g = ye(o, u), y = p.useRef(l);
    return p.useEffect(() => {
      const b = i == null ? void 0 : i.form;
      if (b) {
        const x = () => d(y.current);
        return b.addEventListener("reset", x), () => b.removeEventListener("reset", x);
      }
    }, [i, d]), /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": An(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": Qv(l),
        "data-disabled": a ? "" : void 0,
        disabled: a,
        value: s,
        ...r,
        ref: g,
        onKeyDown: j(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: j(n, (b) => {
          d((x) => An(x) ? !0 : !x), v && m && (f.current = b.isPropagationStopped(), f.current || b.stopPropagation());
        })
      }
    );
  }
);
Kv.displayName = Gv;
var da = p.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: a,
      value: l,
      onCheckedChange: c,
      form: u,
      ...d
    } = e;
    return /* @__PURE__ */ h(
      pk,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: i,
        disabled: a,
        required: s,
        onCheckedChange: c,
        name: r,
        form: u,
        value: l,
        internal_do_not_use_render: ({ isFormControl: f }) => /* @__PURE__ */ L(ke, { children: [
          /* @__PURE__ */ h(
            Kv,
            {
              ...d,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          f && /* @__PURE__ */ h(
            Zv,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
da.displayName = ua;
var Xv = "CheckboxIndicator", Lu = p.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = Iu(Xv, n);
    return /* @__PURE__ */ h(
      ft,
      {
        present: r || An(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ h(
          le.span,
          {
            "data-state": Qv(i.checked),
            "data-disabled": i.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Lu.displayName = Xv;
var qv = "CheckboxBubbleInput", Zv = p.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: i,
      defaultChecked: s,
      required: a,
      disabled: l,
      name: c,
      value: u,
      form: d,
      bubbleInput: f,
      setBubbleInput: m
    } = Iu(qv, e), v = ye(n, m), g = jg(i), y = xg(r);
    p.useEffect(() => {
      const x = f;
      if (!x) return;
      const w = window.HTMLInputElement.prototype, E = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set, S = !o.current;
      if (g !== i && E) {
        const T = new Event("click", { bubbles: S });
        x.indeterminate = An(i), E.call(x, An(i) ? !1 : i), x.dispatchEvent(T);
      }
    }, [f, g, i, o]);
    const b = p.useRef(An(i) ? !1 : i);
    return /* @__PURE__ */ h(
      le.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: s ?? b.current,
        required: a,
        disabled: l,
        name: c,
        value: u,
        form: d,
        ...t,
        tabIndex: -1,
        ref: v,
        style: {
          ...t.style,
          ...y,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Zv.displayName = qv;
function gk(e) {
  return typeof e == "function";
}
function An(e) {
  return e === "indeterminate";
}
function Qv(e) {
  return An(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const $u = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  da,
  {
    ref: n,
    className: X(
      "peer h-4 w-4 shrink-0 rounded border border-checkbox-border bg-checkbox-bg ring-offset-checkbox-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 group-hover:bg-checkbox-hover group-hover:border-checkbox-hover-border disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-checkbox-active data-[state=checked]:border-checkbox-active data-[state=checked]:text-checkbox-icon data-[state=indeterminate]:bg-checkbox-active data-[state=indeterminate]:border-checkbox-active  data-[state=indeterminate]:text-checkbox-icon",
      e
    ),
    ...t,
    children: /* @__PURE__ */ L(Lu, { className: X("flex items-center justify-center text-current"), children: [
      t.checked === "indeterminate" && /* @__PURE__ */ h(Jx, { className: "h-4 w-4 pb-[1px]" }),
      t.checked === !0 && /* @__PURE__ */ h(Xc, { className: "h-4 w-4" })
    ] })
  }
));
$u.displayName = "TriStateCheckbox";
const Kr = (e, t, n) => t ? (typeof t == "function" ? t(e) : t[e]) || e : e ? n ? Rl(e, n) : e : "-", hW = (e, t, n) => {
  const r = t.field;
  console.log("[onSortColumn] field:", r, "| order:", t.order, "| columnExists:", e.columnNames().includes(r), "| tableSize:", e.size);
  const o = n == null ? void 0 : n.find((u) => u.key === r), i = o == null ? void 0 : o.lookup, s = (u) => u == null || !i ? u : typeof i == "function" ? i(String(u)) || u : i[String(u)] || u, a = [];
  for (let u = 0; u < e.size; u++)
    a.push(e.object(u));
  const l = t.order === "asc" ? 1 : -1;
  a.sort((u, d) => {
    const f = s(u[r]), m = s(d[r]);
    return f == null && m == null ? 0 : f == null ? 1 : m == null ? -1 : typeof f == "number" && typeof m == "number" ? (f - m) * l : String(f).localeCompare(String(m)) * l;
  });
  const c = dp(a);
  return console.log("[onSortColumn] result first 3:", a.slice(0, 3).map((u) => ({ [r]: u[r] }))), c;
}, vk = async (e, t, n, r = "", o, i, s, a) => {
  if (!(e != null && e.columnNames().includes(n))) return [];
  r = r.toLowerCase();
  let l = e;
  if (a != null && a[n]) {
    const f = a[n];
    l = e.orderby(
      Fr((m) => {
        const v = f.indexOf(m[n]);
        return v === -1 ? 999999 : v;
      })
    );
  }
  const c = l.select(n).params({ textToFilter: r, columnKey: n }).derive({
    textToMatch: Fr((f, m) => f[m.columnKey] + "|" + Kr(f[m.columnKey], o, i))
  }).filter(
    (f, m) => (
      // @ts-expect-error aq likes overloads :)
      as.includes(as.lower(f.textToMatch), m.textToFilter, 0)
    )
  ).array(n), u = /* @__PURE__ */ new Set(), d = [];
  for (const f of c) {
    const m = Kr(f, o, i);
    if (!u.has(m) && (u.add(m), d.push(f), d.length >= t))
      break;
  }
  return d;
}, yk = (e, t, n) => {
  for (const [r, o] of Object.entries(e)) {
    if (!o.length || !t.columnNames().includes(r))
      continue;
    const i = n == null ? void 0 : n[r];
    t = t.params({ filters: e, rowKey: r }).filter(
      Fr((s, a) => {
        const l = Kr(s[a.rowKey], i == null ? void 0 : i.lookup, i == null ? void 0 : i.mask), c = a.filters[a.rowKey].map((d) => d.label), u = a.filters[a.rowKey].map((d) => d.key);
        return as.includes(c, l, 0) || as.includes(u, s[a.rowKey], 0);
      })
    );
  }
  return t;
}, Uf = (e, t, n, r) => {
  const [o, i] = [
    n.findIndex((c) => c.key === e.column),
    n.findIndex((c) => c.key === t.column)
  ].sort((c, u) => c - u), [s, a] = [e.rowIndex, t.rowIndex].sort((c, u) => c - u), l = [];
  for (let c = s; c <= a; c++) {
    const u = r.object(c);
    for (let d = o; d <= i; d++) {
      const f = n[d];
      f.split || f.groupColumn || l.push({
        column: f.key,
        row: u.key,
        rowIndex: c,
        value: u[f.key]
      });
    }
  }
  return l;
}, Jv = (e, t) => {
  var o;
  if (!t.validate) return !1;
  const n = e, r = Array.isArray(t.validate) ? (o = t.validate.map((i) => i(n[t.key], n))) == null ? void 0 : o.find((i) => i) : t.validate(n[t.key], n);
  return (r == null ? void 0 : r.type) === "disable";
}, go = (e, t, n) => {
  if (!n.validate) return !1;
  const r = t.object(e.rowIndex);
  return Jv(r, n);
}, kr = (e, t, n, r) => {
  const o = bk(r), i = t === "arrowdown" ? 1 : t === "arrowup" ? -1 : 0, s = t === "arrowright" ? 1 : t === "arrowleft" ? -1 : 0;
  if (i !== 0) {
    const a = e.rowIndex + i;
    if (a >= 0 && a < o) {
      const l = Zl(r, a);
      return {
        column: e.column,
        row: l.key,
        rowIndex: a,
        value: l[e.column]
      };
    } else
      return e;
  }
  if (s !== 0) {
    let a = n.findIndex((c) => c.key === e.column) + s, l;
    for (; !l && a >= 0 && a < n.length; ) {
      const c = n[a];
      !c.split && !c.groupColumn && (l = c), a += s;
    }
    if (l) {
      const c = Zl(r, e.rowIndex);
      return {
        column: l.key,
        row: e.row,
        rowIndex: e.rowIndex,
        value: c[l.key]
      };
    } else
      return e;
  }
}, vo = (e, t, n) => {
  const r = Zl(t, e.rowIndex), o = n.find((l) => l.key === e.column), i = (o == null ? void 0 : o.dataType) || "string", s = (e.newValue ?? null) === null;
  if (e.newValue === e.value)
    return [];
  if (s && !(o != null && o.nullable))
    return [];
  const a = i === "number" && !s ? Number(e.newValue) : e.newValue;
  return [
    {
      cells: [
        {
          ...e,
          value: a
        }
      ],
      oldRecord: r,
      newRecord: { ...r, [e.column]: a }
    }
  ];
}, Zl = (e, t) => "length" in e ? e[t] : e.object(t), bk = (e) => "length" in e ? e.length : e.size, wk = (e) => e >= "0" && e <= "9" || e >= "a" && e <= "z" || e === "-" || e === ".";
function xk(e, t) {
  const n = e.findIndex((r) => r.rowspan && r.rowspan > 1);
  if (n >= 0 && t !== n) {
    const r = e[n].rowspan;
    return t < n + r;
  }
  return !1;
}
function mW(e, t) {
  return (n) => {
    if (n > e)
      return {
        type: "error",
        message: t || `Max allowed value is ${e}`
      };
  };
}
function pW(e, t) {
  return (n) => {
    if (n < e)
      return {
        type: "error",
        message: t || `Min allowed value is ${e}`
      };
  };
}
function gW(e) {
  return e.reduce((t, n) => (t[n.key] = {
    lookup: n.lookup,
    mask: n.mask
  }, t), {});
}
function vW(e, t, n) {
  return (r, o, i, s) => {
    const a = t == null ? void 0 : t[r];
    return vk(
      e,
      100,
      r,
      o,
      i,
      s,
      !!a,
      n
    );
  };
}
const Li = (e, t) => [...e].sort((n, r) => {
  const o = t ? t(n.keyText) : n.keyText, i = t ? t(r.keyText) : r.keyText;
  return o.localeCompare(i, void 0, { sensitivity: "base" });
}), ey = ({
  onApply: e,
  onLoadFilters: t,
  activeFilters: n,
  showApplyCancel: r,
  column: o,
  onOpenPopover: i,
  openedPopover: s,
  trigger: a,
  lookup: l,
  onClose: c,
  renderOnBody: u = !0,
  disabled: d = !1
}) => {
  const [f, m] = he([]), [v, g] = he([]), [y, b] = he(""), [x, w] = he(!1), [C, E] = he(!1), S = Ie(
    (N) => o != null && o.mask ? Kr(N, l, o.mask) : `${(l ? typeof l == "function" ? l(N) : l[N] : void 0) || N}`,
    [l, o]
  );
  B1(
    async () => {
      const N = f.filter((O) => O.checked), _ = [...v.filter((O) => O.checked), ...N];
      let W = await T(y);
      const te = new Set(_.map((O) => S(O.keyText)));
      W = W.filter((O) => !te.has(S(O))), m(
        Li(
          W.map((O) => ({ keyText: O, checked: !1 })),
          S
        )
      ), g(Li(_, S));
    },
    500,
    [y, l]
  );
  const T = async (N) => {
    E(!0);
    const M = await t(N || y);
    return E(!1), M;
  }, P = (N) => {
    if (d) return;
    const M = Dt(f, (_) => {
      _[N].checked = !_[N].checked;
    });
    m(M), r || R(void 0, M);
  }, D = (N) => {
    if (d) return;
    const M = Dt(v, (_) => {
      _[N].checked = !_[N].checked;
    });
    g(M), r || R(M, void 0);
  }, k = (N) => {
    if (d) return;
    const M = Dt(f, (W) => {
      W.forEach((te) => te.checked = N);
    }), _ = Dt(v, (W) => {
      W.forEach((te) => te.checked = N);
    });
    m(M), g(_), r || R(_, M);
  }, R = (N, M) => {
    if (d) return;
    const _ = [
      ...(N || v).filter((W) => W.checked).map((W) => W.keyText),
      ...(M || f).filter((W) => W.checked).map((W) => W.keyText)
    ];
    w(_.length > 0), e(_.map((W) => ({ key: W, label: S(W) })));
  }, A = async () => {
    let N = await T();
    N = N.filter(
      (M) => !(n || []).some((_) => _.label === S(M) || _.key === M)
    ), g(
      Li(
        (n || []).map((M) => ({ keyText: M.key, checked: !0 })),
        S
      )
    ), m(
      Li(
        N.map((M) => ({ keyText: M, checked: !1 })),
        S
      )
    );
  }, F = a ? /* @__PURE__ */ h("div", { onClick: A, children: a }) : /* @__PURE__ */ h(Ee, { onClick: A, variant: "ghost", className: "icon hover:bg-transparent text-input-icons", size: "sm", children: n != null && n.length ? /* @__PURE__ */ h(eC, {}) : /* @__PURE__ */ h(Dl, {}) }), I = (N, M, _) => /* @__PURE__ */ h(
    "div",
    {
      className: "flex items-center px-3 py-1.5 rounded-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors",
      children: /* @__PURE__ */ L("label", { className: "flex items-center gap-2.5 cursor-pointer w-full", children: [
        /* @__PURE__ */ h(
          $u,
          {
            className: "shrink-0",
            onCheckedChange: _,
            checked: !!N.checked,
            disabled: d
          }
        ),
        /* @__PURE__ */ h("span", { className: "text-xs font-normal leading-normal text-neutral-text-primary truncate", children: S(N.keyText) })
      ] })
    },
    M
  ), B = /* @__PURE__ */ L(ke, { children: [
    /* @__PURE__ */ h(so, { asChild: !0, children: F }),
    /* @__PURE__ */ h(vr, { renderOnBody: u, align: "start", className: "w-72 p-0 pointer-events-auto", children: /* @__PURE__ */ L("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ h("div", { className: "px-3 pt-3 pb-2", children: /* @__PURE__ */ h(
        Ou,
        {
          label: "",
          placeholder: "Search",
          value: y,
          onChange: (N) => b(N.currentTarget.value),
          starticon: /* @__PURE__ */ h(Dl, { size: 14, className: "text-neutral-400" }),
          disabled: d
        }
      ) }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-3 px-3 py-2 border-b border-neutral-200 dark:border-neutral-700", children: [
        /* @__PURE__ */ h(
          "span",
          {
            className: `text-xs font-medium ${d ? "text-neutral-400" : "text-button-primary-bg hover:text-button-primary-bg/80 cursor-pointer"}`,
            onClick: () => k(!0),
            children: "Select All"
          }
        ),
        /* @__PURE__ */ h("span", { className: "text-neutral-300 dark:text-neutral-600 text-xs", children: "|" }),
        /* @__PURE__ */ h(
          "span",
          {
            className: `text-xs font-medium ${d ? "text-neutral-400" : "text-button-primary-bg hover:text-button-primary-bg/80 cursor-pointer"}`,
            onClick: () => k(!1),
            children: "Deselect All"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "flex flex-col py-1 h-64 overflow-y-auto overflow-x-hidden pretty-scrollbar", children: C ? /* @__PURE__ */ h("div", { className: "w-full flex justify-center py-4", children: /* @__PURE__ */ h("span", { className: "loading loading-spinner loading-sm" }) }) : /* @__PURE__ */ L(ke, { children: [
        v.map((N, M) => I(N, M, () => D(M))),
        v.length > 0 && f.length > 0 && /* @__PURE__ */ h("div", { className: "border-t border-neutral-200 dark:border-neutral-700 mx-3 my-1" }),
        f.map((N, M) => I(N, M, () => P(M)))
      ] }) }),
      r && /* @__PURE__ */ h("div", { className: "flex flex-row-reverse p-2", children: /* @__PURE__ */ h(Ee, { onClick: () => R(), variant: "ghost", size: "sm", color: "primary", disabled: d, children: "Apply" }) })
    ] }) })
  ] }), V = (N) => {
    N ? document.body.classList.add("filter-popover-open") : document.body.classList.remove("filter-popover-open"), o && i ? i(N ? o.key : null) : !N && c && c();
  };
  return o && i ? /* @__PURE__ */ h(lr, { open: o.key === s, onOpenChange: V, children: B }) : /* @__PURE__ */ h(lr, { onOpenChange: V, children: B });
};
function Ck(e) {
  const t = e.column.filterable && e.onFilterChange, n = (r) => e.onFilterChange && e.onFilterChange(e.column, r);
  return t && e.onLoadFilters ? /* @__PURE__ */ h(
    ey,
    {
      activeFilters: e.filters,
      onApply: n,
      onLoadFilters: e.onLoadFilters,
      column: e.column,
      lookup: e.column.lookup,
      onOpenPopover: e.onOpenPopover,
      openedPopover: e.openedPopover
    }
  ) : void 0;
}
function Sk({ id: e, topPosition: t }) {
  return /* @__PURE__ */ h("th", { className: "th-group-path sticky", style: { top: `${t}px` }, children: /* @__PURE__ */ h("div", {}) }, `${e}-column`);
}
function Tk({ id: e, column: t, state: n, topPosition: r, cfg: o }) {
  const i = t.isLocked ? {
    left: `${o.stickyOffsets[t.key]}px`,
    top: `${r}px`,
    zIndex: 25,
    position: "sticky"
  } : void 0;
  return /* @__PURE__ */ h(
    "th",
    {
      className: "th-new-splitter !bg-gradient-to-r !from-neutral-container !to-transparent",
      style: i
    },
    `${e}-column`
  );
}
function Ek(e, t) {
  var n = ae(null), r = ae(null);
  r.current = t;
  var o = ae(null);
  me(function() {
    i();
  });
  var i = Ie(function() {
    var s = o.current, a = r.current, l = s || (a ? a instanceof Element ? a : a.current : null);
    n.current && n.current.element === l && n.current.subscriber === e || (n.current && n.current.cleanup && n.current.cleanup(), n.current = {
      element: l,
      subscriber: e,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: l ? e(l) : void 0
    });
  }, [e]);
  return me(function() {
    return function() {
      n.current && n.current.cleanup && (n.current.cleanup(), n.current = null);
    };
  }, []), Ie(function(s) {
    o.current = s, i();
  }, [i]);
}
function Yf(e, t, n) {
  return e[t] ? e[t][0] ? e[t][0][n] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    e[t][n]
  ) : t === "contentBoxSize" ? e.contentRect[n === "inlineSize" ? "width" : "height"] : void 0;
}
function Pk(e) {
  e === void 0 && (e = {});
  var t = e.onResize, n = ae(void 0);
  n.current = t;
  var r = e.round || Math.round, o = ae(), i = he({
    width: void 0,
    height: void 0
  }), s = i[0], a = i[1], l = ae(!1);
  me(function() {
    return l.current = !1, function() {
      l.current = !0;
    };
  }, []);
  var c = ae({
    width: void 0,
    height: void 0
  }), u = Ek(Ie(function(d) {
    return (!o.current || o.current.box !== e.box || o.current.round !== r) && (o.current = {
      box: e.box,
      round: r,
      instance: new ResizeObserver(function(f) {
        var m = f[0], v = e.box === "border-box" ? "borderBoxSize" : e.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", g = Yf(m, v, "inlineSize"), y = Yf(m, v, "blockSize"), b = g ? r(g) : void 0, x = y ? r(y) : void 0;
        if (c.current.width !== b || c.current.height !== x) {
          var w = {
            width: b,
            height: x
          };
          c.current.width = b, c.current.height = x, n.current ? n.current(w) : l.current || a(w);
        }
      })
    }), o.current.instance.observe(d, {
      box: e.box
    }), function() {
      o.current && o.current.instance.unobserve(d);
    };
  }, [e.box, r]), e.ref);
  return ve(function() {
    return {
      ref: u,
      width: s.width,
      height: s.height
    };
  }, [u, s.width, s.height]);
}
const Gf = ({ children: e, onChangeHeight: t }) => {
  const n = ae(null);
  return Pk({
    ref: n,
    onResize: (r) => {
      r.height && t && t && t(r.height);
    }
  }), /* @__PURE__ */ h("tr", { ref: n, children: e });
};
var ty = /* @__PURE__ */ ((e) => (e.LOADING = "LOADING", e.ERROR = "ERROR", e))(ty || {});
const kk = ({ scroll: e, rowVirtualizer: t, columns: n, visibleColumns: r, table: o }) => ve(() => {
  const s = {}, a = t.getVirtualItems();
  return !o || "length" in o ? {} : (n.forEach((l, c) => {
    var u;
    if (r[c] === -1)
      for (const d of a) {
        const f = d.index, m = o.object(f);
        let v;
        l.validate && (v = Array.isArray(l.validate) ? (u = l.validate.map((g) => g(m[l.key], m))) == null ? void 0 : u.find(Boolean) : l.validate(m[l.key], m)), v && (s[`${c}-${f}`] = v);
      }
  }), s);
}, [e, o, n, r]), Dk = {
  includeHeaders: !1,
  includeContextColumns: !1,
  semicolonSeparated: !1,
  includeCurrencySymbol: !0
}, Rk = (e) => {
  if (!(e != null && e.length)) return [];
  const t = [...new Set(e.map((o) => o.rowIndex))].sort((o, i) => o - i), n = [...new Set(e.map((o) => o.colIndex))].sort((o, i) => o - i), r = new Map(e.map((o) => [`${o.rowIndex}-${o.colIndex}`, o]));
  return t.map((o) => n.map((i) => r.get(`${o}-${i}`)));
}, Mk = (e, t) => e.map((r) => ({
  ...r,
  colIndex: t.findIndex((o) => o.key === r.column)
})), ny = (e, t, n) => {
  var s;
  const r = e.filter((a) => {
    const l = n.find((u) => u.key === a.column);
    let c = (l == null ? void 0 : l.readOnly) || (l == null ? void 0 : l.split) || a.pasteValue === null && (l == null ? void 0 : l.nullable) === !1 || (l == null ? void 0 : l.dataType) === "number" && isNaN(Number(a.pasteValue));
    if (!c && (l != null && l.validate)) {
      const u = t.object(a.rowIndex);
      c = Jv(u, l);
    }
    return !c;
  }), o = [...new Set(r.map((a) => a.rowIndex))], i = [];
  for (const a of o) {
    const l = t == null ? void 0 : t.object(a);
    if (l && "key" in l) {
      const c = r.filter((f) => f.row === l.key), u = { ...l }, d = [];
      for (const f of c) {
        const m = ((s = n.find((v) => v.key === f.column)) == null ? void 0 : s.dataType) || (typeof u[f.column] == "number" ? "number" : "string");
        u[f.column] = m === "number" && f.pasteValue !== null ? Number(f.pasteValue) : f.pasteValue, d.push({
          ...f,
          value: u[f.column]
        });
      }
      i.push({
        newRecord: u,
        oldRecord: l,
        cells: d
      });
    }
  }
  return i;
}, Nk = (e, t, n, r, o) => {
  const { includeHeaders: i, includeContextColumns: s, semicolonSeparated: a, includeCurrencySymbol: l } = {
    ...Dk,
    ...o
  }, c = a ? ";" : "	";
  return {
    copy: async () => {
      if (!n || !(t != null && t.end) && !e.length)
        return;
      const f = (P) => r.find((D) => D.key === P), m = (P) => {
        if (P != null && P.prefix) return P.prefix;
        const D = P == null ? void 0 : P.mask;
        return typeof D == "string" && D[0] === "$" ? "$" : "";
      }, v = (P, D) => D != null && D.lookup ? Kr(P, D.lookup) : P == null || P === "" ? "-" : `${l ? m(D) : ""}${P}`, g = t != null && t.end ? Uf(t.start.cell, t.end.cell, r, n) : e;
      if (!g.length) return;
      if (g.length === 1) {
        const P = g[0];
        await navigator.clipboard.writeText(String(v(P.value, f(P.column)) ?? ""));
        return;
      }
      const y = new Set(g.map((P) => P.column)), b = r.filter((P) => !P.split && !P.groupColumn && y.has(P.key));
      if (!b.length) return;
      let x = [];
      if (s && (x = r.filter((P) => P.isLocked && !P.split && !P.groupColumn && !y.has(P.key)), !x.length)) {
        const P = r.find((D) => !D.split && !D.groupColumn);
        P && !y.has(P.key) && (x = [P]);
      }
      const w = [...x, ...b], E = [...new Set(g.map((P) => P.rowIndex))].sort((P, D) => P - D).map((P) => {
        const D = n.object(P);
        return w.map((k) => v(D == null ? void 0 : D[k.key], k));
      }), T = (i ? [w.map((P) => P.name), ...E] : E).map((P) => P.join(c)).join(`
`);
      await navigator.clipboard.writeText(T);
    },
    paste: async (f) => {
      if (!n || !(t != null && t.end) && !e.length)
        return [];
      const v = (await navigator.clipboard.readText()).trim().split(`
`).map((S) => S.split("	")), [g, y] = [v.length, v[0].length], b = !!(t != null && t.end), x = t != null && t.end ? Uf(t.start.cell, t.end.cell, r, n) : e, w = Mk(x, r), C = Rk(w).map(
        (S) => S.map((T) => ({ ...T, pasteValue: null }))
      );
      for (let S = 0; S < C.length; S++) {
        const T = C[S];
        for (let P = 0; P < T.length; P++) {
          const D = T[P];
          f ? D.pasteValue = null : b ? D.pasteValue = f ? null : v[S % g][P % y] : D.pasteValue = v[0][0];
        }
      }
      return ny(C.flat(), n, r);
    }
  };
}, Ak = (e) => {
  const [t, n] = Au(
    `selection-status-${e}`,
    []
  );
  return {
    selectedCells: t,
    setSelectedCells: n,
    clearSelectedCells: () => {
      n([]);
    },
    cellClicked: (i, s) => {
      !s || s === "replace" ? n(
        Dt(t, () => [i])
      ) : s === "add" && n(
        Dt(t, (a) => {
          a.some((c) => c.column === i.column && c.row === i.row) || a.push(i);
        })
      );
    }
  };
};
function _k({ columns: e, height: t, cfg: n }) {
  const r = 20 * t;
  return /* @__PURE__ */ h("tr", { children: e.map((o, i) => {
    var m, v;
    const s = `row-spacer-${o.key}`;
    if (o.groupColumn)
      return /* @__PURE__ */ h("td", { className: "td-group-path !border-b-table-borders-header !border-b" }, s);
    let a = !1;
    const l = i < e.length - 1 ? (m = e[i + 1]) == null ? void 0 : m.split : !0, c = i > 0 ? (v = e[i - 1]) == null ? void 0 : v.split : !0, u = !!(i > 0 && e[i - 1].groupColumn);
    (i > 0 && u && !o.split || i === 0 || c) && (a = !0);
    const f = !!o.isLocked ? {
      position: "sticky",
      left: `${n.stickyOffsets[o.key]}px`,
      zIndex: 20
    } : {};
    return /* @__PURE__ */ h(
      "td",
      {
        className: ze(
          o.split ? "td-new-splitter bg-gradient-to-r from-neutral-container to-transparent" : "bg-color-greys-100 dark:bg-color-greys-800",
          a ? "!border-l-table-borders-header !border-l" : "!border-l-0",
          "!border-t-table-borders-header",
          "!border-b-table-borders-header",
          l && "!border-r-table-borders-header !border-r"
        ),
        style: {
          ...f,
          height: `${r}px`
        }
      },
      s
    );
  }) });
}
const Ok = ({ sortState: e }) => {
  switch (e) {
    case "asc":
      return /* @__PURE__ */ h(rC, { size: 16 });
    case "desc":
      return /* @__PURE__ */ h(nC, { size: 16 });
    default:
      return /* @__PURE__ */ h(tC, { size: 16 });
  }
};
function Ik({ column: e, sort: t, onSort: n }) {
  const r = t && e.key === t.field ? t.order : null;
  return /* @__PURE__ */ h(Ee, { onClick: () => {
    const i = (t == null ? void 0 : t.order) === "asc" ? "desc" : "asc";
    n({ field: e.key, order: i });
  }, variant: "ghost", className: "icon hover:bg-transparent text-input-icons", size: "sm", children: /* @__PURE__ */ h(Ok, { sortState: r }) });
}
const ry = je(void 0), yW = ({ children: e, lookups: t = {} }) => {
  const n = Ie(
    (o) => o.map((i) => i.lookup ? i : t[i.key] ? { ...i, lookup: t[i.key] } : i),
    [t]
  ), r = ve(
    () => ({
      lookups: t,
      applyLookups: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ h(ry.Provider, { value: r, children: e });
}, Fu = () => Se(ry), bW = (e) => {
  var Tt, _t, en, xr, Et;
  const t = Fu(), n = ve(() => {
    if (Array.isArray(e.table)) {
      const $ = e.table.length ? Object.keys(e.table[0]) : [], J = e.columns.map((ce) => ce.key), Y = [.../* @__PURE__ */ new Set([...$, ...J])];
      return dp(e.table, Y);
    }
    return e.table;
  }, [e.table]), r = ve(() => {
    const $ = e.columns.some((Y) => Y.fixedPercentageWidth), J = e.columns.every((Y) => Y.fixedPercentageWidth);
    if ($ && !J)
      throw new Error("Either all columns must have fixedPercentageWidth set or none of them should have it");
    return $;
  }, [e.columns]), o = e.hooks.getDatatableConfig(), i = ae(null), { state: s, hooks: a } = e, [l, c] = he([]), [u, d] = he(null), [f, m] = Au(`scroll-position-${e.tablekey}`, { x: 0, y: 0 }), [v, g] = he(!1), y = ($) => {
    v && m($);
  };
  me(() => {
    i != null && i.current && n && (i.current.scrollLeft = f.x, i.current.scrollTop = f.y, g(!0));
  }, [n, e.columns]);
  const [b, x] = he(), [w, C] = he(), E = ($, J) => {
    c((Y) => Dt(Y, (ce) => {
      ce[$] = J;
    }));
  }, [S, T, P] = ve(() => {
    var rt;
    const $ = [];
    let J = 0;
    const ce = [...(t == null ? void 0 : t.applyLookups(e.columns)) ?? e.columns];
    let pe = ce.map((ue, Re) => {
      var mt, Le;
      if ("split" in ue)
        return {
          name: "",
          key: ue.key || `sep-${Re}`,
          component: () => /* @__PURE__ */ h(P1, {}),
          _dfColIndex: -1,
          sourceColIndex: -1,
          split: !0,
          isLocked: ue.isLocked
        };
      let Te = "";
      const Z = ue.isLocked || s.lockedColumns.includes(ue.key);
      ((mt = ue.group) != null && mt.length && !ue.group[ue.group.length - 1].label || !((Le = ue.group) != null && Le.length)) && ((Re === 0 || "split" in ce[Re - 1]) && (Te += "rounded-tl "), (Re === ce.length - 1 || "split" in ce[Re + 1]) && (Te += "rounded-tr "));
      const H = {
        ...ue,
        component: ue.component || gr,
        _dfColIndex: -1,
        sourceColIndex: Re,
        isLocked: Z,
        aditionalClasses: Te
      };
      return !ue.onLoadFilters && ue.filterable && e.onLoadFiltersByColumn && (H.onLoadFilters = (tn) => e.onLoadFiltersByColumn(ue.key, tn, H.lookup, H.mask)), H;
    });
    const We = [];
    let at = 0;
    for (const ue of pe) {
      const Re = Nv(ue, s);
      if (!Re)
        !ue.split && !ue.groupColumn && (ue._dfColIndex = at++), We.push(ue);
      else {
        const Te = We.length ? We[We.length - 1] : void 0;
        (!Te || !U1(Te.group, Re)) && We.push(MP(Re, ue.key));
      }
    }
    pe = We;
    for (const ue of pe)
      ue.group && ue.group.length > J && (J = ue.group.length);
    for (let ue = 0; ue < J; ue++) {
      const Re = [];
      for (let Te = 0; Te < pe.length; Te++) {
        const Z = pe[Te], H = Z.group && Z.group[ue];
        if (Z.group && xk(Z.group, ue))
          continue;
        const mt = Te < pe.length - 1 ? pe[Te + 1] : void 0, Le = Z.group && ue > 0 ? Z.group[ue - 1] : void 0, tn = ue === 0 || (Le == null ? void 0 : Le.label) === void 0 || (Le == null ? void 0 : Le.component), Cr = Z.group && Z.groupColumn ? ue > ((rt = Z.group) == null ? void 0 : rt.length) - 2 : void 0, ki = (mt == null ? void 0 : mt.split) || Te === pe.length - 1, de = Z.group ? ue === Z.group.length - 1 || ue === 0 : !1, xe = Te > 0 ? Re[Re.length - 1] : void 0, _e = (H == null ? void 0 : H.label) === void 0 && !Cr || !1, Oe = H == null ? void 0 : H.label;
        if (xe && xe.key === (H == null ? void 0 : H.key))
          Re[Re.length - 1].colspan += 1, ki && tn && (Re[Re.length - 1].aditionalClasses += "rounded-tr ");
        else {
          let Pe, lt = "";
          const Je = (Z.group || []).filter((jt, bt) => bt <= ue);
          if (Oe && !(H != null && H.uncollapsable)) {
            const jt = Je.map((bt) => bt.key).join("_");
            Pe = /* @__PURE__ */ h(
              q1,
              {
                hooks: a,
                group: Je,
                hidding: !s.groupCollapsedStatus[jt]
              }
            );
          }
          _e && (lt += xe != null && xe.name && !Z.split ? "empty-cell-left-border " : "empty-cell "), (xe != null && xe.split || Te === 0) && tn && (lt += "rounded-tl "), ki && tn && (lt += "rounded-tr ");
          let ct = Je;
          H && H.rowspan && (ct = (Z.group || []).filter((jt, bt) => bt <= ue + H.rowspan - 1));
          const Pt = ct.length ? Y1(ct, ce, s) : !1;
          Re.push({
            rowspan: H == null ? void 0 : H.rowspan,
            areSubgroupsCollapsed: Pt,
            aditionalClasses: lt,
            viewComponent: H == null ? void 0 : H.component,
            key: (H == null ? void 0 : H.key) || `no-group-${ue}`,
            name: Oe || "",
            colspan: 1,
            split: Z.split,
            leftStickyOffset: H != null && H.isLocked || Z.split ? o.stickyOffsets[Z.key] : void 0,
            component: Pe,
            isPartOfGroup: Cr,
            isHeadOfGroup: de
          });
        }
      }
      $.push(Re);
    }
    return [pe, $, J];
  }, [
    n,
    e.columns,
    s.lockedColumns,
    s.groupCollapsedStatus,
    s.columnPositions,
    o.stickyOffsets,
    t
  ]);
  me(() => {
    x(void 0);
  }, [s.lockedColumns, s.groupCollapsedStatus, s.columnPositions, e.columns]);
  const D = ve(() => {
    const $ = [];
    let J = z1;
    for (let Y = 0; Y < P + 2; Y++)
      $[Y] = J, J += l[Y] || 25;
    return $;
  }, [l, P]), { rowSize: k, cssClass: R } = ve(() => {
    let $ = 32, J = e.className ?? "";
    return e.isCompressed && ($ = 20, J += " is-compressed"), {
      rowSize: $,
      cssClass: J
    };
  }, [e.isCompressed, e.className]), A = (n == null ? void 0 : n.size) || 0, F = UP({
    count: A,
    getScrollElement: () => i.current,
    estimateSize: () => k
  }), I = F.getVirtualItems().find(($) => $ !== void 0) || { size: k, start: 0 }, B = F.getTotalSize() - (I.start + F.getVirtualItems().length * I.size), V = ((Tt = i.current) == null ? void 0 : Tt.getBoundingClientRect().width) || 1, N = ve(() => {
    if (o.disableColumnVirtualization || r)
      return [];
    const $ = [];
    let J = 0, Y = 0;
    for (let ce = 0; ce < S.length; ce++) {
      const pe = S[ce], We = o.usePositionalColumnSizing ? `column-${pe.sourceColIndex}` : pe.key;
      let at = Math.max(s.columnPositions[We] || 0, pe.minWidth || o.minColumnWidth);
      pe.groupColumn && (at = 24), pe.split && (at = 12), J >= f.x - 200 && J <= f.x + V + 200 || pe.isLocked ? ($.push(-1), Y = ce + 1) : ($.push(0), $[Y]++), J += at;
    }
    return $;
  }, [f, s, V, o.disableColumnVirtualization]), M = ($) => {
    const Y = i.current;
    if (Y) {
      const ce = Y.querySelector(`td[data-row-key="${$.row}"][data-col-key="${$.column}"]`);
      if (!ce) return;
      const pe = ce.getBoundingClientRect(), We = Y.getBoundingClientRect(), at = Y.scrollTop, rt = Y.scrollLeft, ue = D[D.length - 1], Re = Object.keys(o.stickyOffsets).length ? Math.max(...Object.values(o.stickyOffsets)) : 0, Te = {
        top: We.top + ue,
        bottom: We.bottom,
        left: We.left + Re,
        right: We.right
      };
      let Z = pe.top < Te.top + 150 ? at - (Te.top + 150 - pe.top) : void 0, H = pe.left < Te.left + 150 ? rt - (Te.left + 150 - pe.left) : void 0;
      Z = pe.bottom > Te.bottom - 150 ? at + (pe.bottom - (Te.bottom - 150)) : Z, H = pe.right > Te.right - 150 ? rt + (pe.right - (Te.right - 150)) : H, Y.scrollTo({
        top: Z,
        left: H,
        behavior: "instant"
      });
    }
  }, {
    selectedCells: _,
    clearSelectedCells: W,
    cellClicked: te
  } = Ak(e.tablekey), O = e.disableCellSelection ? () => {
  } : te, { copy: z, paste: Q } = Nk(_, b, n, S, e.copyOptions), K = ($, J) => {
    const Y = document.querySelector(`td[data-row-key="${$}"][data-col-key="${J}"]`);
    if (Y) {
      const ce = Y.querySelector("input");
      ce && ce.type === "number" && (ce.focus(), ce.type = "text", ce.setSelectionRange(0, ce.value.length), ce.type = "number");
    }
  }, se = async ($) => {
    var We, at, rt, ue, Re, Te;
    if (!n || u) return;
    let J = $.key.toLocaleLowerCase();
    J === "backspace" && w === void 0 && (J = "delete");
    const Y = $.ctrlKey || $.metaKey, ce = _.length ? _[0] : void 0, pe = ce ? S.find((Z) => Z.key === ce.column) : void 0;
    switch (!0) {
      case (J.length === 1 && wk(J) && !Y && !w && !!ce):
        pe && !pe.readOnly && !pe.split && !go(ce, n, pe) && C({
          ..._[0],
          newValue: "",
          editMode: "express"
        });
        break;
      case J === "escape":
        w ? C(void 0) : (W(), x(void 0)), (We = i.current) == null || We.focus();
        break;
      case J === "enter":
        if (w && e.onRowsCommit) {
          e.onRowsCommit(vo(w, n, S));
          const Z = kr(w, "arrowdown", S, n);
          Z && Z.rowIndex !== w.rowIndex && !go(Z, n, S.find((H) => H.key === Z.column)) ? (O(Z, "replace"), C({
            ...Z,
            newValue: Z == null ? void 0 : Z.value,
            editMode: "normal"
          }), M(Z)) : C(void 0), (at = i.current) == null || at.focus();
        } else if (!w && _.length) {
          const Z = _[0], H = S.find((mt) => mt.key === Z.column);
          H && !H.readOnly && !go(Z, n, H) && C({
            ..._[0],
            newValue: _[0].value,
            editMode: "normal"
          });
        }
        break;
      case (J === "v" && Y):
        {
          const Z = await Q();
          Z != null && Z.length && e.onRowsCommit && e.onRowsCommit(Z), $.preventDefault();
        }
        break;
      case J === "delete":
        if (n && e.onRowsCommit) {
          const Z = await Q(!0);
          Z != null && Z.length && e.onRowsCommit(Z), $.preventDefault();
        }
        break;
      case (J === "c" && Y):
        await z();
        break;
      case (J === "tab" && !w && !!(_ != null && _.length)):
        {
          const Z = _[0], H = kr(Z, "arrowright", S, n);
          H && O(H, "replace");
        }
        $.preventDefault();
        break;
      case (J === "tab" && !!w):
        {
          const Z = vo(w, n, S);
          Z.length && e.onRowsCommit && e.onRowsCommit(Z);
          const H = kr(w, "arrowright", S, n);
          if (H && H.column !== w.column) {
            const mt = S.find((Le) => Le.key === H.column);
            (rt = S.find((Le) => Le.key === H.column)) != null && rt.readOnly || go(H, n, mt) ? C(void 0) : C({
              ...H,
              newValue: H == null ? void 0 : H.value,
              editMode: "normal"
            }), O(H, "replace"), M(H);
          } else
            C(void 0);
          $.preventDefault(), (ue = i.current) == null || ue.focus();
        }
        break;
      case ((w == null ? void 0 : w.editMode) === "express" && ["arrowleft", "arrowup", "arrowright", "arrowdown"].includes(J)):
        if (e.onRowsCommit) {
          const Z = vo(w, n, S);
          Z.length && e.onRowsCommit(Z);
          let H = kr(w, J, S, n), mt = !1;
          for (; H && ((Re = S.find((Le) => Le.key === (H == null ? void 0 : H.column))) != null && Re.readOnly) && !mt; ) {
            const Le = kr(H, J, S, n);
            (Le == null ? void 0 : Le.column) !== H.column || Le.row !== H.row ? H = Le : mt = !0;
          }
          if (H && (H.row !== w.row || H.column !== w.column)) {
            const Le = S.find((Cr) => Cr.key === H.column), tn = Le.readOnly || go(H, n, Le);
            O(H, "replace"), C(
              tn ? void 0 : { ...H, newValue: H.value, editMode: "express" }
            ), setTimeout(() => {
              H && K(H.row, H.column);
            }, 0);
          } else
            C(void 0);
        }
        break;
      case ["arrowup", "arrowdown"].includes(J):
      case (!w && ["arrowleft", "arrowright"].includes(J)):
        {
          const Z = (b == null ? void 0 : b.start.cell) || _.length && _[0];
          if (Z && n) {
            const H = kr(Z, J, S, n);
            H && (x(void 0), O(H, "replace"), M(H), $.preventDefault());
          }
          ["arrowup", "arrowdown"].includes(J) && (C(void 0), (Te = i.current) == null || Te.focus());
        }
        break;
    }
  }, U = ($, J) => {
    O($, J === "ctrl" ? "add" : "replace"), e.onCellSelect && e.onCellSelect($, n.object($.rowIndex));
  }, oe = ($) => {
    w && w.value !== w.newValue && e.onRowsCommit && n && e.onRowsCommit(vo(w, n, S)), C(
      $ ? {
        ...$,
        newValue: $.value,
        editMode: "normal"
      } : void 0
    );
  }, q = ($, J) => {
    if (w) {
      const Y = { ...w, newValue: $ };
      C(Y), J && e.onRowsCommit && n && (e.onRowsCommit(vo(Y, n, S)), C(void 0));
    }
  }, ie = ($, J, Y, ce, pe, We) => {
    var ue, Re, Te, Z;
    const at = -(((ue = i.current) == null ? void 0 : ue.getBoundingClientRect().x) || 0) + J + (((Re = i.current) == null ? void 0 : Re.scrollLeft) || 0), rt = -(((Te = i.current) == null ? void 0 : Te.getBoundingClientRect().y) || 0) + Y + (((Z = i == null ? void 0 : i.current) == null ? void 0 : Z.scrollTop) || 0);
    $ === "start" && x({
      start: {
        absX: at,
        absY: rt,
        width: ce,
        height: pe,
        cell: We
      }
    }), $ === "drag" && b && x({
      ...b,
      end: {
        absX: at,
        absY: rt,
        width: ce,
        height: pe,
        cell: We
      }
    }), $ === "end" && b && (b.start.cell.row !== We.row || b.start.cell.column !== We.column ? (C(void 0), W(), x({
      ...b,
      end: {
        absX: at,
        absY: rt,
        width: ce,
        height: pe,
        cell: We
      }
    })) : x(void 0));
  }, be = ve(() => {
    const $ = b;
    if (!($ != null && $.end)) return;
    const J = S.findIndex((ce) => ce.key === $.start.cell.column), Y = S.findIndex((ce) => ce.key === $.end.cell.column);
    if (!(J < 0 || Y < 0))
      return {
        minCol: Math.min(J, Y),
        maxCol: Math.max(J, Y),
        minRow: Math.min($.start.cell.rowIndex, $.end.cell.rowIndex),
        maxRow: Math.max($.start.cell.rowIndex, $.end.cell.rowIndex)
      };
  }, [b, S]), Ce = ($) => {
    if (e.infoHeader)
      return e.infoHeader.columnNames().includes($.key) ? e.infoHeader.get($.key, 0) : " ";
  }, re = kk({
    scroll: f,
    rowVirtualizer: F,
    columns: S,
    visibleColumns: N,
    table: n
  }), st = ve(() => {
    const $ = Math.max((e.bottomRowsPaddingAmount ?? 6) - ((n == null ? void 0 : n.size) || 0), 0);
    return $ ? /* @__PURE__ */ h(_k, { cfg: o, columns: S, height: $ }) : void 0;
  }, [e.bottomRowsPaddingAmount, n == null ? void 0 : n.size, o, S]);
  return e.error ? /* @__PURE__ */ h(
    "div",
    {
      className: ze(
        "w-full relative bg-red-200 text-red-800 text-sm text-center border rounded-md p-2",
        "border-red-700"
      ),
      children: "There was an error loading data. Please try again."
    }
  ) : !(n != null && n.size) && !(S != null && S.length) ? /* @__PURE__ */ h("div", { className: "h-32 w-full relative", children: /* @__PURE__ */ h(nr, { cover: !0 }) }) : /* @__PURE__ */ h(Cu, { children: /* @__PURE__ */ h("div", { className: "flex overflow-hidden", children: /* @__PURE__ */ L(
    "div",
    {
      ref: i,
      onScroll: ($) => y({
        x: $.currentTarget.scrollLeft,
        y: $.currentTarget.scrollTop
      }),
      onKeyDownCapture: se,
      tabIndex: 0,
      className: ze(" pretty-scrollbar w-0 grow outline-none relative", [
        e.disableScrolling ? "" : "overflow-y-auto overflow-x-auto"
      ]),
      children: [
        /* @__PURE__ */ L(
          "table",
          {
            className: ze(`supertable ${R}`, r && "w-full"),
            style: { minHeight: e.minHeight ?? void 0 },
            children: [
              /* @__PURE__ */ h("colgroup", { children: S.map(($) => {
                const J = o.usePositionalColumnSizing ? `column-${$.sourceColIndex}` : $.key, Y = Math.max(
                  s.columnPositions[J] || 0,
                  $.minWidth || o.minColumnWidth
                ), ce = r ? `${$.fixedPercentageWidth}%` : `${Y}px`;
                return /* @__PURE__ */ h(
                  "col",
                  {
                    style: $.split ? {
                      width: "0.5rem",
                      minWidth: "0.5rem",
                      maxWidth: "0.5rem"
                    } : {
                      minWidth: $.groupColumn ? "24px" : Y ? ce : "50px",
                      maxWidth: $.groupColumn ? "24px" : void 0,
                      width: $.groupColumn ? "24px" : ce
                    }
                  },
                  $.key
                );
              }) }),
              /* @__PURE__ */ L("thead", { className: e.theadClassName ?? "", children: [
                T.map(($, J) => /* @__PURE__ */ h(
                  Gf,
                  {
                    "attr-key": `${J}-grp-row`,
                    onChangeHeight: (Y) => E(J, Y),
                    children: $.map((Y, ce) => {
                      const pe = !!(ce === $.length - 1 || $[ce + 1].split);
                      return /* @__PURE__ */ h(
                        "th",
                        {
                          "attr-key": `${ce}-th`,
                          rowSpan: Y.rowspan,
                          className: ze(
                            "sticky",
                            Y.split && "th-new-splitter bg-gradient-to-r from-neutral-container to-transparent",
                            Y.isPartOfGroup ? Y.name ? "th-is-group" : "th-group-path" : void 0,
                            "font-medium"
                          ),
                          style: {
                            top: `${D[J]}px`,
                            left: Y.leftStickyOffset !== void 0 ? `${Y.leftStickyOffset}px` : void 0,
                            // isHeadOfGroup should be on top of other groups (vertical text)
                            // and if the group is sticky, it should be on top of every other group
                            zIndex: Y.leftStickyOffset !== void 0 ? 25 : Y.isHeadOfGroup ? 18 : 15
                          },
                          colSpan: Y.colspan,
                          children: /* @__PURE__ */ h("div", { className: Y.aditionalClasses, children: Y.isPartOfGroup && Y.name ? /* @__PURE__ */ L(
                            "div",
                            {
                              className: ze(
                                "text-xs bg-table-bg-header vertical-group",
                                pe && "border-r",
                                Y.aditionalClasses
                              ),
                              style: {
                                minHeight: `${100 + T.length * 32}px`
                              },
                              children: [
                                Y.component ? Y.component : "",
                                Y.name
                              ]
                            }
                          ) : /* @__PURE__ */ h(ke, { children: Y.viewComponent ? /* @__PURE__ */ h("div", { className: "grow", children: /* @__PURE__ */ h(Y.viewComponent, { isCollapsed: Y.areSubgroupsCollapsed }) }) : /* @__PURE__ */ L("div", { className: "grow w-0 text-xs flex justify-center items-center px-2 whitespace-nowrap min-w-0", children: [
                            Y.component ? Y.component : "",
                            /* @__PURE__ */ h(
                              Wg,
                              {
                                text: Y.name,
                                className: "align-middle text-ellipsis overflow-hidden whitespace-nowrap min-w-0"
                              }
                            )
                          ] }) }) })
                        },
                        `${ce}-th`
                      );
                    })
                  },
                  `${J}-grp-row`
                )),
                /* @__PURE__ */ h(Gf, { children: S.map(
                  ($, J) => {
                    var Y;
                    return $.groupColumn ? /* @__PURE__ */ h(Sk, { id: J, topPosition: D[D.length - 1] }, $.key) : $.split ? /* @__PURE__ */ h(
                      Tk,
                      {
                        id: J,
                        column: $,
                        state: s,
                        topPosition: D[T.length],
                        cfg: o
                      },
                      $.key
                    ) : /* @__PURE__ */ h(
                      YP,
                      {
                        columns: S,
                        column: $,
                        id: J,
                        state: s,
                        hooks: a,
                        cfg: o,
                        aditionalClasses: $.aditionalClasses,
                        leftSection: $.filterable && e.onFilterChange && /* @__PURE__ */ h(
                          Ck,
                          {
                            column: $,
                            filters: e.filters ? e.filters[$.key] : [],
                            onLoadFilters: $.onLoadFilters,
                            onFilterChange: e.onFilterChange,
                            onOpenPopover: d,
                            openedPopover: u
                          }
                        ),
                        rightSection: $.sortable && e.onSort && /* @__PURE__ */ h(
                          Ik,
                          {
                            column: $,
                            sort: e.sort ? e.sort : null,
                            onSort: e.onSort
                          }
                        ),
                        topPosition: D[T.length],
                        showInfoRow: !!e.infoHeader,
                        infoRow: e.infoHeader ? Ce($) : void 0,
                        disableResize: r,
                        hasActiveFilter: !!(e.filters && ((Y = e.filters[$.key]) != null && Y.length))
                      },
                      $.key
                    );
                  }
                ) }, "column-row")
              ] }),
              /* @__PURE__ */ L("tbody", { children: [
                /* @__PURE__ */ h(
                  "tr",
                  {
                    style: {
                      height: `${I.start + k}px`,
                      display: `${I.start ? "table-row" : "none"}`
                    }
                  }
                ),
                F.getVirtualItems().map(($) => {
                  const J = $.index, Y = n.object(J);
                  return /* @__PURE__ */ h(
                    E1,
                    {
                      onDrag: ie,
                      hooks: a,
                      visibleColumns: N,
                      rowIndex: J,
                      rowSize: $.size,
                      columns: S,
                      record: Y,
                      state: s,
                      selectedCells: _,
                      dragBlock: be,
                      cellValidations: re,
                      onRowsCommit: (ce) => {
                        var pe;
                        e.onRowsCommit && e.onRowsCommit(ce), (pe = i.current) == null || pe.focus();
                      },
                      editingCell: w,
                      onToggleEdit: oe,
                      onChangeEditCellValue: q,
                      onCellSelect: U,
                      cfg: o
                    },
                    Y.key
                  );
                }),
                st,
                /* @__PURE__ */ h(
                  "tr",
                  {
                    className: "bottom-virtual-row",
                    style: {
                      height: `${B}px`,
                      display: `${B ? "table-row" : "none"}`
                    },
                    children: /* @__PURE__ */ h("td", { children: " " })
                  }
                )
              ] })
            ]
          }
        ),
        !n || e.status ? /* @__PURE__ */ h(
          "div",
          {
            className: "z-50 absolute bg-neutral-container/50  place-content-center place-items-center",
            style: {
              left: `${(_t = i.current) == null ? void 0 : _t.scrollLeft}px`,
              top: `${(en = i.current) == null ? void 0 : en.scrollTop}px`,
              width: `${(xr = i.current) == null ? void 0 : xr.clientWidth}px`,
              height: `${(Et = i.current) == null ? void 0 : Et.clientHeight}px`
            },
            children: e.status === ty.ERROR ? /* @__PURE__ */ h("div", { className: "text-red-500", children: /* @__PURE__ */ h(oC, {}) }) : /* @__PURE__ */ h(nr, { cover: !0, transparent: !0 })
          }
        ) : void 0
      ]
    }
  ) }) });
};
function wW() {
  return /* @__PURE__ */ h("div", { className: "w-full relative h-32", children: /* @__PURE__ */ h(nr, { cover: !0 }) });
}
function xW(e) {
  const { trueLabel: t = "Yes", falseLabel: n = "No" } = e, r = e.value === !0 ? t : e.value === !1 ? n : "-", o = [
    {
      key: "true",
      label: t
    },
    {
      key: "false",
      label: n
    },
    e.nullable ? {
      key: "undefined",
      label: "Not defined"
    } : void 0
  ].filter(Boolean), i = (a) => a === "undefined" ? void 0 : a === "true", s = e.value === void 0 || e.value === null ? "undefined" : e.value ? "true" : "false";
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ h(
      "select",
      {
        value: s,
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0",
        onChange: (a) => e.onChange && e.onChange(i(a.currentTarget.value)),
        autoFocus: !0,
        children: o.map((a) => /* @__PURE__ */ h("option", { value: a.key, children: a.label }, a.key))
      }
    ),
    " "
  ] }) : /* @__PURE__ */ h(gr, { ...e, value: r });
}
function CW(e) {
  return /* @__PURE__ */ h("div", { className: "datatable-header-left flex items-center gap-2", children: e.children });
}
function SW(e) {
  return /* @__PURE__ */ h("div", { className: "datatable-header-left flex items-center gap-2", children: e.children });
}
function TW({
  search: e,
  onSearch: t,
  heading: n,
  hooks: r,
  children: o,
  filters: i,
  clearFilters: s,
  colapsableTable: a = !0
}) {
  return /* @__PURE__ */ L("div", { className: ze("flex items-center justify-between mb-4"), children: [
    n && /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h("h2", { className: "text-xl font-semibold", children: n }) }),
    /* @__PURE__ */ h("div", { className: "flex items-center grow gap-2", children: o }),
    /* @__PURE__ */ L("div", { className: "flex items-center overflow-hidden", children: [
      t && /* @__PURE__ */ L("div", { className: "flex items-center py-4", children: [
        /* @__PURE__ */ h(
          fi,
          {
            type: "search",
            placeholder: "Search",
            onInput: (l) => {
              t && t(l.target.value), l.preventDefault();
            },
            value: e,
            className: "max-w-sm pr-10"
          }
        ),
        /* @__PURE__ */ h(Dl, { className: "relative right-7 top-3 transform -translate-y-1/2" })
      ] }),
      /* @__PURE__ */ h(
        GT,
        {
          datatableHooks: r,
          filters: i,
          clearFilters: s,
          colapsableTable: a
        }
      )
    ] })
  ] });
}
function EW(e) {
  let { value: t } = e;
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ h(
      "input",
      {
        value: t ?? "",
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0 disable-stepper",
        autoFocus: !0,
        onInput: (n) => e.onChange && e.onChange(n.currentTarget.value)
      }
    ),
    " "
  ] }) : /* @__PURE__ */ h(gr, { ...e });
}
function Lk(e) {
  var r, o;
  const { mask: t } = e.column;
  let { value: n } = e;
  if (t) {
    const i = ((o = (r = t == null ? void 0 : t.split(".")) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0;
    n = n || n === 0 ? xC(n, i) : void 0;
  }
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ h(
      "input",
      {
        value: n ?? "",
        type: "number",
        className: "bg-transparent outline-none absolute top-0 right-0 bottom-0 left-0 disable-stepper",
        step: 0.01,
        autoFocus: !0,
        onInput: (i) => e.onChange && e.onChange(i.currentTarget.value)
      }
    ),
    " "
  ] }) : /* @__PURE__ */ h(gr, { ...e });
}
function $k(e) {
  const [t, n] = he(""), r = e.numDecimals ?? 2;
  me(() => {
    e.isEditing ? n(e.value ? `${(+e.value * 100).toFixed(r)}` : "") : n("");
  }, [e.isEditing]);
  const o = (i) => {
    n(i), e.onChange && e.onChange(+i / 100);
  };
  return e.isEditing ? /* @__PURE__ */ L("div", { className: "overflow-x-hidden text-ellipsis relative w-full", children: [
    /* @__PURE__ */ L("div", { className: "flex gap-2 absolute inset-0", children: [
      /* @__PURE__ */ h(
        "input",
        {
          value: t,
          type: "number",
          className: "bg-transparent outline-none disable-stepper shrink min-w-0",
          step: 0.01,
          autoFocus: !0,
          onInput: (i) => o(i.currentTarget.value)
        }
      ),
      /* @__PURE__ */ h("div", { className: "grow", children: "%" })
    ] }),
    " "
  ] }) : /* @__PURE__ */ h(gr, { ...e });
}
function PW(e) {
  return /* @__PURE__ */ h(ke, { children: /* @__PURE__ */ h("td", { ...e, className: `${e.className ?? ""} overflow-hidden text-ellipsis whitespace-nowrap`, children: e.children }) });
}
function kW(e) {
  return e.value;
}
function DW(e) {
  const t = (n) => {
  };
  return /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => t(e.column), children: /* @__PURE__ */ h(iC, { className: "size-3" }) });
}
function RW({
  direction: e,
  column: t,
  hooks: n,
  state: r
}) {
  return /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => {
  }, children: /* @__PURE__ */ h(e === 1 ? sC : aC, { className: "size-3", color: "gray" }) });
}
function MW({ column: e, sort: t, onSort: n }) {
  const r = e.key === (t == null ? void 0 : t.field), o = (t == null ? void 0 : t.order) === "asc";
  return /* @__PURE__ */ h(ke, { children: n && /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => {
    n && n(r && !o ? void 0 : { field: e.key, order: r && o ? "desc" : "asc" });
  }, children: /* @__PURE__ */ h(t ? r ? o ? lC : cC : Jd : Jd, { className: "size-3", color: r ? "black" : "gray" }) }) });
}
function NW(e) {
  const t = e.state.lockedColumns.includes(e.column.key), n = (r) => {
    t ? e.hooks.unlockColumns([r.key]) : e.hooks.lockColumns([r.key]);
  };
  return /* @__PURE__ */ h("div", { role: "button", className: "p-1", onClick: () => n(e.column), children: t ? /* @__PURE__ */ h(uC, { className: "size-3" }) : /* @__PURE__ */ h(dC, { className: "size-3" }) });
}
const Fk = ({ checkboxProps: e, labelProps: t, hasChildren: n }) => {
  const r = () => {
    if (n)
      return /* @__PURE__ */ h(jr, { className: "text-input-active -mr-2 peer-disabled:text-input-active/50" });
  };
  return /* @__PURE__ */ L(
    "div",
    {
      "aria-checked": !!e.checked || void 0,
      onClick: t.onOpenChange,
      className: "flex z-10 justify-between group w-full p-2 bg-table-bg border-b border-neutral-borders hover:bg-filters-hover items-center gap-2 has-[:disabled]:border-neutral-borders/50 aria-[checked]:bg-table-primary-highlight",
      children: [
        /* @__PURE__ */ L("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ h($u, { ...e }),
          /* @__PURE__ */ h("label", { className: "text-md text-input-text font-medium leading-6 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", children: t.label })
        ] }),
        r()
      ]
    }
  );
}, oy = ({
  nodes: e,
  ancestors: t,
  handleCheckboxChange: n,
  depth: r,
  useAutoWidth: o
}) => {
  var u;
  const [i, s] = he(), a = e.find(({ id: d }) => d === i), l = o ? {
    width: `${100 / r}%`
  } : {}, c = r !== t.length + 1;
  return /* @__PURE__ */ L(ke, { children: [
    /* @__PURE__ */ h("div", { className: ze("flex flex-col border-neutral-borders h-full", { "border-r": c }), style: l, children: /* @__PURE__ */ h("div", { className: "overflow-y-auto pretty-scrollbar grow h-0", children: e.map((d, f) => {
      const { id: m, label: v, checked: g, childrenNodes: y, disabled: b } = d;
      return /* @__PURE__ */ h(
        Fk,
        {
          checkboxProps: { checked: g, onClick: (w) => {
            w.stopPropagation(), n({ node: d, ancestors: t });
          }, disabled: b },
          labelProps: { id: m, label: v, onOpenChange: () => s(m) },
          hasChildren: !!(y != null && y.length)
        },
        f
      );
    }) }) }),
    !!((u = a == null ? void 0 : a.childrenNodes) != null && u.length) && /* @__PURE__ */ h(
      oy,
      {
        depth: r,
        useAutoWidth: o,
        nodes: a.childrenNodes,
        handleCheckboxChange: n,
        ancestors: [...t, a.id]
      }
    )
  ] });
};
var za = "rovingFocusGroup.onEntryFocus", Vk = { bubbles: !1, cancelable: !0 }, hi = "RovingFocusGroup", [Ql, iy, Bk] = Qs(hi), [Wk, sy] = Bt(
  hi,
  [Bk]
), [zk, jk] = Wk(hi), ay = p.forwardRef(
  (e, t) => /* @__PURE__ */ h(Ql.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ h(Ql.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ h(Hk, { ...e, ref: t }) }) })
);
ay.displayName = hi;
var Hk = p.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = p.useRef(null), m = ye(t, f), v = Su(i), [g, y] = _n({
    prop: s,
    defaultProp: a ?? null,
    onChange: l,
    caller: hi
  }), [b, x] = p.useState(!1), w = Qe(c), C = iy(n), E = p.useRef(!1), [S, T] = p.useState(0);
  return p.useEffect(() => {
    const P = f.current;
    if (P)
      return P.addEventListener(za, w), () => P.removeEventListener(za, w);
  }, [w]), /* @__PURE__ */ h(
    zk,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: g,
      onItemFocus: p.useCallback(
        (P) => y(P),
        [y]
      ),
      onItemShiftTab: p.useCallback(() => x(!0), []),
      onFocusableItemAdd: p.useCallback(
        () => T((P) => P + 1),
        []
      ),
      onFocusableItemRemove: p.useCallback(
        () => T((P) => P - 1),
        []
      ),
      children: /* @__PURE__ */ h(
        le.div,
        {
          tabIndex: b || S === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: j(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: j(e.onFocus, (P) => {
            const D = !E.current;
            if (P.target === P.currentTarget && D && !b) {
              const k = new CustomEvent(za, Vk);
              if (P.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
                const R = C().filter((V) => V.focusable), A = R.find((V) => V.active), F = R.find((V) => V.id === g), B = [A, F, ...R].filter(
                  Boolean
                ).map((V) => V.ref.current);
                uy(B, u);
              }
            }
            E.current = !1;
          }),
          onBlur: j(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), ly = "RovingFocusGroupItem", cy = p.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: s,
      ...a
    } = e, l = bn(), c = i || l, u = jk(ly, n), d = u.currentTabStopId === c, f = iy(n), { onFocusableItemAdd: m, onFocusableItemRemove: v, currentTabStopId: g } = u;
    return p.useEffect(() => {
      if (r)
        return m(), () => v();
    }, [r, m, v]), /* @__PURE__ */ h(
      Ql.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ h(
          le.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: t,
            onMouseDown: j(e.onMouseDown, (y) => {
              r ? u.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: j(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: j(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const b = Gk(y, u.orientation, u.dir);
              if (b !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let w = f().filter((C) => C.focusable).map((C) => C.ref.current);
                if (b === "last") w.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && w.reverse();
                  const C = w.indexOf(y.currentTarget);
                  w = u.loop ? Kk(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => uy(w));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: d, hasTabStop: g != null }) : s
          }
        )
      }
    );
  }
);
cy.displayName = ly;
var Uk = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Yk(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Gk(e, t, n) {
  const r = Yk(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Uk[r];
}
function uy(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Kk(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Xk = ay, qk = cy, Jl = ["Enter", " "], Zk = ["ArrowDown", "PageUp", "Home"], dy = ["ArrowUp", "PageDown", "End"], Qk = [...Zk, ...dy], Jk = {
  ltr: [...Jl, "ArrowRight"],
  rtl: [...Jl, "ArrowLeft"]
}, eD = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, fa = "Menu", [Uo, tD, nD] = Qs(fa), [yr, fy] = Bt(fa, [
  nD,
  $n,
  sy
]), Vu = $n(), hy = sy(), [AW, ao] = yr(fa), [_W, mi] = yr(fa), rD = "MenuAnchor", Bu = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Vu(n);
    return /* @__PURE__ */ h(ai, { ...o, ...r, ref: t });
  }
);
Bu.displayName = rD;
var oD = "MenuPortal", [OW, my] = yr(oD, {
  forceMount: void 0
}), Lt = "MenuContent", [iD, Wu] = yr(Lt), py = p.forwardRef(
  (e, t) => {
    const n = my(Lt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = ao(Lt, e.__scopeMenu), s = mi(Lt, e.__scopeMenu);
    return /* @__PURE__ */ h(Uo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ h(ft, { present: r || i.open, children: /* @__PURE__ */ h(Uo.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ h(sD, { ...o, ref: t }) : /* @__PURE__ */ h(aD, { ...o, ref: t }) }) }) });
  }
), sD = p.forwardRef(
  (e, t) => {
    const n = ao(Lt, e.__scopeMenu), r = p.useRef(null), o = ye(t, r);
    return p.useEffect(() => {
      const i = r.current;
      if (i) return ii(i);
    }, []), /* @__PURE__ */ h(
      zu,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: j(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), aD = p.forwardRef((e, t) => {
  const n = ao(Lt, e.__scopeMenu);
  return /* @__PURE__ */ h(
    zu,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), lD = /* @__PURE__ */ er("MenuContent.ScrollLock"), zu = p.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: m,
      disableOutsideScroll: v,
      ...g
    } = e, y = ao(Lt, n), b = mi(Lt, n), x = Vu(n), w = hy(n), C = tD(n), [E, S] = p.useState(null), T = p.useRef(null), P = ye(t, T, y.onContentChange), D = p.useRef(0), k = p.useRef(""), R = p.useRef(0), A = p.useRef(null), F = p.useRef("right"), I = p.useRef(0), B = v ? oi : p.Fragment, V = v ? { as: lD, allowPinchZoom: !0 } : void 0, N = (_) => {
      var U, oe;
      const W = k.current + _, te = C().filter((q) => !q.disabled), O = document.activeElement, z = (U = te.find((q) => q.ref.current === O)) == null ? void 0 : U.textValue, Q = te.map((q) => q.textValue), K = wD(Q, W, z), se = (oe = te.find((q) => q.textValue === K)) == null ? void 0 : oe.ref.current;
      (function q(ie) {
        k.current = ie, window.clearTimeout(D.current), ie !== "" && (D.current = window.setTimeout(() => q(""), 1e3));
      })(W), se && setTimeout(() => se.focus());
    };
    p.useEffect(() => () => window.clearTimeout(D.current), []), Fs();
    const M = p.useCallback((_) => {
      var te, O;
      return F.current === ((te = A.current) == null ? void 0 : te.side) && CD(_, (O = A.current) == null ? void 0 : O.area);
    }, []);
    return /* @__PURE__ */ h(
      iD,
      {
        scope: n,
        searchRef: k,
        onItemEnter: p.useCallback(
          (_) => {
            M(_) && _.preventDefault();
          },
          [M]
        ),
        onItemLeave: p.useCallback(
          (_) => {
            var W;
            M(_) || ((W = T.current) == null || W.focus(), S(null));
          },
          [M]
        ),
        onTriggerLeave: p.useCallback(
          (_) => {
            M(_) && _.preventDefault();
          },
          [M]
        ),
        pointerGraceTimerRef: R,
        onPointerGraceIntentChange: p.useCallback((_) => {
          A.current = _;
        }, []),
        children: /* @__PURE__ */ h(B, { ...V, children: /* @__PURE__ */ h(
          ri,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: j(i, (_) => {
              var W;
              _.preventDefault(), (W = T.current) == null || W.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ h(
              pr,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: m,
                children: /* @__PURE__ */ h(
                  Xk,
                  {
                    asChild: !0,
                    ...w,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: E,
                    onCurrentTabStopIdChange: S,
                    onEntryFocus: j(l, (_) => {
                      b.isUsingKeyboardRef.current || _.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ h(
                      Us,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Ny(y.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...x,
                        ...g,
                        ref: P,
                        style: { outline: "none", ...g.style },
                        onKeyDown: j(g.onKeyDown, (_) => {
                          const te = _.target.closest("[data-radix-menu-content]") === _.currentTarget, O = _.ctrlKey || _.altKey || _.metaKey, z = _.key.length === 1;
                          te && (_.key === "Tab" && _.preventDefault(), !O && z && N(_.key));
                          const Q = T.current;
                          if (_.target !== Q || !Qk.includes(_.key)) return;
                          _.preventDefault();
                          const se = C().filter((U) => !U.disabled).map((U) => U.ref.current);
                          dy.includes(_.key) && se.reverse(), yD(se);
                        }),
                        onBlur: j(e.onBlur, (_) => {
                          _.currentTarget.contains(_.target) || (window.clearTimeout(D.current), k.current = "");
                        }),
                        onPointerMove: j(
                          e.onPointerMove,
                          Yo((_) => {
                            const W = _.target, te = I.current !== _.clientX;
                            if (_.currentTarget.contains(W) && te) {
                              const O = _.clientX > I.current ? "right" : "left";
                              F.current = O, I.current = _.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
py.displayName = Lt;
var cD = "MenuGroup", ju = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ h(le.div, { role: "group", ...r, ref: t });
  }
);
ju.displayName = cD;
var uD = "MenuLabel", gy = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ h(le.div, { ...r, ref: t });
  }
);
gy.displayName = uD;
var xs = "MenuItem", Kf = "menu.itemSelect", ha = p.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = p.useRef(null), s = mi(xs, e.__scopeMenu), a = Wu(xs, e.__scopeMenu), l = ye(t, i), c = p.useRef(!1), u = () => {
      const d = i.current;
      if (!n && d) {
        const f = new CustomEvent(Kf, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Kf, (m) => r == null ? void 0 : r(m), { once: !0 }), Jc(d, f), f.defaultPrevented ? c.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ h(
      vy,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: j(e.onClick, u),
        onPointerDown: (d) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, d), c.current = !0;
        },
        onPointerUp: j(e.onPointerUp, (d) => {
          var f;
          c.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: j(e.onKeyDown, (d) => {
          const f = a.searchRef.current !== "";
          n || f && d.key === " " || Jl.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
ha.displayName = xs;
var vy = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = Wu(xs, n), a = hy(n), l = p.useRef(null), c = ye(t, l), [u, d] = p.useState(!1), [f, m] = p.useState("");
    return p.useEffect(() => {
      const v = l.current;
      v && m((v.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ h(
      Uo.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? f,
        children: /* @__PURE__ */ h(qk, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ h(
          le.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: j(
              e.onPointerMove,
              Yo((v) => {
                r ? s.onItemLeave(v) : (s.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: j(
              e.onPointerLeave,
              Yo((v) => s.onItemLeave(v))
            ),
            onFocus: j(e.onFocus, () => d(!0)),
            onBlur: j(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), dD = "MenuCheckboxItem", yy = p.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ h(Sy, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ h(
      ha,
      {
        role: "menuitemcheckbox",
        "aria-checked": Cs(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Uu(n),
        onSelect: j(
          o.onSelect,
          () => r == null ? void 0 : r(Cs(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
yy.displayName = dD;
var by = "MenuRadioGroup", [fD, hD] = yr(
  by,
  { value: void 0, onValueChange: () => {
  } }
), wy = p.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = Qe(r);
    return /* @__PURE__ */ h(fD, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ h(ju, { ...o, ref: t }) });
  }
);
wy.displayName = by;
var xy = "MenuRadioItem", Cy = p.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = hD(xy, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ h(Sy, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ h(
      ha,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": Uu(i),
        onSelect: j(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Cy.displayName = xy;
var Hu = "MenuItemIndicator", [Sy, mD] = yr(
  Hu,
  { checked: !1 }
), Ty = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = mD(Hu, n);
    return /* @__PURE__ */ h(
      ft,
      {
        present: r || Cs(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ h(
          le.span,
          {
            ...o,
            ref: t,
            "data-state": Uu(i.checked)
          }
        )
      }
    );
  }
);
Ty.displayName = Hu;
var pD = "MenuSeparator", Ey = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ h(
      le.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Ey.displayName = pD;
var gD = "MenuArrow", Py = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Vu(n);
    return /* @__PURE__ */ h(Ys, { ...o, ...r, ref: t });
  }
);
Py.displayName = gD;
var vD = "MenuSub", [IW, ky] = yr(vD), Eo = "MenuSubTrigger", Dy = p.forwardRef(
  (e, t) => {
    const n = ao(Eo, e.__scopeMenu), r = mi(Eo, e.__scopeMenu), o = ky(Eo, e.__scopeMenu), i = Wu(Eo, e.__scopeMenu), s = p.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, u = p.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return p.useEffect(() => u, [u]), p.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [a, l]), /* @__PURE__ */ h(Bu, { asChild: !0, ...c, children: /* @__PURE__ */ h(
      vy,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Ny(n.open),
        ...e,
        ref: ni(t, o.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = e.onClick) == null || f.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: j(
          e.onPointerMove,
          Yo((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: j(
          e.onPointerLeave,
          Yo((d) => {
            var m, v;
            u();
            const f = (m = n.content) == null ? void 0 : m.getBoundingClientRect();
            if (f) {
              const g = (v = n.content) == null ? void 0 : v.dataset.side, y = g === "right", b = y ? -5 : 5, x = f[y ? "left" : "right"], w = f[y ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + b, y: d.clientY },
                  { x, y: f.top },
                  { x: w, y: f.top },
                  { x: w, y: f.bottom },
                  { x, y: f.bottom }
                ],
                side: g
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: j(e.onKeyDown, (d) => {
          var m;
          const f = i.searchRef.current !== "";
          e.disabled || f && d.key === " " || Jk[r.dir].includes(d.key) && (n.onOpenChange(!0), (m = n.content) == null || m.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
Dy.displayName = Eo;
var Ry = "MenuSubContent", My = p.forwardRef(
  (e, t) => {
    const n = my(Lt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = ao(Lt, e.__scopeMenu), s = mi(Lt, e.__scopeMenu), a = ky(Ry, e.__scopeMenu), l = p.useRef(null), c = ye(t, l);
    return /* @__PURE__ */ h(Uo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ h(ft, { present: r || i.open, children: /* @__PURE__ */ h(Uo.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ h(
      zu,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: j(e.onFocusOutside, (u) => {
          u.target !== a.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: j(e.onEscapeKeyDown, (u) => {
          s.onClose(), u.preventDefault();
        }),
        onKeyDown: j(e.onKeyDown, (u) => {
          var m;
          const d = u.currentTarget.contains(u.target), f = eD[s.dir].includes(u.key);
          d && f && (i.onOpenChange(!1), (m = a.trigger) == null || m.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
My.displayName = Ry;
function Ny(e) {
  return e ? "open" : "closed";
}
function Cs(e) {
  return e === "indeterminate";
}
function Uu(e) {
  return Cs(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function yD(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function bD(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function wD(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = bD(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function xD(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], l = t[s], c = a.x, u = a.y, d = l.x, f = l.y;
    u > r != f > r && n < (d - c) * (r - u) / (f - u) + c && (o = !o);
  }
  return o;
}
function CD(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return xD(n, t);
}
function Yo(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var SD = Bu, TD = py, ED = ju, PD = gy, kD = ha, DD = yy, RD = wy, MD = Cy, ND = Ty, AD = Ey, _D = Py, OD = Dy, ID = My, Ay = "DropdownMenu", [LD] = Bt(
  Ay,
  [fy]
), At = fy(), [LW, _y] = LD(Ay), Oy = "DropdownMenuTrigger", $D = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = _y(Oy, n), s = At(n);
    return /* @__PURE__ */ h(SD, { asChild: !0, ...s, children: /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: ni(t, i.triggerRef),
        onPointerDown: j(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
        }),
        onKeyDown: j(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
$D.displayName = Oy;
var Iy = "DropdownMenuContent", FD = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = _y(Iy, n), i = At(n), s = p.useRef(!1);
    return /* @__PURE__ */ h(
      TD,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: j(e.onCloseAutoFocus, (a) => {
          var l;
          s.current || (l = o.triggerRef.current) == null || l.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: j(e.onInteractOutside, (a) => {
          const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!o.modal || u) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
FD.displayName = Iy;
var VD = "DropdownMenuGroup", BD = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ h(ED, { ...o, ...r, ref: t });
  }
);
BD.displayName = VD;
var WD = "DropdownMenuLabel", Ly = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ h(PD, { ...o, ...r, ref: t });
  }
);
Ly.displayName = WD;
var zD = "DropdownMenuItem", jD = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ h(kD, { ...o, ...r, ref: t });
  }
);
jD.displayName = zD;
var HD = "DropdownMenuCheckboxItem", UD = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(DD, { ...o, ...r, ref: t });
});
UD.displayName = HD;
var YD = "DropdownMenuRadioGroup", GD = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(RD, { ...o, ...r, ref: t });
});
GD.displayName = YD;
var KD = "DropdownMenuRadioItem", XD = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(MD, { ...o, ...r, ref: t });
});
XD.displayName = KD;
var qD = "DropdownMenuItemIndicator", ZD = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(ND, { ...o, ...r, ref: t });
});
ZD.displayName = qD;
var QD = "DropdownMenuSeparator", JD = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(AD, { ...o, ...r, ref: t });
});
JD.displayName = QD;
var eR = "DropdownMenuArrow", tR = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ h(_D, { ...o, ...r, ref: t });
  }
);
tR.displayName = eR;
var nR = "DropdownMenuSubTrigger", rR = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(OD, { ...o, ...r, ref: t });
});
rR.displayName = nR;
var oR = "DropdownMenuSubContent", iR = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ h(
    ID,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
iR.displayName = oR;
var sR = Ly;
const aR = (e, t) => {
  const n = ae();
  return Ie(
    (...r) => {
      const o = () => {
        clearTimeout(n.current), e(...r);
      };
      clearTimeout(n.current), n.current = setTimeout(o, t);
    },
    [e, t]
  );
}, $y = (e) => !e || e.length === 0 ? 0 : 1 + Math.max(...e.map(({ childrenNodes: t }) => $y(t))), lR = ({ value: e, id: t, ancestors: n }) => {
  if (!n.length)
    return e.find((o) => o.id === t);
  let r;
  return n.forEach((o) => {
    r && r.childrenNodes ? r = r.childrenNodes.find((i) => i.id === o) : r = e.find((i) => i.id === o);
  }), r.childrenNodes.find((o) => o.id === t);
}, cR = ({ value: e, ancestors: t }) => {
  if (!t.length)
    return;
  const n = [];
  t.forEach((r) => {
    const o = n.length ? n[0].childrenNodes : e;
    if (o) {
      const i = o.find((s) => s.id === r);
      i && n.unshift(i);
    }
  }), n.forEach((r) => {
    var o, i;
    (o = r == null ? void 0 : r.childrenNodes) != null && o.every((s) => s.checked === !0) ? r.checked = !0 : (i = r == null ? void 0 : r.childrenNodes) != null && i.every((s) => !s.checked) ? r.checked = !1 : r.checked = "indeterminate";
  });
}, Fy = (e) => {
  const t = e.checked;
  e.childrenNodes && e.childrenNodes.forEach((n) => {
    n.disabled || (n.checked = t, Fy(n));
  });
}, Vy = ({ node: e, search: t }) => {
  var r;
  if (!((r = e.childrenNodes) != null && r.length))
    return e.label.toLowerCase().includes(t.toLowerCase()) ? e : void 0;
  const n = e.childrenNodes.map((o) => Vy({ node: o, search: t })).filter(Boolean);
  return n.length ? { ...e, childrenNodes: n } : void 0;
}, uR = (e) => ["indeterminate", !1].includes(e) || !1, dR = (e) => {
  var t, n;
  e.checked = ((t = e.childrenNodes) == null ? void 0 : t.every(({ checked: r }) => r === !0)) || !1, !e.checked && ((n = e.childrenNodes) != null && n.some(({ checked: r }) => [!0, "indeterminate"].includes(r))) && (e.checked = "indeterminate");
}, By = ({
  filteredNodes: e,
  fullNodes: t,
  checked: n
}) => {
  e.forEach(({ id: r, childrenNodes: o }) => {
    var s;
    const i = t.find((a) => a.id === r);
    i && (o != null && o.length && ((s = i.childrenNodes) != null && s.length) ? (By({
      filteredNodes: o,
      fullNodes: i.childrenNodes,
      checked: n
    }), dR(i)) : i.disabled || (i.checked = n));
  });
}, Wy = ({ value: e = [], onChange: t, error: n, useAutoWidth: r }) => {
  const [o, i] = he(""), s = ve(() => o ? Dt(e, (u) => (u = u.map((f) => Vy({ node: f, search: o })).filter(Boolean), u)) : e, [e, o]), a = ({ node: { id: u, disabled: d }, ancestors: f }) => {
    if (!d) {
      const m = Dt(e, (v) => {
        const g = lR({
          value: v,
          id: u,
          ancestors: f
        });
        g.checked = uR(g.checked), Fy(g), cR({ value: v, ancestors: f });
      });
      t(m);
    }
  }, l = (u) => {
    const d = Dt(e, (f) => {
      By({
        filteredNodes: s,
        fullNodes: f,
        checked: u
      });
    });
    t(d);
  }, c = aR(({ target: { value: u } }) => {
    i(u);
  }, 500);
  return /* @__PURE__ */ L("div", { className: "flex flex-col h-full mb-4", children: [
    /* @__PURE__ */ L("div", { className: "flex align-end items-center justify-between mb-2", children: [
      /* @__PURE__ */ h(Ou, { label: "Search", onChange: c }),
      /* @__PURE__ */ L("div", { className: "grow flex flex-row text-button-primary-outline-default space-x-2 text-sm justify-end", children: [
        /* @__PURE__ */ h(Ee, { onClick: () => l(!0), variant: "ghost", children: "Select all" }),
        /* @__PURE__ */ h(Vo, { orientation: "vertical", className: "h-auto" }),
        /* @__PURE__ */ h(Ee, { onClick: () => l(!1), variant: "ghost", children: "Deselect all" })
      ] })
    ] }),
    /* @__PURE__ */ h(
      "div",
      {
        "aria-errormessage": n || void 0,
        className: "grow flex flex-col border border-neutral-border rounded-md overflow-hidden aria-[errormessage]:border-red-500",
        children: /* @__PURE__ */ h("div", { className: "flex grow", children: /* @__PURE__ */ h(
          oy,
          {
            depth: $y(e),
            useAutoWidth: r,
            nodes: s,
            ancestors: [],
            handleCheckboxChange: a
          }
        ) })
      }
    ),
    n && /* @__PURE__ */ h(
      sR,
      {
        "aria-errormessage": n,
        className: "block z-10 text-xs aria-disabled:text-neutral-text-secondary/50 text-red-500 aria-disabled:text-red-500/50",
        children: n
      }
    )
  ] });
}, zy = (e) => {
  switch (e) {
    case "large":
      return "min-h-[32rem]";
    case "medium":
      return "min-h-[24rem]";
    case "small":
    default:
      return "min-h-[16rem]";
  }
}, fR = [Lk, $k, vs], hR = (e) => {
  var t;
  return [(t = e.group) == null ? void 0 : t.map((n) => n.label), e.name].filter(Boolean).join(" > ");
}, mR = ({ columns: e, value: t, onChange: n, size: r }) => {
  const o = ve(() => e.filter((a) => !a.readOnly && fR.includes(a.component)).map((a) => ({
    id: a.key,
    label: hR(a)
  })), [e]), i = ve(() => o.map((a) => ({
    ...a,
    checked: t.includes(a.id)
  })), [o, t]), s = (a) => {
    const l = a.filter((c) => c.checked === !0).map((c) => c.id);
    n(l);
  };
  return /* @__PURE__ */ L("div", { className: `p-2 py-4 ${zy(r)}`, children: [
    /* @__PURE__ */ h("div", { className: "text-neutral-text-primary font-bold text-xl pb-2", children: "Columns" }),
    /* @__PURE__ */ h(Wy, { value: i, onChange: s, useAutoWidth: !0 })
  ] });
}, pR = ({
  column: e,
  value: t,
  onChange: n,
  table: r,
  size: o,
  sortValuesByLookupLabel: i = !1,
  customOrder: s
}) => {
  const a = ve(() => {
    if (!r) return [];
    const d = r.select([e.key]).dedupe().array(e.key).map((f) => ({
      id: f,
      label: Kr(f, e.lookup, e.mask)
    }));
    return s && s.length ? [...d].sort((f, m) => {
      const v = s.indexOf(f.id), g = s.indexOf(m.id);
      return (v === -1 ? Number.MAX_SAFE_INTEGER : v) - (g === -1 ? Number.MAX_SAFE_INTEGER : g);
    }) : i ? [...d].sort(
      (f, m) => f.label.localeCompare(m.label, void 0, { sensitivity: "base", numeric: !0 })
    ) : d;
  }, [r, e.key, e.lookup, e.mask, i, s]), l = ve(() => a.map((u) => ({
    ...u,
    checked: t.includes(u.id)
  })), [a, t]), c = (u) => {
    const d = u.filter((f) => f.checked === !0).map((f) => f.id);
    n(d);
  };
  return /* @__PURE__ */ L("div", { className: `p-2 py-4 ${zy(o)}`, children: [
    /* @__PURE__ */ h("div", { className: "text-neutral-text-primary font-bold text-xl pb-2", children: e.name }),
    /* @__PURE__ */ h(Wy, { value: l, onChange: c, useAutoWidth: !0 })
  ] });
}, Xf = (e) => {
  const t = e.size ? `input-${e.size}` : "input-md";
  return /* @__PURE__ */ h(Ft, { label: e.label, error: e.error, disabled: e.disabled, className: e.className, children: /* @__PURE__ */ L(na, { ...e, children: [
    /* @__PURE__ */ h(
      ra,
      {
        "aria-errormessage": e.error,
        className: ze("w-full0 border-0 data-[state=open]:[&>svg]:text-red-500", t),
        children: /* @__PURE__ */ h(Ru, { placeholder: e.placeholder || "" })
      }
    ),
    /* @__PURE__ */ h(oa, { children: /* @__PURE__ */ h(xv, { children: e.options.map(({ value: n, label: r }) => /* @__PURE__ */ h(ia, { value: n, children: r }, n)) }) })
  ] }) });
};
function gR(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const jy = G.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), pi = () => {
  const e = G.useContext(jy);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
gR(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,100%,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,-100%,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(-100%,0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(100%,0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,100%,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,100%,0)}}@keyframes slideFromTop{from{transform:translate3d(0,-100%,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,-100%,0)}}@keyframes slideFromLeft{from{transform:translate3d(-100%,0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(-100%,0,0)}}@keyframes slideFromRight{from{transform:translate3d(100%,0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(100%,0,0)}}`);
const vR = 24, yR = typeof window < "u" ? hr : me;
function qf(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
function bR() {
  return Yu(/^Mac/);
}
function wR() {
  return Yu(/^iPhone/);
}
function Zf() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function xR() {
  return Yu(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  bR() && navigator.maxTouchPoints > 1;
}
function Hy() {
  return wR() || xR();
}
function Yu(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const ja = typeof document < "u" && window.visualViewport;
function Qf(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function Uy(e) {
  for (Qf(e) && (e = e.parentElement); e && !Qf(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const CR = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let $i = 0, Ha;
function SR(e = {}) {
  let { isDisabled: t } = e;
  yR(() => {
    if (!t)
      return $i++, $i === 1 && Hy() && (Ha = TR()), () => {
        $i--, $i === 0 && (Ha == null || Ha());
      };
  }, [
    t
  ]);
}
function TR() {
  let e, t = 0, n = (d) => {
    e = Uy(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let f = d.changedTouches[0].pageY, m = e.scrollTop, v = e.scrollHeight - e.clientHeight;
    v !== 0 && ((m <= 0 && f > t || m >= v && f < t) && d.preventDefault(), t = f);
  }, o = (d) => {
    let f = d.target;
    ec(f) && f !== document.activeElement && (d.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, i = (d) => {
    let f = d.target;
    ec(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", ja && (ja.height < window.innerHeight ? requestAnimationFrame(() => {
        Jf(f);
      }) : ja.addEventListener("resize", () => Jf(f), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, c = qf(ER(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = qf(yo(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), yo(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), yo(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), yo(document, "focus", i, !0), yo(window, "scroll", s));
  return () => {
    c(), u(), window.scrollTo(a, l);
  };
}
function ER(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function yo(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Jf(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = Uy(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + vR;
      i > s && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function ec(e) {
  return e instanceof HTMLInputElement && !CR.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function PR(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function kR(...e) {
  return (t) => e.forEach((n) => PR(n, t));
}
function Yy(...e) {
  return p.useCallback(kR(...e), e);
}
const Gy = /* @__PURE__ */ new WeakMap();
function et(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && Gy.set(e, r);
}
function DR(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = Gy.get(e);
  n && (e.style[t] = n[t]);
}
const nt = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Fi(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[nt(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[nt(t) ? 5 : 4]) : null);
}
function RR(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Ua(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function MR(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const He = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, Ky = 0.4, NR = 0.25, AR = 100, Xy = 8, jn = 16, tc = 26, Ya = "vaul-dragging";
function qy(e) {
  const t = G.useRef(e);
  return G.useEffect(() => {
    t.current = e;
  }), G.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function _R({ defaultProp: e, onChange: t }) {
  const n = G.useState(e), [r] = n, o = G.useRef(r), i = qy(t);
  return G.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function Zy({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = _R({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = qy(n), l = G.useCallback((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && a(d);
    } else
      o(c);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function OR({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: s, direction: a = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = Zy({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [f, m] = G.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  G.useEffect(() => {
    function T() {
      m({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, []);
  const v = G.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), g = G.useMemo(() => n == null ? void 0 : n.findIndex((T) => T === u), [
    n,
    u
  ]), y = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === u || !n, b = G.useMemo(() => {
    const T = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var P;
    return (P = n == null ? void 0 : n.map((D) => {
      const k = typeof D == "string";
      let R = 0;
      if (k && (R = parseInt(D, 10)), nt(a)) {
        const F = k ? R : f ? D * T.height : 0;
        return f ? a === "bottom" ? T.height - F : -T.height + F : F;
      }
      const A = k ? R : f ? D * T.width : 0;
      return f ? a === "right" ? T.width - A : -T.width + A : A;
    })) != null ? P : [];
  }, [
    n,
    f,
    l
  ]), x = G.useMemo(() => g !== null ? b == null ? void 0 : b[g] : null, [
    b,
    g
  ]), w = G.useCallback((T) => {
    var P;
    const D = (P = b == null ? void 0 : b.findIndex((k) => k === T)) != null ? P : null;
    s(D), et(r.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: nt(a) ? `translate3d(0, ${T}px, 0)` : `translate3d(${T}px, 0, 0)`
    }), b && D !== b.length - 1 && D !== i && D < i ? et(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "0"
    }) : et(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(D, 0)]);
  }, [
    r.current,
    n,
    b,
    i,
    o,
    d
  ]);
  G.useEffect(() => {
    if (u || e) {
      var T;
      const P = (T = n == null ? void 0 : n.findIndex((D) => D === e || D === u)) != null ? T : -1;
      b && P !== -1 && typeof b[P] == "number" && w(b[P]);
    }
  }, [
    u,
    e,
    n,
    b,
    w
  ]);
  function C({ draggedDistance: T, closeDrawer: P, velocity: D, dismissible: k }) {
    if (i === void 0) return;
    const R = a === "bottom" || a === "right" ? (x ?? 0) - T : (x ?? 0) + T, A = g === i - 1, F = g === 0, I = T > 0;
    if (A && et(o.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`
    }), !c && D > 2 && !I) {
      k ? P() : w(b[0]);
      return;
    }
    if (!c && D > 2 && I && b && n) {
      w(b[n.length - 1]);
      return;
    }
    const B = b == null ? void 0 : b.reduce((N, M) => typeof N != "number" || typeof M != "number" ? N : Math.abs(M - R) < Math.abs(N - R) ? M : N), V = nt(a) ? window.innerHeight : window.innerWidth;
    if (D > Ky && Math.abs(T) < V * 0.4) {
      const N = I ? 1 : -1;
      if (N > 0 && v) {
        w(b[n.length - 1]);
        return;
      }
      if (F && N < 0 && k && P(), g === null) return;
      w(b[g + N]);
      return;
    }
    w(B);
  }
  function E({ draggedDistance: T }) {
    if (x === null) return;
    const P = a === "bottom" || a === "right" ? x - T : x + T;
    (a === "bottom" || a === "right") && P < b[b.length - 1] || (a === "top" || a === "left") && P > b[b.length - 1] || et(r.current, {
      transform: nt(a) ? `translate3d(0, ${P}px, 0)` : `translate3d(${P}px, 0, 0)`
    });
  }
  function S(T, P) {
    if (!n || typeof g != "number" || !b || i === void 0) return null;
    const D = g === i - 1;
    if (g >= i && P)
      return 0;
    if (D && !P) return 1;
    if (!y && !D) return null;
    const R = D ? g + 1 : g - 1, A = D ? b[R] - b[R - 1] : b[R + 1] - b[R], F = T / Math.abs(A);
    return D ? 1 - F : F;
  }
  return {
    isLastSnapPoint: v,
    activeSnapPoint: u,
    shouldFade: y,
    getPercentageDragged: S,
    setActiveSnapPoint: d,
    activeSnapPointIndex: g,
    onRelease: C,
    onDrag: E,
    snapPointsOffset: b
  };
}
const IR = () => () => {
};
function LR() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = pi(), i = G.useRef(null), s = ve(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - tc) / window.innerWidth;
  }
  G.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      MR(r && !o ? Ua(document.body, {
        background: "black"
      }) : IR, Ua(l, {
        transformOrigin: nt(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${He.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${He.EASE.join(",")})`
      }));
      const c = Ua(l, {
        borderRadius: `${Xy}px`,
        overflow: "hidden",
        ...nt(e) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), i.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, He.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let bo = null;
function $R({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [s, a] = G.useState(() => typeof window < "u" ? window.location.href : ""), l = G.useRef(0), c = G.useCallback(() => {
    if (Zf() && bo === null && e && !i) {
      bo = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const m = f - window.innerHeight;
        m && l.current >= f && (document.body.style.top = `${-(l.current + m)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = G.useCallback(() => {
    if (Zf() && bo !== null && !i) {
      const d = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, bo), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(f, d);
      }), bo = null;
    }
  }, [
    s
  ]);
  return G.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), G.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    r,
    s,
    t,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function FR({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: s = !1, setBackgroundColorOnScale: a = !0, closeThreshold: l = NR, scrollLockTimeout: c = AR, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: f = i && i.length - 1, activeSnapPoint: m, setActiveSnapPoint: v, fixed: g, modal: y = !0, onClose: b, nested: x, noBodyStyles: w, direction: C = "bottom", defaultOpen: E = !1, disablePreventScroll: S = !0, snapToSequentialPoint: T = !1, preventScrollRestoration: P = !1, repositionInputs: D = !0, onAnimationEnd: k, container: R, autoFocus: A = !1 }) {
  var F, I;
  const [B = !1, V] = Zy({
    defaultProp: E,
    prop: e,
    onChange: (de) => {
      t == null || t(de), !de && !x && at(), setTimeout(() => {
        k == null || k(de);
      }, He.DURATION * 1e3), de && !y && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), de || (document.body.style.pointerEvents = "auto");
    }
  }), [N, M] = G.useState(!1), [_, W] = G.useState(!1), [te, O] = G.useState(!1), z = G.useRef(null), Q = G.useRef(null), K = G.useRef(null), se = G.useRef(null), U = G.useRef(null), oe = G.useRef(!1), q = G.useRef(null), ie = G.useRef(0), be = G.useRef(!1), Ce = G.useRef(0), re = G.useRef(null), st = G.useRef(((F = re.current) == null ? void 0 : F.getBoundingClientRect().height) || 0), Tt = G.useRef(((I = re.current) == null ? void 0 : I.getBoundingClientRect().width) || 0), _t = G.useRef(0), en = G.useCallback((de) => {
    i && de === Y.length - 1 && (Q.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: xr, activeSnapPointIndex: Et, setActiveSnapPoint: $, onRelease: J, snapPointsOffset: Y, onDrag: ce, shouldFade: pe, getPercentageDragged: We } = OR({
    snapPoints: i,
    activeSnapPointProp: m,
    setActiveSnapPointProp: v,
    drawerRef: re,
    fadeFromIndex: f,
    overlayRef: z,
    onSnapPointChange: en,
    direction: C,
    container: R,
    snapToSequentialPoint: T
  });
  SR({
    isDisabled: !B || _ || !y || te || !N || !D || !S
  });
  const { restorePositionSetting: at } = $R({
    isOpen: B,
    modal: y,
    nested: x,
    hasBeenOpened: N,
    preventScrollRestoration: P,
    noBodyStyles: w
  });
  function rt() {
    return (window.innerWidth - tc) / window.innerWidth;
  }
  function ue(de) {
    var xe, _e;
    !u && !i || re.current && !re.current.contains(de.target) || (st.current = ((xe = re.current) == null ? void 0 : xe.getBoundingClientRect().height) || 0, Tt.current = ((_e = re.current) == null ? void 0 : _e.getBoundingClientRect().width) || 0, W(!0), K.current = /* @__PURE__ */ new Date(), Hy() && window.addEventListener("touchend", () => oe.current = !1, {
      once: !0
    }), de.target.setPointerCapture(de.pointerId), ie.current = nt(C) ? de.pageY : de.pageX);
  }
  function Re(de, xe) {
    var _e, Oe;
    let Pe = de;
    const lt = (_e = window.getSelection()) == null ? void 0 : _e.toString(), Je = re.current ? Fi(re.current, C) : null, ct = /* @__PURE__ */ new Date();
    if (Pe.hasAttribute("data-vaul-no-drag") || Pe.closest("[data-vaul-no-drag]"))
      return !1;
    if (C === "right" || C === "left")
      return !0;
    if (Q.current && ct.getTime() - Q.current.getTime() < 500)
      return !1;
    if (Je !== null && (C === "bottom" ? Je > 0 : Je < 0))
      return !0;
    if (lt && lt.length > 0)
      return !1;
    if (ct.getTime() - ((Oe = U.current) == null ? void 0 : Oe.getTime()) < c && Je === 0 || xe)
      return U.current = ct, !1;
    for (; Pe; ) {
      if (Pe.scrollHeight > Pe.clientHeight) {
        if (Pe.scrollTop !== 0)
          return U.current = /* @__PURE__ */ new Date(), !1;
        if (Pe.getAttribute("role") === "dialog")
          return !0;
      }
      Pe = Pe.parentNode;
    }
    return !0;
  }
  function Te(de) {
    if (re.current && _) {
      const xe = C === "bottom" || C === "right" ? 1 : -1, _e = (ie.current - (nt(C) ? de.pageY : de.pageX)) * xe, Oe = _e > 0, Pe = i && !u && !Oe;
      if (Pe && Et === 0) return;
      const lt = Math.abs(_e), Je = document.querySelector("[data-vaul-drawer-wrapper]"), ct = C === "bottom" || C === "top" ? st.current : Tt.current;
      let Pt = lt / ct;
      const jt = We(lt, Oe);
      if (jt !== null && (Pt = jt), Pe && Pt >= 1 || !oe.current && !Re(de.target, Oe)) return;
      if (re.current.classList.add(Ya), oe.current = !0, et(re.current, {
        transition: "none"
      }), et(z.current, {
        transition: "none"
      }), i && ce({
        draggedDistance: _e
      }), Oe && !i) {
        const nn = RR(_e), Di = Math.min(nn * -1, 0) * xe;
        et(re.current, {
          transform: nt(C) ? `translate3d(0, ${Di}px, 0)` : `translate3d(${Di}px, 0, 0)`
        });
        return;
      }
      const bt = 1 - Pt;
      if ((pe || f && Et === f - 1) && (r == null || r(de, Pt), et(z.current, {
        opacity: `${bt}`,
        transition: "none"
      }, !0)), Je && z.current && s) {
        const nn = Math.min(rt() + Pt * (1 - rt()), 1), Di = 8 - Pt * 8, Qd = Math.max(0, 14 - Pt * 14);
        et(Je, {
          borderRadius: `${Di}px`,
          transform: nt(C) ? `scale(${nn}) translate3d(0, ${Qd}px, 0)` : `scale(${nn}) translate3d(${Qd}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const nn = lt * xe;
        et(re.current, {
          transform: nt(C) ? `translate3d(0, ${nn}px, 0)` : `translate3d(${nn}px, 0, 0)`
        });
      }
    }
  }
  G.useEffect(() => {
    var de;
    function xe() {
      if (!re.current || !D) return;
      const _e = document.activeElement;
      if (ec(_e) || be.current) {
        var Oe;
        const Pe = ((Oe = window.visualViewport) == null ? void 0 : Oe.height) || 0, lt = window.innerHeight;
        let Je = lt - Pe;
        const ct = re.current.getBoundingClientRect().height || 0, Pt = ct > lt * 0.8;
        _t.current || (_t.current = ct);
        const jt = re.current.getBoundingClientRect().top;
        if (Math.abs(Ce.current - Je) > 60 && (be.current = !be.current), i && i.length > 0 && Y && Et) {
          const bt = Y[Et] || 0;
          Je += bt;
        }
        if (Ce.current = Je, ct > Pe || be.current) {
          const bt = re.current.getBoundingClientRect().height;
          let nn = bt;
          bt > Pe && (nn = Pe - (Pt ? jt : tc)), g ? re.current.style.height = `${bt - Math.max(Je, 0)}px` : re.current.style.height = `${Math.max(nn, Pe - jt)}px`;
        } else
          re.current.style.height = `${_t.current}px`;
        i && i.length > 0 && !be.current ? re.current.style.bottom = "0px" : re.current.style.bottom = `${Math.max(Je, 0)}px`;
      }
    }
    return (de = window.visualViewport) == null || de.addEventListener("resize", xe), () => {
      var _e;
      return (_e = window.visualViewport) == null ? void 0 : _e.removeEventListener("resize", xe);
    };
  }, [
    Et,
    i,
    Y
  ]);
  function Z(de) {
    mt(), b == null || b(), de || V(!1), setTimeout(() => {
      i && $(i[0]);
    }, He.DURATION * 1e3);
  }
  function H() {
    if (!re.current) return;
    const de = document.querySelector("[data-vaul-drawer-wrapper]"), xe = Fi(re.current, C);
    et(re.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`
    }), et(z.current, {
      transition: `opacity ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      opacity: "1"
    }), s && xe && xe > 0 && B && et(de, {
      borderRadius: `${Xy}px`,
      overflow: "hidden",
      ...nt(C) ? {
        transform: `scale(${rt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${rt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${He.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${He.EASE.join(",")})`
    }, !0);
  }
  function mt() {
    !_ || !re.current || (re.current.classList.remove(Ya), oe.current = !1, W(!1), se.current = /* @__PURE__ */ new Date());
  }
  function Le(de) {
    if (!_ || !re.current) return;
    re.current.classList.remove(Ya), oe.current = !1, W(!1), se.current = /* @__PURE__ */ new Date();
    const xe = Fi(re.current, C);
    if (!Re(de.target, !1) || !xe || Number.isNaN(xe) || K.current === null) return;
    const _e = se.current.getTime() - K.current.getTime(), Oe = ie.current - (nt(C) ? de.pageY : de.pageX), Pe = Math.abs(Oe) / _e;
    if (Pe > 0.05 && (O(!0), setTimeout(() => {
      O(!1);
    }, 200)), i) {
      J({
        draggedDistance: Oe * (C === "bottom" || C === "right" ? 1 : -1),
        closeDrawer: Z,
        velocity: Pe,
        dismissible: u
      }), o == null || o(de, !0);
      return;
    }
    if (C === "bottom" || C === "right" ? Oe > 0 : Oe < 0) {
      H(), o == null || o(de, !0);
      return;
    }
    if (Pe > Ky) {
      Z(), o == null || o(de, !1);
      return;
    }
    var lt;
    const Je = Math.min((lt = re.current.getBoundingClientRect().height) != null ? lt : 0, window.innerHeight);
    var ct;
    const Pt = Math.min((ct = re.current.getBoundingClientRect().width) != null ? ct : 0, window.innerWidth), jt = C === "left" || C === "right";
    if (Math.abs(xe) >= (jt ? Pt : Je) * l) {
      Z(), o == null || o(de, !1);
      return;
    }
    o == null || o(de, !0), H();
  }
  G.useEffect(() => (B && (et(document.documentElement, {
    scrollBehavior: "auto"
  }), Q.current = /* @__PURE__ */ new Date()), () => {
    DR(document.documentElement, "scrollBehavior");
  }), [
    B
  ]);
  function tn(de) {
    const xe = de ? (window.innerWidth - jn) / window.innerWidth : 1, _e = de ? -jn : 0;
    q.current && window.clearTimeout(q.current), et(re.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: `scale(${xe}) translate3d(0, ${_e}px, 0)`
    }), !de && re.current && (q.current = setTimeout(() => {
      const Oe = Fi(re.current, C);
      et(re.current, {
        transition: "none",
        transform: nt(C) ? `translate3d(0, ${Oe}px, 0)` : `translate3d(${Oe}px, 0, 0)`
      });
    }, 500));
  }
  function Cr(de, xe) {
    if (xe < 0) return;
    const _e = (window.innerWidth - jn) / window.innerWidth, Oe = _e + xe * (1 - _e), Pe = -jn + xe * jn;
    et(re.current, {
      transform: nt(C) ? `scale(${Oe}) translate3d(0, ${Pe}px, 0)` : `scale(${Oe}) translate3d(${Pe}px, 0, 0)`,
      transition: "none"
    });
  }
  function ki(de, xe) {
    const _e = nt(C) ? window.innerHeight : window.innerWidth, Oe = xe ? (_e - jn) / _e : 1, Pe = xe ? -jn : 0;
    xe && et(re.current, {
      transition: `transform ${He.DURATION}s cubic-bezier(${He.EASE.join(",")})`,
      transform: nt(C) ? `scale(${Oe}) translate3d(0, ${Pe}px, 0)` : `scale(${Oe}) translate3d(${Pe}px, 0, 0)`
    });
  }
  return /* @__PURE__ */ G.createElement(Zp, {
    defaultOpen: E,
    onOpenChange: (de) => {
      !u && !de || (de ? M(!0) : Z(!0), V(de));
    },
    open: B
  }, /* @__PURE__ */ G.createElement(jy.Provider, {
    value: {
      activeSnapPoint: xr,
      snapPoints: i,
      setActiveSnapPoint: $,
      drawerRef: re,
      overlayRef: z,
      onOpenChange: t,
      onPress: ue,
      onRelease: Le,
      onDrag: Te,
      dismissible: u,
      handleOnly: d,
      isOpen: B,
      isDragging: _,
      shouldFade: pe,
      closeDrawer: Z,
      onNestedDrag: Cr,
      onNestedOpenChange: tn,
      onNestedRelease: ki,
      keyboardIsOpen: be,
      modal: y,
      snapPointsOffset: Y,
      direction: C,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: a,
      noBodyStyles: w,
      container: R,
      autoFocus: A
    }
  }, n));
}
const Qy = /* @__PURE__ */ G.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: s, modal: a } = pi(), l = Yy(t, n), c = r && r.length > 0;
  return a ? /* @__PURE__ */ G.createElement(iu, {
    onMouseUp: o,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && c ? "true" : "false",
    "data-vaul-snap-points-overlay": s && i ? "true" : "false",
    ...e
  }) : (typeof window < "u" && window.requestAnimationFrame(() => {
    document.body.style.pointerEvents = "auto";
  }), null);
});
Qy.displayName = "Drawer.Overlay";
const Jy = /* @__PURE__ */ G.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: s, onRelease: a, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, modal: d, isOpen: f, direction: m, snapPoints: v, container: g, handleOnly: y, autoFocus: b } = pi(), [x, w] = G.useState(!1), C = Yy(o, i), E = G.useRef(null), S = G.useRef(null), T = G.useRef(!1), P = v && v.length > 0;
  LR();
  const D = (R, A, F = 0) => {
    if (T.current) return !0;
    const I = Math.abs(R.y), B = Math.abs(R.x), V = B > I, N = [
      "bottom",
      "right"
    ].includes(A) ? 1 : -1;
    if (A === "left" || A === "right") {
      if (!(R.x * N < 0) && B >= 0 && B <= F)
        return V;
    } else if (!(R.y * N < 0) && I >= 0 && I <= F)
      return !V;
    return T.current = !0, !0;
  };
  G.useEffect(() => {
    P && window.requestAnimationFrame(() => {
      w(!0);
    });
  }, []);
  function k(R) {
    E.current = null, T.current = !1, a(R);
  }
  return /* @__PURE__ */ G.createElement(su, {
    "data-vaul-drawer-direction": m,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": x ? "true" : "false",
    "data-vaul-snap-points": f && P ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    ...r,
    ref: C,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[0]}px`,
      ...t
    } : t,
    onPointerDown: (R) => {
      y || (r.onPointerDown == null || r.onPointerDown.call(r, R), E.current = {
        x: R.pageX,
        y: R.pageY
      }, s(R));
    },
    onOpenAutoFocus: (R) => {
      n == null || n(R), b || R.preventDefault();
    },
    onPointerDownOutside: (R) => {
      if (e == null || e(R), !d || R.defaultPrevented) {
        R.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (R) => {
      if (!d) {
        R.preventDefault();
        return;
      }
    },
    onPointerMove: (R) => {
      if (S.current = R, y || (r.onPointerMove == null || r.onPointerMove.call(r, R), !E.current)) return;
      const A = R.pageY - E.current.y, F = R.pageX - E.current.x, I = R.pointerType === "touch" ? 10 : 2;
      D({
        x: F,
        y: A
      }, m, I) ? l(R) : (Math.abs(F) > I || Math.abs(A) > I) && (E.current = null);
    },
    onPointerUp: (R) => {
      r.onPointerUp == null || r.onPointerUp.call(r, R), E.current = null, T.current = !1, a(R);
    },
    onPointerOut: (R) => {
      r.onPointerOut == null || r.onPointerOut.call(r, R), k(S.current);
    },
    onContextMenu: (R) => {
      r.onContextMenu == null || r.onContextMenu.call(r, R), k(S.current);
    }
  });
});
Jy.displayName = "Drawer.Content";
const VR = 250, BR = 120, WR = /* @__PURE__ */ G.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: s, activeSnapPoint: a, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: f, onDrag: m } = pi(), v = G.useRef(null), g = G.useRef(!1);
  function y() {
    if (g.current) {
      w();
      return;
    }
    window.setTimeout(() => {
      b();
    }, BR);
  }
  function b() {
    if (i || e || g.current) {
      w();
      return;
    }
    if (w(), (!s || s.length === 0) && c) {
      o();
      return;
    }
    if (a === s[s.length - 1] && c) {
      o();
      return;
    }
    const E = s.findIndex((T) => T === a);
    if (E === -1) return;
    const S = s[E + 1];
    l(S);
  }
  function x() {
    v.current = window.setTimeout(() => {
      g.current = !0;
    }, VR);
  }
  function w() {
    window.clearTimeout(v.current), g.current = !1;
  }
  return /* @__PURE__ */ G.createElement("div", {
    onClick: y,
    onPointerCancel: w,
    onPointerDown: (C) => {
      u && f(C), x();
    },
    onPointerMove: (C) => {
      u && m(C);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ G.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
WR.displayName = "Drawer.Handle";
function zR(e) {
  const t = pi(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ G.createElement(Jp, {
    container: n,
    ...r
  });
}
const Jt = {
  Root: FR,
  Content: Jy,
  Overlay: Qy,
  Trigger: Qp,
  Portal: zR,
  Close: cu,
  Title: au,
  Description: lu
}, eb = ({ shouldScaleBackground: e = !0, ...t }) => /* @__PURE__ */ h(Jt.Root, { shouldScaleBackground: e, ...t });
eb.displayName = "Drawer";
const $W = Jt.Trigger, jR = Jt.Portal, FW = Jt.Close, tb = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(Jt.Overlay, { ref: n, className: X("fixed inset-0 z-50 bg-black/80", e), ...t }));
tb.displayName = Jt.Overlay.displayName;
const nb = p.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(jR, { children: [
  /* @__PURE__ */ h(tb, {}),
  /* @__PURE__ */ h(
    Jt.Content,
    {
      ref: r,
      className: X(
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-l-2xl border bg-background",
        e
      ),
      ...n,
      children: t
    }
  )
] }));
nb.displayName = "DrawerContent";
const HR = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: X("grid gap-1.5 p-4 text-center sm:text-left", e), ...t });
HR.displayName = "DrawerHeader";
const UR = ({ className: e, ...t }) => /* @__PURE__ */ h("div", { className: X("mt-auto flex flex-col gap-2 p-4", e), ...t });
UR.displayName = "DrawerFooter";
const rb = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Jt.Title,
  {
    ref: n,
    className: X("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
rb.displayName = Jt.Title.displayName;
const YR = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(Jt.Description, { ref: n, className: X("text-sm text-muted-foreground", e), ...t }));
YR.displayName = Jt.Description.displayName;
const GR = mr(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), ob = p.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ h("div", { ref: r, role: "alert", className: X(GR({ variant: t }), e), ...n }));
ob.displayName = "Alert";
const ib = p.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ h("h5", { ref: n, className: X("mb-1 font-medium leading-none tracking-tight", e), ...t })
);
ib.displayName = "AlertTitle";
const sb = p.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ h("div", { ref: n, className: X("text-sm [&_p]:leading-relaxed", e), ...t })
);
sb.displayName = "AlertDescription";
const KR = ({
  isOpen: e,
  close: t,
  columns: n,
  onRowsCommit: r,
  onRowsSkipped: o,
  table: i,
  valueFormatter: s,
  size: a,
  columnsToHide: l = [],
  maxLength: c = 20,
  sortUsingLookup: u,
  sortUsingCustomOrder: d
}) => {
  const [f, m] = he({}), [v, g] = he([]), [y, b] = he("delta"), [x, w] = he("0"), C = Fu(), E = ve(() => {
    let k = n.filter((R) => R.filterable && !(l != null && l.includes(R.key)));
    return C && (k = C.applyLookups(k)), k;
  }, [n, l]), S = Ie(
    (k) => {
      var F;
      const R = n.find((I) => I.key === k);
      if (!R) return [];
      const A = (F = R.componentProps) == null ? void 0 : F.options;
      if (!A) return [];
      if (Array.isArray(A))
        return A.map((I) => ({ key: I.key, label: I.label }));
      if (typeof A == "function" && i) {
        const I = /* @__PURE__ */ new Map();
        for (const B of i.objects())
          try {
            const V = A(B.key, k, B);
            Array.isArray(V) && V.forEach((N) => {
              I.has(N.key) || I.set(N.key, { key: N.key, label: N.label });
            });
          } catch (V) {
            console.warn(`Error getting options for row ${B.key}:`, V);
          }
        return Array.from(I.values());
      }
      return [];
    },
    [n, i]
  ), T = ve(() => {
    const k = v.filter((A) => {
      var F;
      return ((F = n.find((I) => I.key === A)) == null ? void 0 : F.component) === vs;
    }).map((A) => {
      const F = S(A);
      return {
        key: A,
        optStr: F.map((I) => I.key).sort().join(",")
      };
    }), R = v.filter(
      (A) => {
        var F;
        return ((F = n.find((I) => I.key === A)) == null ? void 0 : F.dataType) === "number";
      }
    );
    return k.length && R.length ? "error_mixed" : k.length ? k.every((F) => F.optStr === k[0].optStr) ? "select" : "error_mixed" : R.length ? "number" : "none";
  }, [v, n, S]);
  me(() => {
    w("");
  }, [T]), me(() => {
    e || (m({}), g([]), w("0"));
  }, [e]);
  const P = ve(() => !(!i || T === "error_mixed" || !v.length || !Object.values(f).some((k) => k.length) || T === "number" && isNaN(Number(x)) || T === "select" && !x || x.length > c), [i, v, f, T, x]), D = () => {
    var I;
    if (!P) return;
    const k = yk(f, i), R = [];
    let A = 0;
    for (const B of v) {
      const V = n.find((M) => M.key === B);
      let N = 0;
      for (const M of k.objects()) {
        const _ = M[B];
        let W;
        if (T === "select") {
          W = x;
          const te = (I = V == null ? void 0 : V.componentProps) == null ? void 0 : I.options;
          if (typeof te == "function")
            try {
              const O = te(M.key, B, M);
              if (Array.isArray(O) && !O.some((Q) => Q.key === W)) {
                A++, N++;
                continue;
              }
            } catch (O) {
              console.warn(`Error validating option for row ${M.key}:`, O), A++, N++;
              continue;
            }
        } else
          V && V.dataType === "number" && V.mask === "100#.##%" ? W = Number(x) / 100 : W = x, W = s ? s(Number(W)) : Number(W);
        R.push({
          value: W,
          column: B,
          pasteValue: T === "select" ? W : y === "delta" ? (_ || 0) + W : W,
          row: M.key,
          rowIndex: N
        }), N++;
      }
    }
    const F = ny(R, k, n);
    F.length && r(F), A > 0 && o && o(A), t();
  };
  return /* @__PURE__ */ L(eb, { open: e, onOpenChange: (k) => !k && t(), direction: "right", children: [
    /* @__PURE__ */ h(rb, {}),
    /* @__PURE__ */ h(
      nb,
      {
        className: X("h-screen top-0 right-0 left-auto mt-0 p-4 xl:p-8 min-w-150 focus-visible:outline-0"),
        "data-vaul-no-drag": !0,
        style: {
          width: "60vw",
          borderTopRightRadius: "0",
          borderBottomRightRadius: "0"
        },
        children: /* @__PURE__ */ L("div", { className: "flex flex-col gap-4 grow", children: [
          /* @__PURE__ */ L("div", { className: "flex flex-col gap-2 grow pretty-scrollbar h-0 overflow-y-scroll", children: [
            E.map((k) => {
              var R;
              return /* @__PURE__ */ h(
                pR,
                {
                  column: k,
                  table: i,
                  value: ((R = f == null ? void 0 : f[k.key]) == null ? void 0 : R.map((A) => A.key)) || [],
                  onChange: (A) => {
                    m({
                      ...f,
                      [k.key]: A.map((F) => ({ key: F, label: F }))
                    });
                  },
                  size: a,
                  sortValuesByLookupLabel: u != null && u.includes(k.key),
                  customOrder: d == null ? void 0 : d[k.key]
                },
                k.key
              );
            }),
            /* @__PURE__ */ h(
              mR,
              {
                columns: n,
                value: v,
                onChange: (k) => {
                  g(k);
                },
                size: a
              }
            )
          ] }),
          /* @__PURE__ */ L("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ L("div", { className: "grow flex gap-2", children: [
              T === "error_mixed" && /* @__PURE__ */ L(
                ob,
                {
                  variant: "destructive",
                  className: "p-1 pl-2 text-sm bg-red-100 dark:bg-red-900 dark:text-white mb-2",
                  children: [
                    /* @__PURE__ */ h(ib, { children: "Mixed Input Types" }),
                    /* @__PURE__ */ h(sb, { children: "Mixed input types are not allowed. Please select only one type of input." })
                  ]
                }
              ),
              T === "select" && /* @__PURE__ */ h(
                Xf,
                {
                  label: "Value",
                  className: "w-full",
                  options: S(v[0]).map((k) => ({
                    label: k.label,
                    value: k.key
                  })) || [],
                  value: x,
                  onValueChange: (k) => w(k || "")
                }
              ),
              T === "number" && /* @__PURE__ */ L(ke, { children: [
                /* @__PURE__ */ h(
                  Xf,
                  {
                    label: "Mode",
                    className: "w-full",
                    options: [
                      {
                        label: "Delta",
                        value: "delta"
                      },
                      {
                        label: "Absolute",
                        value: "absolute"
                      }
                    ],
                    value: y,
                    onValueChange: (k) => b(k || "delta")
                  }
                ),
                /* @__PURE__ */ h(
                  Ou,
                  {
                    className: "w-full",
                    maxLength: c,
                    label: "Value",
                    value: x,
                    onChange: (k) => w(k.currentTarget.value)
                  }
                )
              ] })
            ] }),
            T !== "error_mixed" && /* @__PURE__ */ h(Ee, { disabled: !P, onClick: D, children: "Apply" })
          ] })
        ] })
      }
    )
  ] });
}, VW = ({
  trigger: e,
  columns: t,
  onRowsCommit: n,
  onRowsSkipped: r,
  table: o,
  valueFormatter: i,
  size: s,
  columnsToHide: a,
  sortUsingLookup: l,
  sortUsingCustomOrder: c
}) => {
  const [u, d] = he(!1);
  return /* @__PURE__ */ L(ke, { children: [
    e ? /* @__PURE__ */ h("div", { onClick: () => d(!0), children: e }) : /* @__PURE__ */ L(Ee, { className: "icon-left", variant: "outline", disabled: !o, onClick: () => d(!0), children: [
      /* @__PURE__ */ h(fC, {}),
      "Bulk Update"
    ] }),
    /* @__PURE__ */ h(
      KR,
      {
        isOpen: u,
        close: () => d(!1),
        columns: t,
        onRowsCommit: n,
        onRowsSkipped: r,
        table: o,
        valueFormatter: i,
        size: s,
        columnsToHide: a,
        sortUsingLookup: l,
        sortUsingCustomOrder: c
      }
    )
  ] });
}, BW = (e) => {
  const [t, n] = Au(e, {});
  return {
    filters: t,
    setFilters: (i, s) => {
      n({
        ...t,
        [i.key]: s
      });
    },
    clearFilters: () => {
      n({});
    }
  };
};
function XR() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ve(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const qR = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function ZR(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function QR(e) {
  return "nodeType" in e;
}
function ab(e) {
  var t, n;
  return e ? ZR(e) ? e : QR(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
const ma = qR ? hr : me;
function lb(e) {
  const t = ae(e);
  return ma(() => {
    t.current = e;
  }), Ie(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function nc(e, t) {
  t === void 0 && (t = [e]);
  const n = ae(e);
  return ma(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function rc(e) {
  const t = lb(e), n = ae(null), r = Ie(
    (o) => {
      o !== n.current && (t == null || t(o, n.current)), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
let Ga = {};
function cb(e, t) {
  return ve(() => {
    const n = Ga[e] == null ? 0 : Ga[e] + 1;
    return Ga[e] = n, e + "-" + n;
  }, [e, t]);
}
function JR(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = ab(e.target);
  return t && e instanceof t;
}
const Go = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Go.Translate.toString(e), Go.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
});
var Mo;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Mo || (Mo = {}));
function eh() {
}
const eM = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function tM(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function nM(e, t, n) {
  const r = tM(t);
  if (!r)
    return e;
  const {
    scaleX: o,
    scaleY: i,
    x: s,
    y: a
  } = r, l = e.left - s - (1 - o) * parseFloat(n), c = e.top - a - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), u = o ? e.width / o : e.width, d = i ? e.height / i : e.height;
  return {
    width: u,
    height: d,
    top: c,
    right: l + u,
    bottom: c + d,
    left: l
  };
}
const rM = {
  ignoreTransform: !1
};
function oM(e, t) {
  t === void 0 && (t = rM);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: c,
      transformOrigin: u
    } = ab(e).getComputedStyle(e);
    c && (n = nM(n, c, u));
  }
  const {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  } = n;
  return {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  };
}
var _r;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(_r || (_r = {}));
var th;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(th || (th = {}));
var Ot;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(Ot || (Ot = {}));
Ot.Space, Ot.Enter, Ot.Esc, Ot.Space, Ot.Enter, Ot.Tab;
var nh;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(nh || (nh = {}));
var rh;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(rh || (rh = {}));
var oh;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(oh || (oh = {}));
_r.Backward + "", _r.Forward + "", _r.Backward + "", _r.Forward + "";
var oc;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(oc || (oc = {}));
var ic;
(function(e) {
  e.Optimized = "optimized";
})(ic || (ic = {}));
function iM(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = lb(t), o = ve(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: i
      } = window;
      return new i(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return me(() => () => o == null ? void 0 : o.disconnect(), [o]), o;
}
function sM(e, t) {
  return ve(() => e.reduce((n, r) => {
    let {
      eventName: o,
      handler: i
    } = r;
    return n[o] = (s) => {
      i(s, t);
    }, n;
  }, {}), [e, t]);
}
oc.WhileDragging, ic.Optimized;
const aM = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: eh,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: eh
}, ub = /* @__PURE__ */ je(aM), lM = /* @__PURE__ */ je({
  ...eM,
  scaleX: 1,
  scaleY: 1
});
var ih;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(ih || (ih = {}));
const cM = /* @__PURE__ */ je(null), sh = "button", uM = "Draggable";
function dM(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: o
  } = e;
  const i = cb(uM), {
    activators: s,
    activatorEvent: a,
    active: l,
    activeNodeRect: c,
    ariaDescribedById: u,
    draggableNodes: d,
    over: f
  } = Se(ub), {
    role: m = sh,
    roleDescription: v = "draggable",
    tabIndex: g = 0
  } = o ?? {}, y = (l == null ? void 0 : l.id) === t, b = Se(y ? lM : cM), [x, w] = rc(), [C, E] = rc(), S = sM(s, t), T = nc(n);
  ma(
    () => (d.set(t, {
      id: t,
      key: i,
      node: x,
      activatorNode: C,
      data: T
    }), () => {
      const D = d.get(t);
      D && D.key === i && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const P = ve(() => ({
    role: m,
    tabIndex: g,
    "aria-disabled": r,
    "aria-pressed": y && m === sh ? !0 : void 0,
    "aria-roledescription": v,
    "aria-describedby": u.draggable
  }), [r, m, g, y, v, u.draggable]);
  return {
    active: l,
    activatorEvent: a,
    activeNodeRect: c,
    attributes: P,
    isDragging: y,
    listeners: r ? void 0 : S,
    node: x,
    over: f,
    setNodeRef: w,
    setActivatorNodeRef: E,
    transform: b
  };
}
const fM = "Droppable", hM = {
  timeout: 25
};
function mM(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: o
  } = e;
  const i = cb(fM), {
    active: s,
    dispatch: a,
    over: l,
    measureDroppableContainers: c
  } = Se(ub), u = ae({
    disabled: n
  }), d = ae(!1), f = ae(null), m = ae(null), {
    disabled: v,
    updateMeasurementsFor: g,
    timeout: y
  } = {
    ...hM,
    ...o
  }, b = nc(g ?? r), x = Ie(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      m.current != null && clearTimeout(m.current), m.current = setTimeout(() => {
        c(Array.isArray(b.current) ? b.current : [b.current]), m.current = null;
      }, y);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  ), w = iM({
    callback: x,
    disabled: v || !s
  }), C = Ie((P, D) => {
    w && (D && (w.unobserve(D), d.current = !1), P && w.observe(P));
  }, [w]), [E, S] = rc(C), T = nc(t);
  return me(() => {
    !w || !E.current || (w.disconnect(), d.current = !1, w.observe(E.current));
  }, [E, w]), me(
    () => (a({
      type: Mo.RegisterDroppable,
      element: {
        id: r,
        key: i,
        disabled: n,
        node: E,
        rect: f,
        data: T
      }
    }), () => a({
      type: Mo.UnregisterDroppable,
      key: i,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), me(() => {
    n !== u.current.disabled && (a({
      type: Mo.SetDroppableDisabled,
      id: r,
      key: i,
      disabled: n
    }), u.current.disabled = n);
  }, [r, i, n, a]), {
    active: s,
    rect: f,
    isOver: (l == null ? void 0 : l.id) === r,
    node: E,
    over: l,
    setNodeRef: S
  };
}
function db(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function Vi(e) {
  return e !== null && e >= 0;
}
const pM = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: o
  } = e;
  const i = db(t, r, n), s = t[o], a = i[o];
  return !a || !s ? null : {
    x: a.left - s.left,
    y: a.top - s.top,
    scaleX: a.width / s.width,
    scaleY: a.height / s.height
  };
}, gM = "Sortable", vM = /* @__PURE__ */ G.createContext({
  activeIndex: -1,
  containerId: gM,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: pM,
  disabled: {
    draggable: !1,
    droppable: !1
  }
}), yM = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: o
  } = e;
  return db(n, r, o).indexOf(t);
}, bM = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: o,
    items: i,
    newIndex: s,
    previousItems: a,
    previousContainerId: l,
    transition: c
  } = e;
  return !c || !r || a !== i && o === s ? !1 : n ? !0 : s !== o && t === l;
}, wM = {
  duration: 200,
  easing: "ease"
}, fb = "transform", xM = /* @__PURE__ */ Go.Transition.toString({
  property: fb,
  duration: 0,
  easing: "linear"
}), CM = {
  roleDescription: "sortable"
};
function SM(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: o
  } = e;
  const [i, s] = he(null), a = ae(n);
  return ma(() => {
    if (!t && n !== a.current && r.current) {
      const l = o.current;
      if (l) {
        const c = oM(r.current, {
          ignoreTransform: !0
        }), u = {
          x: l.left - c.left,
          y: l.top - c.top,
          scaleX: l.width / c.width,
          scaleY: l.height / c.height
        };
        (u.x || u.y) && s(u);
      }
    }
    n !== a.current && (a.current = n);
  }, [t, n, r, o]), me(() => {
    i && s(null);
  }, [i]), i;
}
function TM(e) {
  let {
    animateLayoutChanges: t = bM,
    attributes: n,
    disabled: r,
    data: o,
    getNewIndex: i = yM,
    id: s,
    strategy: a,
    resizeObserverConfig: l,
    transition: c = wM
  } = e;
  const {
    items: u,
    containerId: d,
    activeIndex: f,
    disabled: m,
    disableTransforms: v,
    sortedRects: g,
    overIndex: y,
    useDragOverlay: b,
    strategy: x
  } = Se(vM), w = EM(r, m), C = u.indexOf(s), E = ve(() => ({
    sortable: {
      containerId: d,
      index: C,
      items: u
    },
    ...o
  }), [d, o, C, u]), S = ve(() => u.slice(u.indexOf(s)), [u, s]), {
    rect: T,
    node: P,
    isOver: D,
    setNodeRef: k
  } = mM({
    id: s,
    data: E,
    disabled: w.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: S,
      ...l
    }
  }), {
    active: R,
    activatorEvent: A,
    activeNodeRect: F,
    attributes: I,
    setNodeRef: B,
    listeners: V,
    isDragging: N,
    over: M,
    setActivatorNodeRef: _,
    transform: W
  } = dM({
    id: s,
    data: E,
    attributes: {
      ...CM,
      ...n
    },
    disabled: w.draggable
  }), te = XR(k, B), O = !!R, z = O && !v && Vi(f) && Vi(y), Q = !b && N, K = Q && z ? W : null, U = z ? K ?? (a ?? x)({
    rects: g,
    activeNodeRect: F,
    activeIndex: f,
    overIndex: y,
    index: C
  }) : null, oe = Vi(f) && Vi(y) ? i({
    id: s,
    items: u,
    activeIndex: f,
    overIndex: y
  }) : C, q = R == null ? void 0 : R.id, ie = ae({
    activeId: q,
    items: u,
    newIndex: oe,
    containerId: d
  }), be = u !== ie.current.items, Ce = t({
    active: R,
    containerId: d,
    isDragging: N,
    isSorting: O,
    id: s,
    index: C,
    items: u,
    newIndex: ie.current.newIndex,
    previousItems: ie.current.items,
    previousContainerId: ie.current.containerId,
    transition: c,
    wasDragging: ie.current.activeId != null
  }), re = SM({
    disabled: !Ce,
    index: C,
    node: P,
    rect: T
  });
  return me(() => {
    O && ie.current.newIndex !== oe && (ie.current.newIndex = oe), d !== ie.current.containerId && (ie.current.containerId = d), u !== ie.current.items && (ie.current.items = u);
  }, [O, oe, d, u]), me(() => {
    if (q === ie.current.activeId)
      return;
    if (q != null && ie.current.activeId == null) {
      ie.current.activeId = q;
      return;
    }
    const Tt = setTimeout(() => {
      ie.current.activeId = q;
    }, 50);
    return () => clearTimeout(Tt);
  }, [q]), {
    active: R,
    activeIndex: f,
    attributes: I,
    data: E,
    rect: T,
    index: C,
    newIndex: oe,
    items: u,
    isOver: D,
    isSorting: O,
    isDragging: N,
    listeners: V,
    node: P,
    overIndex: y,
    over: M,
    setNodeRef: te,
    setActivatorNodeRef: _,
    setDroppableNodeRef: k,
    setDraggableNodeRef: B,
    transform: re ?? U,
    transition: st()
  };
  function st() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      re || // Or to prevent items jumping to back to their "new" position when items change
      be && ie.current.newIndex === C
    )
      return xM;
    if (!(Q && !JR(A) || !c) && (O || Ce))
      return Go.Transition.toString({
        ...c,
        property: fb
      });
  }
}
function EM(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
Ot.Down, Ot.Right, Ot.Up, Ot.Left;
const hb = je({});
function gi(e) {
  const t = ae(null);
  return t.current === null && (t.current = e()), t.current;
}
const PM = typeof window < "u", mb = PM ? hr : me, Gu = /* @__PURE__ */ je(null);
function Ku(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Ss(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
function kM([...e], t, n) {
  const r = t < 0 ? e.length + t : t;
  if (r >= 0 && r < e.length) {
    const o = n < 0 ? e.length + n : n, [i] = e.splice(t, 1);
    e.splice(o, 0, i);
  }
  return e;
}
const fn = (e, t, n) => n > t ? t : n < e ? e : n;
function sc(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let lo = () => {
}, qt = () => {
};
var sp;
typeof process < "u" && ((sp = process.env) == null ? void 0 : sp.NODE_ENV) !== "production" && (lo = (e, t, n) => {
  !e && typeof console < "u" && console.warn(sc(t, n));
}, qt = (e, t, n) => {
  if (!e)
    throw new Error(sc(t, n));
});
const Ln = {}, pb = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), gb = (e) => typeof e == "object" && e !== null, vb = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function yb(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const $t = /* @__NO_SIDE_EFFECTS__ */ (e) => e, vi = (...e) => e.reduce((t, n) => (r) => n(t(r))), Ko = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r ? (n - e) / r : 1;
};
class Xu {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Ku(this.subscriptions, t), () => Ss(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const s = this.subscriptions[i];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Ct = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, It = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, bb = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? e * (1e3 / t) : 0, ah = /* @__PURE__ */ new Set();
function qu(e, t, n) {
  e || ah.has(t) || (console.warn(sc(t, n)), ah.add(t));
}
const wb = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, DM = 1e-7, RM = 12;
function MM(e, t, n, r, o) {
  let i, s, a = 0;
  do
    s = t + (n - t) / 2, i = wb(s, r, o) - e, i > 0 ? n = s : t = s;
  while (Math.abs(i) > DM && ++a < RM);
  return s;
}
// @__NO_SIDE_EFFECTS__
function yi(e, t, n, r) {
  if (e === t && n === r)
    return $t;
  const o = (i) => MM(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : wb(o(i), t, r);
}
const xb = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Cb = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), Sb = /* @__PURE__ */ yi(0.33, 1.53, 0.69, 0.99), Zu = /* @__PURE__ */ Cb(Sb), Tb = /* @__PURE__ */ xb(Zu), Eb = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * Zu(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Qu = (e) => 1 - Math.sin(Math.acos(e)), Pb = /* @__PURE__ */ Cb(Qu), kb = /* @__PURE__ */ xb(Qu), NM = /* @__PURE__ */ yi(0.42, 0, 1, 1), AM = /* @__PURE__ */ yi(0, 0, 0.58, 1), Db = /* @__PURE__ */ yi(0.42, 0, 0.58, 1), _M = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number", Rb = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", lh = {
  linear: $t,
  easeIn: NM,
  easeInOut: Db,
  easeOut: AM,
  circIn: Qu,
  circInOut: kb,
  circOut: Pb,
  backIn: Zu,
  backInOut: Tb,
  backOut: Sb,
  anticipate: Eb
}, OM = (e) => typeof e == "string", ch = (e) => {
  if (/* @__PURE__ */ Rb(e)) {
    qt(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, o] = e;
    return /* @__PURE__ */ yi(t, n, r, o);
  } else if (OM(e))
    return qt(lh[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), lh[e];
  return e;
}, Bi = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function IM(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), o = !1, i = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(u) {
    s.has(u) && (c.schedule(u), e()), u(a);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, d = !1, f = !1) => {
      const v = f && o ? n : r;
      return d && s.add(u), v.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      r.delete(u), s.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (a = u, o) {
        i = !0;
        return;
      }
      o = !0;
      const d = n;
      n = r, r = d, n.forEach(l), n.clear(), o = !1, i && (i = !1, c.process(u));
    }
  };
  return c;
}
const LM = 40;
function Mb(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, s = Bi.reduce((w, C) => (w[C] = IM(i), w), {}), { setup: a, read: l, resolveKeyframes: c, preUpdate: u, update: d, preRender: f, render: m, postRender: v } = s, g = () => {
    const w = Ln.useManualTiming, C = w ? o.timestamp : performance.now();
    n = !1, w || (o.delta = r ? 1e3 / 60 : Math.max(Math.min(C - o.timestamp, LM), 1)), o.timestamp = C, o.isProcessing = !0, a.process(o), l.process(o), c.process(o), u.process(o), d.process(o), f.process(o), m.process(o), v.process(o), o.isProcessing = !1, n && t && (r = !1, e(g));
  }, y = () => {
    n = !0, r = !0, o.isProcessing || e(g);
  };
  return { schedule: Bi.reduce((w, C) => {
    const E = s[C];
    return w[C] = (S, T = !1, P = !1) => (n || y(), E.schedule(S, T, P)), w;
  }, {}), cancel: (w) => {
    for (let C = 0; C < Bi.length; C++)
      s[Bi[C]].cancel(w);
  }, state: o, steps: s };
}
const { schedule: Ae, cancel: Cn, state: ut, steps: Ka } = /* @__PURE__ */ Mb(typeof requestAnimationFrame < "u" ? requestAnimationFrame : $t, !0);
let qi;
function $M() {
  qi = void 0;
}
const pt = {
  now: () => (qi === void 0 && pt.set(ut.isProcessing || Ln.useManualTiming ? ut.timestamp : performance.now()), qi),
  set: (e) => {
    qi = e, queueMicrotask($M);
  }
}, Nb = (e) => (t) => typeof t == "string" && t.startsWith(e), Ab = /* @__PURE__ */ Nb("--"), FM = /* @__PURE__ */ Nb("var(--"), Ju = (e) => FM(e) ? VM.test(e.split("/*")[0].trim()) : !1, VM = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function uh(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const co = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Xo = {
  ...co,
  transform: (e) => fn(0, 1, e)
}, Wi = {
  ...co,
  default: 1
}, No = (e) => Math.round(e * 1e5) / 1e5, ed = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function BM(e) {
  return e == null;
}
const WM = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, td = (e, t) => (n) => !!(typeof n == "string" && WM.test(n) && n.startsWith(e) || t && !BM(n) && Object.prototype.hasOwnProperty.call(n, t)), _b = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, i, s, a] = r.match(ed);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, zM = (e) => fn(0, 255, e), Xa = {
  ...co,
  transform: (e) => Math.round(zM(e))
}, Xn = {
  test: /* @__PURE__ */ td("rgb", "red"),
  parse: /* @__PURE__ */ _b("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Xa.transform(e) + ", " + Xa.transform(t) + ", " + Xa.transform(n) + ", " + No(Xo.transform(r)) + ")"
};
function jM(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const ac = {
  test: /* @__PURE__ */ td("#"),
  parse: jM,
  transform: Xn.transform
}, bi = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), yn = /* @__PURE__ */ bi("deg"), dn = /* @__PURE__ */ bi("%"), ne = /* @__PURE__ */ bi("px"), HM = /* @__PURE__ */ bi("vh"), UM = /* @__PURE__ */ bi("vw"), dh = {
  ...dn,
  parse: (e) => dn.parse(e) / 100,
  transform: (e) => dn.transform(e * 100)
}, Or = {
  test: /* @__PURE__ */ td("hsl", "hue"),
  parse: /* @__PURE__ */ _b("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + dn.transform(No(t)) + ", " + dn.transform(No(n)) + ", " + No(Xo.transform(r)) + ")"
}, Ze = {
  test: (e) => Xn.test(e) || ac.test(e) || Or.test(e),
  parse: (e) => Xn.test(e) ? Xn.parse(e) : Or.test(e) ? Or.parse(e) : ac.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Xn.transform(e) : Or.transform(e),
  getAnimatableNone: (e) => {
    const t = Ze.parse(e);
    return t.alpha = 0, Ze.transform(t);
  }
}, YM = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function GM(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(ed)) == null ? void 0 : t.length) || 0) + (((n = e.match(YM)) == null ? void 0 : n.length) || 0) > 0;
}
const Ob = "number", Ib = "color", KM = "var", XM = "var(", fh = "${}", qM = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Xr(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const a = t.replace(qM, (l) => (Ze.test(l) ? (r.color.push(i), o.push(Ib), n.push(Ze.parse(l))) : l.startsWith(XM) ? (r.var.push(i), o.push(KM), n.push(l)) : (r.number.push(i), o.push(Ob), n.push(parseFloat(l))), ++i, fh)).split(fh);
  return { values: n, split: a, indexes: r, types: o };
}
function ZM(e) {
  return Xr(e).values;
}
function Lb({ split: e, types: t }) {
  const n = e.length;
  return (r) => {
    let o = "";
    for (let i = 0; i < n; i++)
      if (o += e[i], r[i] !== void 0) {
        const s = t[i];
        s === Ob ? o += No(r[i]) : s === Ib ? o += Ze.transform(r[i]) : o += r[i];
      }
    return o;
  };
}
function QM(e) {
  return Lb(Xr(e));
}
const JM = (e) => typeof e == "number" ? 0 : Ze.test(e) ? Ze.getAnimatableNone(e) : e, eN = (e, t) => typeof e == "number" ? t != null && t.trim().endsWith("/") ? e : 0 : JM(e);
function tN(e) {
  const t = Xr(e);
  return Lb(t)(t.values.map((r, o) => eN(r, t.split[o])));
}
const Gt = {
  test: GM,
  parse: ZM,
  createTransformer: QM,
  getAnimatableNone: tN
};
function qa(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function nN({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, s = 0;
  if (!t)
    o = i = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - a;
    o = qa(l, a, e + 1 / 3), i = qa(l, a, e), s = qa(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Ts(e, t) {
  return (n) => n > 0 ? t : e;
}
const Ne = (e, t, n) => e + (t - e) * n, Za = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, rN = [ac, Xn, Or], oN = (e) => rN.find((t) => t.test(e));
function hh(e) {
  const t = oN(e);
  if (lo(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === Or && (n = nN(n)), n;
}
const mh = (e, t) => {
  const n = hh(e), r = hh(t);
  if (!n || !r)
    return Ts(e, t);
  const o = { ...n };
  return (i) => (o.red = Za(n.red, r.red, i), o.green = Za(n.green, r.green, i), o.blue = Za(n.blue, r.blue, i), o.alpha = Ne(n.alpha, r.alpha, i), Xn.transform(o));
}, lc = /* @__PURE__ */ new Set(["none", "hidden"]);
function iN(e, t) {
  return lc.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function sN(e, t) {
  return (n) => Ne(e, t, n);
}
function nd(e) {
  return typeof e == "number" ? sN : typeof e == "string" ? Ju(e) ? Ts : Ze.test(e) ? mh : cN : Array.isArray(e) ? $b : typeof e == "object" ? Ze.test(e) ? mh : aN : Ts;
}
function $b(e, t) {
  const n = [...e], r = n.length, o = e.map((i, s) => nd(i)(i, t[s]));
  return (i) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](i);
    return n;
  };
}
function aN(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = nd(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}
function lN(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const i = t.types[o], s = e.indexes[i][r[i]], a = e.values[s] ?? 0;
    n[o] = a, r[i]++;
  }
  return n;
}
const cN = (e, t) => {
  const n = Gt.createTransformer(t), r = Xr(e), o = Xr(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? lc.has(e) && !o.values.length || lc.has(t) && !r.values.length ? iN(e, t) : vi($b(lN(r, o), o.values), n) : (lo(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Ts(e, t));
};
function Fb(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Ne(e, t, n) : nd(e)(e, t);
}
const uN = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => Ae.update(t, n),
    stop: () => Cn(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => ut.isProcessing ? ut.timestamp : pt.now()
  };
}, Vb = (e, t, n = 10) => {
  let r = "";
  const o = Math.max(Math.round(t / n), 2);
  for (let i = 0; i < o; i++)
    r += Math.round(e(i / (o - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Es = 2e4;
function rd(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Es; )
    t += n, r = e.next(t);
  return t >= Es ? 1 / 0 : t;
}
function dN(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), o = Math.min(rd(r), Es);
  return {
    type: "keyframes",
    ease: (i) => r.next(o * i).value / t,
    duration: /* @__PURE__ */ It(o)
  };
}
const Ue = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function cc(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const fN = 12;
function hN(e, t, n) {
  let r = n;
  for (let o = 1; o < fN; o++)
    r = r - e(r) / t(r);
  return r;
}
const Qa = 1e-3;
function mN({ duration: e = Ue.duration, bounce: t = Ue.bounce, velocity: n = Ue.velocity, mass: r = Ue.mass }) {
  let o, i;
  lo(e <= /* @__PURE__ */ Ct(Ue.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let s = 1 - t;
  s = fn(Ue.minDamping, Ue.maxDamping, s), e = fn(Ue.minDuration, Ue.maxDuration, /* @__PURE__ */ It(e)), s < 1 ? (o = (c) => {
    const u = c * s, d = u * e, f = u - n, m = cc(c, s), v = Math.exp(-d);
    return Qa - f / m * v;
  }, i = (c) => {
    const d = c * s * e, f = d * n + n, m = Math.pow(s, 2) * Math.pow(c, 2) * e, v = Math.exp(-d), g = cc(Math.pow(c, 2), s);
    return (-o(c) + Qa > 0 ? -1 : 1) * ((f - m) * v) / g;
  }) : (o = (c) => {
    const u = Math.exp(-c * e), d = (c - n) * e + 1;
    return -Qa + u * d;
  }, i = (c) => {
    const u = Math.exp(-c * e), d = (n - c) * (e * e);
    return u * d;
  });
  const a = 5 / e, l = hN(o, i, a);
  if (e = /* @__PURE__ */ Ct(e), isNaN(l))
    return {
      stiffness: Ue.stiffness,
      damping: Ue.damping,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: s * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const pN = ["duration", "bounce"], gN = ["stiffness", "damping", "mass"];
function ph(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function vN(e) {
  let t = {
    velocity: Ue.velocity,
    stiffness: Ue.stiffness,
    damping: Ue.damping,
    mass: Ue.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!ph(e, gN) && ph(e, pN))
    if (t.velocity = 0, e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), o = r * r, i = 2 * fn(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(o);
      t = {
        ...t,
        mass: Ue.mass,
        stiffness: o,
        damping: i
      };
    } else {
      const n = mN({ ...e, velocity: 0 });
      t = {
        ...t,
        ...n,
        mass: Ue.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Ps(e = Ue.visualDuration, t = Ue.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: o } = n;
  const i = n.keyframes[0], s = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: i }, { stiffness: l, damping: c, mass: u, duration: d, velocity: f, isResolvedFromDuration: m } = vN({
    ...n,
    velocity: -/* @__PURE__ */ It(n.velocity || 0)
  }), v = f || 0, g = c / (2 * Math.sqrt(l * u)), y = s - i, b = /* @__PURE__ */ It(Math.sqrt(l / u)), x = Math.abs(y) < 5;
  r || (r = x ? Ue.restSpeed.granular : Ue.restSpeed.default), o || (o = x ? Ue.restDelta.granular : Ue.restDelta.default);
  let w, C, E, S, T, P;
  if (g < 1)
    E = cc(b, g), S = (v + g * b * y) / E, w = (k) => {
      const R = Math.exp(-g * b * k);
      return s - R * (S * Math.sin(E * k) + y * Math.cos(E * k));
    }, T = g * b * S + y * E, P = g * b * y - S * E, C = (k) => Math.exp(-g * b * k) * (T * Math.sin(E * k) + P * Math.cos(E * k));
  else if (g === 1) {
    w = (R) => s - Math.exp(-b * R) * (y + (v + b * y) * R);
    const k = v + b * y;
    C = (R) => Math.exp(-b * R) * (b * k * R - v);
  } else {
    const k = b * Math.sqrt(g * g - 1);
    w = (I) => {
      const B = Math.exp(-g * b * I), V = Math.min(k * I, 300);
      return s - B * ((v + g * b * y) * Math.sinh(V) + k * y * Math.cosh(V)) / k;
    };
    const R = (v + g * b * y) / k, A = g * b * R - y * k, F = g * b * y - R * k;
    C = (I) => {
      const B = Math.exp(-g * b * I), V = Math.min(k * I, 300);
      return B * (A * Math.sinh(V) + F * Math.cosh(V));
    };
  }
  const D = {
    calculatedDuration: m && d || null,
    velocity: (k) => /* @__PURE__ */ Ct(C(k)),
    next: (k) => {
      if (!m && g < 1) {
        const A = Math.exp(-g * b * k), F = Math.sin(E * k), I = Math.cos(E * k), B = s - A * (S * F + y * I), V = /* @__PURE__ */ Ct(A * (T * F + P * I));
        return a.done = Math.abs(V) <= r && Math.abs(s - B) <= o, a.value = a.done ? s : B, a;
      }
      const R = w(k);
      if (m)
        a.done = k >= d;
      else {
        const A = /* @__PURE__ */ Ct(C(k));
        a.done = Math.abs(A) <= r && Math.abs(s - R) <= o;
      }
      return a.value = a.done ? s : R, a;
    },
    toString: () => {
      const k = Math.min(rd(D), Es), R = Vb((A) => D.next(k * A).value, k, 30);
      return k + "ms " + R;
    },
    toTransition: () => {
    }
  };
  return D;
}
Ps.applyToOptions = (e) => {
  const t = dN(e, 100, Ps);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Ct(t.duration), e.type = "keyframes", e;
};
const yN = 5;
function Bb(e, t, n) {
  const r = Math.max(t - yN, 0);
  return /* @__PURE__ */ bb(n - e(r), t - r);
}
function uc({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: s, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, m = (P) => a !== void 0 && P < a || l !== void 0 && P > l, v = (P) => a === void 0 ? l : l === void 0 || Math.abs(a - P) < Math.abs(l - P) ? a : l;
  let g = n * t;
  const y = d + g, b = s === void 0 ? y : s(y);
  b !== y && (g = b - d);
  const x = (P) => -g * Math.exp(-P / r), w = (P) => b + x(P), C = (P) => {
    const D = x(P), k = w(P);
    f.done = Math.abs(D) <= c, f.value = f.done ? b : k;
  };
  let E, S;
  const T = (P) => {
    m(f.value) && (E = P, S = Ps({
      keyframes: [f.value, v(f.value)],
      velocity: Bb(w, P, f.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return T(0), {
    calculatedDuration: null,
    next: (P) => {
      let D = !1;
      return !S && E === void 0 && (D = !0, C(P), T(P)), E !== void 0 && P >= E ? S.next(P - E) : (!D && C(P), f);
    }
  };
}
function bN(e, t, n) {
  const r = [], o = n || Ln.mix || Fb, i = e.length - 1;
  for (let s = 0; s < i; s++) {
    let a = o(e[s], e[s + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[s] || $t : t;
      a = vi(l, a);
    }
    r.push(a);
  }
  return r;
}
function Wb(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (qt(i === t.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const s = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = bN(t, r, o), l = a.length, c = (u) => {
    if (s && u < e[0])
      return t[0];
    let d = 0;
    if (l > 1)
      for (; d < e.length - 2 && !(u < e[d + 1]); d++)
        ;
    const f = /* @__PURE__ */ Ko(e[d], e[d + 1], u);
    return a[d](f);
  };
  return n ? (u) => c(fn(e[0], e[i - 1], u)) : c;
}
function wN(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = /* @__PURE__ */ Ko(0, t, r);
    e.push(Ne(n, 1, o));
  }
}
function xN(e) {
  const t = [0];
  return wN(t, e.length - 1), t;
}
function CN(e, t) {
  return e.map((n) => n * t);
}
function SN(e, t) {
  return e.map(() => t || Db).splice(0, e.length - 1);
}
function Ir({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = /* @__PURE__ */ _M(r) ? r.map(ch) : ch(r), i = {
    done: !1,
    value: t[0]
  }, s = CN(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : xN(t),
    e
  ), a = Wb(s, t, {
    ease: Array.isArray(o) ? o : SN(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = a(l), i.done = l >= e, i)
  };
}
const TN = (e) => e !== null;
function pa(e, { repeat: t, repeatType: n = "loop" }, r, o = 1) {
  const i = e.filter(TN), a = o < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !a || r === void 0 ? i[a] : r;
}
const EN = {
  decay: uc,
  inertia: uc,
  tween: Ir,
  keyframes: Ir,
  spring: Ps
};
function zb(e) {
  typeof e.type == "string" && (e.type = EN[e.type]);
}
class od {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const PN = (e) => e / 100;
class ks extends od {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      var r, o;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== pt.now() && this.tick(pt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (o = (r = this.options).onStop) == null || o.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    zb(t);
    const { type: n = Ir, repeat: r = 0, repeatDelay: o = 0, repeatType: i, velocity: s = 0 } = t;
    let { keyframes: a } = t;
    const l = n || Ir;
    process.env.NODE_ENV !== "production" && l !== Ir && qt(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== Ir && typeof a[0] != "number" && (this.mixKeyframes = vi(PN, Fb(a[0], a[1])), a = [0, 100]);
    const c = l({ ...t, keyframes: a });
    i === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -s
    })), c.calculatedDuration === null && (c.calculatedDuration = rd(c));
    const { calculatedDuration: u } = c;
    this.calculatedDuration = u, this.resolvedDuration = u + o, this.totalDuration = this.resolvedDuration * (r + 1) - o, this.generator = c;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: o, mixKeyframes: i, mirroredGenerator: s, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: c = 0, keyframes: u, repeat: d, repeatType: f, repeatDelay: m, type: v, onUpdate: g, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - o / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const b = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), x = this.playbackSpeed >= 0 ? b < 0 : b > o;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = o);
    let w = this.currentTime, C = r;
    if (d) {
      const P = Math.min(this.currentTime, o) / a;
      let D = Math.floor(P), k = P % 1;
      !k && P >= 1 && (k = 1), k === 1 && D--, D = Math.min(D, d + 1), !!(D % 2) && (f === "reverse" ? (k = 1 - k, m && (k -= m / a)) : f === "mirror" && (C = s)), w = fn(0, 1, k) * a;
    }
    let E;
    x ? (this.delayState.value = u[0], E = this.delayState) : E = C.next(w), i && !x && (E.value = i(E.value));
    let { done: S } = E;
    !x && l !== null && (S = this.playbackSpeed >= 0 ? this.currentTime >= o : this.currentTime <= 0);
    const T = this.holdTime === null && (this.state === "finished" || this.state === "running" && S);
    return T && v !== uc && (E.value = pa(u, this.options, y, this.speed)), g && g(E.value), T && this.finish(), E;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ It(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ It(t);
  }
  get time() {
    return /* @__PURE__ */ It(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Ct(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return Bb((r) => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(pt.now()), this.playbackSpeed = t, n && this.driver && (this.time = /* @__PURE__ */ It(this.currentTime));
  }
  play() {
    var o, i;
    if (this.isStopped)
      return;
    const { driver: t = uN, startTime: n } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), (i = (o = this.options).onPlay) == null || i.call(o);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(pt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function kN(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const qn = (e) => e * 180 / Math.PI, dc = (e) => {
  const t = qn(Math.atan2(e[1], e[0]));
  return fc(t);
}, DN = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: dc,
  rotateZ: dc,
  skewX: (e) => qn(Math.atan(e[1])),
  skewY: (e) => qn(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, fc = (e) => (e = e % 360, e < 0 && (e += 360), e), gh = dc, vh = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), yh = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), RN = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: vh,
  scaleY: yh,
  scale: (e) => (vh(e) + yh(e)) / 2,
  rotateX: (e) => fc(qn(Math.atan2(e[6], e[5]))),
  rotateY: (e) => fc(qn(Math.atan2(-e[2], e[0]))),
  rotateZ: gh,
  rotate: gh,
  skewX: (e) => qn(Math.atan(e[4])),
  skewY: (e) => qn(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function hc(e) {
  return e.includes("scale") ? 1 : 0;
}
function mc(e, t) {
  if (!e || e === "none")
    return hc(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, o;
  if (n)
    r = RN, o = n;
  else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = DN, o = a;
  }
  if (!o)
    return hc(t);
  const i = r[t], s = o[1].split(",").map(NN);
  return typeof i == "function" ? i(s) : s[i];
}
const MN = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return mc(n, t);
};
function NN(e) {
  return parseFloat(e.trim());
}
const uo = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], fo = /* @__PURE__ */ new Set([...uo, "pathRotation"]), bh = (e) => e === co || e === ne, AN = /* @__PURE__ */ new Set(["x", "y", "z"]), _N = uo.filter((e) => !AN.has(e));
function ON(e) {
  const t = [];
  return _N.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Nn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
    const o = e.max - e.min;
    return r === "border-box" ? o : o - parseFloat(t) - parseFloat(n);
  },
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
    const o = e.max - e.min;
    return r === "border-box" ? o : o - parseFloat(t) - parseFloat(n);
  },
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => mc(t, "x"),
  y: (e, { transform: t }) => mc(t, "y")
};
Nn.translateX = Nn.x;
Nn.translateY = Nn.y;
const Qn = /* @__PURE__ */ new Set();
let pc = !1, gc = !1, vc = !1;
function jb() {
  if (gc) {
    const e = Array.from(Qn).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = ON(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([i, s]) => {
        var a;
        (a = r.getValue(i)) == null || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  gc = !1, pc = !1, Qn.forEach((e) => e.complete(vc)), Qn.clear();
}
function Hb() {
  Qn.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (gc = !0);
  });
}
function IN() {
  vc = !0, Hb(), jb(), vc = !1;
}
class id {
  constructor(t, n, r, o, i, s = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = i, this.isAsync = s;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Qn.add(this), pc || (pc = !0, Ae.read(Hb), Ae.resolveKeyframes(jb))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    if (t[0] === null) {
      const i = o == null ? void 0 : o.get(), s = t[t.length - 1];
      if (i !== void 0)
        t[0] = i;
      else if (r && n) {
        const a = r.readValue(n, s);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = s), o && i === void 0 && o.set(t[0]);
    }
    kN(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), Qn.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Qn.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const LN = (e) => e.startsWith("--");
function Ub(e, t, n) {
  LN(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const $N = {};
function Yb(e, t) {
  const n = /* @__PURE__ */ yb(e);
  return () => $N[t] ?? n();
}
const FN = /* @__PURE__ */ Yb(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Gb = /* @__PURE__ */ Yb(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Po = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, wh = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Po([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Po([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Po([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Po([0.33, 1.53, 0.69, 0.99])
};
function Kb(e, t) {
  if (e)
    return typeof e == "function" ? Gb() ? Vb(e, t) : "ease-out" : /* @__PURE__ */ Rb(e) ? Po(e) : Array.isArray(e) ? e.map((n) => Kb(n, t) || wh.easeOut) : wh[e];
}
function VN(e, t, n, { delay: r = 0, duration: o = 300, repeat: i = 0, repeatType: s = "loop", ease: a = "easeOut", times: l } = {}, c = void 0) {
  const u = {
    [t]: n
  };
  l && (u.offset = l);
  const d = Kb(a, o);
  Array.isArray(d) && (u.easing = d);
  const f = {
    delay: r,
    duration: o,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: i + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  };
  return c && (f.pseudoElement = c), e.animate(u, f);
}
function Xb(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function BN({ type: e, ...t }) {
  return Xb(e) && Gb() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class qb extends od {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t)
      return;
    const { element: n, name: r, keyframes: o, pseudoElement: i, allowFlatten: s = !1, finalKeyframe: a, onComplete: l } = t;
    this.isPseudoElement = !!i, this.allowFlatten = s, this.options = t, qt(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const c = BN(t);
    this.animation = VN(n, r, o, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const u = pa(o, this.options, a, this.speed);
        this.updateMotionValue && this.updateMotionValue(u), Ub(n, r, u), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var n, r, o;
    const t = (n = this.options) == null ? void 0 : n.element;
    !this.isPseudoElement && (t != null && t.isConnected) && ((o = (r = this.animation).commitStyles) == null || o.call(r));
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ It(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ It(t);
  }
  get time() {
    return /* @__PURE__ */ It(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Ct(t), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, rangeStart: n, rangeEnd: r, observe: o }) {
    var i;
    return this.allowFlatten && ((i = this.animation.effect) == null || i.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && FN() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), $t) : o(this);
  }
}
const Zb = {
  anticipate: Eb,
  backInOut: Tb,
  circInOut: kb
};
function WN(e) {
  return e in Zb;
}
function zN(e) {
  typeof e.ease == "string" && WN(e.ease) && (e.ease = Zb[e.ease]);
}
const Ja = 10;
class jN extends qb {
  constructor(t) {
    zN(t), zb(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: o, element: i, ...s } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const a = new ks({
      ...s,
      autoplay: !1
    }), l = Math.max(Ja, pt.now() - this.startTime), c = fn(0, Ja, l - Ja), u = a.sample(l).value, { name: d } = this.options;
    i && d && Ub(i, d, u), n.setWithVelocity(a.sample(Math.max(0, l - c)).value, u, c), a.stop();
  }
}
const xh = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Gt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function HN(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function UN(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], s = xh(o, t), a = xh(i, t);
  return lo(s === a, `You are trying to animate ${t} from "${o}" to "${i}". "${s ? i : o}" is not an animatable value.`, "value-not-animatable"), !s || !a ? !1 : HN(e) || (n === "spring" || Xb(n)) && r;
}
function yc(e) {
  e.duration = 0, e.type = "keyframes";
}
const Qb = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), YN = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function GN(e) {
  for (let t = 0; t < e.length; t++)
    if (typeof e[t] == "string" && YN.test(e[t]))
      return !0;
  return !1;
}
const KN = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), XN = /* @__PURE__ */ yb(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function qN(e) {
  var d;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: o, damping: i, type: s, keyframes: a } = e;
  if (!(((d = t == null ? void 0 : t.owner) == null ? void 0 : d.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: u } = t.owner.getProps();
  return XN() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (Qb.has(n) || KN.has(n) && GN(a)) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !r && o !== "mirror" && i !== 0 && s !== "inertia";
}
const ZN = 40;
class QN extends od {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: s = "loop", keyframes: a, name: l, motionValue: c, element: u, ...d }) {
    var v;
    super(), this.stop = () => {
      var g, y;
      this._animation && (this._animation.stop(), (g = this.stopTimeline) == null || g.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = pt.now();
    const f = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: i,
      repeatType: s,
      name: l,
      motionValue: c,
      element: u,
      ...d
    }, m = (u == null ? void 0 : u.KeyframeResolver) || id;
    this.keyframeResolver = new m(a, (g, y, b) => this.onKeyframesResolved(g, y, f, !b), l, c, u), (v = this.keyframeResolver) == null || v.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, o) {
    var b, x;
    this.keyframeResolver = void 0;
    const { name: i, type: s, velocity: a, delay: l, isHandoff: c, onUpdate: u } = r;
    this.resolvedAt = pt.now();
    let d = !0;
    UN(t, i, s, a) || (d = !1, (Ln.instantAnimations || !l) && (u == null || u(pa(t, r, n))), t[0] = t[t.length - 1], yc(r), r.repeat = 0);
    const m = {
      startTime: o ? this.resolvedAt ? this.resolvedAt - this.createdAt > ZN ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, v = d && !c && qN(m), g = (x = (b = m.motionValue) == null ? void 0 : b.owner) == null ? void 0 : x.current;
    let y;
    if (v)
      try {
        y = new jN({
          ...m,
          element: g
        });
      } catch {
        y = new ks(m);
      }
    else
      y = new ks(m);
    y.finished.then(() => {
      this.notifyFinished();
    }).catch($t), this.pendingTimeline && (this.stopTimeline = y.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = y;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), IN()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
function Jb(e, t, n, r = 0, o = 1) {
  const i = Array.from(e).sort((c, u) => c.sortNodePosition(u)).indexOf(t), s = e.size, a = (s - 1) * r;
  return typeof n == "function" ? n(i, s) : o === 1 ? i * r : a - i * r;
}
const Ch = 30, JN = (e) => !isNaN(parseFloat(e)), Ao = {
  current: void 0
};
class eA {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var i;
      const o = pt.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const s of this.dependents)
          s.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = pt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = JN(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && qu(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Xu());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Ae.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return Ao.current && Ao.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = pt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Ch)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Ch);
    return /* @__PURE__ */ bb(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function cr(e, t) {
  return new eA(e, t);
}
function ew(e, t) {
  if (e != null && e.inherit && t) {
    const { inherit: n, ...r } = e;
    return { ...t, ...r };
  }
  return e;
}
function sd(e, t) {
  const n = (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
  return n !== e ? ew(n, e) : n;
}
const tA = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, nA = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), rA = {
  type: "keyframes",
  duration: 0.8
}, oA = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, iA = (e, { keyframes: t }) => t.length > 2 ? rA : fo.has(e) ? e.startsWith("scale") ? nA(t[1]) : tA : oA, sA = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function aA(e) {
  for (const t in e)
    if (!sA.has(t))
      return !0;
  return !1;
}
const ad = (e, t, n, r = {}, o, i) => (s) => {
  const a = sd(r, e) || {}, l = a.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ Ct(l);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (f) => {
      t.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  aA(a) || Object.assign(u, iA(e, u)), u.duration && (u.duration = /* @__PURE__ */ Ct(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Ct(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (yc(u), u.delay === 0 && (d = !0)), (Ln.instantAnimations || Ln.skipAnimations || o != null && o.shouldSkipAnimations || a.skipAnimations) && (d = !0, yc(u), u.delay = 0), u.allowFlatten = !a.type && !a.ease, d && !i && t.get() !== void 0) {
    const f = pa(u.keyframes, a);
    if (f !== void 0) {
      Ae.update(() => {
        u.onUpdate(f), u.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new ks(u) : new QN(u);
}, lA = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function cA(e) {
  const t = lA.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const uA = 4;
function tw(e, t, n = 1) {
  qt(n <= uA, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, o] = cA(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const s = i.trim();
    return pb(s) ? parseFloat(s) : s;
  }
  return Ju(o) ? tw(o, t, n + 1) : o;
}
function Sh(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function ld(e, t, n, r) {
  if (typeof t == "function") {
    const [o, i] = Sh(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = Sh(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  return t;
}
function Jn(e, t, n) {
  const r = e.getProps();
  return ld(r, t, n !== void 0 ? n : r.custom, e);
}
const nw = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...uo
]), bc = (e) => Array.isArray(e);
function dA(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, cr(n));
}
function fA(e) {
  return bc(e) ? e[e.length - 1] || 0 : e;
}
function hA(e, t) {
  const n = Jn(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const s in i) {
    const a = fA(i[s]);
    dA(e, s, a);
  }
}
const ot = (e) => !!(e && e.getVelocity);
function mA(e) {
  return !!(ot(e) && e.add);
}
function wc(e, t) {
  const n = e.getValue("willChange");
  if (mA(n))
    return n.add(t);
  if (!n && Ln.WillChange) {
    const r = new Ln.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function cd(e) {
  return e.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
}
const pA = "framerAppearId", rw = "data-" + cd(pA);
function ow(e) {
  return e.props[rw];
}
function gA({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function iw(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: i, transitionEnd: s, ...a } = t;
  const l = e.getDefaultTransition();
  i = i ? ew(i, l) : l;
  const c = i == null ? void 0 : i.reduceMotion, u = i == null ? void 0 : i.skipAnimations;
  r && (i = r);
  const d = [], f = o && e.animationState && e.animationState.getState()[o], m = i == null ? void 0 : i.path;
  m && m.animateVisualElement(e, a, i, n, d);
  for (const v in a) {
    const g = e.getValue(v, e.latestValues[v] ?? null), y = a[v];
    if (y === void 0 || f && gA(f, v))
      continue;
    const b = {
      delay: n,
      ...sd(i || {}, v)
    };
    u && (b.skipAnimations = !0);
    const x = g.get();
    if (x !== void 0 && !g.isAnimating() && !Array.isArray(y) && y === x && !b.velocity) {
      Ae.update(() => g.set(y));
      continue;
    }
    let w = !1;
    if (window.MotionHandoffAnimation) {
      const S = ow(e);
      if (S) {
        const T = window.MotionHandoffAnimation(S, v, Ae);
        T !== null && (b.startTime = T, w = !0);
      }
    }
    wc(e, v);
    const C = c ?? e.shouldReduceMotion;
    g.start(ad(v, g, y, C && nw.has(v) ? { type: !1 } : b, e, w));
    const E = g.animation;
    E && d.push(E);
  }
  if (s) {
    const v = () => Ae.update(() => {
      s && hA(e, s);
    });
    d.length ? Promise.all(d).then(v) : v();
  }
  return d;
}
function xc(e, t, n = {}) {
  var l;
  const r = Jn(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const i = r ? () => Promise.all(iw(e, r, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: f } = o;
    return vA(e, t, c, u, d, f, n);
  } : () => Promise.resolve(), { when: a } = o;
  if (a) {
    const [c, u] = a === "beforeChildren" ? [i, s] : [s, i];
    return c().then(() => u());
  } else
    return Promise.all([i(), s(n.delay)]);
}
function vA(e, t, n = 0, r = 0, o = 0, i = 1, s) {
  const a = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), a.push(xc(l, t, {
      ...s,
      delay: n + (typeof r == "function" ? 0 : r) + Jb(e.variantChildren, l, r, o, i)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(a);
}
function yA(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => xc(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = xc(e, t, n);
  else {
    const o = typeof t == "function" ? Jn(e, t, n.custom) : t;
    r = Promise.all(iw(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const bA = {
  test: (e) => e === "auto",
  parse: (e) => e
}, sw = (e) => (t) => t.test(e), aw = [co, ne, dn, yn, UM, HM, bA], Th = (e) => aw.find(sw(e));
function wA(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || vb(e) : !0;
}
const xA = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function CA(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(ed) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = xA.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const SA = /\b([a-z-]*)\(.*?\)/gu, Cc = {
  ...Gt,
  getAnimatableNone: (e) => {
    const t = e.match(SA);
    return t ? t.map(CA).join(" ") : e;
  }
}, Sc = {
  ...Gt,
  getAnimatableNone: (e) => {
    const t = Gt.parse(e);
    return Gt.createTransformer(e)(t.map((r) => typeof r == "number" ? 0 : typeof r == "object" ? { ...r, alpha: 1 } : r));
  }
}, Eh = {
  ...co,
  transform: Math.round
}, TA = {
  rotate: yn,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: yn,
  rotateX: yn,
  rotateY: yn,
  rotateZ: yn,
  scale: Wi,
  scaleX: Wi,
  scaleY: Wi,
  scaleZ: Wi,
  skew: yn,
  skewX: yn,
  skewY: yn,
  distance: ne,
  translateX: ne,
  translateY: ne,
  translateZ: ne,
  x: ne,
  y: ne,
  z: ne,
  perspective: ne,
  transformPerspective: ne,
  opacity: Xo,
  originX: dh,
  originY: dh,
  originZ: ne
}, Ds = {
  // Border props
  borderWidth: ne,
  borderTopWidth: ne,
  borderRightWidth: ne,
  borderBottomWidth: ne,
  borderLeftWidth: ne,
  borderRadius: ne,
  borderTopLeftRadius: ne,
  borderTopRightRadius: ne,
  borderBottomRightRadius: ne,
  borderBottomLeftRadius: ne,
  // Positioning props
  width: ne,
  maxWidth: ne,
  height: ne,
  maxHeight: ne,
  top: ne,
  right: ne,
  bottom: ne,
  left: ne,
  inset: ne,
  insetBlock: ne,
  insetBlockStart: ne,
  insetBlockEnd: ne,
  insetInline: ne,
  insetInlineStart: ne,
  insetInlineEnd: ne,
  // Spacing props
  padding: ne,
  paddingTop: ne,
  paddingRight: ne,
  paddingBottom: ne,
  paddingLeft: ne,
  paddingBlock: ne,
  paddingBlockStart: ne,
  paddingBlockEnd: ne,
  paddingInline: ne,
  paddingInlineStart: ne,
  paddingInlineEnd: ne,
  margin: ne,
  marginTop: ne,
  marginRight: ne,
  marginBottom: ne,
  marginLeft: ne,
  marginBlock: ne,
  marginBlockStart: ne,
  marginBlockEnd: ne,
  marginInline: ne,
  marginInlineStart: ne,
  marginInlineEnd: ne,
  // Typography
  fontSize: ne,
  // Misc
  backgroundPositionX: ne,
  backgroundPositionY: ne,
  ...TA,
  zIndex: Eh,
  // SVG
  fillOpacity: Xo,
  strokeOpacity: Xo,
  numOctaves: Eh
}, EA = {
  ...Ds,
  // Color props
  color: Ze,
  backgroundColor: Ze,
  outlineColor: Ze,
  fill: Ze,
  stroke: Ze,
  // Border props
  borderColor: Ze,
  borderTopColor: Ze,
  borderRightColor: Ze,
  borderBottomColor: Ze,
  borderLeftColor: Ze,
  filter: Cc,
  WebkitFilter: Cc,
  mask: Sc,
  WebkitMask: Sc
}, lw = (e) => EA[e], PA = /* @__PURE__ */ new Set([Cc, Sc]);
function cw(e, t) {
  let n = lw(e);
  return PA.has(n) || (n = Gt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const kA = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function DA(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const i = e[r];
    typeof i == "string" && !kA.has(i) && Xr(i).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const i of t)
      e[i] = cw(n, o);
}
class RA extends id {
  constructor(t, n, r, o, i) {
    super(t, n, r, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let u = 0; u < t.length; u++) {
      let d = t[u];
      if (typeof d == "string" && (d = d.trim(), Ju(d))) {
        const f = tw(d, n.current);
        f !== void 0 && (t[u] = f), u === t.length - 1 && (this.finalKeyframe = d);
      }
    }
    if (this.resolveNoneKeyframes(), !nw.has(r) || t.length !== 2)
      return;
    const [o, i] = t, s = Th(o), a = Th(i), l = uh(o), c = uh(i);
    if (l !== c && Nn[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (s !== a)
      if (bh(s) && bh(a))
        for (let u = 0; u < t.length; u++) {
          const d = t[u];
          typeof d == "string" && (t[u] = parseFloat(d));
        }
      else Nn[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      (t[o] === null || wA(t[o])) && r.push(o);
    r.length && DA(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Nn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var a;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const o = t.getValue(n);
    o && o.jump(this.measuredOrigin, !1);
    const i = r.length - 1, s = r[i];
    r[i] = Nn[n](t.measureViewportBox(), window.getComputedStyle(t.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, c]) => {
      t.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function uw(e, t, n) {
  if (e == null)
    return [];
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const o = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return o ? Array.from(o) : [];
  }
  return Array.from(e).filter((r) => r != null);
}
const Tc = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function MA(e) {
  return gb(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const { schedule: ud } = /* @__PURE__ */ Mb(queueMicrotask, !1), Yt = {
  x: !1,
  y: !1
};
function dw() {
  return Yt.x || Yt.y;
}
function NA(e) {
  return e === "x" || e === "y" ? Yt[e] ? null : (Yt[e] = !0, () => {
    Yt[e] = !1;
  }) : Yt.x || Yt.y ? null : (Yt.x = Yt.y = !0, () => {
    Yt.x = Yt.y = !1;
  });
}
function fw(e, t) {
  const n = uw(e), r = new AbortController(), o = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, o, () => r.abort()];
}
function AA(e) {
  return !(e.pointerType === "touch" || dw());
}
function _A(e, t, n = {}) {
  const [r, o, i] = fw(e, n);
  return r.forEach((s) => {
    let a = !1, l = !1, c;
    const u = () => {
      s.removeEventListener("pointerleave", v);
    }, d = (y) => {
      c && (c(y), c = void 0), u();
    }, f = (y) => {
      a = !1, window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", f), l && (l = !1, d(y));
    }, m = () => {
      a = !0, window.addEventListener("pointerup", f, o), window.addEventListener("pointercancel", f, o);
    }, v = (y) => {
      if (y.pointerType !== "touch") {
        if (a) {
          l = !0;
          return;
        }
        d(y);
      }
    }, g = (y) => {
      if (!AA(y))
        return;
      l = !1;
      const b = t(s, y);
      typeof b == "function" && (c = b, s.addEventListener("pointerleave", v, o));
    };
    s.addEventListener("pointerenter", g, o), s.addEventListener("pointerdown", m, o);
  }), i;
}
const hw = (e, t) => t ? e === t ? !0 : hw(e, t.parentElement) : !1, dd = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, OA = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function IA(e) {
  return OA.has(e.tagName) || e.isContentEditable === !0;
}
const LA = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function $A(e) {
  return LA.has(e.tagName) || e.isContentEditable === !0;
}
const Zi = /* @__PURE__ */ new WeakSet();
function Ph(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function el(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const FA = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = Ph(() => {
    if (Zi.has(n))
      return;
    el(n, "down");
    const o = Ph(() => {
      el(n, "up");
    }), i = () => el(n, "cancel");
    n.addEventListener("keyup", o, t), n.addEventListener("blur", i, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function kh(e) {
  return dd(e) && !dw();
}
const Dh = /* @__PURE__ */ new WeakSet();
function VA(e, t, n = {}) {
  const [r, o, i] = fw(e, n), s = (a) => {
    const l = a.currentTarget;
    if (!kh(a) || Dh.has(a))
      return;
    Zi.add(l), n.stopPropagation && Dh.add(a);
    const c = t(l, a), u = (m, v) => {
      window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", f), Zi.has(l) && Zi.delete(l), kh(m) && typeof c == "function" && c(m, { success: v });
    }, d = (m) => {
      u(m, l === window || l === document || n.useGlobalTarget || hw(l, m.target));
    }, f = (m) => {
      u(m, !1);
    };
    window.addEventListener("pointerup", d, o), window.addEventListener("pointercancel", f, o);
  };
  return r.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", s, o), MA(a) && (a.addEventListener("focus", (c) => FA(c, o)), !IA(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), i;
}
function fd(e) {
  return gb(e) && "ownerSVGElement" in e;
}
const Qi = /* @__PURE__ */ new WeakMap();
let Rn;
const mw = (e, t, n) => (r, o) => o && o[0] ? o[0][e + "Size"] : fd(r) && "getBBox" in r ? r.getBBox()[t] : r[n], BA = /* @__PURE__ */ mw("inline", "width", "offsetWidth"), WA = /* @__PURE__ */ mw("block", "height", "offsetHeight");
function zA({ target: e, borderBoxSize: t }) {
  var n;
  (n = Qi.get(e)) == null || n.forEach((r) => {
    r(e, {
      get width() {
        return BA(e, t);
      },
      get height() {
        return WA(e, t);
      }
    });
  });
}
function jA(e) {
  e.forEach(zA);
}
function HA() {
  typeof ResizeObserver > "u" || (Rn = new ResizeObserver(jA));
}
function UA(e, t) {
  Rn || HA();
  const n = uw(e);
  return n.forEach((r) => {
    let o = Qi.get(r);
    o || (o = /* @__PURE__ */ new Set(), Qi.set(r, o)), o.add(t), Rn == null || Rn.observe(r);
  }), () => {
    n.forEach((r) => {
      const o = Qi.get(r);
      o == null || o.delete(t), o != null && o.size || Rn == null || Rn.unobserve(r);
    });
  };
}
const Ji = /* @__PURE__ */ new Set();
let Lr;
function YA() {
  Lr = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    Ji.forEach((t) => t(e));
  }, window.addEventListener("resize", Lr);
}
function GA(e) {
  return Ji.add(e), Lr || YA(), () => {
    Ji.delete(e), !Ji.size && typeof Lr == "function" && (window.removeEventListener("resize", Lr), Lr = void 0);
  };
}
function Rh(e, t) {
  return typeof e == "function" ? GA(e) : UA(e, t);
}
function KA(e) {
  return fd(e) && e.tagName === "svg";
}
function XA(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], o = e[1 + n], i = e[2 + n], s = e[3 + n], a = Wb(o, i, s);
  return t ? a(r) : a;
}
const qA = [...aw, Ze, Gt], ZA = (e) => qA.find(sw(e)), Mh = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), $r = () => ({
  x: Mh(),
  y: Mh()
}), Nh = () => ({ min: 0, max: 0 }), tt = () => ({
  x: Nh(),
  y: Nh()
}), QA = /* @__PURE__ */ new WeakMap();
function ga(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function qo(e) {
  return typeof e == "string" || Array.isArray(e);
}
const hd = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], md = ["initial", ...hd];
function va(e) {
  return ga(e.animate) || md.some((t) => qo(e[t]));
}
function pw(e) {
  return !!(va(e) || e.variants);
}
function JA(e, t, n) {
  for (const r in t) {
    const o = t[r], i = n[r];
    if (ot(o))
      e.addValue(r, o);
    else if (ot(i))
      e.addValue(r, cr(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(o) : s.hasAnimated || s.set(o);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, cr(s !== void 0 ? s : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Ec = { current: null }, gw = { current: !1 }, e_ = typeof window < "u";
function t_() {
  if (gw.current = !0, !!e_)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Ec.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Ec.current = !1;
}
const Ah = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Rs = {};
function vw(e) {
  Rs = e;
}
function n_() {
  return Rs;
}
class r_ {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, skipAnimations: i, blockInitialAnimation: s, visualState: a }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = id, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const m = pt.now();
      this.renderScheduledAt < m && (this.renderScheduledAt = m, Ae.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: u } = a;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.skipAnimationsConfig = i, this.options = l, this.blockInitialAnimation = !!s, this.isControllingVariants = va(n), this.isVariantNode = pw(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const m in f) {
      const v = f[m];
      c[m] !== void 0 && ot(v) && v.set(c[m]);
    }
  }
  mount(t) {
    var n, r;
    if (this.hasBeenMounted)
      for (const o in this.initialValues)
        (n = this.values.get(o)) == null || n.jump(this.initialValues[o]), this.latestValues[o] = this.initialValues[o];
    this.current = t, QA.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((o, i) => this.bindToMotionValue(i, o)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (gw.current || t_(), this.shouldReduceMotion = Ec.current), process.env.NODE_ENV !== "production" && qu(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, (r = this.parent) == null || r.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), Cn(this.notifyUpdate), Cn(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && Qb.has(t) && this.current instanceof HTMLElement) {
      const { factory: s, keyframes: a, times: l, ease: c, duration: u } = n.accelerate, d = new qb({
        element: this.current,
        name: t,
        keyframes: a,
        times: l,
        ease: c,
        duration: /* @__PURE__ */ Ct(u)
      }), f = s(d);
      this.valueSubscriptions.set(t, () => {
        f(), d.cancel();
      });
      return;
    }
    const r = fo.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const o = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && Ae.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let i;
    typeof window < "u" && window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), i && i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Rs) {
      const n = Rs[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : tt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Ah.length; r++) {
      const o = Ah[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, s = t[i];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = JA(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = cr(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (pb(r) || vb(r)) ? r = parseFloat(r) : !ZA(r) && Gt.test(n) && (r = cw(t, n)), this.setBaseTarget(t, ot(r) ? r.get() : r)), ot(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var i;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const s = ld(this.props, n, (i = this.presenceContext) == null ? void 0 : i.custom);
      s && (r = s[t]);
    }
    if (n && r !== void 0)
      return r;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !ot(o) ? o : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Xu()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    ud.render(this.render);
  }
}
class yw extends r_ {
  constructor() {
    super(...arguments), this.KeyframeResolver = RA;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    ot(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Wn {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function bw({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function o_({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function i_(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function tl(e) {
  return e === void 0 || e === 1;
}
function Pc({ scale: e, scaleX: t, scaleY: n }) {
  return !tl(e) || !tl(t) || !tl(n);
}
function Yn(e) {
  return Pc(e) || ww(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function ww(e) {
  return _h(e.x) || _h(e.y);
}
function _h(e) {
  return e && e !== "0%";
}
function Ms(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function Oh(e, t, n, r, o) {
  return o !== void 0 && (e = Ms(e, o, r)), Ms(e, n, r) + t;
}
function kc(e, t = 0, n = 1, r, o) {
  e.min = Oh(e.min, t, n, r, o), e.max = Oh(e.max, t, n, r, o);
}
function xw(e, { x: t, y: n }) {
  kc(e.x, t.translate, t.scale, t.originPoint), kc(e.y, n.translate, n.scale, n.originPoint);
}
const Ih = 0.999999999999, Lh = 1.0000000000001;
function s_(e, t, n, r = !1) {
  var a;
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, s;
  for (let l = 0; l < o; l++) {
    i = n[l], s = i.projectionDelta;
    const { visualElement: c } = i.options;
    c && c.props.style && c.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && (on(e.x, -i.scroll.offset.x), on(e.y, -i.scroll.offset.y)), s && (t.x *= s.x.scale, t.y *= s.y.scale, xw(e, s)), r && Yn(i.latestValues) && es(e, i.latestValues, (a = i.layout) == null ? void 0 : a.layoutBox));
  }
  t.x < Lh && t.x > Ih && (t.x = 1), t.y < Lh && t.y > Ih && (t.y = 1);
}
function on(e, t) {
  e.min += t, e.max += t;
}
function $h(e, t, n, r, o = 0.5) {
  const i = Ne(e.min, e.max, o);
  kc(e, t, n, i, r);
}
function Fh(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function es(e, t, n) {
  const r = n ?? e;
  $h(e.x, Fh(t.x, r.x), t.scaleX, t.scale, t.originX), $h(e.y, Fh(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function Cw(e, t) {
  return bw(i_(e.getBoundingClientRect(), t));
}
function a_(e, t, n) {
  const r = Cw(e, n), { scroll: o } = t;
  return o && (on(r.x, o.offset.x), on(r.y, o.offset.y)), r;
}
const l_ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, c_ = uo.length;
function u_(e, t, n) {
  let r = "", o = !0;
  for (let s = 0; s < c_; s++) {
    const a = uo[s], l = e[a];
    if (l === void 0)
      continue;
    let c = !0;
    if (typeof l == "number")
      c = l === (a.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(l);
      c = a.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!c || n) {
      const u = Tc(l, Ds[a]);
      if (!c) {
        o = !1;
        const d = l_[a] || a;
        r += `${d}(${u}) `;
      }
      n && (t[a] = u);
    }
  }
  const i = e.pathRotation;
  return i && (o = !1, r += `rotate(${Tc(i, Ds.pathRotation)}) `), r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function pd(e, t, n) {
  const { style: r, vars: o, transformOrigin: i } = e;
  let s = !1, a = !1;
  for (const l in t) {
    const c = t[l];
    if (fo.has(l)) {
      s = !0;
      continue;
    } else if (Ab(l)) {
      o[l] = c;
      continue;
    } else {
      const u = Tc(c, Ds[l]);
      l.startsWith("origin") ? (a = !0, i[l] = u) : r[l] = u;
    }
  }
  if (t.transform || (s || n ? r.transform = u_(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = i;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
function Sw(e, { style: t, vars: n }, r, o) {
  const i = e.style;
  let s;
  for (s in t)
    i[s] = t[s];
  o == null || o.applyProjectionStyles(i, r);
  for (s in n)
    i.setProperty(s, n[s]);
}
function Vh(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const wo = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ne.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Vh(e, t.target.x), r = Vh(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, d_ = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = Gt.parse(e);
    if (o.length > 5)
      return r;
    const i = Gt.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + s] /= a, o[1 + s] /= l;
    const c = Ne(a, l, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= c), typeof o[3 + s] == "number" && (o[3 + s] /= c), i(o);
  }
}, Dc = {
  borderRadius: {
    ...wo,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: wo,
  borderTopRightRadius: wo,
  borderBottomLeftRadius: wo,
  borderBottomRightRadius: wo,
  boxShadow: d_
};
function Tw(e, { layout: t, layoutId: n }) {
  return fo.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Dc[e] || e === "opacity");
}
function gd(e, t, n) {
  var s;
  const r = e.style, o = t == null ? void 0 : t.style, i = {};
  if (!r)
    return i;
  for (const a in r)
    (ot(r[a]) || o && ot(o[a]) || Tw(a, e) || ((s = n == null ? void 0 : n.getValue(a)) == null ? void 0 : s.liveStyle) !== void 0) && (i[a] = r[a]);
  return i;
}
function f_(e) {
  return window.getComputedStyle(e);
}
class h_ extends yw {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Sw;
  }
  readValueFromInstance(t, n) {
    var r;
    if (fo.has(n))
      return (r = this.projection) != null && r.isProjecting ? hc(n) : MN(t, n);
    {
      const o = f_(t), i = (Ab(n) ? o.getPropertyValue(n) : o[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Cw(t, n);
  }
  build(t, n, r) {
    pd(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return gd(t, n, r);
  }
}
const m_ = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, p_ = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function g_(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? m_ : p_;
  e[i.offset] = `${-r}`, e[i.array] = `${t} ${n}`;
}
const v_ = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function Ew(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: o,
  pathSpacing: i = 1,
  pathOffset: s = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, c, u) {
  if (pd(e, a, c), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: d, style: f } = e;
  d.transform && (f.transform = d.transform, delete d.transform), (f.transform || d.transformOrigin) && (f.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), f.transform && (f.transformBox = (u == null ? void 0 : u.transformBox) ?? "fill-box", delete d.transformBox);
  for (const m of v_)
    d[m] !== void 0 && (f[m] = d[m], delete d[m]);
  t !== void 0 && (d.x = t), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), o !== void 0 && g_(d, o, i, s, !1);
}
const Pw = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), kw = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function y_(e, t, n, r) {
  Sw(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Pw.has(o) ? o : cd(o), t.attrs[o]);
}
function Dw(e, t, n) {
  const r = gd(e, t, n);
  for (const o in e)
    if (ot(e[o]) || ot(t[o])) {
      const i = uo.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[i] = e[o];
    }
  return r;
}
class b_ extends yw {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = tt;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (fo.has(n)) {
      const r = lw(n);
      return r && r.default || 0;
    }
    return n = Pw.has(n) ? n : cd(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Dw(t, n, r);
  }
  build(t, n, r) {
    Ew(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, o) {
    y_(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = kw(t.tagName), super.mount(t);
  }
}
const w_ = md.length;
function Rw(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Rw(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < w_; n++) {
    const r = md[n], o = e.props[r];
    (qo(o) || o === !1) && (t[r] = o);
  }
  return t;
}
function Mw(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const x_ = [...hd].reverse(), C_ = hd.length;
function S_(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => yA(e, n, r)));
}
function T_(e) {
  let t = S_(e), n = Bh(), r = !0, o = !1;
  const i = (c) => (u, d) => {
    var m;
    const f = Jn(e, d, c === "exit" ? (m = e.presenceContext) == null ? void 0 : m.custom : void 0);
    if (f) {
      const { transition: v, transitionEnd: g, ...y } = f;
      u = { ...u, ...y, ...g };
    }
    return u;
  };
  function s(c) {
    t = c(e);
  }
  function a(c) {
    const { props: u } = e, d = Rw(e.parent) || {}, f = [], m = /* @__PURE__ */ new Set();
    let v = {}, g = 1 / 0;
    for (let b = 0; b < C_; b++) {
      const x = x_[b], w = n[x], C = u[x] !== void 0 ? u[x] : d[x], E = qo(C), S = x === c ? w.isActive : null;
      S === !1 && (g = b);
      let T = C === d[x] && C !== u[x] && E;
      if (T && (r || o) && e.manuallyAnimateOnMount && (T = !1), w.protectedKeys = { ...v }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && S === null || // If we didn't and don't have any defined prop for this animation type
      !C && !w.prevProp || // Or if the prop doesn't define an animation
      ga(C) || typeof C == "boolean")
        continue;
      if (x === "exit" && w.isActive && S !== !0) {
        w.prevResolvedValues && (v = {
          ...v,
          ...w.prevResolvedValues
        });
        continue;
      }
      const P = E_(w.prevProp, C);
      let D = P || // If we're making this variant active, we want to always make it active
      x === c && w.isActive && !T && E || // If we removed a higher-priority variant (i is in reverse order)
      b > g && E, k = !1;
      const R = Array.isArray(C) ? C : [C];
      let A = R.reduce(i(x), {});
      S === !1 && (A = {});
      const { prevResolvedValues: F = {} } = w, I = {
        ...F,
        ...A
      }, B = (M) => {
        D = !0, m.has(M) && (k = !0, m.delete(M)), w.needsAnimating[M] = !0;
        const _ = e.getValue(M);
        _ && (_.liveStyle = !1);
      };
      for (const M in I) {
        const _ = A[M], W = F[M];
        if (v.hasOwnProperty(M))
          continue;
        let te = !1;
        bc(_) && bc(W) ? te = !Mw(_, W) || P : te = _ !== W, te ? _ != null ? B(M) : m.add(M) : _ !== void 0 && m.has(M) ? B(M) : w.protectedKeys[M] = !0;
      }
      w.prevProp = C, w.prevResolvedValues = A, w.isActive && (v = { ...v, ...A }), (r || o) && e.blockInitialAnimation && (D = !1);
      const V = T && P;
      D && (!V || k) && f.push(...R.map((M) => {
        const _ = { type: x };
        if (typeof M == "string" && (r || o) && !V && e.manuallyAnimateOnMount && e.parent) {
          const { parent: W } = e, te = Jn(W, M);
          if (W.enteringChildren && te) {
            const { delayChildren: O } = te.transition || {};
            _.delay = Jb(W.enteringChildren, e, O);
          }
        }
        return {
          animation: M,
          options: _
        };
      }));
    }
    if (m.size) {
      const b = {};
      if (typeof u.initial != "boolean") {
        const x = Jn(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        x && x.transition && (b.transition = x.transition);
      }
      m.forEach((x) => {
        const w = e.getBaseTarget(x), C = e.getValue(x);
        C && (C.liveStyle = !0), b[x] = w ?? null;
      }), f.push({ animation: b });
    }
    let y = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, o = !1, y ? t(f) : Promise.resolve();
  }
  function l(c, u) {
    var f;
    if (n[c].isActive === u)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((m) => {
      var v;
      return (v = m.animationState) == null ? void 0 : v.setActive(c, u);
    }), n[c].isActive = u;
    const d = a(c);
    for (const m in n)
      n[m].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: a,
    setActive: l,
    setAnimateFunction: s,
    getState: () => n,
    reset: () => {
      n = Bh(), o = !0;
    }
  };
}
function E_(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Mw(t, e) : !1;
}
function Hn(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Bh() {
  return {
    animate: Hn(!0),
    whileInView: Hn(),
    whileHover: Hn(),
    whileTap: Hn(),
    whileDrag: Hn(),
    whileFocus: Hn(),
    exit: Hn()
  };
}
function Rc(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ht(e, t) {
  Rc(e.x, t.x), Rc(e.y, t.y);
}
function Wh(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const Nw = 1e-4, P_ = 1 - Nw, k_ = 1 + Nw, Aw = 0.01, D_ = 0 - Aw, R_ = 0 + Aw;
function gt(e) {
  return e.max - e.min;
}
function M_(e, t, n) {
  return Math.abs(e - t) <= n;
}
function zh(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Ne(t.min, t.max, e.origin), e.scale = gt(n) / gt(t), e.translate = Ne(n.min, n.max, e.origin) - e.originPoint, (e.scale >= P_ && e.scale <= k_ || isNaN(e.scale)) && (e.scale = 1), (e.translate >= D_ && e.translate <= R_ || isNaN(e.translate)) && (e.translate = 0);
}
function _o(e, t, n, r) {
  zh(e.x, t.x, n.x, r ? r.originX : void 0), zh(e.y, t.y, n.y, r ? r.originY : void 0);
}
function jh(e, t, n, r = 0) {
  const o = r ? Ne(n.min, n.max, r) : n.min;
  e.min = o + t.min, e.max = e.min + gt(t);
}
function N_(e, t, n, r) {
  jh(e.x, t.x, n.x, r == null ? void 0 : r.x), jh(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function Hh(e, t, n, r = 0) {
  const o = r ? Ne(n.min, n.max, r) : n.min;
  e.min = t.min - o, e.max = e.min + gt(t);
}
function Ns(e, t, n, r) {
  Hh(e.x, t.x, n.x, r == null ? void 0 : r.x), Hh(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function Uh(e, t, n, r, o) {
  return e -= t, e = Ms(e, 1 / n, r), o !== void 0 && (e = Ms(e, 1 / o, r)), e;
}
function A_(e, t = 0, n = 1, r = 0.5, o, i = e, s = e) {
  if (dn.test(t) && (t = parseFloat(t), t = Ne(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = Ne(i.min, i.max, r);
  e === i && (a -= t), e.min = Uh(e.min, t, n, a, o), e.max = Uh(e.max, t, n, a, o);
}
function Yh(e, t, [n, r, o], i, s) {
  A_(e, t[n], t[r], t[o], t.scale, i, s);
}
const __ = ["x", "scaleX", "originX"], O_ = ["y", "scaleY", "originY"];
function Gh(e, t, n, r) {
  Yh(e.x, t, __, n ? n.x : void 0, r ? r.x : void 0), Yh(e.y, t, O_, n ? n.y : void 0, r ? r.y : void 0);
}
function Kh(e) {
  return e.translate === 0 && e.scale === 1;
}
function _w(e) {
  return Kh(e.x) && Kh(e.y);
}
function Xh(e, t) {
  return e.min === t.min && e.max === t.max;
}
function I_(e, t) {
  return Xh(e.x, t.x) && Xh(e.y, t.y);
}
function qh(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Ow(e, t) {
  return qh(e.x, t.x) && qh(e.y, t.y);
}
function Zh(e) {
  return gt(e.x) / gt(e.y);
}
function Qh(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function rn(e) {
  return [e("x"), e("y")];
}
function L_(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((o || i || s) && (r = `translate3d(${o}px, ${i}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: u, pathRotation: d, rotateX: f, rotateY: m, skewX: v, skewY: g } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotate(${d}deg) `), f && (r += `rotateX(${f}deg) `), m && (r += `rotateY(${m}deg) `), v && (r += `skewX(${v}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const Iw = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomLeftRadius",
  "borderBottomRightRadius"
], $_ = Iw.length, Jh = (e) => typeof e == "string" ? parseFloat(e) : e, em = (e) => typeof e == "number" || ne.test(e);
function F_(e, t, n, r, o, i) {
  o ? (e.opacity = Ne(0, n.opacity ?? 1, V_(r)), e.opacityExit = Ne(t.opacity ?? 1, 0, B_(r))) : i && (e.opacity = Ne(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let s = 0; s < $_; s++) {
    const a = Iw[s];
    let l = tm(t, a), c = tm(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || em(l) === em(c) ? (e[a] = Math.max(Ne(Jh(l), Jh(c), r), 0), (dn.test(c) || dn.test(l)) && (e[a] += "%")) : e[a] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = Ne(t.rotate || 0, n.rotate || 0, r));
}
function tm(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const V_ = /* @__PURE__ */ Lw(0, 0.5, Pb), B_ = /* @__PURE__ */ Lw(0.5, 0.95, $t);
function Lw(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Ko(e, t, r));
}
function W_(e, t, n) {
  const r = ot(e) ? e : cr(e);
  return r.start(ad("", r, t, n)), r.animation;
}
function Zo(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const z_ = (e, t) => e.depth - t.depth;
class j_ {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Ku(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Ss(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(z_), this.isDirty = !1, this.children.forEach(t);
  }
}
function H_(e, t) {
  const n = pt.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (Cn(r), e(i - t));
  };
  return Ae.setup(r, !0), () => Cn(r);
}
function ts(e) {
  return ot(e) ? e.get() : e;
}
class U_ {
  constructor() {
    this.members = [];
  }
  add(t) {
    Ku(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead)
        continue;
      const o = r.instance;
      (!o || o.isConnected === !1) && !r.snapshot && (Ss(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Ss(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    var n;
    for (let r = this.members.indexOf(t) - 1; r >= 0; r--) {
      const o = this.members[r];
      if (o.isPresent !== !1 && ((n = o.instance) == null ? void 0 : n.isConnected) !== !1)
        return this.promote(o), !0;
    }
    return !1;
  }
  promote(t, n) {
    var o;
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const { layoutDependency: i } = r.options, { layoutDependency: s } = t.options;
      (i === void 0 || i !== s) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), (o = t.root) != null && o.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      var n, r, o, i, s;
      (r = (n = t.options).onExitComplete) == null || r.call(n), (s = (o = t.resumingFrom) == null ? void 0 : (i = o.options).onExitComplete) == null || s.call(i);
    });
  }
  scheduleRender() {
    this.members.forEach((t) => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    var t;
    (t = this.lead) != null && t.snapshot && (this.lead.snapshot = void 0);
  }
}
const ns = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, nl = ["", "X", "Y", "Z"], Y_ = 1e3;
let G_ = 0;
function rl(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function $w(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = ow(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Ae, !(o || i));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && $w(r);
}
function Fw({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = G_++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(q_), this.nodes.forEach(nO), this.nodes.forEach(rO), this.nodes.forEach(Z_);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new j_());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Xu()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const l = this.eventHandlers.get(s);
      l && l.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s) {
      if (this.instance)
        return;
      this.isSVG = fd(s) && !KA(s), this.instance = s;
      const { layoutId: a, layout: l, visualElement: c } = this.options;
      if (c && !c.current && c.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), e) {
        let u, d = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        Ae.read(() => {
          d = window.innerWidth;
        }), e(s, () => {
          const m = window.innerWidth;
          m !== d && (d = m, this.root.updateBlockedByResize = !0, u && u(), u = H_(f, 250), ns.hasAnimatedSinceResize && (ns.hasAnimatedSinceResize = !1, this.nodes.forEach(om)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && c && (a || l) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d, hasRelativeLayoutChanged: f, layout: m }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || c.getDefaultTransition() || lO, { onLayoutAnimationStart: g, onLayoutAnimationComplete: y } = c.getProps(), b = !this.targetLayout || !Ow(this.targetLayout, m), x = !d && f;
        if (this.options.layoutRoot || this.resumeFrom || x || d && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const w = {
            ...sd(v, "layout"),
            onPlay: g,
            onComplete: y
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w), this.setAnimationOrigin(u, x, w.path);
        } else
          d || om(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = m;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Cn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(oO), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && $w(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, (typeof d.latestValues.x == "string" || typeof d.latestValues.y == "string") && (d.isLayoutDirty = !0), d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(J_), this.nodes.forEach(nm);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(rm);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(eO), this.nodes.forEach(tO), this.nodes.forEach(K_), this.nodes.forEach(X_)) : this.nodes.forEach(rm), this.clearAllSnapshots();
      const a = pt.now();
      ut.delta = fn(0, 1e3 / 60, a - ut.timestamp), ut.timestamp = a, ut.isProcessing = !0, Ka.update.process(ut), Ka.preRender.process(ut), Ka.render.process(ut), ut.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, ud.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Q_), this.sharedNodes.forEach(iO);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Ae.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Ae.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !gt(this.snapshot.measuredBox.x) && !gt(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = tt()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !_w(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      s && this.instance && (a || Yn(this.latestValues) || u) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return s && (l = this.removeTransform(l)), cO(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var c;
      const { visualElement: s } = this.options;
      if (!s)
        return tt();
      const a = s.measureViewportBox();
      if (!(((c = this.scroll) == null ? void 0 : c.wasRoot) || this.path.some(uO))) {
        const { scroll: u } = this.root;
        u && (on(a.x, u.offset.x), on(a.y, u.offset.y));
      }
      return a;
    }
    removeElementScroll(s) {
      var l;
      const a = tt();
      if (Ht(a, s), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: d, options: f } = u;
        u !== this.root && d && f.layoutScroll && (d.wasRoot && Ht(a, s), on(a.x, d.offset.x), on(a.y, d.offset.y));
      }
      return a;
    }
    applyTransform(s, a = !1, l) {
      var u, d;
      const c = l || tt();
      Ht(c, s);
      for (let f = 0; f < this.path.length; f++) {
        const m = this.path[f];
        !a && m.options.layoutScroll && m.scroll && m !== m.root && (on(c.x, -m.scroll.offset.x), on(c.y, -m.scroll.offset.y)), Yn(m.latestValues) && es(c, m.latestValues, (u = m.layout) == null ? void 0 : u.layoutBox);
      }
      return Yn(this.latestValues) && es(c, this.latestValues, (d = this.layout) == null ? void 0 : d.layoutBox), c;
    }
    removeTransform(s) {
      var l;
      const a = tt();
      Ht(a, s);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        if (!Yn(u.latestValues))
          continue;
        let d;
        u.instance && (Pc(u.latestValues) && u.updateSnapshot(), d = tt(), Ht(d, u.measurePageBox())), Gh(a, u.latestValues, (l = u.snapshot) == null ? void 0 : l.layoutBox, d);
      }
      return Yn(this.latestValues) && Gh(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== ut.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var m;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(s || l && this.isSharedProjectionDirty || this.isProjectionDirty || (m = this.parent) != null && m.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: d } = this.options;
      if (!this.layout || !(u || d))
        return;
      this.resolvedRelativeTargetAt = ut.timestamp;
      const f = this.getClosestProjectingParent();
      f && this.linkedParentVersion !== f.layoutVersion && !f.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && f && f.layout ? this.createRelativeTarget(f, this.layout.layoutBox, f.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = tt(), this.targetWithTransforms = tt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), N_(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : Ht(this.target, this.layout.layoutBox), xw(this.target, this.targetDelta)) : Ht(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? this.createRelativeTarget(f, this.target, f.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Pc(this.parent.latestValues) || ww(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(s, a, l) {
      this.relativeParent = s, this.linkedParentVersion = s.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = tt(), this.relativeTargetOrigin = tt(), Ns(this.relativeTargetOrigin, a, l, this.options.layoutAnchor || void 0), Ht(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var v;
      const s = this.getLead(), a = !!this.resumingFrom || this !== s;
      let l = !0;
      if ((this.isProjectionDirty || (v = this.parent) != null && v.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === ut.timestamp && (l = !1), l)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      Ht(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, f = this.treeScale.y;
      s_(this.layoutCorrected, this.treeScale, this.path, a), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = tt());
      const { target: m } = s;
      if (!m) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Wh(this.prevProjectionDelta.x, this.projectionDelta.x), Wh(this.prevProjectionDelta.y, this.projectionDelta.y)), _o(this.projectionDelta, this.layoutCorrected, m, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== f || !Qh(this.projectionDelta.x, this.prevProjectionDelta.x) || !Qh(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", m));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), s) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = $r(), this.projectionDelta = $r(), this.projectionDeltaWithTransform = $r();
    }
    setAnimationOrigin(s, a = !1, l) {
      const c = this.snapshot, u = c ? c.latestValues : {}, d = { ...this.latestValues }, f = $r();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const m = tt(), v = c ? c.source : void 0, g = this.layout ? this.layout.source : void 0, y = v !== g, b = this.getStack(), x = !b || b.members.length <= 1, w = !!(y && !x && this.options.crossfade === !0 && !this.path.some(aO));
      this.animationProgress = 0;
      let C;
      const E = l == null ? void 0 : l.interpolateProjection(s);
      this.mixTargetDelta = (S) => {
        const T = S / 1e3, P = E == null ? void 0 : E(T);
        P ? (f.x.translate = P.x, f.x.scale = Ne(s.x.scale, 1, T), f.x.origin = s.x.origin, f.x.originPoint = s.x.originPoint, f.y.translate = P.y, f.y.scale = Ne(s.y.scale, 1, T), f.y.origin = s.y.origin, f.y.originPoint = s.y.originPoint) : (im(f.x, s.x, T), im(f.y, s.y, T)), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Ns(m, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), sO(this.relativeTarget, this.relativeTargetOrigin, m, T), C && I_(this.relativeTarget, C) && (this.isProjectionDirty = !1), C || (C = tt()), Ht(C, this.relativeTarget)), y && (this.animationValues = d, F_(d, u, this.latestValues, T, w, x)), P && P.rotate !== void 0 && (this.animationValues || (this.animationValues = d), this.animationValues.pathRotation = P.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = T;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      var a, l, c;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (c = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || c.stop(), this.pendingAnimation && (Cn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Ae.update(() => {
        ns.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = cr(0)), this.motionValue.jump(0, !1), this.currentAnimation = W_(this.motionValue, [0, 1e3], {
          ...s,
          velocity: 0,
          isSync: !0,
          onUpdate: (u) => {
            this.mixTargetDelta(u), s.onUpdate && s.onUpdate(u);
          },
          onStop: () => {
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Y_), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = s;
      if (!(!a || !l || !c)) {
        if (this !== s && this.layout && c && Vw(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || tt();
          const d = gt(this.layout.layoutBox.x);
          l.x.min = s.target.x.min, l.x.max = l.x.min + d;
          const f = gt(this.layout.layoutBox.y);
          l.y.min = s.target.y.min, l.y.max = l.y.min + f;
        }
        Ht(a, l), es(a, u), _o(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new U_()), this.sharedNodes.get(s).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: l } = s;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && rl("z", s, c, this.animationValues);
      for (let u = 0; u < nl.length; u++)
        rl(`rotate${nl[u]}`, s, c, this.animationValues), rl(`skew${nl[u]}`, s, c, this.animationValues);
      s.render();
      for (const u in c)
        s.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      s.scheduleRender();
    }
    applyProjectionStyles(s, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        s.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, s.visibility = "", s.opacity = "", s.pointerEvents = ts(a == null ? void 0 : a.pointerEvents) || "", s.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        this.options.layoutId && (s.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, s.pointerEvents = ts(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Yn(this.latestValues) && (s.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      s.visibility = "";
      const u = c.animationValues || c.latestValues;
      this.applyTransformsToTarget();
      let d = L_(this.projectionDeltaWithTransform, this.treeScale, u);
      l && (d = l(u, d)), s.transform = d;
      const { x: f, y: m } = this.projectionDelta;
      s.transformOrigin = `${f.origin * 100}% ${m.origin * 100}% 0`, c.animationValues ? s.opacity = c === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : s.opacity = c === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const v in Dc) {
        if (u[v] === void 0)
          continue;
        const { correct: g, applyTo: y, isCSSVariable: b } = Dc[v], x = d === "none" ? u[v] : g(u[v], c);
        if (y) {
          const w = y.length;
          for (let C = 0; C < w; C++)
            s[y[C]] = x;
        } else
          b ? this.options.visualElement.renderState.vars[v] = x : s[v] = x;
      }
      this.options.layoutId && (s.pointerEvents = c === this ? ts(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(nm), this.root.sharedNodes.clear();
    }
  };
}
function K_(e) {
  e.updateLayout();
}
function X_(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, s = t.source !== e.layout.source;
    if (i === "size")
      rn((d) => {
        const f = s ? t.measuredBox[d] : t.layoutBox[d], m = gt(f);
        f.min = r[d].min, f.max = f.min + m;
      });
    else if (i === "x" || i === "y") {
      const d = i === "x" ? "y" : "x";
      Rc(s ? t.measuredBox[d] : t.layoutBox[d], r[d]);
    } else Vw(i, t.layoutBox, r) && rn((d) => {
      const f = s ? t.measuredBox[d] : t.layoutBox[d], m = gt(r[d]);
      f.max = f.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + m);
    });
    const a = $r();
    _o(a, r, t.layoutBox);
    const l = $r();
    s ? _o(l, e.applyTransform(o, !0), t.measuredBox) : _o(l, r, t.layoutBox);
    const c = !_w(a);
    let u = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: m } = d;
        if (f && m) {
          const v = e.options.layoutAnchor || void 0, g = tt();
          Ns(g, t.layoutBox, f.layoutBox, v);
          const y = tt();
          Ns(y, r, m.layoutBox, v), Ow(g, y) || (u = !0), d.options.layoutRoot && (e.relativeTarget = y, e.relativeTargetOrigin = g, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function q_(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function Z_(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function Q_(e) {
  e.clearSnapshot();
}
function nm(e) {
  e.clearMeasurements();
}
function J_(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function rm(e) {
  e.isLayoutDirty = !1;
}
function eO(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function tO(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function om(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function nO(e) {
  e.resolveTargetDelta();
}
function rO(e) {
  e.calcProjection();
}
function oO(e) {
  e.resetSkewAndRotation();
}
function iO(e) {
  e.removeLeadSnapshot();
}
function im(e, t, n) {
  e.translate = Ne(t.translate, 0, n), e.scale = Ne(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function sm(e, t, n, r) {
  e.min = Ne(t.min, n.min, r), e.max = Ne(t.max, n.max, r);
}
function sO(e, t, n, r) {
  sm(e.x, t.x, n.x, r), sm(e.y, t.y, n.y, r);
}
function aO(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const lO = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, am = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), lm = am("applewebkit/") && !am("chrome/") ? Math.round : $t;
function cm(e) {
  e.min = lm(e.min), e.max = lm(e.max);
}
function cO(e) {
  cm(e.x), cm(e.y);
}
function Vw(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !M_(Zh(t), Zh(n), 0.2);
}
function uO(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const dO = Fw({
  attachResizeListener: (e, t) => Zo(e, "resize", t),
  measureScroll: () => {
    var e, t;
    return {
      x: document.documentElement.scrollLeft || ((e = document.body) == null ? void 0 : e.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((t = document.body) == null ? void 0 : t.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), ol = {
  current: void 0
}, Bw = Fw({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!ol.current) {
      const e = new dO({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), ol.current = e;
    }
    return ol.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), vd = je({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function fO(e = !0) {
  const t = Se(Gu);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: o } = t, i = Yx();
  me(() => {
    if (e)
      return o(i);
  }, [e]);
  const s = Ie(() => e && r && r(i), [i, r, e]);
  return !n && r ? [!1, s] : [!0];
}
const Ww = je({ strict: !1 }), um = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let dm = !1;
function hO() {
  if (dm)
    return;
  const e = {};
  for (const t in um)
    e[t] = {
      isEnabled: (n) => um[t].some((r) => !!n[r])
    };
  vw(e), dm = !0;
}
function zw() {
  return hO(), n_();
}
function mO(e) {
  const t = zw();
  for (const n in e)
    t[n] = {
      ...t[n],
      ...e[n]
    };
  vw(t);
}
const pO = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function As(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || pO.has(e);
}
let jw = (e) => !As(e);
function gO(e) {
  typeof e == "function" && (jw = (t) => t.startsWith("on") ? !As(t) : e(t));
}
try {
  gO(require("@emotion/is-prop-valid").default);
} catch {
}
function vO(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || ot(e[o]) || (jw(o) || n === !0 && As(o) || !t && !As(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
const ya = /* @__PURE__ */ je({});
function yO(e, t) {
  if (va(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || qo(n) ? n : void 0,
      animate: qo(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function bO(e) {
  const { initial: t, animate: n } = yO(e, Se(ya));
  return ve(() => ({ initial: t, animate: n }), [fm(t), fm(n)]);
}
function fm(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const yd = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Hw(e, t, n) {
  for (const r in t)
    !ot(t[r]) && !Tw(r, n) && (e[r] = t[r]);
}
function wO({ transformTemplate: e }, t) {
  return ve(() => {
    const n = yd();
    return pd(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function xO(e, t) {
  const n = e.style || {}, r = {};
  return Hw(r, n, e), Object.assign(r, wO(e, t)), r;
}
function CO(e, t) {
  const n = {}, r = xO(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const Uw = () => ({
  ...yd(),
  attrs: {}
});
function SO(e, t, n, r) {
  const o = ve(() => {
    const i = Uw();
    return Ew(i, t, kw(r), e.transformTemplate, e.style), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Hw(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
const TO = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function bd(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(TO.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function EO(e, t, n, { latestValues: r }, o, i = !1, s) {
  const l = (s ?? bd(e) ? SO : CO)(t, r, o, e), c = vO(t, typeof e == "string", i), u = e !== $s ? { ...c, ...l, ref: n } : {}, { children: d } = t, f = ve(() => ot(d) ? d.get() : d, [d]);
  return Fe(e, {
    ...u,
    children: f
  });
}
function PO({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, o) {
  return {
    latestValues: kO(n, r, o, e),
    renderState: t()
  };
}
function kO(e, t, n, r) {
  const o = {}, i = r(e, {});
  for (const f in i)
    o[f] = ts(i[f]);
  let { initial: s, animate: a } = e;
  const l = va(e), c = pw(e);
  t && c && !l && e.inherit !== !1 && (s === void 0 && (s = t.initial), a === void 0 && (a = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || s === !1;
  const d = u ? a : s;
  if (d && typeof d != "boolean" && !ga(d)) {
    const f = Array.isArray(d) ? d : [d];
    for (let m = 0; m < f.length; m++) {
      const v = ld(e, f[m]);
      if (v) {
        const { transitionEnd: g, transition: y, ...b } = v;
        for (const x in b) {
          let w = b[x];
          if (Array.isArray(w)) {
            const C = u ? w.length - 1 : 0;
            w = w[C];
          }
          w !== null && (o[x] = w);
        }
        for (const x in g)
          o[x] = g[x];
      }
    }
  }
  return o;
}
const Yw = (e) => (t, n) => {
  const r = Se(ya), o = Se(Gu), i = () => PO(e, t, r, o);
  return n ? i() : gi(i);
}, DO = /* @__PURE__ */ Yw({
  scrapeMotionValuesFromProps: gd,
  createRenderState: yd
}), RO = /* @__PURE__ */ Yw({
  scrapeMotionValuesFromProps: Dw,
  createRenderState: Uw
}), MO = Symbol.for("motionComponentSymbol");
function NO(e, t, n) {
  const r = ae(n);
  ap(() => {
    r.current = n;
  });
  const o = ae(null);
  return Ie((i) => {
    var a;
    i && ((a = e.onMount) == null || a.call(e, i)), t && (i ? t.mount(i) : t.unmount());
    const s = r.current;
    if (typeof s == "function")
      if (i) {
        const l = s(i);
        typeof l == "function" && (o.current = l);
      } else o.current ? (o.current(), o.current = null) : s(i);
    else s && (s.current = i);
  }, [t]);
}
const Gw = je({});
function Nr(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function AO(e, t, n, r, o, i) {
  var w, C;
  const { visualElement: s } = Se(ya), a = Se(Ww), l = Se(Gu), c = Se(vd), u = c.reducedMotion, d = c.skipAnimations, f = ae(null), m = ae(!1);
  r = r || a.renderer, !f.current && r && (f.current = r(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: u,
    skipAnimations: d,
    isSVG: i
  }), m.current && f.current && (f.current.manuallyAnimateOnMount = !0));
  const v = f.current, g = Se(Gw);
  v && !v.projection && o && (v.type === "html" || v.type === "svg") && _O(f.current, n, o, g);
  const y = ae(!1);
  ap(() => {
    v && y.current && v.update(n, l);
  });
  const b = n[rw], x = ae(!!b && typeof window < "u" && !((w = window.MotionHandoffIsComplete) != null && w.call(window, b)) && ((C = window.MotionHasOptimisedAnimation) == null ? void 0 : C.call(window, b)));
  return mb(() => {
    m.current = !0, v && (y.current = !0, window.MotionIsMounted = !0, v.updateFeatures(), v.scheduleRenderMicrotask(), x.current && v.animationState && v.animationState.animateChanges());
  }), me(() => {
    v && (!x.current && v.animationState && v.animationState.animateChanges(), x.current && (queueMicrotask(() => {
      var E;
      (E = window.MotionHandoffMarkAsComplete) == null || E.call(window, b);
    }), x.current = !1), v.enteringChildren = void 0);
  }), v;
}
function _O(e, t, n, r) {
  const { layoutId: o, layout: i, drag: s, dragConstraints: a, layoutScroll: l, layoutRoot: c, layoutAnchor: u, layoutCrossfade: d } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Kw(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!s || a && Nr(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    crossfade: d,
    layoutScroll: l,
    layoutRoot: c,
    layoutAnchor: u
  });
}
function Kw(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Kw(e.parent);
}
function il(e, { forwardMotionProps: t = !1, type: n } = {}, r, o) {
  r && mO(r);
  const i = n ? n === "svg" : bd(e), s = i ? RO : DO;
  function a(c, u) {
    let d;
    const f = {
      ...Se(vd),
      ...c,
      layoutId: OO(c)
    }, { isStatic: m } = f, v = bO(c), g = s(c, m);
    if (!m && typeof window < "u") {
      IO(f, r);
      const y = LO(f);
      d = y.MeasureLayout, v.visualElement = AO(e, g, f, o, y.ProjectionNode, i);
    }
    return L(ya.Provider, { value: v, children: [d && v.visualElement ? h(d, { visualElement: v.visualElement, ...f }) : null, EO(e, c, NO(g, v.visualElement, u), g, m, t, i)] });
  }
  a.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const l = Ke(a);
  return l[MO] = e, l;
}
function OO({ layoutId: e }) {
  const t = Se(hb).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function IO(e, t) {
  const n = Se(Ww).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? lo(!1, r, "lazy-strict-mode") : qt(!1, r, "lazy-strict-mode");
  }
}
function LO(e) {
  const t = zw(), { drag: n, layout: r } = t;
  if (!n && !r)
    return {};
  const o = { ...n, ...r };
  return {
    MeasureLayout: n != null && n.isEnabled(e) || r != null && r.isEnabled(e) ? o.MeasureLayout : void 0,
    ProjectionNode: o.ProjectionNode
  };
}
function $O(e, t) {
  if (typeof Proxy > "u")
    return il;
  const n = /* @__PURE__ */ new Map(), r = (i, s) => il(i, s, e, t), o = (i, s) => (process.env.NODE_ENV !== "production" && qu(!1, "motion() is deprecated. Use motion.create() instead."), r(i, s));
  return new Proxy(o, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, s) => s === "create" ? r : (n.has(s) || n.set(s, il(s, void 0, e, t)), n.get(s))
  });
}
const FO = (e, t) => t.isSVG ?? bd(e) ? new b_(t) : new h_(t, {
  allowProjection: e !== $s
});
class VO extends Wn {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = T_(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    ga(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let BO = 0;
class WO extends Wn {
  constructor() {
    super(...arguments), this.id = BO++, this.isExitComplete = !1;
  }
  update() {
    var i;
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const { initial: s, custom: a } = this.node.getProps();
        if (typeof s == "string" || typeof s == "object" && s !== null && !Array.isArray(s)) {
          const l = Jn(this.node, s, a);
          if (l) {
            const { transition: c, transitionEnd: u, ...d } = l;
            for (const f in d)
              (i = this.node.getValue(f)) == null || i.jump(d[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const zO = {
  animation: {
    Feature: VO
  },
  exit: {
    Feature: WO
  }
};
function wi(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const jO = (e) => (t) => dd(t) && e(t, wi(t));
function Oo(e, t, n, r) {
  return Zo(e, t, jO(n), r);
}
const Xw = ({ current: e }) => e ? e.ownerDocument.defaultView : null, hm = (e, t) => Math.abs(e - t);
function HO(e, t) {
  const n = hm(e.x, t.x), r = hm(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const mm = /* @__PURE__ */ new Set(["auto", "scroll"]);
class qw {
  constructor(t, n, { transformPagePoint: r, contextWindow: o = window, dragSnapToOrigin: i = !1, distanceThreshold: s = 3, element: a } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (m) => {
      this.handleScroll(m.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = zi(this.lastRawMoveEventInfo, this.transformPagePoint));
      const m = sl(this.lastMoveEventInfo, this.history), v = this.startEvent !== null, g = HO(m.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!v && !g)
        return;
      const { point: y } = m, { timestamp: b } = ut;
      this.history.push({ ...y, timestamp: b });
      const { onStart: x, onMove: w } = this.handlers;
      v || (x && x(this.lastMoveEvent, m), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, m);
    }, this.handlePointerMove = (m, v) => {
      this.lastMoveEvent = m, this.lastRawMoveEventInfo = v, this.lastMoveEventInfo = zi(v, this.transformPagePoint), Ae.update(this.updatePoint, !0);
    }, this.handlePointerUp = (m, v) => {
      this.end();
      const { onEnd: g, onSessionEnd: y, resumeAnimation: b } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && b && b(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const x = sl(m.type === "pointercancel" ? this.lastMoveEventInfo : zi(v, this.transformPagePoint), this.history);
      this.startEvent && g && g(m, x), y && y(m, x);
    }, !dd(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = s, this.contextWindow = o || window;
    const l = wi(t), c = zi(l, this.transformPagePoint), { point: u } = c, { timestamp: d } = ut;
    this.history = [{ ...u, timestamp: d }];
    const { onSessionStart: f } = n;
    f && f(t, sl(c, this.history)), this.removeListeners = vi(Oo(this.contextWindow, "pointermove", this.handlePointerMove), Oo(this.contextWindow, "pointerup", this.handlePointerUp), Oo(this.contextWindow, "pointercancel", this.handlePointerUp)), a && this.startScrollTracking(a);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n; ) {
      const r = getComputedStyle(n);
      (mm.has(r.overflowX) || mm.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n)
      return;
    const r = t === window, o = r ? { x: window.scrollX, y: window.scrollY } : {
      x: t.scrollLeft,
      y: t.scrollTop
    }, i = { x: o.x - n.x, y: o.y - n.y };
    i.x === 0 && i.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += i.x, this.lastMoveEventInfo.point.y += i.y) : this.history.length > 0 && (this.history[0].x -= i.x, this.history[0].y -= i.y), this.scrollPositions.set(t, o), Ae.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Cn(this.updatePoint);
  }
}
function zi(e, t) {
  return t ? { point: t(e.point) } : e;
}
function pm(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function sl({ point: e }, t) {
  return {
    point: e,
    delta: pm(e, Zw(t)),
    offset: pm(e, UO(t)),
    velocity: YO(t, 0.1)
  };
}
function UO(e) {
  return e[0];
}
function Zw(e) {
  return e[e.length - 1];
}
function YO(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = Zw(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > /* @__PURE__ */ Ct(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  r === e[0] && e.length > 2 && o.timestamp - r.timestamp > /* @__PURE__ */ Ct(t) * 2 && (r = e[1]);
  const i = /* @__PURE__ */ It(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function GO(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Ne(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Ne(n, e, r.max) : Math.min(e, n)), e;
}
function gm(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function KO(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: gm(e.x, n, o),
    y: gm(e.y, t, r)
  };
}
function vm(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function XO(e, t) {
  return {
    x: vm(e.x, t.x),
    y: vm(e.y, t.y)
  };
}
function qO(e, t) {
  let n = 0.5;
  const r = gt(e), o = gt(t);
  return o > r ? n = /* @__PURE__ */ Ko(t.min, t.max - r, e.min) : r > o && (n = /* @__PURE__ */ Ko(e.min, e.max - o, t.min)), fn(0, 1, n);
}
function ZO(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Mc = 0.35;
function QO(e = Mc) {
  return e === !1 ? e = 0 : e === !0 && (e = Mc), {
    x: ym(e, "left", "right"),
    y: ym(e, "top", "bottom")
  };
}
function ym(e, t, n) {
  return {
    min: bm(e, t),
    max: bm(e, n)
  };
}
function bm(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const JO = /* @__PURE__ */ new WeakMap();
class eI {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = tt(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: o } = this.visualElement;
    if (o && o.isPresent === !1)
      return;
    const i = (d) => {
      n && this.snapToCursor(wi(d).point), this.stopAnimation();
    }, s = (d, f) => {
      const { drag: m, dragPropagation: v, onDragStart: g } = this.getProps();
      if (m && !v && (this.openDragLock && this.openDragLock(), this.openDragLock = NA(m), !this.openDragLock))
        return;
      this.latestPointerEvent = d, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), rn((b) => {
        let x = this.getAxisMotionValue(b).get() || 0;
        if (dn.test(x)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const C = w.layout.layoutBox[b];
            C && (x = gt(C) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[b] = x;
      }), g && Ae.update(() => g(d, f), !1, !0), wc(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, a = (d, f) => {
      this.latestPointerEvent = d, this.latestPanInfo = f;
      const { dragPropagation: m, dragDirectionLock: v, onDirectionLock: g, onDrag: y } = this.getProps();
      if (!m && !this.openDragLock)
        return;
      const { offset: b } = f;
      if (v && this.currentDirection === null) {
        this.currentDirection = nI(b), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, b), this.updateAxis("y", f.point, b), this.visualElement.render(), y && Ae.update(() => y(d, f), !1, !0);
    }, l = (d, f) => {
      this.latestPointerEvent = d, this.latestPanInfo = f, this.stop(d, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, c = () => {
      const { dragSnapToOrigin: d } = this.getProps();
      (d || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new qw(t, {
      onSessionStart: i,
      onStart: s,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: r,
      contextWindow: Xw(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, o = n || this.latestPanInfo, i = this.isDragging;
    if (this.cancel(), !i || !o || !r)
      return;
    const { velocity: s } = o;
    this.startAnimation(s);
    const { onDragEnd: a } = this.getProps();
    a && Ae.postRender(() => a(r, o));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !ji(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = GO(s, this.constraints[t], this.elastic[t])), i.set(s);
  }
  resolveConstraints() {
    var i;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (i = this.visualElement.projection) == null ? void 0 : i.layout, o = this.constraints;
    t && Nr(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = KO(r.layoutBox, t) : this.constraints = !1, this.elastic = QO(n), o !== this.constraints && !Nr(t) && r && this.constraints && !this.hasMutatedConstraints && rn((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = ZO(r.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Nr(t))
      return !1;
    const r = t.current;
    qt(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    o.root && (o.root.scroll = void 0, o.root.updateScroll());
    const i = a_(r, o.root, this.visualElement.getTransformPagePoint());
    let s = XO(o.layout.layoutBox, i);
    if (n) {
      const a = n(o_(s));
      this.hasMutatedConstraints = !!a, a && (s = bw(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = rn((u) => {
      if (!ji(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      (s === !0 || s === u) && (d = { min: 0, max: 0 });
      const f = o ? 200 : 1e6, m = o ? 40 : 1e7, v = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: f,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...d
      };
      return this.startAxisValueAnimation(u, v);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return wc(this.visualElement, t), r.start(ad(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    rn((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, o = this.visualElement.getProps()[n];
    return o || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    rn((n) => {
      const { drag: r } = this.getProps();
      if (!ji(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: s, max: a } = o.layout.layoutBox[n], l = i.get() || 0;
        i.set(t[n] - Ne(s, a, 0.5) + l);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Nr(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    rn((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const l = a.get();
        o[s] = qO({ min: l, max: l }, this.constraints[s]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), rn((s) => {
      if (!ji(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: l, max: c } = this.constraints[s];
      a.set(Ne(l, c, o[s]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    JO.set(this.visualElement, this);
    const t = this.visualElement.current, n = Oo(t, "pointerdown", (c) => {
      const { drag: u, dragListener: d = !0 } = this.getProps(), f = c.target, m = f !== t && $A(f);
      u && d && !m && this.start(c);
    });
    let r;
    const o = () => {
      const { dragConstraints: c } = this.getProps();
      Nr(c) && c.current && (this.constraints = this.resolveRefConstraints(), r || (r = tI(t, c.current, () => this.scalePositionWithinConstraints())));
    }, { projection: i } = this.visualElement, s = i.addEventListener("measure", o);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Ae.read(o);
    const a = Zo(window, "resize", () => this.scalePositionWithinConstraints()), l = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (rn((d) => {
        const f = this.getAxisMotionValue(d);
        f && (this.originPoint[d] += c[d].translate, f.set(f.get() + c[d].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), s(), l && l(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: s = Mc, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function wm(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function tI(e, t, n) {
  const r = Rh(e, wm(n)), o = Rh(t, wm(n));
  return () => {
    r(), o();
  };
}
function ji(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function nI(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class rI extends Wn {
  constructor(t) {
    super(t), this.removeGroupControls = $t, this.removeListeners = $t, this.controls = new eI(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || $t;
  }
  update() {
    const { dragControls: t } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const al = (e) => (t, n) => {
  e && Ae.update(() => e(t, n), !1, !0);
};
class oI extends Wn {
  constructor() {
    super(...arguments), this.removePointerDownListener = $t;
  }
  onPointerDown(t) {
    this.session = new qw(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Xw(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: al(t),
      onStart: al(n),
      onMove: al(r),
      onEnd: (i, s) => {
        delete this.session, o && Ae.postRender(() => o(i, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Oo(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let ll = !1;
class iI extends Gx {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    i && (n.group && n.group.add(i), r && r.register && o && r.register(i), ll && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), ns.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, { projection: s } = r;
    return s && (s.isPresent = i, t.layoutDependency !== n && s.setOptions({
      ...s.options,
      layoutDependency: n
    }), ll = !0, o || t.layoutDependency !== n || n === void 0 || t.isPresent !== i ? s.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? s.promote() : s.relegate() || Ae.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: t, layoutAnchor: n } = this.props, { projection: r } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), ud.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    ll = !0, o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Qw(e) {
  const [t, n] = fO(), r = Se(hb);
  return h(iI, { ...e, layoutGroup: r, switchLayoutGroup: Se(Gw), isPresent: t, safeToRemove: n });
}
const sI = {
  pan: {
    Feature: oI
  },
  drag: {
    Feature: rI,
    ProjectionNode: Bw,
    MeasureLayout: Qw
  }
};
function xm(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const o = "onHover" + n, i = r[o];
  i && Ae.postRender(() => i(t, wi(t)));
}
class aI extends Wn {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = _A(t, (n, r) => (xm(this.node, r, "Start"), (o) => xm(this.node, o, "End"))));
  }
  unmount() {
  }
}
class lI extends Wn {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = vi(Zo(this.node.current, "focus", () => this.onFocus()), Zo(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Cm(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const o = "onTap" + (n === "End" ? "" : n), i = r[o];
  i && Ae.postRender(() => i(t, wi(t)));
}
class cI extends Wn {
  mount() {
    const { current: t } = this.node;
    if (!t)
      return;
    const { globalTapTarget: n, propagate: r } = this.node.props;
    this.unmount = VA(t, (o, i) => (Cm(this.node, i, "Start"), (s, { success: a }) => Cm(this.node, s, a ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: (r == null ? void 0 : r.tap) === !1
    });
  }
  unmount() {
  }
}
const Nc = /* @__PURE__ */ new WeakMap(), cl = /* @__PURE__ */ new WeakMap(), uI = (e) => {
  const t = Nc.get(e.target);
  t && t(e);
}, dI = (e) => {
  e.forEach(uI);
};
function fI({ root: e, ...t }) {
  const n = e || document;
  cl.has(n) || cl.set(n, {});
  const r = cl.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(dI, { root: e, ...t })), r[o];
}
function hI(e, t, n) {
  const r = fI(t);
  return Nc.set(e, n), r.observe(e), () => {
    Nc.delete(e), r.unobserve(e);
  };
}
const mI = {
  some: 0,
  all: 1
};
class pI extends Wn {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    var l;
    (l = this.stopObserver) == null || l.call(this);
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : mI[o]
    }, a = (c) => {
      const { isIntersecting: u } = c;
      if (this.isInView === u || (this.isInView = u, i && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: d, onViewportLeave: f } = this.node.getProps(), m = u ? d : f;
      m && m(c);
    };
    this.stopObserver = hI(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(gI(t, n)) && this.startObserver();
  }
  unmount() {
    var t;
    (t = this.stopObserver) == null || t.call(this), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function gI({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const vI = {
  inView: {
    Feature: pI
  },
  tap: {
    Feature: cI
  },
  focus: {
    Feature: lI
  },
  hover: {
    Feature: aI
  }
}, yI = {
  layout: {
    ProjectionNode: Bw,
    MeasureLayout: Qw
  }
}, bI = {
  ...zO,
  ...vI,
  ...sI,
  ...yI
}, Qo = /* @__PURE__ */ $O(bI, FO);
function Jw(e) {
  const t = gi(() => cr(e)), { isStatic: n } = Se(vd);
  if (n) {
    const [, r] = he(e);
    me(() => t.on("change", r), []);
  }
  return t;
}
function e0(e, t) {
  const n = Jw(t()), r = () => n.set(t());
  return r(), mb(() => {
    const o = () => Ae.preRender(r, !1, !0), i = e.map((s) => s.on("change", o));
    return () => {
      i.forEach((s) => s()), Cn(r);
    };
  }), n;
}
function wI(e) {
  Ao.current = [], e();
  const t = e0(Ao.current, e);
  return Ao.current = void 0, t;
}
function xI(e, t, n, r) {
  if (typeof e == "function")
    return wI(e);
  const i = typeof t == "function" ? t : XA(t, n, r), s = Array.isArray(e) ? Sm(e, i) : Sm([e], ([l]) => i(l)), a = Array.isArray(e) ? void 0 : e.accelerate;
  return a && !a.isTransformed && typeof t != "function" && Array.isArray(n) && (r == null ? void 0 : r.clamp) !== !1 && (s.accelerate = {
    ...a,
    times: t,
    keyframes: n,
    isTransformed: !0
  }), s;
}
function Sm(e, t) {
  const n = gi(() => []);
  return e0(e, () => {
    n.length = 0;
    const r = e.length;
    for (let o = 0; o < r; o++)
      n[o] = e[o].get();
    return t(n);
  });
}
const t0 = je(null);
function CI(e, t, n, r) {
  if (!r)
    return e;
  const o = e.findIndex((u) => u.value === t);
  if (o === -1)
    return e;
  const i = r > 0 ? 1 : -1, s = e[o + i];
  if (!s)
    return e;
  const a = e[o], l = s.layout, c = Ne(l.min, l.max, 0.5);
  return i === 1 && a.layout.max + n > c || i === -1 && a.layout.min + n < c ? kM(e, o, o + i) : e;
}
function SI({ children: e, as: t = "ul", axis: n = "y", onReorder: r, values: o, ...i }, s) {
  const a = gi(() => Qo[t]), l = [], c = ae(!1), u = ae(null);
  qt(!!o, "Reorder.Group must be provided a values prop", "reorder-values");
  const d = {
    axis: n,
    groupRef: u,
    registerItem: (v, g) => {
      const y = l.findIndex((b) => v === b.value);
      y !== -1 ? l[y].layout = g[n] : l.push({ value: v, layout: g[n] }), l.sort(EI);
    },
    updateOrder: (v, g, y) => {
      if (c.current)
        return;
      const b = CI(l, v, g, y);
      if (l !== b) {
        c.current = !0;
        const x = [...o];
        for (let w = 0; w < b.length; w++)
          if (l[w].value !== b[w].value) {
            const C = o.indexOf(l[w].value), E = o.indexOf(b[w].value);
            C !== -1 && E !== -1 && ([x[C], x[E]] = [x[E], x[C]]);
            break;
          }
        r(x);
      }
    }
  };
  me(() => {
    c.current = !1;
  });
  const f = (v) => {
    u.current = v, typeof s == "function" ? s(v) : s && (s.current = v);
  }, m = {
    overflowAnchor: "none",
    ...i.style
  };
  return h(a, { ...i, style: m, ref: f, ignoreStrict: !0, children: h(t0.Provider, { value: d, children: e }) });
}
const TI = /* @__PURE__ */ Ke(SI);
function EI(e, t) {
  return e.layout.min - t.layout.min;
}
const Hi = 50, Tm = 25, PI = /* @__PURE__ */ new Set(["auto", "scroll"]), Io = /* @__PURE__ */ new WeakMap(), Lo = /* @__PURE__ */ new WeakMap();
let ko = null;
function kI() {
  if (ko) {
    const e = Ac(ko, "y");
    e && (Lo.delete(e), Io.delete(e));
    const t = Ac(ko, "x");
    t && t !== e && (Lo.delete(t), Io.delete(t)), ko = null;
  }
}
function DI(e, t) {
  const n = getComputedStyle(e), r = t === "x" ? n.overflowX : n.overflowY, o = e === document.body || e === document.documentElement;
  return PI.has(r) || o;
}
function Ac(e, t) {
  let n = e == null ? void 0 : e.parentElement;
  for (; n; ) {
    if (DI(n, t))
      return n;
    n = n.parentElement;
  }
  return null;
}
function RI(e, t, n) {
  const r = t.getBoundingClientRect(), o = n === "x" ? Math.max(0, r.left) : Math.max(0, r.top), i = n === "x" ? Math.min(window.innerWidth, r.right) : Math.min(window.innerHeight, r.bottom), s = e - o, a = i - e;
  if (s < Hi) {
    const l = 1 - s / Hi;
    return { amount: -Tm * l * l, edge: "start" };
  } else if (a < Hi) {
    const l = 1 - a / Hi;
    return { amount: Tm * l * l, edge: "end" };
  }
  return { amount: 0, edge: null };
}
function MI(e, t, n, r) {
  if (!e)
    return;
  ko = e;
  const o = Ac(e, n);
  if (!o)
    return;
  const i = t - (n === "x" ? window.scrollX : window.scrollY), { amount: s, edge: a } = RI(i, o, n);
  if (a === null) {
    Lo.delete(o), Io.delete(o);
    return;
  }
  const l = Lo.get(o), c = o === document.body || o === document.documentElement;
  if (l !== a) {
    if (!(a === "start" && r < 0 || a === "end" && r > 0))
      return;
    Lo.set(o, a);
    const d = n === "x" ? o.scrollWidth - (c ? window.innerWidth : o.clientWidth) : o.scrollHeight - (c ? window.innerHeight : o.clientHeight);
    Io.set(o, d);
  }
  if (s > 0) {
    const u = Io.get(o);
    if ((n === "x" ? c ? window.scrollX : o.scrollLeft : c ? window.scrollY : o.scrollTop) >= u)
      return;
  }
  n === "x" ? c ? window.scrollBy({ left: s }) : o.scrollLeft += s : c ? window.scrollBy({ top: s }) : o.scrollTop += s;
}
function Em(e, t = 0) {
  return ot(e) ? e : Jw(t);
}
function NI({ children: e, style: t = {}, value: n, as: r = "li", onDrag: o, onDragEnd: i, layout: s = !0, ...a }, l) {
  const c = gi(() => Qo[r]), u = Se(t0), d = {
    x: Em(t.x),
    y: Em(t.y)
  }, f = xI([d.x, d.y], ([b, x]) => b || x ? 1 : "unset");
  qt(!!u, "Reorder.Item must be a child of Reorder.Group", "reorder-item-child");
  const { axis: m, registerItem: v, updateOrder: g, groupRef: y } = u;
  return h(c, { drag: m, ...a, dragSnapToOrigin: !0, style: { ...t, x: d.x, y: d.y, zIndex: f }, layout: s, onDrag: (b, x) => {
    const { velocity: w, point: C } = x, E = d[m].get();
    g(n, E, w[m]), MI(y.current, C[m], m, w[m]), o && o(b, x);
  }, onDragEnd: (b, x) => {
    kI(), i && i(b, x);
  }, onLayoutMeasure: (b) => {
    v(n, b);
  }, ref: l, ignoreStrict: !0, children: e });
}
const AI = /* @__PURE__ */ Ke(NI);
function zW({ id: e, children: t, className: n = "" }) {
  const {
    attributes: r,
    listeners: o,
    setNodeRef: i,
    transform: s,
    transition: a,
    isDragging: l
  } = TM({ id: e }), c = {
    transform: Go.Transform.toString(s),
    transition: a
  };
  return /* @__PURE__ */ h(
    Qo.div,
    {
      ref: i,
      style: c,
      ...r,
      ...o,
      className: n,
      layout: !0,
      initial: { opacity: 0, y: 20 },
      animate: {
        opacity: l ? 0.5 : 1,
        y: 0,
        scale: l ? 1.05 : 1,
        rotateZ: l ? 2 : 0
      },
      exit: { opacity: 0, y: -20 },
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
        opacity: { duration: 0.2 }
      },
      whileHover: {
        scale: l ? 1.05 : 1.02,
        transition: { duration: 0.2 }
      },
      whileTap: {
        scale: 0.98,
        transition: { duration: 0.1 }
      },
      drag: !0,
      dragConstraints: { left: 0, right: 0, top: 0, bottom: 0 },
      dragElastic: 0.1,
      children: t
    }
  );
}
function jW({
  options: e,
  onReorder: t,
  renderOption: n,
  showDragHandle: r = !0,
  showHeader: o = !0,
  customHeader: i,
  className: s = "",
  itemClassName: a = "",
  disabled: l = !1
}) {
  const c = (u, d) => /* @__PURE__ */ L(
    Qo.div,
    {
      className: `grid grid-cols-3 gap-4 p-4 hover:bg-muted/50 transition-colors ${d % 2 === 0 ? "bg-card" : "bg-muted/30"}`,
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      children: [
        r && /* @__PURE__ */ h(Qo.div, { className: "flex-shrink-0 cursor-grab active:cursor-grabbing p-1", children: /* @__PURE__ */ h(hC, { size: 16, className: "text-muted-foreground" }) }),
        /* @__PURE__ */ h("div", { className: "text-sm font-medium text-foreground", children: u.name }),
        /* @__PURE__ */ h("div", { className: "text-sm text-muted-foreground", children: u.description || "No description" })
      ]
    }
  );
  return l ? /* @__PURE__ */ L("div", { className: `${s} bg-card border border-border rounded-lg overflow-hidden`, children: [
    o && (i || /* @__PURE__ */ L("div", { className: "grid grid-cols-3 gap-4 p-3 bg-muted border-b border-border font-medium text-sm text-muted-foreground", children: [
      /* @__PURE__ */ h("div", { children: "Product Name" }),
      /* @__PURE__ */ h("div", { children: "Description" }),
      /* @__PURE__ */ h("div", { children: "Actions" })
    ] })),
    /* @__PURE__ */ h("div", { className: "divide-y divide-border", children: e.map((u, d) => /* @__PURE__ */ h("div", { className: a, children: n ? n(u, d) : c(u, d) }, u.id)) })
  ] }) : /* @__PURE__ */ L("div", { className: `${s} bg-card border border-border rounded-lg overflow-hidden`, children: [
    o && (i || /* @__PURE__ */ L("div", { className: "grid grid-cols-3 gap-4 p-3 bg-muted border-b border-border font-medium text-sm text-muted-foreground", children: [
      /* @__PURE__ */ h("div", { children: "Product Name" }),
      /* @__PURE__ */ h("div", { children: "Description" }),
      /* @__PURE__ */ h("div", { children: "Actions" })
    ] })),
    /* @__PURE__ */ h(TI, { axis: "y", values: e, onReorder: t, className: "divide-y divide-border", children: e.map((u, d) => /* @__PURE__ */ h(
      AI,
      {
        value: u,
        className: "cursor-move",
        whileDrag: {
          scale: 1.02,
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          zIndex: 10
        },
        children: n ? n(u, d) : c(u, d)
      },
      u.id
    )) })
  ] });
}
const _I = (e, t) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: t,
  minimumFractionDigits: t
}).format(e), OI = [
  // Percentage mask x 100
  {
    mask: /100#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e, e *= 100;
      const n = t.match(/100#\.(#+)%$/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Percentage mask
  {
    mask: /#\.#+%$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/#\.(#+)%/)[1].length;
      return `${e.toFixed(n)}%`;
    }
  },
  // Dollar mask
  {
    mask: /\$#(\.#*)?$/,
    apply: (e, t) => {
      e = typeof e == "string" ? parseFloat(e) : e;
      const n = t.match(/\$#(\.(#*))?$/)[2], r = n ? n.length : 0;
      return _I(e, r);
    }
  },
  // Millions mask
  {
    mask: /#\.#+M$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n != null && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e6).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" M");
      }
      return "";
    }
  },
  // Trillions mask (fixed)
  {
    mask: /#\.#+T$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n != null && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e12).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" T");
      }
      return "";
    }
  },
  // Thousands mask
  {
    mask: /#\.#+K$/,
    apply: (e, t) => {
      if (e) {
        const n = t.split("."), r = n && n[1] ? n[1].length - 1 : 0;
        e = Number(e);
        const o = new RegExp("\\.0+$|(?<=\\.[0-9]*[1-9])0+$");
        let i = (e / 1e3).toFixed(r).replace(o, "");
        return i.includes(".") || (i = i.concat(".0")), i.concat(" K");
      }
      return "";
    }
  },
  // Decimal masks (fixed to include #.#####)
  {
    mask: ["#.#", "#.##", "#.###", "#.####", "#.#####"],
    apply: (e, t) => {
      if (e) {
        e = Number(e);
        const n = t.split("."), r = n && n[1] ? n[1].length : 0;
        return `${e.toFixed(r)}`;
      }
      return "";
    }
  },
  {
    mask: ["#"],
    apply: (e) => e ? `${Number(e).toFixed(0)}` : ""
  },
  {
    mask: ["#th"],
    apply: (e) => {
      e = Number(e);
      const t = e % 10, n = e % 100;
      return t === 1 && n !== 11 ? e + "st" : t === 2 && n !== 12 ? e + "nd" : t === 3 && n !== 13 ? e + "rd" : e + "th";
    }
  }
];
function Pm(e, t) {
  const n = OI.find(
    (r) => Array.isArray(r.mask) && r.mask.includes(t) || !Array.isArray(r.mask) && t.match(r.mask)
  );
  return n ? n.apply(e, t) : "Invalid Mask";
}
const II = (e, t, n) => t && (typeof t == "function" ? t(e) : t[e]) || e;
function n0(e, t, n) {
  const r = t.filter(({ split: d }) => !d), o = r.map(({ key: d }) => d);
  let i = e;
  const s = i.columnNames(), a = t.filter(({ key: d }) => !s.includes(d)).map(({ key: d }) => d), l = r.filter(({ lookup: d }) => !!d), c = r.filter(({ componentProps: d }) => !!(d != null && d.options)), u = r.reduce((d, f) => {
    var m;
    if (f.group) {
      const v = (m = f.group) == null ? void 0 : m.filter(({ label: b }) => !!b), g = v == null ? void 0 : v.map(({ label: b }) => b), y = (g == null ? void 0 : g.join(" - ")) || "";
      d[`${f.key}`] = y != null && y.length ? `${y} - ${f.name}` : f.name;
    } else
      d[`${f.key}`] = f.name;
    return d;
  }, {});
  for (const d of a)
    i = i.derive({
      [d]: (f) => ""
    });
  if (i.print(), i = i.select(o), n) {
    const d = r.filter(({ mask: f, conditionalMask: m }) => !!f || !!m);
    for (const f of d)
      i = i.derive({
        [f.key]: Fr((m) => {
          let v = m[f.key] || "-";
          const g = f.dataType === "number" ? m[f.key] && m[f.key] < 0 : !1, y = f.negativeFormat ?? "brackets";
          return f.conditionalMask && (typeof m[f.key] == "number" || typeof m[f.key] == "string") && v !== "-" ? v = Pm(Math.abs(+m[f.key]), f.conditionalMask(f.key, f.name, m)) : f.mask && (typeof m[f.key] == "number" || typeof m[f.key] == "string") && v !== "-" && (v = Pm(Math.abs(+m[f.key]), f.mask)), v = `${f.prefix ?? ""}${v}${f.suffix ?? ""}`, y === "brackets" && g && v !== "-" && (v = `(${v})`), y === "minus" && g && v !== "-" && (v = `-${v}`), v;
        })
      });
  }
  for (const d of l)
    i = i.derive({
      [d.key]: Fr((f) => II(f[d.key], d.lookup))
    });
  for (const d of c)
    i = i.derive({
      [d.key]: Fr((f) => {
        const m = d.componentProps.options, v = typeof m == "function" ? m(f.key, d, f) : m;
        if (!Array.isArray(v))
          return f[d.key];
        const g = v.find(({ key: y }) => y === f[d.key]);
        return (g == null ? void 0 : g.label) || f[d.key];
      })
    });
  return i = i.rename(u), i;
}
function LI({ tbl: e, columns: t, fileName: n, applyMasks: r }) {
  const o = n0(e, t, r), i = /* @__PURE__ */ new Date(), s = new Blob([o.toCSV()], { type: "text/csv" }), a = URL.createObjectURL(s), l = document.createElement("a");
  l.href = a, l.download = `${i.toISOString()}-${n || "exported.csv"}`, l.click(), l.remove();
}
function $I({ tables: e, fileName: t, applyMasks: n }) {
  if (!e || e.length === 0) {
    console.warn("No tables provided for export");
    return;
  }
  const r = [];
  for (let c = 0; c < e.length; c++) {
    const u = e[c];
    if (!u)
      continue;
    const { table: d, columns: f, sectionName: m } = u, v = typeof d == "function" ? d() : d;
    if (!v || !f || v.size === 0)
      continue;
    const g = n0(v, f, n), y = g.toCSV();
    if (m) {
      const b = g.columnNames().length, x = `"${m}",${",".repeat(b - 1)}`;
      r.push(x);
    }
    r.push(y), c < e.length - 1 && r.push("");
  }
  const o = r.join(`
`), i = /* @__PURE__ */ new Date(), s = new Blob([o], { type: "text/csv" }), a = URL.createObjectURL(s), l = document.createElement("a");
  l.href = a, l.download = `${i.toISOString()}-${t || "exported.csv"}`, l.click(), l.remove();
}
const HW = ({ tbl: e, columns: t, tables: n, fileName: r, applyMasks: o, disabled: i, iconOnly: s = !1, overrideMask: a }) => {
  const [l, c] = he(!1), u = Fu(), d = async () => {
    c(!0);
    try {
      if (n && n.length > 0) {
        const g = n.filter(({ table: b, columns: x }) => {
          const w = typeof b == "function" ? b() : b;
          return (w == null ? void 0 : w.size) && (x == null ? void 0 : x.length);
        });
        if (g.length === 0)
          return;
        const y = g.map(({ table: b, columns: x, sectionName: w }) => {
          const C = x.map((E) => ({
            ...E,
            mask: (a == null ? void 0 : a(E)) ?? E.mask
          }));
          return {
            table: typeof b == "function" ? b() : b,
            columns: (u == null ? void 0 : u.applyLookups(C)) ?? C,
            sectionName: w
          };
        });
        $I({ tables: y, fileName: r, applyMasks: o });
      } else {
        const g = typeof e == "function" ? e() : e;
        if (!(g != null && g.size) || !(t != null && t.length))
          return;
        const y = t.map((x) => ({
          ...x,
          mask: (a == null ? void 0 : a(x)) ?? x.mask
        })), b = (u == null ? void 0 : u.applyLookups(y)) ?? y;
        LI({ tbl: g, columns: b, fileName: r, applyMasks: o });
      }
    } catch (g) {
      console.error("ExportTableButton - Error trying to export csv", g);
    } finally {
      c(!1);
    }
  }, f = l || i || (() => {
    if (n && n.length > 0)
      return !n.some(({ table: g, columns: y }) => {
        const b = typeof g == "function" ? g() : g;
        return (b == null ? void 0 : b.size) && (y == null ? void 0 : y.length);
      });
    {
      const g = typeof e == "function" ? e() : e;
      return !(g != null && g.size) || !(t != null && t.length);
    }
  })(), v = /* @__PURE__ */ h(
    Ee,
    {
      className: s ? "" : "icon-left",
      size: s ? "sm" : "default",
      variant: "outline",
      onClick: d,
      disabled: f,
      children: l ? /* @__PURE__ */ h(lp, { className: "animate-spin size-5" }) : /* @__PURE__ */ L(ke, { children: [
        /* @__PURE__ */ h(mC, {}),
        !s && /* @__PURE__ */ h("span", { children: "Export" })
      ] })
    }
  );
  return /* @__PURE__ */ L(ke, { children: [
    s ? /* @__PURE__ */ h(Cu, { children: /* @__PURE__ */ L(qs, { children: [
      /* @__PURE__ */ h(Zs, { asChild: !0, children: v }),
      /* @__PURE__ */ h(ci, { children: "Export" })
    ] }) }) : v,
    !s && /* @__PURE__ */ h(Vo, { orientation: "vertical", className: "h-auto" })
  ] });
};
function we(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function $e(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function dt(e, t) {
  const n = we(e);
  return isNaN(t) ? $e(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Vt(e, t) {
  const n = we(e);
  if (isNaN(t)) return $e(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = $e(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const i = o.getDate();
  return r >= i ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
const wd = 6048e5, FI = 864e5, VI = 6e4, BI = 36e5, WI = 1e3;
let zI = {};
function br() {
  return zI;
}
function Nt(e, t) {
  var a, l, c, u;
  const n = br(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = we(e), i = o.getDay(), s = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function Sn(e) {
  return Nt(e, { weekStartsOn: 1 });
}
function r0(e) {
  const t = we(e), n = t.getFullYear(), r = $e(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = Sn(r), i = $e(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = Sn(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function qr(e) {
  const t = we(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Zr(e) {
  const t = we(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function cn(e, t) {
  const n = qr(e), r = qr(t), o = +n - Zr(n), i = +r - Zr(r);
  return Math.round((o - i) / FI);
}
function jI(e) {
  const t = r0(e), n = $e(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Sn(n);
}
function _c(e, t) {
  const n = t * 7;
  return dt(e, n);
}
function HI(e, t) {
  return Vt(e, t * 12);
}
function UI(e) {
  let t;
  return e.forEach(function(n) {
    const r = we(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function YI(e) {
  let t;
  return e.forEach((n) => {
    const r = we(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function xt(e, t) {
  const n = qr(e), r = qr(t);
  return +n == +r;
}
function xd(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function GI(e) {
  if (!xd(e) && typeof e != "number")
    return !1;
  const t = we(e);
  return !isNaN(Number(t));
}
function Jo(e, t) {
  const n = we(e), r = we(t), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
function KI(e, t, n) {
  const r = Nt(e, n), o = Nt(t, n), i = +r - Zr(r), s = +o - Zr(o);
  return Math.round((i - s) / wd);
}
function Cd(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function St(e) {
  const t = we(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function o0(e) {
  const t = we(e), n = $e(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Sd(e, t) {
  var a, l, c, u;
  const n = br(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = we(e), i = o.getDay(), s = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + s), o.setHours(23, 59, 59, 999), o;
}
function i0(e) {
  return Sd(e, { weekStartsOn: 1 });
}
const XI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qI = (e, t, n) => {
  let r;
  const o = XI[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ul(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const ZI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, QI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, JI = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, eL = {
  date: ul({
    formats: ZI,
    defaultWidth: "full"
  }),
  time: ul({
    formats: QI,
    defaultWidth: "full"
  }),
  dateTime: ul({
    formats: JI,
    defaultWidth: "full"
  })
}, tL = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, nL = (e, t, n, r) => tL[e];
function xo(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[a] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[a] || e.values[s];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const rL = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, oL = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, iL = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, sL = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, aL = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lL = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, cL = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, uL = {
  ordinalNumber: cL,
  era: xo({
    values: rL,
    defaultWidth: "wide"
  }),
  quarter: xo({
    values: oL,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: xo({
    values: iL,
    defaultWidth: "wide"
  }),
  day: xo({
    values: sL,
    defaultWidth: "wide"
  }),
  dayPeriod: xo({
    values: aL,
    defaultWidth: "wide",
    formattingValues: lL,
    defaultFormattingWidth: "wide"
  })
};
function Co(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const s = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? fL(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      dL(a, (d) => d.test(s))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(s.length);
    return { value: c, rest: u };
  };
}
function dL(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function fL(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function hL(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = t.slice(o.length);
    return { value: s, rest: a };
  };
}
const mL = /^(\d+)(th|st|nd|rd)?/i, pL = /\d+/i, gL = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, vL = {
  any: [/^b/i, /^(a|c)/i]
}, yL = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bL = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wL = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xL = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, CL = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, SL = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, TL = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, EL = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, PL = {
  ordinalNumber: hL({
    matchPattern: mL,
    parsePattern: pL,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Co({
    matchPatterns: gL,
    defaultMatchWidth: "wide",
    parsePatterns: vL,
    defaultParseWidth: "any"
  }),
  quarter: Co({
    matchPatterns: yL,
    defaultMatchWidth: "wide",
    parsePatterns: bL,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Co({
    matchPatterns: wL,
    defaultMatchWidth: "wide",
    parsePatterns: xL,
    defaultParseWidth: "any"
  }),
  day: Co({
    matchPatterns: CL,
    defaultMatchWidth: "wide",
    parsePatterns: SL,
    defaultParseWidth: "any"
  }),
  dayPeriod: Co({
    matchPatterns: TL,
    defaultMatchWidth: "any",
    parsePatterns: EL,
    defaultParseWidth: "any"
  })
}, Td = {
  code: "en-US",
  formatDistance: qI,
  formatLong: eL,
  formatRelative: nL,
  localize: uL,
  match: PL,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function kL(e) {
  const t = we(e);
  return cn(t, o0(t)) + 1;
}
function Ed(e) {
  const t = we(e), n = +Sn(t) - +jI(t);
  return Math.round(n / wd) + 1;
}
function Pd(e, t) {
  var u, d, f, m;
  const n = we(e), r = n.getFullYear(), o = br(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = $e(e, 0);
  s.setFullYear(r + 1, 0, i), s.setHours(0, 0, 0, 0);
  const a = Nt(s, t), l = $e(e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Nt(l, t);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function DL(e, t) {
  var a, l, c, u;
  const n = br(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = Pd(e, t), i = $e(e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Nt(i, t);
}
function kd(e, t) {
  const n = we(e), r = +Nt(n, t) - +DL(n, t);
  return Math.round(r / wd) + 1;
}
function Me(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const kn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Me(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Me(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Me(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Me(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Me(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Me(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Me(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Me(o, t.length);
  }
}, Dr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, km = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return kn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Pd(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = i % 100;
      return Me(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Me(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = r0(e);
    return Me(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Me(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Me(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Me(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return kn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Me(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = kd(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Me(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Ed(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Me(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : kn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = kL(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Me(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Me(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Me(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Me(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Dr.noon : r === 0 ? o = Dr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Dr.evening : r >= 12 ? o = Dr.afternoon : r >= 4 ? o = Dr.morning : o = Dr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return kn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : kn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Me(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Me(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : kn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : kn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return kn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Rm(r);
      case "XXXX":
      case "XX":
        return Gn(r);
      case "XXXXX":
      case "XXX":
      default:
        return Gn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Rm(r);
      case "xxxx":
      case "xx":
        return Gn(r);
      case "xxxxx":
      case "xxx":
      default:
        return Gn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Dm(r, ":");
      case "OOOO":
      default:
        return "GMT" + Gn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Dm(r, ":");
      case "zzzz":
      default:
        return "GMT" + Gn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Me(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Me(r, t.length);
  }
};
function Dm(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Me(i, 2);
}
function Rm(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Me(Math.abs(e) / 60, 2) : Gn(e, t);
}
function Gn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Me(Math.trunc(r / 60), 2), i = Me(r % 60, 2);
  return n + o + t + i;
}
const Mm = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, s0 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, RL = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Mm(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Mm(r, t)).replace("{{time}}", s0(o, t));
}, Oc = {
  p: s0,
  P: RL
}, ML = /^D+$/, NL = /^Y+$/, AL = ["D", "DD", "YY", "YYYY"];
function a0(e) {
  return ML.test(e);
}
function l0(e) {
  return NL.test(e);
}
function Ic(e, t, n) {
  const r = _L(e, t, n);
  if (console.warn(r), AL.includes(e)) throw new RangeError(r);
}
function _L(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const OL = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, IL = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, LL = /^'([^]*?)'?$/, $L = /''/g, FL = /[a-zA-Z]/;
function mn(e, t, n) {
  var u, d, f, m, v, g, y, b;
  const r = br(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Td, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, a = we(e);
  if (!GI(a))
    throw new RangeError("Invalid time value");
  let l = t.match(IL).map((x) => {
    const w = x[0];
    if (w === "p" || w === "P") {
      const C = Oc[w];
      return C(x, o.formatLong);
    }
    return x;
  }).join("").match(OL).map((x) => {
    if (x === "''")
      return { isToken: !1, value: "'" };
    const w = x[0];
    if (w === "'")
      return { isToken: !1, value: VL(x) };
    if (km[w])
      return { isToken: !0, value: x };
    if (w.match(FL))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: x };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  };
  return l.map((x) => {
    if (!x.isToken) return x.value;
    const w = x.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && l0(w) || !(n != null && n.useAdditionalDayOfYearTokens) && a0(w)) && Ic(w, t, String(e));
    const C = km[w[0]];
    return C(a, w, o.localize, c);
  }).join("");
}
function VL(e) {
  const t = e.match(LL);
  return t ? t[1].replace($L, "'") : e;
}
function BL(e) {
  const t = we(e), n = t.getFullYear(), r = t.getMonth(), o = $e(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function WL() {
  return Object.assign({}, br());
}
function zL(e) {
  let n = we(e).getDay();
  return n === 0 && (n = 7), n;
}
function jL(e) {
  return Math.trunc(+we(e) / 1e3);
}
function HL(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function UL(e, t) {
  return KI(
    HL(e),
    St(e),
    t
  ) + 1;
}
function Lc(e, t) {
  const n = we(e), r = we(t);
  return n.getTime() > r.getTime();
}
function c0(e, t) {
  const n = we(e), r = we(t);
  return +n < +r;
}
function YL(e, t) {
  const n = t instanceof Date ? $e(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const GL = 10;
class u0 {
  constructor() {
    ee(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class KL extends u0 {
  constructor(t, n, r, o, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class XL extends u0 {
  constructor() {
    super(...arguments);
    ee(this, "priority", GL);
    ee(this, "subPriority", -1);
  }
  set(n, r) {
    return r.timestampIsSet ? n : $e(n, YL(n, Date));
  }
}
class De {
  run(t, n, r, o) {
    const i = this.parse(t, n, r, o);
    return i ? {
      setter: new KL(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class qL extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 140);
    ee(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Xe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, sn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function qe(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ye(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function an(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * BI + i * VI + s * WI),
    rest: t.slice(n[0].length)
  };
}
function d0(e) {
  return Ye(Xe.anyDigitsSigned, e);
}
function Ge(e, t) {
  switch (e) {
    case 1:
      return Ye(Xe.singleDigit, t);
    case 2:
      return Ye(Xe.twoDigits, t);
    case 3:
      return Ye(Xe.threeDigits, t);
    case 4:
      return Ye(Xe.fourDigits, t);
    default:
      return Ye(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function _s(e, t) {
  switch (e) {
    case 1:
      return Ye(Xe.singleDigitSigned, t);
    case 2:
      return Ye(Xe.twoDigitsSigned, t);
    case 3:
      return Ye(Xe.threeDigitsSigned, t);
    case 4:
      return Ye(Xe.fourDigitsSigned, t);
    default:
      return Ye(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Dd(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function f0(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const i = r + 50, s = Math.trunc(i / 100) * 100, a = e >= i % 100;
    o = e + s - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function h0(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class ZL extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 130);
    ee(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return qe(Ge(4, n), i);
      case "yo":
        return qe(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return qe(Ge(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const i = n.getFullYear();
    if (o.isTwoDigitYear) {
      const a = f0(
        o.year,
        i
      );
      return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const s = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class QL extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 130);
    ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return qe(Ge(4, n), i);
      case "Yo":
        return qe(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return qe(Ge(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, i) {
    const s = Pd(n, i);
    if (o.isTwoDigitYear) {
      const l = f0(
        o.year,
        s
      );
      return n.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Nt(n, i);
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(a, 0, i.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Nt(n, i);
  }
}
class JL extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 130);
    ee(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return _s(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const i = $e(n, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), Sn(i);
  }
}
class e$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 130);
    ee(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return _s(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class t$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 120);
    ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return Ge(r.length, n);
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class n$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 120);
    ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return Ge(r.length, n);
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class r$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ee(this, "priority", 110);
  }
  parse(n, r, o) {
    const i = (s) => s - 1;
    switch (r) {
      case "M":
        return qe(
          Ye(Xe.month, n),
          i
        );
      case "MM":
        return qe(Ge(2, n), i);
      case "Mo":
        return qe(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class o$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 110);
    ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => s - 1;
    switch (r) {
      case "L":
        return qe(
          Ye(Xe.month, n),
          i
        );
      case "LL":
        return qe(Ge(2, n), i);
      case "Lo":
        return qe(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function i$(e, t, n) {
  const r = we(e), o = kd(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class s$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 100);
    ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return Ye(Xe.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, i) {
    return Nt(i$(n, o, i), i);
  }
}
function a$(e, t) {
  const n = we(e), r = Ed(n) - t;
  return n.setDate(n.getDate() - r * 7), n;
}
class l$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 100);
    ee(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return Ye(Xe.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return Sn(a$(n, o));
  }
}
const c$ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], u$ = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class d$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 90);
    ee(this, "subPriority", 1);
    ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return Ye(Xe.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), i = h0(o), s = n.getMonth();
    return i ? r >= 1 && r <= u$[s] : r >= 1 && r <= c$[s];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class f$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 90);
    ee(this, "subpriority", 1);
    ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return Ye(Xe.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return h0(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function Rd(e, t, n) {
  var d, f, m, v;
  const r = br(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((v = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : v.weekStartsOn) ?? 0, i = we(e), s = i.getDay(), l = (t % 7 + 7) % 7, c = 7 - o, u = t < 0 || t > 6 ? t - (s + c) % 7 : (l + c) % 7 - (s + c) % 7;
  return dt(i, u);
}
class h$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 90);
    ee(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = Rd(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class m$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 90);
    ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const s = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "e":
      case "ee":
        return qe(Ge(r.length, n), s);
      case "eo":
        return qe(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = Rd(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class p$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 90);
    ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const s = (a) => {
      const l = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "c":
      case "cc":
        return qe(Ge(r.length, n), s);
      case "co":
        return qe(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = Rd(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
function g$(e, t) {
  const n = we(e), r = zL(n), o = t - r;
  return dt(n, o);
}
class v$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 90);
    ee(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (s) => s === 0 ? 7 : s;
    switch (r) {
      case "i":
      case "ii":
        return Ge(r.length, n);
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      case "iii":
        return qe(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return qe(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return qe(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return qe(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = g$(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class y$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 80);
    ee(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Dd(o), 0, 0, 0), n;
  }
}
class b$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 80);
    ee(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Dd(o), 0, 0, 0), n;
  }
}
class w$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 80);
    ee(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Dd(o), 0, 0, 0), n;
  }
}
class x$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 70);
    ee(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return Ye(Xe.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const i = n.getHours() >= 12;
    return i && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class C$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 70);
    ee(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return Ye(Xe.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class S$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 70);
    ee(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return Ye(Xe.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class T$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 70);
    ee(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return Ye(Xe.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const i = o <= 24 ? o % 24 : o;
    return n.setHours(i, 0, 0, 0), n;
  }
}
class E$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 60);
    ee(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return Ye(Xe.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class P$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 50);
    ee(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return Ye(Xe.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return Ge(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class k$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 30);
    ee(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return qe(Ge(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class D$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 10);
    ee(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return an(
          sn.basicOptionalMinutes,
          n
        );
      case "XX":
        return an(sn.basic, n);
      case "XXXX":
        return an(
          sn.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return an(
          sn.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return an(sn.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : $e(
      n,
      n.getTime() - Zr(n) - o
    );
  }
}
class R$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 10);
    ee(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return an(
          sn.basicOptionalMinutes,
          n
        );
      case "xx":
        return an(sn.basic, n);
      case "xxxx":
        return an(
          sn.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return an(
          sn.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return an(sn.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : $e(
      n,
      n.getTime() - Zr(n) - o
    );
  }
}
class M$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 40);
    ee(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return d0(n);
  }
  set(n, r, o) {
    return [$e(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class N$ extends De {
  constructor() {
    super(...arguments);
    ee(this, "priority", 20);
    ee(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return d0(n);
  }
  set(n, r, o) {
    return [$e(n, o), { timestampIsSet: !0 }];
  }
}
const A$ = {
  G: new qL(),
  y: new ZL(),
  Y: new QL(),
  R: new JL(),
  u: new e$(),
  Q: new t$(),
  q: new n$(),
  M: new r$(),
  L: new o$(),
  w: new s$(),
  I: new l$(),
  d: new d$(),
  D: new f$(),
  E: new h$(),
  e: new m$(),
  c: new p$(),
  i: new v$(),
  a: new y$(),
  b: new b$(),
  B: new w$(),
  h: new x$(),
  H: new C$(),
  K: new S$(),
  k: new T$(),
  m: new E$(),
  s: new P$(),
  S: new k$(),
  X: new D$(),
  x: new R$(),
  t: new M$(),
  T: new N$()
}, _$ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, O$ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, I$ = /^'([^]*?)'?$/, L$ = /''/g, $$ = /\S/, F$ = /[a-zA-Z]/;
function V$(e, t, n, r) {
  var g, y, b, x;
  const o = WL(), i = o.locale ?? Td, s = o.firstWeekContainsDate ?? ((y = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, a = o.weekStartsOn ?? ((x = (b = o.locale) == null ? void 0 : b.options) == null ? void 0 : x.weekStartsOn) ?? 0, l = {
    firstWeekContainsDate: s,
    weekStartsOn: a,
    locale: i
  }, c = [new XL()], u = t.match(O$).map((w) => {
    const C = w[0];
    if (C in Oc) {
      const E = Oc[C];
      return E(w, i.formatLong);
    }
    return w;
  }).join("").match(_$), d = [];
  for (let w of u) {
    l0(w) && Ic(w, t, e), a0(w) && Ic(w, t, e);
    const C = w[0], E = A$[C];
    if (E) {
      const { incompatibleTokens: S } = E;
      if (Array.isArray(S)) {
        const P = d.find(
          (D) => S.includes(D.token) || D.token === C
        );
        if (P)
          throw new RangeError(
            `The format string mustn't contain \`${P.fullToken}\` and \`${w}\` at the same time`
          );
      } else if (E.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${w}\` and any other token at the same time`
        );
      d.push({ token: C, fullToken: w });
      const T = E.run(
        e,
        w,
        i.match,
        l
      );
      if (!T)
        return $e(n, NaN);
      c.push(T.setter), e = T.rest;
    } else {
      if (C.match(F$))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + C + "`"
        );
      if (w === "''" ? w = "'" : C === "'" && (w = B$(w)), e.indexOf(w) === 0)
        e = e.slice(w.length);
      else
        return $e(n, NaN);
    }
  }
  if (e.length > 0 && $$.test(e))
    return $e(n, NaN);
  const f = c.map((w) => w.priority).sort((w, C) => C - w).filter((w, C, E) => E.indexOf(w) === C).map(
    (w) => c.filter((C) => C.priority === w).sort((C, E) => E.subPriority - C.subPriority)
  ).map((w) => w[0]);
  let m = we(n);
  if (isNaN(m.getTime()))
    return $e(n, NaN);
  const v = {};
  for (const w of f) {
    if (!w.validate(m, l))
      return $e(n, NaN);
    const C = w.set(m, v, l);
    Array.isArray(C) ? (m = C[0], Object.assign(v, C[1])) : m = C;
  }
  return $e(n, m);
}
function B$(e) {
  return e.match(I$)[1].replace(L$, "'");
}
function Md(e, t) {
  const n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function W$(e, t) {
  const n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear();
}
function dl(e, t) {
  return dt(e, -t);
}
function fl(e, t) {
  const n = we(e), r = n.getFullYear(), o = n.getDate(), i = $e(e, 0);
  i.setFullYear(r, t, 15), i.setHours(0, 0, 0, 0);
  const s = BL(i);
  return n.setMonth(t, Math.min(o, s)), n;
}
function Nm(e, t) {
  const n = we(e);
  return isNaN(+n) ? $e(e, NaN) : (n.setFullYear(t), n);
}
var fe = function() {
  return fe = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, fe.apply(this, arguments);
};
function z$(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function m0(e, t, n) {
  for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function xi(e) {
  return e.mode === "multiple";
}
function Ci(e) {
  return e.mode === "range";
}
function ba(e) {
  return e.mode === "single";
}
var j$ = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function H$(e, t) {
  return mn(e, "LLLL y", t);
}
function U$(e, t) {
  return mn(e, "d", t);
}
function Y$(e, t) {
  return mn(e, "LLLL", t);
}
function G$(e) {
  return "".concat(e);
}
function K$(e, t) {
  return mn(e, "cccccc", t);
}
function X$(e, t) {
  return mn(e, "yyyy", t);
}
var q$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: H$,
  formatDay: U$,
  formatMonthCaption: Y$,
  formatWeekNumber: G$,
  formatWeekdayName: K$,
  formatYearCaption: X$
}), Z$ = function(e, t, n) {
  return mn(e, "do MMMM (EEEE)", n);
}, Q$ = function() {
  return "Month: ";
}, J$ = function() {
  return "Go to next month";
}, eF = function() {
  return "Go to previous month";
}, tF = function(e, t) {
  return mn(e, "cccc", t);
}, nF = function(e) {
  return "Week n. ".concat(e);
}, rF = function() {
  return "Year: ";
}, oF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: Z$,
  labelMonthDropdown: Q$,
  labelNext: J$,
  labelPrevious: eF,
  labelWeekNumber: nF,
  labelWeekday: tF,
  labelYearDropdown: rF
});
function iF() {
  var e = "buttons", t = j$, n = Td, r = {}, o = {}, i = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: q$,
    labels: oF,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: i,
    styles: s,
    today: a,
    mode: "default"
  };
}
function sF(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, i = e.fromDate, s = e.toDate;
  return r ? i = St(r) : t && (i = new Date(t, 0, 1)), o ? s = Cd(o) : n && (s = new Date(n, 11, 31)), {
    fromDate: i ? qr(i) : void 0,
    toDate: s ? qr(s) : void 0
  };
}
var p0 = je(void 0);
function aF(e) {
  var t, n = e.initialProps, r = iF(), o = sF(n), i = o.fromDate, s = o.toDate, a = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  a !== "buttons" && (!i || !s) && (a = "buttons");
  var l;
  (ba(n) || xi(n) || Ci(n)) && (l = n.onSelect);
  var c = fe(fe(fe({}, r), n), { captionLayout: a, classNames: fe(fe({}, r.classNames), n.classNames), components: fe({}, n.components), formatters: fe(fe({}, r.formatters), n.formatters), fromDate: i, labels: fe(fe({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: fe(fe({}, r.modifiers), n.modifiers), modifiersClassNames: fe(fe({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: fe(fe({}, r.styles), n.styles), toDate: s });
  return h(p0.Provider, { value: c, children: e.children });
}
function Ve() {
  var e = Se(p0);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function g0(e) {
  var t = Ve(), n = t.locale, r = t.classNames, o = t.styles, i = t.formatters.formatCaption;
  return h("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: n }) });
}
function lF(e) {
  return h("svg", fe({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: h("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function v0(e) {
  var t, n, r = e.onChange, o = e.value, i = e.children, s = e.caption, a = e.className, l = e.style, c = Ve(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : lF;
  return L("div", { className: a, style: l, children: [h("span", { className: c.classNames.vhidden, children: e["aria-label"] }), h("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r, children: i }), L("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [s, h(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function cF(e) {
  var t, n = Ve(), r = n.fromDate, o = n.toDate, i = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return h(ke, {});
  if (!o)
    return h(ke, {});
  var d = [];
  if (W$(r, o))
    for (var f = St(r), m = r.getMonth(); m <= o.getMonth(); m++)
      d.push(fl(f, m));
  else
    for (var f = St(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      d.push(fl(f, m));
  var v = function(y) {
    var b = Number(y.target.value), x = fl(St(e.displayMonth), b);
    e.onChange(x);
  }, g = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : v0;
  return h(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: i.dropdown_month, onChange: v, value: e.displayMonth.getMonth(), caption: a(e.displayMonth, { locale: s }), children: d.map(function(y) {
    return h("option", { value: y.getMonth(), children: a(y, { locale: s }) }, y.getMonth());
  }) });
}
function uF(e) {
  var t, n = e.displayMonth, r = Ve(), o = r.fromDate, i = r.toDate, s = r.locale, a = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!o)
    return h(ke, {});
  if (!i)
    return h(ke, {});
  for (var m = o.getFullYear(), v = i.getFullYear(), g = m; g <= v; g++)
    f.push(Nm(o0(/* @__PURE__ */ new Date()), g));
  var y = function(x) {
    var w = Nm(St(n), Number(x.target.value));
    e.onChange(w);
  }, b = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : v0;
  return h(b, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: y, value: n.getFullYear(), caption: u(n, { locale: s }), children: f.map(function(x) {
    return h("option", { value: x.getFullYear(), children: u(x, { locale: s }) }, x.getFullYear());
  }) });
}
function dF(e, t) {
  var n = he(e), r = n[0], o = n[1], i = t === void 0 ? r : t;
  return [i, o];
}
function fF(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), i = e.toDate, s = e.fromDate, a = e.numberOfMonths, l = a === void 0 ? 1 : a;
  if (i && Jo(i, o) < 0) {
    var c = -1 * (l - 1);
    o = Vt(i, c);
  }
  return s && Jo(o, s) < 0 && (o = s), St(o);
}
function hF() {
  var e = Ve(), t = fF(e), n = dF(t, e.month), r = n[0], o = n[1], i = function(s) {
    var a;
    if (!e.disableNavigation) {
      var l = St(s);
      o(l), (a = e.onMonthChange) === null || a === void 0 || a.call(e, l);
    }
  };
  return [r, i];
}
function mF(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = St(e), i = St(Vt(o, r)), s = Jo(i, o), a = [], l = 0; l < s; l++) {
    var c = Vt(o, l);
    a.push(c);
  }
  return n && (a = a.reverse()), a;
}
function pF(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = St(e);
    if (!n)
      return Vt(a, s);
    var l = Jo(n, e);
    if (!(l < i))
      return Vt(a, s);
  }
}
function gF(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = St(e);
    if (!n)
      return Vt(a, -s);
    var l = Jo(a, n);
    if (!(l <= 0))
      return Vt(a, -s);
  }
}
var y0 = je(void 0);
function vF(e) {
  var t = Ve(), n = hF(), r = n[0], o = n[1], i = mF(r, t), s = pF(r, t), a = gF(r, t), l = function(d) {
    return i.some(function(f) {
      return Md(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && c0(d, f) ? o(Vt(d, 1 + t.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: o,
    goToDate: c,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return h(y0.Provider, { value: u, children: e.children });
}
function Si() {
  var e = Se(y0);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function Am(e) {
  var t, n = Ve(), r = n.classNames, o = n.styles, i = n.components, s = Si().goToMonth, a = function(u) {
    s(Vt(u, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : g0, c = h(l, { id: e.id, displayMonth: e.displayMonth });
  return L("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [h("div", { className: r.vhidden, children: c }), h(cF, { onChange: a, displayMonth: e.displayMonth }), h(uF, { onChange: a, displayMonth: e.displayMonth })] });
}
function yF(e) {
  return h("svg", fe({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: h("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function bF(e) {
  return h("svg", fe({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: h("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var Os = Ke(function(e, t) {
  var n = Ve(), r = n.classNames, o = n.styles, i = [r.button_reset, r.button];
  e.className && i.push(e.className);
  var s = i.join(" "), a = fe(fe({}, o.button_reset), o.button);
  return e.style && Object.assign(a, e.style), h("button", fe({}, e, { ref: t, type: "button", className: s, style: a }));
});
function wF(e) {
  var t, n, r = Ve(), o = r.dir, i = r.locale, s = r.classNames, a = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return h(ke, {});
  var f = c(e.previousMonth, { locale: i }), m = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), v = u(e.nextMonth, { locale: i }), g = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), y = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : bF, b = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : yF;
  return L("div", { className: s.nav, style: a.nav, children: [!e.hidePrevious && h(Os, { name: "previous-month", "aria-label": f, className: m, style: a.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? h(y, { className: s.nav_icon, style: a.nav_icon }) : h(b, { className: s.nav_icon, style: a.nav_icon }) }), !e.hideNext && h(Os, { name: "next-month", "aria-label": v, className: g, style: a.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? h(b, { className: s.nav_icon, style: a.nav_icon }) : h(y, { className: s.nav_icon, style: a.nav_icon }) })] });
}
function _m(e) {
  var t = Ve().numberOfMonths, n = Si(), r = n.previousMonth, o = n.nextMonth, i = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(v) {
    return Md(e.displayMonth, v);
  }), l = a === 0, c = a === s.length - 1, u = t > 1 && (l || !c), d = t > 1 && (c || !l), f = function() {
    r && i(r);
  }, m = function() {
    o && i(o);
  };
  return h(wF, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: f, onNextClick: m });
}
function xF(e) {
  var t, n = Ve(), r = n.classNames, o = n.disableNavigation, i = n.styles, s = n.captionLayout, a = n.components, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : g0, c;
  return o ? c = h(l, { id: e.id, displayMonth: e.displayMonth }) : s === "dropdown" ? c = h(Am, { displayMonth: e.displayMonth, id: e.id }) : s === "dropdown-buttons" ? c = L(ke, { children: [h(Am, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), h(_m, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = L(ke, { children: [h(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), h(_m, { displayMonth: e.displayMonth, id: e.id })] }), h("div", { className: r.caption, style: i.caption, children: c });
}
function CF(e) {
  var t = Ve(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? h("tfoot", { className: o, style: r.tfoot, children: h("tr", { children: h("td", { colSpan: 8, children: n }) }) }) : h(ke, {});
}
function SF(e, t, n) {
  for (var r = n ? Sn(/* @__PURE__ */ new Date()) : Nt(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], i = 0; i < 7; i++) {
    var s = dt(r, i);
    o.push(s);
  }
  return o;
}
function TF() {
  var e = Ve(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, i = e.weekStartsOn, s = e.ISOWeek, a = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = SF(o, i, s);
  return L("tr", { style: n.head_row, className: t.head_row, children: [r && h("td", { style: n.head_cell, className: t.head_cell }), c.map(function(u, d) {
    return h("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }), children: a(u, { locale: o }) }, d);
  })] });
}
function EF() {
  var e, t = Ve(), n = t.classNames, r = t.styles, o = t.components, i = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : TF;
  return h("thead", { style: r.head, className: n.head, children: h(i, {}) });
}
function PF(e) {
  var t = Ve(), n = t.locale, r = t.formatters.formatDay;
  return h(ke, { children: r(e.date, { locale: n }) });
}
var Nd = je(void 0);
function kF(e) {
  if (!xi(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return h(Nd.Provider, { value: t, children: e.children });
  }
  return h(DF, { initialProps: e.initialProps, children: e.children });
}
function DF(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, i = t.max, s = function(c, u, d) {
    var f, m;
    (f = t.onDayClick) === null || f === void 0 || f.call(t, c, u, d);
    var v = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!v) {
      var g = !!(!u.selected && i && (r == null ? void 0 : r.length) === i);
      if (!g) {
        var y = r ? m0([], r) : [];
        if (u.selected) {
          var b = y.findIndex(function(x) {
            return xt(c, x);
          });
          y.splice(b, 1);
        } else
          y.push(c);
        (m = t.onSelect) === null || m === void 0 || m.call(t, y, c, u, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(c) {
    var u = i && r.length > i - 1, d = r.some(function(f) {
      return xt(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return h(Nd.Provider, { value: l, children: n });
}
function Ad() {
  var e = Se(Nd);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function RF(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? xt(o, e) && xt(r, e) ? void 0 : xt(o, e) ? { from: o, to: void 0 } : xt(r, e) ? void 0 : Lc(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? Lc(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? c0(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var _d = je(void 0);
function MF(e) {
  if (!Ci(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return h(_d.Provider, { value: t, children: e.children });
  }
  return h(NF, { initialProps: e.initialProps, children: e.children });
}
function NF(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, i = o.from, s = o.to, a = t.min, l = t.max, c = function(m, v, g) {
    var y, b;
    (y = t.onDayClick) === null || y === void 0 || y.call(t, m, v, g);
    var x = RF(m, r);
    (b = t.onSelect) === null || b === void 0 || b.call(t, x, m, v, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (u.range_start = [i], s ? (u.range_end = [s], xt(i, s) || (u.range_middle = [
    {
      after: i,
      before: s
    }
  ])) : u.range_end = [i]) : s && (u.range_start = [s], u.range_end = [s]), a && (i && !s && u.disabled.push({
    after: dl(i, a - 1),
    before: dt(i, a - 1)
  }), i && s && u.disabled.push({
    after: i,
    before: dt(i, a - 1)
  }), !i && s && u.disabled.push({
    after: dl(s, a - 1),
    before: dt(s, a - 1)
  })), l) {
    if (i && !s && (u.disabled.push({
      before: dt(i, -l + 1)
    }), u.disabled.push({
      after: dt(i, l - 1)
    })), i && s) {
      var d = cn(s, i) + 1, f = l - d;
      u.disabled.push({
        before: dl(i, f)
      }), u.disabled.push({
        after: dt(s, f)
      });
    }
    !i && s && (u.disabled.push({
      before: dt(s, -l + 1)
    }), u.disabled.push({
      after: dt(s, l - 1)
    }));
  }
  return h(_d.Provider, { value: { selected: r, onDayClick: c, modifiers: u }, children: n });
}
function Od() {
  var e = Se(_d);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function rs(e) {
  return Array.isArray(e) ? m0([], e) : e !== void 0 ? [e] : [];
}
function AF(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = rs(o);
  }), t;
}
var Zt;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(Zt || (Zt = {}));
var _F = Zt.Selected, vn = Zt.Disabled, OF = Zt.Hidden, IF = Zt.Today, hl = Zt.RangeEnd, ml = Zt.RangeMiddle, pl = Zt.RangeStart, LF = Zt.Outside;
function $F(e, t, n) {
  var r, o = (r = {}, r[_F] = rs(e.selected), r[vn] = rs(e.disabled), r[OF] = rs(e.hidden), r[IF] = [e.today], r[hl] = [], r[ml] = [], r[pl] = [], r[LF] = [], r);
  return e.fromDate && o[vn].push({ before: e.fromDate }), e.toDate && o[vn].push({ after: e.toDate }), xi(e) ? o[vn] = o[vn].concat(t.modifiers[vn]) : Ci(e) && (o[vn] = o[vn].concat(n.modifiers[vn]), o[pl] = n.modifiers[pl], o[ml] = n.modifiers[ml], o[hl] = n.modifiers[hl]), o;
}
var b0 = je(void 0);
function FF(e) {
  var t = Ve(), n = Ad(), r = Od(), o = $F(t, n, r), i = AF(t.modifiers), s = fe(fe({}, o), i);
  return h(b0.Provider, { value: s, children: e.children });
}
function w0() {
  var e = Se(b0);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function VF(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function BF(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function WF(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function zF(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function jF(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function HF(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var i = cn(o, r) < 0;
    i && (n = [o, r], r = n[0], o = n[1]);
    var s = cn(e, r) >= 0 && cn(o, e) >= 0;
    return s;
  }
  return o ? xt(o, e) : r ? xt(r, e) : !1;
}
function UF(e) {
  return xd(e);
}
function YF(e) {
  return Array.isArray(e) && e.every(xd);
}
function GF(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (UF(n))
      return xt(e, n);
    if (YF(n))
      return n.includes(e);
    if (BF(n))
      return HF(e, n);
    if (jF(n))
      return n.dayOfWeek.includes(e.getDay());
    if (VF(n)) {
      var r = cn(n.before, e), o = cn(n.after, e), i = r > 0, s = o < 0, a = Lc(n.before, n.after);
      return a ? s && i : i || s;
    }
    return WF(n) ? cn(e, n.after) > 0 : zF(n) ? cn(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function Id(e, t, n) {
  var r = Object.keys(t).reduce(function(i, s) {
    var a = t[s];
    return GF(e, a) && i.push(s), i;
  }, []), o = {};
  return r.forEach(function(i) {
    return o[i] = !0;
  }), n && !Md(e, n) && (o.outside = !0), o;
}
function KF(e, t) {
  for (var n = St(e[0]), r = Cd(e[e.length - 1]), o, i, s = n; s <= r; ) {
    var a = Id(s, t), l = !a.disabled && !a.hidden;
    if (!l) {
      s = dt(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !i && (i = s), o || (o = s), s = dt(s, 1);
  }
  return i || o;
}
var XF = 365;
function x0(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, i = t.modifiers, s = t.retry, a = s === void 0 ? { count: 0, lastFocused: e } : s, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: dt,
    week: _c,
    month: Vt,
    year: HI,
    startOfWeek: function(y) {
      return o.ISOWeek ? Sn(y) : Nt(y, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(y) {
      return o.ISOWeek ? i0(y) : Sd(y, { locale: d, weekStartsOn: l });
    }
  }, m = f[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? m = UI([c, m]) : r === "after" && u && (m = YI([u, m]));
  var v = !0;
  if (i) {
    var g = Id(m, i);
    v = !g.disabled && !g.hidden;
  }
  return v ? m : a.count > XF ? a.lastFocused : x0(m, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: i,
    retry: fe(fe({}, a), { count: a.count + 1 })
  });
}
var C0 = je(void 0);
function qF(e) {
  var t = Si(), n = w0(), r = he(), o = r[0], i = r[1], s = he(), a = s[0], l = s[1], c = KF(t.displayMonths, n), u = o ?? (a && t.isDateDisplayed(a)) ? a : c, d = function() {
    l(o), i(void 0);
  }, f = function(y) {
    i(y);
  }, m = Ve(), v = function(y, b) {
    if (o) {
      var x = x0(o, {
        moveBy: y,
        direction: b,
        context: m,
        modifiers: n
      });
      xt(o, x) || (t.goToDate(x, o), f(x));
    }
  }, g = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return v("day", "after");
    },
    focusDayBefore: function() {
      return v("day", "before");
    },
    focusWeekAfter: function() {
      return v("week", "after");
    },
    focusWeekBefore: function() {
      return v("week", "before");
    },
    focusMonthBefore: function() {
      return v("month", "before");
    },
    focusMonthAfter: function() {
      return v("month", "after");
    },
    focusYearBefore: function() {
      return v("year", "before");
    },
    focusYearAfter: function() {
      return v("year", "after");
    },
    focusStartOfWeek: function() {
      return v("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return v("endOfWeek", "after");
    }
  };
  return h(C0.Provider, { value: g, children: e.children });
}
function Ld() {
  var e = Se(C0);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function ZF(e, t) {
  var n = w0(), r = Id(e, n, t);
  return r;
}
var $d = je(void 0);
function QF(e) {
  if (!ba(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return h($d.Provider, { value: t, children: e.children });
  }
  return h(JF, { initialProps: e.initialProps, children: e.children });
}
function JF(e) {
  var t = e.initialProps, n = e.children, r = function(i, s, a) {
    var l, c, u;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, i, s, a), s.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, i, s, a);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, i, i, s, a);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return h($d.Provider, { value: o, children: n });
}
function S0() {
  var e = Se($d);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function e2(e, t) {
  var n = Ve(), r = S0(), o = Ad(), i = Od(), s = Ld(), a = s.focusDayAfter, l = s.focusDayBefore, c = s.focusWeekAfter, u = s.focusWeekBefore, d = s.blur, f = s.focus, m = s.focusMonthBefore, v = s.focusMonthAfter, g = s.focusYearBefore, y = s.focusYearAfter, b = s.focusStartOfWeek, x = s.focusEndOfWeek, w = function(N) {
    var M, _, W, te;
    ba(n) ? (M = r.onDayClick) === null || M === void 0 || M.call(r, e, t, N) : xi(n) ? (_ = o.onDayClick) === null || _ === void 0 || _.call(o, e, t, N) : Ci(n) ? (W = i.onDayClick) === null || W === void 0 || W.call(i, e, t, N) : (te = n.onDayClick) === null || te === void 0 || te.call(n, e, t, N);
  }, C = function(N) {
    var M;
    f(e), (M = n.onDayFocus) === null || M === void 0 || M.call(n, e, t, N);
  }, E = function(N) {
    var M;
    d(), (M = n.onDayBlur) === null || M === void 0 || M.call(n, e, t, N);
  }, S = function(N) {
    var M;
    (M = n.onDayMouseEnter) === null || M === void 0 || M.call(n, e, t, N);
  }, T = function(N) {
    var M;
    (M = n.onDayMouseLeave) === null || M === void 0 || M.call(n, e, t, N);
  }, P = function(N) {
    var M;
    (M = n.onDayPointerEnter) === null || M === void 0 || M.call(n, e, t, N);
  }, D = function(N) {
    var M;
    (M = n.onDayPointerLeave) === null || M === void 0 || M.call(n, e, t, N);
  }, k = function(N) {
    var M;
    (M = n.onDayTouchCancel) === null || M === void 0 || M.call(n, e, t, N);
  }, R = function(N) {
    var M;
    (M = n.onDayTouchEnd) === null || M === void 0 || M.call(n, e, t, N);
  }, A = function(N) {
    var M;
    (M = n.onDayTouchMove) === null || M === void 0 || M.call(n, e, t, N);
  }, F = function(N) {
    var M;
    (M = n.onDayTouchStart) === null || M === void 0 || M.call(n, e, t, N);
  }, I = function(N) {
    var M;
    (M = n.onDayKeyUp) === null || M === void 0 || M.call(n, e, t, N);
  }, B = function(N) {
    var M;
    switch (N.key) {
      case "ArrowLeft":
        N.preventDefault(), N.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        N.preventDefault(), N.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        N.preventDefault(), N.stopPropagation(), c();
        break;
      case "ArrowUp":
        N.preventDefault(), N.stopPropagation(), u();
        break;
      case "PageUp":
        N.preventDefault(), N.stopPropagation(), N.shiftKey ? g() : m();
        break;
      case "PageDown":
        N.preventDefault(), N.stopPropagation(), N.shiftKey ? y() : v();
        break;
      case "Home":
        N.preventDefault(), N.stopPropagation(), b();
        break;
      case "End":
        N.preventDefault(), N.stopPropagation(), x();
        break;
    }
    (M = n.onDayKeyDown) === null || M === void 0 || M.call(n, e, t, N);
  }, V = {
    onClick: w,
    onFocus: C,
    onBlur: E,
    onKeyDown: B,
    onKeyUp: I,
    onMouseEnter: S,
    onMouseLeave: T,
    onPointerEnter: P,
    onPointerLeave: D,
    onTouchCancel: k,
    onTouchEnd: R,
    onTouchMove: A,
    onTouchStart: F
  };
  return V;
}
function t2() {
  var e = Ve(), t = S0(), n = Ad(), r = Od(), o = ba(e) ? t.selected : xi(e) ? n.selected : Ci(e) ? r.selected : void 0;
  return o;
}
function n2(e) {
  return Object.values(Zt).includes(e);
}
function r2(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (n2(r)) {
      var i = e.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function o2(e, t) {
  var n = fe({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = fe(fe({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function i2(e, t, n) {
  var r, o, i, s = Ve(), a = Ld(), l = ZF(e, t), c = e2(e, l), u = t2(), d = !!(s.onDayClick || s.mode !== "default");
  me(function() {
    var S;
    l.outside || a.focusedDay && d && xt(a.focusedDay, e) && ((S = n.current) === null || S === void 0 || S.focus());
  }, [
    a.focusedDay,
    e,
    n,
    d,
    l.outside
  ]);
  var f = r2(s, l).join(" "), m = o2(s, l), v = !!(l.outside && !s.showOutsideDays || l.hidden), g = (i = (o = s.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : PF, y = h(g, { date: e, displayMonth: t, activeModifiers: l }), b = {
    style: m,
    className: f,
    children: y,
    role: "gridcell"
  }, x = a.focusTarget && xt(a.focusTarget, e) && !l.outside, w = a.focusedDay && xt(a.focusedDay, e), C = fe(fe(fe({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = w || x ? 0 : -1, r)), c), E = {
    isButton: d,
    isHidden: v,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: C,
    divProps: b
  };
  return E;
}
function s2(e) {
  var t = ae(null), n = i2(e.date, e.displayMonth, t);
  return n.isHidden ? h("div", { role: "gridcell" }) : n.isButton ? h(Os, fe({ name: "day", ref: t }, n.buttonProps)) : h("div", fe({}, n.divProps));
}
function a2(e) {
  var t = e.number, n = e.dates, r = Ve(), o = r.onWeekNumberClick, i = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(t), { locale: a });
  if (!o)
    return h("span", { className: s.weeknumber, style: i.weeknumber, children: u });
  var d = l(Number(t), { locale: a }), f = function(m) {
    o(t, n, m);
  };
  return h(Os, { name: "week-number", "aria-label": d, className: s.weeknumber, style: i.weeknumber, onClick: f, children: u });
}
function l2(e) {
  var t, n, r = Ve(), o = r.styles, i = r.classNames, s = r.showWeekNumber, a = r.components, l = (t = a == null ? void 0 : a.Day) !== null && t !== void 0 ? t : s2, c = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : a2, u;
  return s && (u = h("td", { className: i.cell, style: o.cell, children: h(c, { number: e.weekNumber, dates: e.dates }) })), L("tr", { className: i.row, style: o.row, children: [u, e.dates.map(function(d) {
    return h("td", { className: i.cell, style: o.cell, role: "presentation", children: h(l, { displayMonth: e.displayMonth, date: d }) }, jL(d));
  })] });
}
function Om(e, t, n) {
  for (var r = n != null && n.ISOWeek ? i0(t) : Sd(t, n), o = n != null && n.ISOWeek ? Sn(e) : Nt(e, n), i = cn(r, o), s = [], a = 0; a <= i; a++)
    s.push(dt(o, a));
  var l = s.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? Ed(u) : kd(u, n), f = c.find(function(m) {
      return m.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function c2(e, t) {
  var n = Om(St(e), Cd(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = UL(e, t);
    if (r < 6) {
      var o = n[n.length - 1], i = o.dates[o.dates.length - 1], s = _c(i, 6 - r), a = Om(_c(i, 1), s, t);
      n.push.apply(n, a);
    }
  }
  return n;
}
function u2(e) {
  var t, n, r, o = Ve(), i = o.locale, s = o.classNames, a = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, m = o.ISOWeek, v = c2(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: m,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), g = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : EF, y = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : l2, b = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : CF;
  return L("table", { id: e.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && h(g, {}), h("tbody", { className: s.tbody, style: a.tbody, children: v.map(function(x) {
    return h(y, { displayMonth: e.displayMonth, dates: x.dates, weekNumber: x.weekNumber }, x.weekNumber);
  }) }), h(b, { displayMonth: e.displayMonth })] });
}
function d2() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var f2 = d2() ? hr : me, gl = !1, h2 = 0;
function Im() {
  return "react-day-picker-".concat(++h2);
}
function m2(e) {
  var t, n = e ?? (gl ? Im() : null), r = he(n), o = r[0], i = r[1];
  return f2(function() {
    o === null && i(Im());
  }, []), me(function() {
    gl === !1 && (gl = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function p2(e) {
  var t, n, r = Ve(), o = r.dir, i = r.classNames, s = r.styles, a = r.components, l = Si().displayMonths, c = m2(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], f = s.month, m = e.displayIndex === 0, v = e.displayIndex === l.length - 1, g = !m && !v;
  o === "rtl" && (t = [m, v], v = t[0], m = t[1]), m && (d.push(i.caption_start), f = fe(fe({}, f), s.caption_start)), v && (d.push(i.caption_end), f = fe(fe({}, f), s.caption_end)), g && (d.push(i.caption_between), f = fe(fe({}, f), s.caption_between));
  var y = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : xF;
  return L("div", { className: d.join(" "), style: f, children: [h(y, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), h(u2, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function g2(e) {
  var t = Ve(), n = t.classNames, r = t.styles;
  return h("div", { className: n.months, style: r.months, children: e.children });
}
function v2(e) {
  var t, n, r = e.initialProps, o = Ve(), i = Ld(), s = Si(), a = he(!1), l = a[0], c = a[1];
  me(function() {
    o.initialFocus && i.focusTarget && (l || (i.focus(i.focusTarget), c(!0)));
  }, [
    o.initialFocus,
    l,
    i.focus,
    i.focusTarget,
    i
  ]);
  var u = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && u.push(o.classNames.multiple_months), o.showWeekNumber && u.push(o.classNames.with_weeknumber);
  var d = fe(fe({}, o.styles.root), o.style), f = Object.keys(r).filter(function(v) {
    return v.startsWith("data-");
  }).reduce(function(v, g) {
    var y;
    return fe(fe({}, v), (y = {}, y[g] = r[g], y));
  }, {}), m = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : g2;
  return h("div", fe({ className: u.join(" "), style: d, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, f, { children: h(m, { children: s.displayMonths.map(function(v, g) {
    return h(p2, { displayIndex: g, displayMonth: v }, g);
  }) }) }));
}
function y2(e) {
  var t = e.children, n = z$(e, ["children"]);
  return h(aF, { initialProps: n, children: h(vF, { children: h(QF, { initialProps: n, children: h(kF, { initialProps: n, children: h(MF, { initialProps: n, children: h(FF, { children: h(qF, { children: t }) }) }) }) }) }) });
}
function b2(e) {
  return h(y2, fe({}, e, { children: h(v2, { initialProps: e }) }));
}
function w2(e, t) {
  return p.useReducer((n, r) => t[n][r] ?? n, e);
}
var Fd = "ScrollArea", [T0] = Bt(Fd), [x2, Wt] = T0(Fd), E0 = p.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...s
    } = e, [a, l] = p.useState(null), [c, u] = p.useState(null), [d, f] = p.useState(null), [m, v] = p.useState(null), [g, y] = p.useState(null), [b, x] = p.useState(0), [w, C] = p.useState(0), [E, S] = p.useState(!1), [T, P] = p.useState(!1), D = ye(t, (R) => l(R)), k = Su(o);
    return /* @__PURE__ */ h(
      x2,
      {
        scope: n,
        type: r,
        dir: k,
        scrollHideDelay: i,
        scrollArea: a,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: f,
        scrollbarX: m,
        onScrollbarXChange: v,
        scrollbarXEnabled: E,
        onScrollbarXEnabledChange: S,
        scrollbarY: g,
        onScrollbarYChange: y,
        scrollbarYEnabled: T,
        onScrollbarYEnabledChange: P,
        onCornerWidthChange: x,
        onCornerHeightChange: C,
        children: /* @__PURE__ */ h(
          le.div,
          {
            dir: k,
            ...s,
            ref: D,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": w + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
E0.displayName = Fd;
var P0 = "ScrollAreaViewport", k0 = p.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...i } = e, s = Wt(P0, n), a = p.useRef(null), l = ye(t, a, s.onViewportChange);
    return /* @__PURE__ */ L(ke, { children: [
      /* @__PURE__ */ h(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ h(
        le.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ h("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
k0.displayName = P0;
var pn = "ScrollAreaScrollbar", Vd = p.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Wt(pn, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: s } = o, a = e.orientation === "horizontal";
    return p.useEffect(() => (a ? i(!0) : s(!0), () => {
      a ? i(!1) : s(!1);
    }), [a, i, s]), o.type === "hover" ? /* @__PURE__ */ h(C2, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ h(S2, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ h(D0, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ h(Bd, { ...r, ref: t }) : null;
  }
);
Vd.displayName = pn;
var C2 = p.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Wt(pn, e.__scopeScrollArea), [i, s] = p.useState(!1);
  return p.useEffect(() => {
    const a = o.scrollArea;
    let l = 0;
    if (a) {
      const c = () => {
        window.clearTimeout(l), s(!0);
      }, u = () => {
        l = window.setTimeout(() => s(!1), o.scrollHideDelay);
      };
      return a.addEventListener("pointerenter", c), a.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), a.removeEventListener("pointerenter", c), a.removeEventListener("pointerleave", u);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ h(ft, { present: n || i, children: /* @__PURE__ */ h(
    D0,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), S2 = p.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Wt(pn, e.__scopeScrollArea), i = e.orientation === "horizontal", s = xa(() => l("SCROLL_END"), 100), [a, l] = w2("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return p.useEffect(() => {
    if (a === "idle") {
      const c = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [a, o.scrollHideDelay, l]), p.useEffect(() => {
    const c = o.viewport, u = i ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const f = () => {
        const m = c[u];
        d !== m && (l("SCROLL"), s()), d = m;
      };
      return c.addEventListener("scroll", f), () => c.removeEventListener("scroll", f);
    }
  }, [o.viewport, i, l, s]), /* @__PURE__ */ h(ft, { present: n || a !== "hidden", children: /* @__PURE__ */ h(
    Bd,
    {
      "data-state": a === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: j(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: j(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), D0 = p.forwardRef((e, t) => {
  const n = Wt(pn, e.__scopeScrollArea), { forceMount: r, ...o } = e, [i, s] = p.useState(!1), a = e.orientation === "horizontal", l = xa(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(a ? c : u);
    }
  }, 10);
  return Qr(n.viewport, l), Qr(n.content, l), /* @__PURE__ */ h(ft, { present: r || i, children: /* @__PURE__ */ h(
    Bd,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Bd = p.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Wt(pn, e.__scopeScrollArea), i = p.useRef(null), s = p.useRef(0), [a, l] = p.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = _0(a.viewport, a.content), u = {
    ...r,
    sizes: a,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (f) => i.current = f,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (f) => s.current = f
  };
  function d(f, m) {
    return R2(f, s.current, a, m);
  }
  return n === "horizontal" ? /* @__PURE__ */ h(
    T2,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const f = o.viewport.scrollLeft, m = Lm(f, a, o.dir);
          i.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (f) => {
        o.viewport && (o.viewport.scrollLeft = f);
      },
      onDragScroll: (f) => {
        o.viewport && (o.viewport.scrollLeft = d(f, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ h(
    E2,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const f = o.viewport.scrollTop, m = Lm(f, a);
          i.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (f) => {
        o.viewport && (o.viewport.scrollTop = f);
      },
      onDragScroll: (f) => {
        o.viewport && (o.viewport.scrollTop = d(f));
      }
    }
  ) : null;
}), T2 = p.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = Wt(pn, e.__scopeScrollArea), [s, a] = p.useState(), l = p.useRef(null), c = ye(t, l, i.onScrollbarXChange);
  return p.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ h(
    M0,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": wa(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (i.viewport) {
          const f = i.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(f), I0(f, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && s && r({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Ls(s.paddingLeft),
            paddingEnd: Ls(s.paddingRight)
          }
        });
      }
    }
  );
}), E2 = p.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = Wt(pn, e.__scopeScrollArea), [s, a] = p.useState(), l = p.useRef(null), c = ye(t, l, i.onScrollbarYChange);
  return p.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ h(
    M0,
    {
      "data-orientation": "vertical",
      ...o,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": wa(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (i.viewport) {
          const f = i.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(f), I0(f, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && s && r({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Ls(s.paddingTop),
            paddingEnd: Ls(s.paddingBottom)
          }
        });
      }
    }
  );
}), [P2, R0] = T0(pn), M0 = p.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: s,
    onThumbPointerDown: a,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...f
  } = e, m = Wt(pn, n), [v, g] = p.useState(null), y = ye(t, (D) => g(D)), b = p.useRef(null), x = p.useRef(""), w = m.viewport, C = r.content - r.viewport, E = Qe(u), S = Qe(l), T = xa(d, 10);
  function P(D) {
    if (b.current) {
      const k = D.clientX - b.current.left, R = D.clientY - b.current.top;
      c({ x: k, y: R });
    }
  }
  return p.useEffect(() => {
    const D = (k) => {
      const R = k.target;
      (v == null ? void 0 : v.contains(R)) && E(k, C);
    };
    return document.addEventListener("wheel", D, { passive: !1 }), () => document.removeEventListener("wheel", D, { passive: !1 });
  }, [w, v, C, E]), p.useEffect(S, [r, S]), Qr(v, T), Qr(m.content, T), /* @__PURE__ */ h(
    P2,
    {
      scope: n,
      scrollbar: v,
      hasThumb: o,
      onThumbChange: Qe(i),
      onThumbPointerUp: Qe(s),
      onThumbPositionChange: S,
      onThumbPointerDown: Qe(a),
      children: /* @__PURE__ */ h(
        le.div,
        {
          ...f,
          ref: y,
          style: { position: "absolute", ...f.style },
          onPointerDown: j(e.onPointerDown, (D) => {
            D.button === 0 && (D.target.setPointerCapture(D.pointerId), b.current = v.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), P(D));
          }),
          onPointerMove: j(e.onPointerMove, P),
          onPointerUp: j(e.onPointerUp, (D) => {
            const k = D.target;
            k.hasPointerCapture(D.pointerId) && k.releasePointerCapture(D.pointerId), document.body.style.webkitUserSelect = x.current, m.viewport && (m.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), Is = "ScrollAreaThumb", N0 = p.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = R0(Is, e.__scopeScrollArea);
    return /* @__PURE__ */ h(ft, { present: n || o.hasThumb, children: /* @__PURE__ */ h(k2, { ref: t, ...r }) });
  }
), k2 = p.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, i = Wt(Is, n), s = R0(Is, n), { onThumbPositionChange: a } = s, l = ye(
      t,
      (d) => s.onThumbChange(d)
    ), c = p.useRef(void 0), u = xa(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return p.useEffect(() => {
      const d = i.viewport;
      if (d) {
        const f = () => {
          if (u(), !c.current) {
            const m = M2(d, a);
            c.current = m, a();
          }
        };
        return a(), d.addEventListener("scroll", f), () => d.removeEventListener("scroll", f);
      }
    }, [i.viewport, u, a]), /* @__PURE__ */ h(
      le.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: j(e.onPointerDownCapture, (d) => {
          const m = d.target.getBoundingClientRect(), v = d.clientX - m.left, g = d.clientY - m.top;
          s.onThumbPointerDown({ x: v, y: g });
        }),
        onPointerUp: j(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
N0.displayName = Is;
var Wd = "ScrollAreaCorner", A0 = p.forwardRef(
  (e, t) => {
    const n = Wt(Wd, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ h(D2, { ...e, ref: t }) : null;
  }
);
A0.displayName = Wd;
var D2 = p.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = Wt(Wd, n), [i, s] = p.useState(0), [a, l] = p.useState(0), c = !!(i && a);
  return Qr(o.scrollbarX, () => {
    var d;
    const u = ((d = o.scrollbarX) == null ? void 0 : d.offsetHeight) || 0;
    o.onCornerHeightChange(u), l(u);
  }), Qr(o.scrollbarY, () => {
    var d;
    const u = ((d = o.scrollbarY) == null ? void 0 : d.offsetWidth) || 0;
    o.onCornerWidthChange(u), s(u);
  }), c ? /* @__PURE__ */ h(
    le.div,
    {
      ...r,
      ref: t,
      style: {
        width: i,
        height: a,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Ls(e) {
  return e ? parseInt(e, 10) : 0;
}
function _0(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function wa(e) {
  const t = _0(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function R2(e, t, n, r = "ltr") {
  const o = wa(n), i = o / 2, s = t || i, a = o - s, l = n.scrollbar.paddingStart + s, c = n.scrollbar.size - n.scrollbar.paddingEnd - a, u = n.content - n.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
  return O0([l, c], d)(e);
}
function Lm(e, t, n = "ltr") {
  const r = wa(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, s = t.content - t.viewport, a = i - r, l = n === "ltr" ? [0, s] : [s * -1, 0], c = Vl(e, l);
  return O0([0, s], [0, a])(c);
}
function O0(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function I0(e, t) {
  return e > 0 && e < t;
}
var M2 = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== i.left, a = n.top !== i.top;
    (s || a) && t(), n = i, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function xa(e, t) {
  const n = Qe(e), r = p.useRef(0);
  return p.useEffect(() => () => window.clearTimeout(r.current), []), p.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Qr(e, t) {
  const n = Qe(t);
  it(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var L0 = E0, N2 = k0, A2 = A0;
const $0 = p.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ L(L0, { ref: r, className: X("relative overflow-hidden", e), ...n, children: [
  /* @__PURE__ */ h(N2, { className: "h-full w-full rounded-[inherit]", children: t }),
  /* @__PURE__ */ h(F0, {}),
  /* @__PURE__ */ h(A2, {})
] }));
$0.displayName = L0.displayName;
const F0 = p.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ h(
  Vd,
  {
    ref: r,
    orientation: t,
    className: X(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ h(N0, { className: "relative flex-1 rounded-full bg-button-primary-bg" })
  }
));
F0.displayName = Vd.displayName;
function zd({ className: e, classNames: t, showOutsideDays: n = !0, ...r }) {
  return /* @__PURE__ */ h(
    b2,
    {
      showOutsideDays: n,
      className: X("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        caption_dropdowns: "flex justify-center gap-1 w-48",
        nav: "space-x-1 flex items-center",
        nav_button: X(Nl({ variant: "minimal" }), "icon bg-transparent p-0"),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: X(Nl({ variant: "ghost" }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-30 cursor-not-allowed pointer-events-none",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        vhidden: "vhidden hidden",
        ...t
      },
      components: {
        Dropdown: ({ value: o, onChange: i, children: s, ...a }) => {
          var d;
          const l = p.Children.toArray(s), c = l.find((f) => f.props.value === o), u = (f) => {
            const m = {
              target: { value: f }
            };
            i == null || i(m);
          };
          return /* @__PURE__ */ L(
            na,
            {
              value: o == null ? void 0 : o.toString(),
              onValueChange: (f) => {
                u(f);
              },
              children: [
                /* @__PURE__ */ h(ra, { className: "pr-1.5 focus:ring-0", children: /* @__PURE__ */ h(Ru, { children: (d = c == null ? void 0 : c.props) == null ? void 0 : d.children }) }),
                /* @__PURE__ */ h(oa, { position: "popper", children: /* @__PURE__ */ h($0, { className: "h-80", children: l.map((f, m) => {
                  var v;
                  return /* @__PURE__ */ h(ia, { value: ((v = f.props.value) == null ? void 0 : v.toString()) ?? "", children: f.props.children }, `${f.props.value}-${m}`);
                }) }) })
              ]
            }
          );
        },
        IconLeft: ({ ...o }) => /* @__PURE__ */ h(gC, { className: "h-4 w-4" }),
        IconRight: ({ ...o }) => /* @__PURE__ */ h(pC, { className: "h-4 w-4" })
      },
      ...r
    }
  );
}
zd.displayName = "Calendar";
function _2(e, t) {
  if (!e || !(e instanceof Date) || isNaN(e.getTime()))
    return t;
  try {
    return mn(e, "PPP");
  } catch {
    return t;
  }
}
function $m(e) {
  const t = e.selected ? _2(e.selected, e.placeholder || "Pick a date") : e.placeholder || "Pick a date";
  return /* @__PURE__ */ L(
    Ee,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.selected || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: t
          }
        ),
        /* @__PURE__ */ h(qc, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function UW(e) {
  const [t, n] = he(!1), r = (i, s, a, l) => {
    var c;
    (c = e.onSelect) == null || c.call(e, i, s, a, l), i && n(!1);
  }, o = (i) => {
    n(i), i && window.dispatchEvent(new CustomEvent("datepicker-opening", { detail: { source: e.label } }));
  };
  return G.useEffect(() => {
    const i = (a) => {
      var l;
      ((l = a.detail) == null ? void 0 : l.source) !== e.label && t && n(!1);
    }, s = () => {
      console.log("LabeledDatePicker: Received force-close-all-popovers event, current open state:", t), t && (console.log("LabeledDatePicker: Closing picker for label:", e.label), n(!1), setTimeout(() => {
        document.querySelectorAll("[data-radix-popper-content-wrapper]").forEach((c) => {
          const u = c;
          u.style.pointerEvents !== "none" && (u.style.display = "none", u.style.pointerEvents = "none");
        }), document.querySelectorAll("[data-radix-portal]").forEach((c) => {
          const u = c;
          u.contains(document.querySelector("[data-radix-popper-content-wrapper]")) && (u.style.display = "none", u.style.pointerEvents = "none");
        });
      }, 50));
    };
    return window.addEventListener("datepicker-opening", i), window.addEventListener("force-close-all-popovers", s), () => {
      window.removeEventListener("datepicker-opening", i), window.removeEventListener("force-close-all-popovers", s);
    };
  }, [t, e.label]), G.useEffect(() => {
    var i;
    (i = e.onOpenChange) == null || i.call(e, t);
  }, [t, e.onOpenChange]), e.disabled ? /* @__PURE__ */ h(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h($m, { ...e })
    }
  ) : /* @__PURE__ */ L(lr, { modal: e.modal, open: t, onOpenChange: o, children: [
    /* @__PURE__ */ h(so, { asChild: !0, children: /* @__PURE__ */ h("div", { className: e.className, children: /* @__PURE__ */ h(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(io, { children: /* @__PURE__ */ h($m, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(
      vr,
      {
        className: X("w-auto min-w-[280px] p-0", e.modal && "z-[100]"),
        renderOnBody: !e.modal,
        onInteractOutside: e.modal && !e.allowOutsideClose ? (i) => i.preventDefault() : void 0,
        onPointerDownOutside: e.modal && !e.allowOutsideClose ? (i) => i.preventDefault() : void 0,
        children: /* @__PURE__ */ h(
          zd,
          {
            ...e,
            onSelect: r,
            disabled: e.disabledDate,
            className: X("bg-input-bg", e.className),
            mode: "single",
            initialFocus: !0,
            captionLayout: "dropdown-buttons",
            fromYear: 2e3,
            toYear: (/* @__PURE__ */ new Date()).getFullYear() + 5,
            defaultMonth: e.selected || void 0
          }
        )
      }
    )
  ] });
}
function Fm(e) {
  if (!e || !(e instanceof Date) || isNaN(e.getTime()))
    return "";
  try {
    return mn(e, "MM/dd/yyyy");
  } catch {
    return "";
  }
}
function Vm(e) {
  const { from: t, to: n } = (e == null ? void 0 : e.selected) || {}, r = Fm(t), o = Fm(n), i = r ? `${r} ${o ? `to ${o}` : ""}` : e.placeholder || "Pick a range";
  return /* @__PURE__ */ L(
    Ee,
    {
      disabled: !!e.disabled,
      variant: "ghost",
      className: "input group justify-between text-left w-full border-0 ",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.selected || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: i
          }
        ),
        /* @__PURE__ */ h(vC, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function YW(e) {
  return e.disabled ? /* @__PURE__ */ h(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(Vm, { ...e })
    }
  ) : /* @__PURE__ */ L(lr, { children: [
    /* @__PURE__ */ h(so, { asChild: !0, children: /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(io, { children: /* @__PURE__ */ h(Vm, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(vr, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ h(
      zd,
      {
        mode: "range",
        className: X("bg-input-bg", e.className),
        disabled: e.disabledDate,
        initialFocus: !0,
        selected: e.selected,
        onSelect: e.onSelect,
        numberOfMonths: 2,
        captionLayout: "dropdown-buttons",
        fromYear: 2e3,
        toYear: (/* @__PURE__ */ new Date()).getFullYear()
      }
    ) })
  ] });
}
const O2 = "text-xxs px-4 py-0 font-normal", I2 = mr(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 cursor-pointer min-h-[18px]",
  {
    variants: {
      variant: {
        default: "border border-button-primary-bg text-button-primary-txt bg-button-primary-bg hover:bg-button-primary-hover hover:border-button-primary-hover ",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        disabled: "border bg-button-primary-disabled border-button-primary-disabled cursor-not-allowed text-neutral-text-secondary/50",
        outline: "text-foreground",
        "scenario-count": `${O2} px-2 border-status-primary-border bg-status-primary-bg text-status-primary-text`
        // [`scenario-${ScenarioStatusSchema.enum.DRAFT}`]: `${scenarioStatusVariatsCommonStyles} border-status-grey-border bg-status-grey-bg text-status-grey-text`,
        // [`scenario-${ScenarioStatusSchema.enum.GENERATING}`]: `${scenarioStatusVariatsCommonStyles} border-status-yellow-border bg-status-yellow-bg text-status-yellow-text`,
        // [`scenario-${ScenarioStatusSchema.enum.FAILED}`]: `${scenarioStatusVariatsCommonStyles} border-status-danger-border bg-status-danger-bg text-status-danger-text`,
        // [`scenario-${ScenarioStatusSchema.enum.WORKING}`]: `${scenarioStatusVariatsCommonStyles} border-status-primary-border bg-status-primary-bg text-status-primary-text`,
        // [`scenario-${ScenarioStatusSchema.enum.READY}`]: `${scenarioStatusVariatsCommonStyles} border-status-primary-border-2 bg-status-primary-bg-2 text-status-primary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['PRE ALIGNMENT']}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['SENT FOR APPROVAL']}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum['ALIGNED.PROCESSING']}`]: `${scenarioStatusVariatsCommonStyles} border-status-yellow-border bg-status-yellow-bg text-status-yellow-text`,
        // [`scenario-${ScenarioStatusSchema.enum.ALIGNED}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
        // [`scenario-${ScenarioStatusSchema.enum.APPROVED}`]: `${scenarioStatusVariatsCommonStyles} border-status-secondary-border-2 bg-status-secondary-bg-2 text-status-secondary-text-2`,
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), V0 = Ke(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ h("div", { ref: r, className: X(I2({ variant: t }), e), ...n }));
V0.displayName = "Badge";
var Bm = 1, L2 = 0.9, $2 = 0.8, F2 = 0.17, vl = 0.1, yl = 0.999, V2 = 0.9999, B2 = 0.99, W2 = /[\\\/_+.#"@\[\(\{&]/, z2 = /[\\\/_+.#"@\[\(\{&]/g, j2 = /[\s-]/, B0 = /[\s-]/g;
function $c(e, t, n, r, o, i, s) {
  if (i === t.length) return o === e.length ? Bm : B2;
  var a = `${o},${i}`;
  if (s[a] !== void 0) return s[a];
  for (var l = r.charAt(i), c = n.indexOf(l, o), u = 0, d, f, m, v; c >= 0; ) d = $c(e, t, n, r, c + 1, i + 1, s), d > u && (c === o ? d *= Bm : W2.test(e.charAt(c - 1)) ? (d *= $2, m = e.slice(o, c - 1).match(z2), m && o > 0 && (d *= Math.pow(yl, m.length))) : j2.test(e.charAt(c - 1)) ? (d *= L2, v = e.slice(o, c - 1).match(B0), v && o > 0 && (d *= Math.pow(yl, v.length))) : (d *= F2, o > 0 && (d *= Math.pow(yl, c - o))), e.charAt(c) !== t.charAt(i) && (d *= V2)), (d < vl && n.charAt(c - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(c - 1) !== r.charAt(i)) && (f = $c(e, t, n, r, c + 1, i + 2, s), f * vl > d && (d = f * vl)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return s[a] = u, u;
}
function Wm(e) {
  return e.toLowerCase().replace(B0, " ");
}
function H2(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, $c(e, t, Wm(e), Wm(t), 0, 0, {});
}
function vt() {
  return vt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vt.apply(null, arguments);
}
function zr(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function U2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function W0(...e) {
  return (t) => e.forEach(
    (n) => U2(n, t)
  );
}
function Ti(...e) {
  return Ie(W0(...e), e);
}
function Y2(e, t) {
  const n = /* @__PURE__ */ je(t);
  function r(i) {
    const { children: s, ...a } = i, l = ve(
      () => a,
      Object.values(a)
    );
    return /* @__PURE__ */ Fe(n.Provider, {
      value: l
    }, s);
  }
  function o(i) {
    const s = Se(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    o
  ];
}
function G2(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = /* @__PURE__ */ je(s), l = n.length;
    n = [
      ...n,
      s
    ];
    function c(d) {
      const { scope: f, children: m, ...v } = d, g = (f == null ? void 0 : f[e][l]) || a, y = ve(
        () => v,
        Object.values(v)
      );
      return /* @__PURE__ */ Fe(g.Provider, {
        value: y
      }, m);
    }
    function u(d, f) {
      const m = (f == null ? void 0 : f[e][l]) || a, v = Se(m);
      if (v) return v;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const i = n.map((s) => /* @__PURE__ */ je(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return ve(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    K2(o, ...t)
  ];
}
function K2(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return ve(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Fc = globalThis != null && globalThis.document ? hr : () => {
}, X2 = p.useId || (() => {
});
let q2 = 0;
function bl(e) {
  const [t, n] = p.useState(X2());
  return Fc(() => {
    n(
      (r) => r ?? String(q2++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function ur(e) {
  const t = ae(e);
  return me(() => {
    t.current = e;
  }), ve(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Z2({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Q2({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = ur(n), l = Ie((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && a(d);
    } else o(c);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function Q2({ defaultProp: e, onChange: t }) {
  const n = he(e), [r] = n, o = ae(r), i = ur(t);
  return me(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const jd = /* @__PURE__ */ Ke((e, t) => {
  const { children: n, ...r } = e, o = Zn.toArray(n), i = o.find(eV);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? Zn.count(s) > 1 ? Zn.only(null) : /* @__PURE__ */ ss(s) ? s.props.children : null : l);
    return /* @__PURE__ */ Fe(Vc, vt({}, r, {
      ref: t
    }), /* @__PURE__ */ ss(s) ? /* @__PURE__ */ Gc(s, void 0, a) : null);
  }
  return /* @__PURE__ */ Fe(Vc, vt({}, r, {
    ref: t
  }), n);
});
jd.displayName = "Slot";
const Vc = /* @__PURE__ */ Ke((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ ss(n) ? /* @__PURE__ */ Gc(n, {
    ...tV(r, n.props),
    ref: t ? W0(t, n.ref) : n.ref
  }) : Zn.count(n) > 1 ? Zn.only(null) : null;
});
Vc.displayName = "SlotClone";
const J2 = ({ children: e }) => /* @__PURE__ */ Fe($s, null, e);
function eV(e) {
  return /* @__PURE__ */ ss(e) && e.type === J2;
}
function tV(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const nV = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], zt = nV.reduce((e, t) => {
  const n = /* @__PURE__ */ Ke((r, o) => {
    const { asChild: i, ...s } = r, a = i ? jd : t;
    return me(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Fe(a, vt({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function rV(e, t) {
  e && Zc(
    () => e.dispatchEvent(t)
  );
}
function oV(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ur(e);
  me(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Bc = "dismissableLayer.update", iV = "dismissableLayer.pointerDownOutside", sV = "dismissableLayer.focusOutside";
let zm;
const aV = /* @__PURE__ */ je({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), lV = /* @__PURE__ */ Ke((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = e, u = Se(aV), [d, f] = he(null), m = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, v] = he({}), g = Ti(
    t,
    (P) => f(P)
  ), y = Array.from(u.layers), [b] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), x = y.indexOf(b), w = d ? y.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= x, S = cV((P) => {
    const D = P.target, k = [
      ...u.branches
    ].some(
      (R) => R.contains(D)
    );
    !E || k || (i == null || i(P), a == null || a(P), P.defaultPrevented || l == null || l());
  }, m), T = uV((P) => {
    const D = P.target;
    [
      ...u.branches
    ].some(
      (R) => R.contains(D)
    ) || (s == null || s(P), a == null || a(P), P.defaultPrevented || l == null || l());
  }, m);
  return oV((P) => {
    w === u.layers.size - 1 && (o == null || o(P), !P.defaultPrevented && l && (P.preventDefault(), l()));
  }, m), me(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (zm = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), jm(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = zm);
      };
  }, [
    d,
    m,
    r,
    u
  ]), me(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), jm());
  }, [
    d,
    u
  ]), me(() => {
    const P = () => v({});
    return document.addEventListener(Bc, P), () => document.removeEventListener(Bc, P);
  }, []), /* @__PURE__ */ Fe(zt.div, vt({}, c, {
    ref: g,
    style: {
      pointerEvents: C ? E ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: zr(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: zr(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: zr(e.onPointerDownCapture, S.onPointerDownCapture)
  }));
});
function cV(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ur(e), r = ae(!1), o = ae(() => {
  });
  return me(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          z0(iV, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function uV(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ur(e), r = ae(!1);
  return me(() => {
    const o = (i) => {
      i.target && !r.current && z0(sV, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function jm() {
  const e = new CustomEvent(Bc);
  document.dispatchEvent(e);
}
function z0(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? rV(o, i) : o.dispatchEvent(i);
}
const wl = "focusScope.autoFocusOnMount", xl = "focusScope.autoFocusOnUnmount", Hm = {
  bubbles: !1,
  cancelable: !0
}, dV = /* @__PURE__ */ Ke((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = e, [a, l] = he(null), c = ur(o), u = ur(i), d = ae(null), f = Ti(
    t,
    (g) => l(g)
  ), m = ae({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  me(() => {
    if (r) {
      let g = function(w) {
        if (m.paused || !a) return;
        const C = w.target;
        a.contains(C) ? d.current = C : Mn(d.current, {
          select: !0
        });
      }, y = function(w) {
        if (m.paused || !a) return;
        const C = w.relatedTarget;
        C !== null && (a.contains(C) || Mn(d.current, {
          select: !0
        }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const E of w) E.removedNodes.length > 0 && Mn(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const x = new MutationObserver(b);
      return a && x.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [
    r,
    a,
    m.paused
  ]), me(() => {
    if (a) {
      Ym.add(m);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(wl, Hm);
        a.addEventListener(wl, c), a.dispatchEvent(b), b.defaultPrevented || (fV(vV(j0(a)), {
          select: !0
        }), document.activeElement === g && Mn(a));
      }
      return () => {
        a.removeEventListener(wl, c), setTimeout(() => {
          const b = new CustomEvent(xl, Hm);
          a.addEventListener(xl, u), a.dispatchEvent(b), b.defaultPrevented || Mn(g ?? document.body, {
            select: !0
          }), a.removeEventListener(xl, u), Ym.remove(m);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    m
  ]);
  const v = Ie((g) => {
    if (!n && !r || m.paused) return;
    const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (y && b) {
      const x = g.currentTarget, [w, C] = hV(x);
      w && C ? !g.shiftKey && b === C ? (g.preventDefault(), n && Mn(w, {
        select: !0
      })) : g.shiftKey && b === w && (g.preventDefault(), n && Mn(C, {
        select: !0
      })) : b === x && g.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ Fe(zt.div, vt({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: v
  }));
});
function fV(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Mn(r, {
      select: t
    }), document.activeElement !== n) return;
}
function hV(e) {
  const t = j0(e), n = Um(t, e), r = Um(t.reverse(), e);
  return [
    n,
    r
  ];
}
function j0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Um(e, t) {
  for (const n of e)
    if (!mV(n, {
      upTo: t
    })) return n;
}
function mV(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function pV(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Mn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && pV(e) && t && e.select();
  }
}
const Ym = gV();
function gV() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Gm(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Gm(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Gm(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function vV(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const yV = /* @__PURE__ */ Ke((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ up.createPortal(/* @__PURE__ */ Fe(zt.div, vt({}, o, {
    ref: t
  })), r) : null;
});
function bV(e, t) {
  return Kx((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Ca = (e) => {
  const { present: t, children: n } = e, r = wV(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Zn.only(n), i = Ti(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Gc(o, {
    ref: i
  }) : null;
};
Ca.displayName = "Presence";
function wV(e) {
  const [t, n] = he(), r = ae({}), o = ae(e), i = ae("none"), s = e ? "mounted" : "unmounted", [a, l] = bV(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return me(() => {
    const c = Ui(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [
    a
  ]), Fc(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = i.current, m = Ui(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), Fc(() => {
    if (t) {
      const c = (d) => {
        const m = Ui(r.current).includes(d.animationName);
        d.target === t && m && Zc(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = Ui(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: Ie((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Ui(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let Cl = 0;
function xV() {
  me(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Km()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Km()), Cl++, () => {
      Cl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Cl--;
    };
  }, []);
}
function Km() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var H0 = Pp(), Sl = function() {
}, Sa = p.forwardRef(function(e, t) {
  var n = p.useRef(null), r = p.useState({
    onScrollCapture: Sl,
    onWheelCapture: Sl,
    onTouchMoveCapture: Sl
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, b = y === void 0 ? "div" : y, x = eu(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, C = Ep([n, t]), E = ht(ht({}, x), o);
  return p.createElement(
    p.Fragment,
    null,
    u && p.createElement(w, { sideCar: H0, removeScrollBar: c, shards: d, noIsolation: m, inert: v, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    s ? p.cloneElement(p.Children.only(a), ht(ht({}, E), { ref: C })) : p.createElement(b, ht({}, E, { className: l, ref: C }), a)
  );
});
Sa.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Sa.classNames = {
  fullWidth: Ro,
  zeroRight: Do
};
var Wc = !1;
if (typeof window < "u")
  try {
    var Yi = Object.defineProperty({}, "passive", {
      get: function() {
        return Wc = !0, !0;
      }
    });
    window.addEventListener("test", Yi, Yi), window.removeEventListener("test", Yi, Yi);
  } catch {
    Wc = !1;
  }
var Rr = Wc ? { passive: !1 } : !1, CV = function(e) {
  return e.tagName === "TEXTAREA";
}, U0 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !CV(e) && n[t] === "visible")
  );
}, SV = function(e) {
  return U0(e, "overflowY");
}, TV = function(e) {
  return U0(e, "overflowX");
}, Xm = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Y0(e, n);
    if (r) {
      var o = G0(e, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, EV = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, PV = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Y0 = function(e, t) {
  return e === "v" ? SV(t) : TV(t);
}, G0 = function(e, t) {
  return e === "v" ? EV(t) : PV(t);
}, kV = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, DV = function(e, t, n, r, o) {
  var i = kV(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var m = G0(e, a), v = m[0], g = m[1], y = m[2], b = g - y - i * v;
    (v || b) && Y0(e, a) && (d += b, f += v), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && d === 0 || !u && f === 0) && (c = !0), c;
}, Gi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, qm = function(e) {
  return [e.deltaX, e.deltaY];
}, Zm = function(e) {
  return e && "current" in e ? e.current : e;
}, RV = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, MV = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, NV = 0, Mr = [];
function AV(e) {
  var t = p.useRef([]), n = p.useRef([0, 0]), r = p.useRef(), o = p.useState(NV++)[0], i = p.useState(function() {
    return tu();
  })[0], s = p.useRef(e);
  p.useEffect(function() {
    s.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = Tp([e.lockRef.current], (e.shards || []).map(Zm), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = p.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var b = Gi(g), x = n.current, w = "deltaX" in g ? g.deltaX : x[0] - b[0], C = "deltaY" in g ? g.deltaY : x[1] - b[1], E, S = g.target, T = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && T === "h" && S.type === "range")
      return !1;
    var P = Xm(T, S);
    if (!P)
      return !0;
    if (P ? E = T : (E = T === "v" ? "h" : "v", P = Xm(T, S)), !P)
      return !1;
    if (!r.current && "changedTouches" in g && (w || C) && (r.current = E), !E)
      return !0;
    var D = r.current || E;
    return DV(D, y, g, D === "h" ? w : C);
  }, []), l = p.useCallback(function(g) {
    var y = g;
    if (!(!Mr.length || Mr[Mr.length - 1] !== i)) {
      var b = "deltaY" in y ? qm(y) : Gi(y), x = t.current.filter(function(E) {
        return E.name === y.type && E.target === y.target && RV(E.delta, b);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(Zm).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), C = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        C && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = p.useCallback(function(g, y, b, x) {
    var w = { name: g, delta: y, target: b, should: x };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), u = p.useCallback(function(g) {
    n.current = Gi(g), r.current = void 0;
  }, []), d = p.useCallback(function(g) {
    c(g.type, qm(g), g.target, a(g, e.lockRef.current));
  }, []), f = p.useCallback(function(g) {
    c(g.type, Gi(g), g.target, a(g, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return Mr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Rr), document.addEventListener("touchmove", l, Rr), document.addEventListener("touchstart", u, Rr), function() {
      Mr = Mr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Rr), document.removeEventListener("touchmove", l, Rr), document.removeEventListener("touchstart", u, Rr);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    v ? p.createElement(i, { styles: MV(o) }) : null,
    m ? p.createElement(Mp, { gapMode: "margin" }) : null
  );
}
const _V = Dp(H0, AV);
var K0 = p.forwardRef(function(e, t) {
  return p.createElement(Sa, ht({}, e, { ref: t, sideCar: _V }));
});
K0.classNames = Sa.classNames;
const X0 = "Dialog", [q0] = G2(X0), [OV, wr] = q0(X0), IV = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: s = !0 } = e, a = ae(null), l = ae(null), [c = !1, u] = Z2({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Fe(OV, {
    scope: t,
    triggerRef: a,
    contentRef: l,
    contentId: bl(),
    titleId: bl(),
    descriptionId: bl(),
    open: c,
    onOpenChange: u,
    onOpenToggle: Ie(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: s
  }, n);
}, Z0 = "DialogPortal", [LV, Q0] = q0(Z0, {
  forceMount: void 0
}), $V = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = wr(Z0, t);
  return /* @__PURE__ */ Fe(LV, {
    scope: t,
    forceMount: n
  }, Zn.map(
    r,
    (s) => /* @__PURE__ */ Fe(Ca, {
      present: n || i.open
    }, /* @__PURE__ */ Fe(yV, {
      asChild: !0,
      container: o
    }, s))
  ));
}, zc = "DialogOverlay", FV = /* @__PURE__ */ Ke((e, t) => {
  const n = Q0(zc, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = wr(zc, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ Fe(Ca, {
    present: r || i.open
  }, /* @__PURE__ */ Fe(VV, vt({}, o, {
    ref: t
  }))) : null;
}), VV = /* @__PURE__ */ Ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = wr(zc, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Fe(K0, {
      as: jd,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ Fe(zt.div, vt({
      "data-state": ex(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), Jr = "DialogContent", BV = /* @__PURE__ */ Ke((e, t) => {
  const n = Q0(Jr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = wr(Jr, e.__scopeDialog);
  return /* @__PURE__ */ Fe(Ca, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Fe(WV, vt({}, o, {
    ref: t
  })) : /* @__PURE__ */ Fe(zV, vt({}, o, {
    ref: t
  })));
}), WV = /* @__PURE__ */ Ke((e, t) => {
  const n = wr(Jr, e.__scopeDialog), r = ae(null), o = Ti(t, n.contentRef, r);
  return me(() => {
    const i = r.current;
    if (i) return ii(i);
  }, []), /* @__PURE__ */ Fe(J0, vt({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: zr(e.onCloseAutoFocus, (i) => {
      var s;
      i.preventDefault(), (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: zr(e.onPointerDownOutside, (i) => {
      const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
      (s.button === 2 || a) && i.preventDefault();
    }),
    onFocusOutside: zr(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), zV = /* @__PURE__ */ Ke((e, t) => {
  const n = wr(Jr, e.__scopeDialog), r = ae(!1), o = ae(!1);
  return /* @__PURE__ */ Fe(J0, vt({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, i), !i.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var s, a;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), J0 = /* @__PURE__ */ Ke((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = wr(Jr, n), l = ae(null), c = Ti(t, l);
  return xV(), /* @__PURE__ */ Fe($s, null, /* @__PURE__ */ Fe(dV, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Fe(lV, vt({
    role: "dialog",
    id: a.contentId,
    "aria-describedby": a.descriptionId,
    "aria-labelledby": a.titleId,
    "data-state": ex(a.open)
  }, s, {
    ref: c,
    onDismiss: () => a.onOpenChange(!1)
  }))), !1);
}), jV = "DialogTitle";
function ex(e) {
  return e ? "open" : "closed";
}
const HV = "DialogTitleWarning";
Y2(HV, {
  contentName: Jr,
  titleName: jV,
  docsSlug: "dialog"
});
const UV = IV, YV = $V, GV = FV, KV = BV;
var So = '[cmdk-group=""]', Tl = '[cmdk-group-items=""]', XV = '[cmdk-group-heading=""]', Hd = '[cmdk-item=""]', Qm = `${Hd}:not([aria-disabled="true"])`, jc = "cmdk-item-select", Kn = "data-value", qV = (e, t, n) => H2(e, t, n), tx = p.createContext(void 0), Ei = () => p.useContext(tx), nx = p.createContext(void 0), Ud = () => p.useContext(nx), rx = p.createContext(void 0), ox = p.forwardRef((e, t) => {
  let n = Ar(() => {
    var O, z;
    return { search: "", value: (z = (O = e.value) != null ? O : e.defaultValue) != null ? z : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Ar(() => /* @__PURE__ */ new Set()), o = Ar(() => /* @__PURE__ */ new Map()), i = Ar(() => /* @__PURE__ */ new Map()), s = Ar(() => /* @__PURE__ */ new Set()), a = ix(e), { label: l, children: c, value: u, onValueChange: d, filter: f, shouldFilter: m, loop: v, disablePointerSelection: g = !1, vimBindings: y = !0, ...b } = e, x = p.useId(), w = p.useId(), C = p.useId(), E = p.useRef(null), S = aB();
  dr(() => {
    if (u !== void 0) {
      let O = u.trim();
      n.current.value = O, T.emit();
    }
  }, [u]), dr(() => {
    S(6, F);
  }, []);
  let T = p.useMemo(() => ({ subscribe: (O) => (s.current.add(O), () => s.current.delete(O)), snapshot: () => n.current, setState: (O, z, Q) => {
    var K, se, U;
    if (!Object.is(n.current[O], z)) {
      if (n.current[O] = z, O === "search") A(), k(), S(1, R);
      else if (O === "value" && (Q || S(5, F), ((K = a.current) == null ? void 0 : K.value) !== void 0)) {
        let oe = z ?? "";
        (U = (se = a.current).onValueChange) == null || U.call(se, oe);
        return;
      }
      T.emit();
    }
  }, emit: () => {
    s.current.forEach((O) => O());
  } }), []), P = p.useMemo(() => ({ value: (O, z, Q) => {
    var K;
    z !== ((K = i.current.get(O)) == null ? void 0 : K.value) && (i.current.set(O, { value: z, keywords: Q }), n.current.filtered.items.set(O, D(z, Q)), S(2, () => {
      k(), T.emit();
    }));
  }, item: (O, z) => (r.current.add(O), z && (o.current.has(z) ? o.current.get(z).add(O) : o.current.set(z, /* @__PURE__ */ new Set([O]))), S(3, () => {
    A(), k(), n.current.value || R(), T.emit();
  }), () => {
    i.current.delete(O), r.current.delete(O), n.current.filtered.items.delete(O);
    let Q = I();
    S(4, () => {
      A(), (Q == null ? void 0 : Q.getAttribute("id")) === O && R(), T.emit();
    });
  }), group: (O) => (o.current.has(O) || o.current.set(O, /* @__PURE__ */ new Set()), () => {
    i.current.delete(O), o.current.delete(O);
  }), filter: () => a.current.shouldFilter, label: l || e["aria-label"], disablePointerSelection: g, listId: x, inputId: C, labelId: w, listInnerRef: E }), []);
  function D(O, z) {
    var Q, K;
    let se = (K = (Q = a.current) == null ? void 0 : Q.filter) != null ? K : qV;
    return O ? se(O, n.current.search, z) : 0;
  }
  function k() {
    if (!n.current.search || a.current.shouldFilter === !1) return;
    let O = n.current.filtered.items, z = [];
    n.current.filtered.groups.forEach((K) => {
      let se = o.current.get(K), U = 0;
      se.forEach((oe) => {
        let q = O.get(oe);
        U = Math.max(q, U);
      }), z.push([K, U]);
    });
    let Q = E.current;
    B().sort((K, se) => {
      var U, oe;
      let q = K.getAttribute("id"), ie = se.getAttribute("id");
      return ((U = O.get(ie)) != null ? U : 0) - ((oe = O.get(q)) != null ? oe : 0);
    }).forEach((K) => {
      let se = K.closest(Tl);
      se ? se.appendChild(K.parentElement === se ? K : K.closest(`${Tl} > *`)) : Q.appendChild(K.parentElement === Q ? K : K.closest(`${Tl} > *`));
    }), z.sort((K, se) => se[1] - K[1]).forEach((K) => {
      let se = E.current.querySelector(`${So}[${Kn}="${encodeURIComponent(K[0])}"]`);
      se == null || se.parentElement.appendChild(se);
    });
  }
  function R() {
    let O = B().find((Q) => Q.getAttribute("aria-disabled") !== "true"), z = O == null ? void 0 : O.getAttribute(Kn);
    T.setState("value", z || void 0);
  }
  function A() {
    var O, z, Q, K;
    if (!n.current.search || a.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let se = 0;
    for (let U of r.current) {
      let oe = (z = (O = i.current.get(U)) == null ? void 0 : O.value) != null ? z : "", q = (K = (Q = i.current.get(U)) == null ? void 0 : Q.keywords) != null ? K : [], ie = D(oe, q);
      n.current.filtered.items.set(U, ie), ie > 0 && se++;
    }
    for (let [U, oe] of o.current) for (let q of oe) if (n.current.filtered.items.get(q) > 0) {
      n.current.filtered.groups.add(U);
      break;
    }
    n.current.filtered.count = se;
  }
  function F() {
    var O, z, Q;
    let K = I();
    K && (((O = K.parentElement) == null ? void 0 : O.firstChild) === K && ((Q = (z = K.closest(So)) == null ? void 0 : z.querySelector(XV)) == null || Q.scrollIntoView({ block: "nearest" })), K.scrollIntoView({ block: "nearest" }));
  }
  function I() {
    var O;
    return (O = E.current) == null ? void 0 : O.querySelector(`${Hd}[aria-selected="true"]`);
  }
  function B() {
    var O;
    return Array.from((O = E.current) == null ? void 0 : O.querySelectorAll(Qm));
  }
  function V(O) {
    let z = B()[O];
    z && T.setState("value", z.getAttribute(Kn));
  }
  function N(O) {
    var z;
    let Q = I(), K = B(), se = K.findIndex((oe) => oe === Q), U = K[se + O];
    (z = a.current) != null && z.loop && (U = se + O < 0 ? K[K.length - 1] : se + O === K.length ? K[0] : K[se + O]), U && T.setState("value", U.getAttribute(Kn));
  }
  function M(O) {
    let z = I(), Q = z == null ? void 0 : z.closest(So), K;
    for (; Q && !K; ) Q = O > 0 ? iB(Q, So) : sB(Q, So), K = Q == null ? void 0 : Q.querySelector(Qm);
    K ? T.setState("value", K.getAttribute(Kn)) : N(O);
  }
  let _ = () => V(B().length - 1), W = (O) => {
    O.preventDefault(), O.metaKey ? _() : O.altKey ? M(1) : N(1);
  }, te = (O) => {
    O.preventDefault(), O.metaKey ? V(0) : O.altKey ? M(-1) : N(-1);
  };
  return p.createElement(zt.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (O) => {
    var z;
    if ((z = b.onKeyDown) == null || z.call(b, O), !O.defaultPrevented) switch (O.key) {
      case "n":
      case "j": {
        y && O.ctrlKey && W(O);
        break;
      }
      case "ArrowDown": {
        W(O);
        break;
      }
      case "p":
      case "k": {
        y && O.ctrlKey && te(O);
        break;
      }
      case "ArrowUp": {
        te(O);
        break;
      }
      case "Home": {
        O.preventDefault(), V(0);
        break;
      }
      case "End": {
        O.preventDefault(), _();
        break;
      }
      case "Enter":
        if (!O.nativeEvent.isComposing && O.keyCode !== 229) {
          O.preventDefault();
          let Q = I();
          if (Q) {
            let K = new Event(jc);
            Q.dispatchEvent(K);
          }
        }
    }
  } }, p.createElement("label", { "cmdk-label": "", htmlFor: P.inputId, id: P.labelId, style: cB }, l), Ta(e, (O) => p.createElement(nx.Provider, { value: T }, p.createElement(tx.Provider, { value: P }, O))));
}), ZV = p.forwardRef((e, t) => {
  var n, r;
  let o = p.useId(), i = p.useRef(null), s = p.useContext(rx), a = Ei(), l = ix(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : s == null ? void 0 : s.forceMount;
  dr(() => {
    if (!c) return a.item(o, s == null ? void 0 : s.id);
  }, [c]);
  let u = sx(o, i, [e.value, e.children, i], e.keywords), d = Ud(), f = fr((S) => S.value && S.value === u.current), m = fr((S) => c || a.filter() === !1 ? !0 : S.search ? S.filtered.items.get(o) > 0 : !0);
  p.useEffect(() => {
    let S = i.current;
    if (!(!S || e.disabled)) return S.addEventListener(jc, v), () => S.removeEventListener(jc, v);
  }, [m, e.onSelect, e.disabled]);
  function v() {
    var S, T;
    g(), (T = (S = l.current).onSelect) == null || T.call(S, u.current);
  }
  function g() {
    d.setState("value", u.current, !0);
  }
  if (!m) return null;
  let { disabled: y, value: b, onSelect: x, forceMount: w, keywords: C, ...E } = e;
  return p.createElement(zt.div, { ref: ei([i, t]), ...E, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!f, "data-disabled": !!y, "data-selected": !!f, onPointerMove: y || a.disablePointerSelection ? void 0 : g, onClick: y ? void 0 : v }, e.children);
}), QV = p.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, s = p.useId(), a = p.useRef(null), l = p.useRef(null), c = p.useId(), u = Ei(), d = fr((m) => o || u.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(s) : !0);
  dr(() => u.group(s), []), sx(s, a, [e.value, e.heading, l]);
  let f = p.useMemo(() => ({ id: s, forceMount: o }), [o]);
  return p.createElement(zt.div, { ref: ei([a, t]), ...i, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && p.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), Ta(e, (m) => p.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, p.createElement(rx.Provider, { value: f }, m))));
}), JV = p.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = p.useRef(null), i = fr((s) => !s.search);
  return !n && !i ? null : p.createElement(zt.div, { ref: ei([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), eB = p.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = Ud(), s = fr((u) => u.search), a = fr((u) => u.value), l = Ei(), c = p.useMemo(() => {
    var u;
    let d = (u = l.listInnerRef.current) == null ? void 0 : u.querySelector(`${Hd}[${Kn}="${encodeURIComponent(a)}"]`);
    return d == null ? void 0 : d.getAttribute("id");
  }, []);
  return p.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), p.createElement(zt.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": c, id: l.inputId, type: "text", value: o ? e.value : s, onChange: (u) => {
    o || i.setState("search", u.target.value), n == null || n(u.target.value);
  } });
}), tB = p.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = p.useRef(null), s = p.useRef(null), a = Ei();
  return p.useEffect(() => {
    if (s.current && i.current) {
      let l = s.current, c = i.current, u, d = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let f = l.offsetHeight;
          c.style.setProperty("--cmdk-list-height", f.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(u), d.unobserve(l);
      };
    }
  }, []), p.createElement(zt.div, { ref: ei([i, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: a.listId }, Ta(e, (l) => p.createElement("div", { ref: ei([s, a.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), nB = p.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: s, ...a } = e;
  return p.createElement(UV, { open: n, onOpenChange: r }, p.createElement(YV, { container: s }, p.createElement(GV, { "cmdk-overlay": "", className: o }), p.createElement(KV, { "aria-label": e.label, "cmdk-dialog": "", className: i }, p.createElement(ox, { ref: t, ...a }))));
}), rB = p.forwardRef((e, t) => fr((n) => n.filtered.count === 0) ? p.createElement(zt.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), oB = p.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return p.createElement(zt.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Ta(e, (s) => p.createElement("div", { "aria-hidden": !0 }, s)));
}), yt = Object.assign(ox, { List: tB, Item: ZV, Input: eB, Group: QV, Separator: JV, Dialog: nB, Empty: rB, Loading: oB });
function iB(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function sB(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function ix(e) {
  let t = p.useRef(e);
  return dr(() => {
    t.current = e;
  }), t;
}
var dr = typeof window > "u" ? p.useEffect : p.useLayoutEffect;
function Ar(e) {
  let t = p.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function ei(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function fr(e) {
  let t = Ud(), n = () => e(t.snapshot());
  return p.useSyncExternalStore(t.subscribe, n, n);
}
function sx(e, t, n, r = []) {
  let o = p.useRef(), i = Ei();
  return dr(() => {
    var s;
    let a = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    i.value(e, a, l), (s = t.current) == null || s.setAttribute(Kn, a), o.current = a;
  }), o;
}
var aB = () => {
  let [e, t] = p.useState(), n = Ar(() => /* @__PURE__ */ new Map());
  return dr(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function lB(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Ta({ asChild: e, children: t }, n) {
  return e && p.isValidElement(t) ? p.cloneElement(lB(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var cB = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Yd = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yt,
  {
    ref: n,
    className: X(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
Yd.displayName = yt.displayName;
const GW = ({ children: e, ...t }) => /* @__PURE__ */ h(eg, { ...t, children: /* @__PURE__ */ h(uu, { className: "overflow-hidden p-0 shadow-lg", children: /* @__PURE__ */ h(Yd, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), uB = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ L("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ h(yC, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ h(
    yt.Input,
    {
      ref: n,
      className: X(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
uB.displayName = yt.Input.displayName;
const ax = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yt.List,
  {
    ref: n,
    className: X("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
ax.displayName = yt.List.displayName;
const lx = p.forwardRef((e, t) => /* @__PURE__ */ h(yt.Empty, { ref: t, className: "py-6 text-center text-sm", ...e }));
lx.displayName = yt.Empty.displayName;
const dB = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yt.Group,
  {
    ref: n,
    className: X(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
dB.displayName = yt.Group.displayName;
const fB = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(yt.Separator, { ref: n, className: X("-mx-1 h-px bg-border", e), ...t }));
fB.displayName = yt.Separator.displayName;
const cx = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yt.Item,
  {
    ref: n,
    className: X(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50",
      e
    ),
    ...t
  }
));
cx.displayName = yt.Item.displayName;
const hB = ({ className: e, ...t }) => /* @__PURE__ */ h("span", { className: X("ml-auto text-xs tracking-widest text-muted-foreground", e), ...t });
hB.displayName = "CommandShortcut";
const ux = je(null), Ea = () => {
  const e = Se(ux);
  if (!e)
    throw new Error("useMultiSelect must be used within MultiSelectProvider");
  return e;
}, mB = ({
  values: e,
  options: t,
  onValuesChange: n,
  loop: r = !1,
  className: o,
  children: i,
  dir: s,
  disabled: a,
  ...l
}) => {
  const [c, u] = he(""), [d, f] = he(!1), [m, v] = he(-1), g = G.useRef(null), [y, b] = G.useState(!1), [x, w] = G.useState(""), C = Ie(
    (T) => {
      e.some((P) => P === T) ? n(e.filter((P) => P !== T)) : n([...e, T]);
    },
    [e]
  ), E = G.useCallback(
    (T) => {
      T.preventDefault();
      const P = T.currentTarget, D = P.value.substring(P.selectionStart ?? 0, P.selectionEnd ?? 0);
      w(D), b(D === c);
    },
    [c]
  ), S = Ie(
    (T) => {
      T.stopPropagation();
      const P = g.current;
      if (!P) return;
      const D = () => {
        const A = m + 1;
        v(A > e.length - 1 ? r ? 0 : -1 : A);
      }, k = () => {
        const A = m - 1;
        v(A < 0 ? e.length - 1 : A);
      }, R = () => {
        const A = m - 1 <= 0 ? e.length - 1 === 0 ? -1 : 0 : m - 1;
        v(A);
      };
      switch (T.key) {
        case "ArrowLeft":
          s === "rtl" ? e.length > 0 && (m !== -1 || r) && D() : e.length > 0 && P.selectionStart === 0 && k();
          break;
        case "ArrowRight":
          s === "rtl" ? e.length > 0 && P.selectionStart === 0 && k() : e.length > 0 && (m !== -1 || r) && D();
          break;
        case "Backspace":
        case "Delete":
          e.length > 0 && (m !== -1 && m < e.length ? (C(e[m]), R()) : P.selectionStart === 0 && (x === c || y) && C(e[e.length - 1]));
          break;
        case "Enter":
          f(!0);
          break;
        case "Escape":
          m !== -1 ? v(-1) : d && f(!1);
          break;
      }
    },
    [e, c, m, r]
  );
  return /* @__PURE__ */ h(
    ux.Provider,
    {
      value: {
        value: e,
        options: t,
        onValueChange: C,
        open: d,
        setOpen: f,
        inputValue: c,
        setInputValue: u,
        activeIndex: m,
        setActiveIndex: v,
        ref: g,
        handleSelect: E,
        disabled: a
      },
      children: /* @__PURE__ */ h(Yd, { onKeyDown: S, className: X("flex flex-row bg-transparent", o), dir: s, ...l, children: i })
    }
  );
}, dx = Ke(
  ({ className: e, children: t, ...n }, r) => {
    const { value: o, options: i, onValueChange: s, activeIndex: a, disabled: l } = Ea(), [c, u] = he(!1), [d, f] = he(!1), m = ae(null), v = Ie((b) => {
      b.preventDefault(), b.stopPropagation();
    }, []), g = (b) => {
      const x = b.currentTarget, w = x.scrollLeft, C = x.scrollWidth, E = x.clientWidth;
      w > 10 ? u(!0) : u(!1), w + E < C - 20 ? f(!0) : f(!1);
    }, y = () => {
      var b;
      (b = m.current) == null || b.scrollIntoView({ behavior: "smooth" });
    };
    return me(() => {
      y();
    }, [o]), /* @__PURE__ */ L(
      "div",
      {
        ref: r,
        onScroll: g,
        className: X(
          "flex overflow-x-auto overflow-y-hidden rounded-lg max-w-[80%] relative pretty-scrollbar-thin",
          e,
          "before:opacity-0 before:block before:shrink-0 before:sticky before:w-4 before:-ml-4 before:h-full before:bg-gradient-to-r before:from-white before:-left-px before:transition-opacity before:duration-150",
          "after:opacity-0 after:block after:shrink-0 after:sticky after:w-4 after:-mr-4 after:h-full after:bg-gradient-to-l after:from-white after:-right-px after:transition-opacity after:duration-150",
          c && "before:opacity-100",
          d && "after:opacity-100"
        ),
        ...n,
        children: [
          o.map((b, x) => {
            const w = i.find((C) => C.value === b);
            return /* @__PURE__ */ L(
              V0,
              {
                className: X(
                  "m-1 my-2 py-0 rounded-xl flex items-center gap-1",
                  a === x && "ring-2 ring-muted-foreground "
                ),
                variant: l ? "disabled" : "default",
                children: [
                  /* @__PURE__ */ h("span", { className: "text-xxs text-nowrap", children: w == null ? void 0 : w.label }),
                  /* @__PURE__ */ L(
                    "button",
                    {
                      "aria-label": `Remove ${w == null ? void 0 : w.label} option`,
                      "aria-roledescription": "button to remove option",
                      type: "button",
                      onMouseDown: v,
                      onClick: () => w && s(w.value),
                      disabled: l,
                      className: X(l && "cursor-not-allowed"),
                      children: [
                        /* @__PURE__ */ L("span", { className: "sr-only", children: [
                          "Remove ",
                          w == null ? void 0 : w.label,
                          " option"
                        ] }),
                        /* @__PURE__ */ h(Kc, { className: "h-4 w-4" })
                      ]
                    }
                  )
                ]
              },
              w == null ? void 0 : w.value
            );
          }),
          /* @__PURE__ */ h("div", { ref: m }),
          t
        ]
      }
    );
  }
);
dx.displayName = "MultiSelectorTrigger";
const fx = Ke(({ className: e, ...t }, n) => {
  const {
    value: r,
    setOpen: o,
    inputValue: i,
    setInputValue: s,
    activeIndex: a,
    setActiveIndex: l,
    handleSelect: c,
    ref: u,
    disabled: d
  } = Ea(), f = () => r.length === 0 ? t.placeholder : `${r.length.toString()} selected`;
  return /* @__PURE__ */ h(
    yt.Input,
    {
      ...t,
      placeholder: f(),
      tabIndex: 0,
      ref: u,
      value: i,
      onValueChange: a === -1 ? s : void 0,
      onSelect: c,
      onBlur: () => o(!1),
      onFocus: () => o(!0),
      onClick: () => l(-1),
      className: X(
        "w-24 shrink-0 text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50 outline-none aria-disabled:text-neutral-text-secondary/50",
        e,
        a !== -1 && "caret-transparent"
      ),
      "aria-disabled": d,
      disabled: d
    }
  );
});
fx.displayName = "MultiSelectorInput";
const hx = Ke(({ children: e }, t) => {
  const { open: n } = Ea();
  return /* @__PURE__ */ h("div", { ref: t, className: " absolute left-0 right-0 top-[calc(100%+.25rem)] z-40", children: n && e });
});
hx.displayName = "MultiSelectorContent";
const mx = Ke(({ className: e, children: t }, n) => /* @__PURE__ */ L(
  ax,
  {
    ref: n,
    className: X(
      "bg-input-bg flex flex-col rounded-md scrollbar-thin scrollbar-track-transparent transition-colors scrollbar-thumb-muted-foreground dark:scrollbar-thumb-muted scrollbar-thumb-rounded-lg w-full absolute shadow-md z-10 border top-0",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ h(lx, { children: /* @__PURE__ */ h("span", { className: "text-muted-foreground", children: "No results found" }) })
    ]
  }
));
mx.displayName = "MultiSelectorList";
const px = Ke(({ className: e, value: t, children: n, ...r }, o) => {
  const { value: i, onValueChange: s, setInputValue: a } = Ea(), l = Ie((u) => {
    u.preventDefault(), u.stopPropagation();
  }, []), c = i.includes(t);
  return /* @__PURE__ */ L(
    cx,
    {
      ref: o,
      ...r,
      onSelect: () => {
        s(t), a("");
      },
      className: X(
        "flex control cursor-default border select-none items-center text-sm outline-none rounded-none justify-between data-[selected=true]:bg-input-hover",
        e,
        c && "bg-input-active text-input-bg data-[selected=true]::bg-input-hover",
        r.disabled && "pointer-events-none opacity-50"
      ),
      onMouseDown: l,
      children: [
        n,
        c && /* @__PURE__ */ h(Xc, { className: "h-4 w-4" })
      ]
    }
  );
});
px.displayName = "MultiSelectorItem";
const pB = mr("", {
  variants: {
    size: {
      sm: "input-sm",
      default: "input",
      md: "input-md"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function gB({
  value: e,
  options: t,
  onChange: n,
  size: r,
  placeholder: o,
  disabled: i,
  className: s
}) {
  return /* @__PURE__ */ L(
    mB,
    {
      values: e,
      options: t,
      onValuesChange: n,
      loop: !0,
      disablePointerSelection: !0,
      disabled: i,
      className: X(s),
      children: [
        /* @__PURE__ */ h(dx, {}),
        /* @__PURE__ */ h(fx, { className: X("bg-transparent", pB({ size: r })), placeholder: o }),
        /* @__PURE__ */ h(hx, { children: /* @__PURE__ */ h(mx, { children: t.map((a) => /* @__PURE__ */ h(px, { value: a.value, children: a.label }, a.value)) }) })
      ]
    }
  );
}
const KW = (e) => /* @__PURE__ */ h(Ft, { label: e.label, error: e.error, disabled: e.disabled, hideOverflow: !1, children: /* @__PURE__ */ h(gB, { placeholder: e.placeholder, ...e, className: X(e.className) }) }), vB = ({ label: e, className: t, text: n }) => /* @__PURE__ */ h(
  Ft,
  {
    label: e,
    className: ze("select-none cursor-pointer !flex w-full max-h-10 first:*:w-full first:*:flex"),
    children: /* @__PURE__ */ h("div", { className: ze("p-2 whitespace-nowrap text-ellipsis overflow-hidden w-0 grow"), children: n })
  }
), XW = ({
  maxToShowInLabel: e,
  onSelect: t,
  options: n,
  allSelectedLabel: r,
  lookup: o,
  noneSelectedLabel: i,
  value: s,
  className: a,
  label: l,
  onClose: c
}) => {
  const u = (v) => {
    t(v);
  }, d = (s == null ? void 0 : s.length) || 0;
  let f;
  switch (!0) {
    case d === 0:
      f = i || "Please select";
      break;
    case d <= e:
      f = s.map((v) => (o == null ? void 0 : o[v]) || v).join(", ");
      break;
    case d === n.length:
      f = r || "All Selected";
      break;
    default:
      f = `${d} selected`;
      break;
  }
  const m = async (v) => n.filter((g) => g.label.toLocaleLowerCase().includes(v.toLocaleLowerCase())).map((g) => g.key);
  return /* @__PURE__ */ h("div", { className: a, children: /* @__PURE__ */ h(
    ey,
    {
      onClose: c,
      activeFilters: (s == null ? void 0 : s.map((v) => ({ key: v, label: (o == null ? void 0 : o[v]) || v }))) || [],
      onApply: (v) => u(v.map((g) => g.key)),
      onLoadFilters: m,
      lookup: (v) => (o == null ? void 0 : o[v]) || v,
      trigger: /* @__PURE__ */ h(vB, { text: f, label: l })
    }
  ) });
};
function Gd(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ L("div", { className: "form-control w-full", children: [
    /* @__PURE__ */ h("div", { className: "label mb-[8px]", children: /* @__PURE__ */ h("span", { className: "label-text", children: e.label }) }),
    e.children,
    /* @__PURE__ */ h("div", { className: "label mt-[5px]", children: /* @__PURE__ */ h("span", { className: "label-text-alt text-error h-2", children: t.fieldErrors[e.name] }) })
  ] });
}
function qW(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ h(Gd, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ h(
    fi,
    {
      type: "text",
      name: e.name,
      defaultValue: e.initialValue,
      placeholder: e.placeholder,
      className: ze("input", "input-bordered", "w-full", {
        "border-error": t.fieldErrors[e.name]
      })
    }
  ) });
}
function ZW(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ h(Gd, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ h(
    fi,
    {
      type: "date",
      name: e.name,
      defaultValue: e.initialValue,
      className: ze("input", "input-bordered", "w-full", {
        "border-error": t.fieldErrors[e.name]
      })
    }
  ) });
}
function QW(e) {
  const t = e.formState || {};
  return /* @__PURE__ */ h(Gd, { formState: t, label: e.label, name: e.name, children: /* @__PURE__ */ L(na, { name: e.name, defaultValue: e.initialValue ?? "", children: [
    /* @__PURE__ */ h(Tu, { className: "w-[180px]", children: /* @__PURE__ */ h(Eu, { placeholder: "-- Select an option --" }) }),
    /* @__PURE__ */ h(Pu, { children: e.options.map((n, r) => /* @__PURE__ */ h(Du, { value: n[0], children: n[1] }, r)) })
  ] }) });
}
const gx = ({
  fullContractData: e,
  scenarioContractData: t
}) => {
  let n = "indeterminate";
  return e.forEach(({ id: r, children: o }) => {
    const i = t.find(({ id: s }) => s === r);
    o && (i != null && i.children) ? n = gx({ fullContractData: o, scenarioContractData: i.children }) : n = e.length === t.length || "indeterminate";
  }), n;
}, yB = (e, t) => {
  const n = [];
  return e.forEach(({ id: r, label: o, children: i }) => {
    const s = { id: r, label: o, childrenNodes: [], checked: !1 }, a = t.find((l) => l.id === r);
    a && (s.checked = a.children && i ? gx({ fullContractData: i, scenarioContractData: a.children }) : !0), i && (s.childrenNodes = yB(i, a != null && a.children ? a.children : [])), n.push(s);
  }), n;
}, vx = (e) => {
  var n;
  if (!((n = e.childrenNodes) != null && n.length))
    return e.checked ? { id: e.id } : void 0;
  const t = e.childrenNodes.map(vx).filter(Boolean);
  return t.length ? { id: e.id, children: t } : void 0;
}, JW = (e) => e.map(vx).filter(Boolean), yx = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], bx = (e, t) => `${e}-${t < 10 ? `0${t}` : t}`, bB = (e) => {
  try {
    const [t, n] = e.split("-");
    return `${yx[Number(n) - 1]} ${t == null ? void 0 : t.substring(2, 4)}`;
  } catch {
    return "-";
  }
};
function Jm({
  mode: e,
  monthOrYear: t,
  index: n,
  selectedYearValue: r,
  onChange: o,
  currentYear: i,
  currentMonth: s,
  isDisabled: a
}) {
  const l = n + 1;
  return /* @__PURE__ */ h(
    Ee,
    {
      variant: (e === "year" || s === l) && i === r ? "default" : "minimal",
      size: "sm",
      value: e === "year" ? t : l,
      onClick: () => o(e === "year" ? t : bx(r, l)),
      disabled: a,
      children: t
    },
    e === "year" ? t : l
  );
}
const ep = ({ mode: e, value: t, index: n, selectedYearOrDecadeValue: r, minDate: o, maxDate: i }) => {
  if (e === "month") {
    const s = bx(r, n + 1);
    return !!i && s > i || !!o && s < o;
  } else
    return !!(o && t < o || i && t > i);
};
function Kd({ mode: e, value: t = "", maxDate: n = "", minDate: r = "", onChange: o }) {
  const [i, s] = ve(() => {
    const m = t && e === "month" ? Number(t.split("-")[1]) : void 0;
    return t ? e === "year" ? [parseInt(t), m] : [Number(t.split("-")[0]), m] : [(/* @__PURE__ */ new Date()).getFullYear(), m];
  }, [t, e]), a = ve(() => parseInt(i.toString().slice(0, -1)), [i]), [l, c] = ve(() => {
    if (e === "year") {
      const g = "2024", y = (i + 10).toString();
      return [r || g, n || y];
    }
    const m = "2024-01", v = `${i + 10}-12`;
    return [r || m, n || v];
  }, [e, i, r, n]), [u, d] = he(
    e === "year" ? a : i
  ), f = ve(
    () => [...Array(10).keys()].map((m) => `${u}${m}`),
    [u]
  );
  return /* @__PURE__ */ L("div", { className: "flex flex-col gap-2 p-4 w-80", children: [
    /* @__PURE__ */ L("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ h(
        Ee,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => d((m) => m - 1),
          disabled: !!l && `${u}` <= l,
          children: /* @__PURE__ */ h(Fo, { size: "18" })
        }
      ),
      /* @__PURE__ */ L("span", { className: "text-xs font-medium text-button-primary-outline-default", children: [
        u,
        e === "year" && "0s"
      ] }),
      /* @__PURE__ */ h(
        Ee,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => d((m) => m + 1),
          disabled: !!c && `${u + 1}` > c,
          children: /* @__PURE__ */ h(jr, { size: "18" })
        }
      )
    ] }),
    /* @__PURE__ */ h("div", { className: `grid ${e === "year" ? "grid-cols-2" : "grid-cols-3"} gap-x-2`, children: e === "year" ? f.map((m, v) => /* @__PURE__ */ h(
      Jm,
      {
        mode: e,
        monthOrYear: m,
        index: v,
        selectedYearValue: i,
        onChange: o,
        currentYear: parseInt(m),
        currentMonth: s,
        isDisabled: ep({ mode: e, value: m, index: v, selectedYearOrDecadeValue: u, minDate: l, maxDate: c })
      },
      v
    )) : yx.map((m, v) => /* @__PURE__ */ h(
      Jm,
      {
        mode: e,
        monthOrYear: m,
        index: v,
        selectedYearValue: u,
        onChange: o,
        currentYear: i,
        currentMonth: s,
        isDisabled: ep({ mode: e, value: m, index: v, selectedYearOrDecadeValue: u, minDate: l, maxDate: c })
      },
      v
    )) })
  ] });
}
function tp(e) {
  return /* @__PURE__ */ L(
    Ee,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.value || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: e.value ? bB(e.value) : e.placeholder || "Pick a date"
          }
        ),
        /* @__PURE__ */ h(qc, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function wB(e) {
  const [t, n] = p.useState(!1), r = (o) => {
    e.onChange(o), n(!1);
  };
  return e.disabled ? /* @__PURE__ */ h(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(tp, { ...e })
    }
  ) : /* @__PURE__ */ L(lr, { open: t, onOpenChange: (o) => n(o), children: [
    /* @__PURE__ */ h(so, { asChild: !0, children: /* @__PURE__ */ h("div", { className: e.className, children: /* @__PURE__ */ h(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(io, { children: /* @__PURE__ */ h(tp, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(vr, { renderOnBody: !1, className: "w-auto p-0", children: /* @__PURE__ */ h(
      Kd,
      {
        mode: "month",
        onChange: r,
        value: e.value,
        maxDate: e.maxDate,
        minDate: e.minDate
      }
    ) })
  ] });
}
function ez({
  loading: e,
  onChange: t,
  value: n,
  minDate: r,
  maxDate: o
}) {
  const i = (s) => {
    if (n) {
      const a = mn(Vt(V$(n, "yyyy-MM", /* @__PURE__ */ new Date()), s), "yyyy-MM");
      t(a);
    }
  };
  return /* @__PURE__ */ L("div", { className: "flex gap-2 relative items-center", children: [
    /* @__PURE__ */ h(Ee, { variant: "minimal", size: "sm", onClick: () => i(-1), disabled: !!r && n <= r, children: /* @__PURE__ */ h(Fo, { size: "18" }) }),
    /* @__PURE__ */ h(
      wB,
      {
        label: "Date",
        value: n,
        onChange: t,
        disabled: e,
        minDate: r,
        maxDate: o
      }
    ),
    /* @__PURE__ */ h(Ee, { variant: "minimal", size: "sm", onClick: () => i(1), disabled: !!o && n >= o, children: /* @__PURE__ */ h(jr, { size: "18" }) }),
    e && /* @__PURE__ */ h(nr, { cover: !0 })
  ] });
}
function np(e) {
  return /* @__PURE__ */ L(
    Ee,
    {
      disabled: !!e.disabled,
      size: "md",
      variant: "ghost",
      className: "group control justify-between text-left w-full border-0",
      children: [
        /* @__PURE__ */ h(
          "span",
          {
            "aria-disabled": !!e.disabled || void 0,
            "aria-checked": !!e.value || void 0,
            className: "text-input-text-secondary aria-[checked]:text-input-text aria-[disabled]:opacity-50",
            children: e.value ? e.value : e.placeholder || "Pick a date"
          }
        ),
        /* @__PURE__ */ h(qc, { className: "ml-2 h-4 w-4 text-input-active" })
      ]
    }
  );
}
function xB(e) {
  const [t, n] = p.useState(!1), r = (o) => {
    e.onChange(o), n(!1);
  };
  return e.disabled ? /* @__PURE__ */ h(
    Ft,
    {
      label: e.label,
      error: e.error,
      disabled: !!e.disabled || void 0,
      className: e.className,
      children: /* @__PURE__ */ h(np, { ...e })
    }
  ) : /* @__PURE__ */ L(lr, { open: t, onOpenChange: (o) => n(o), children: [
    /* @__PURE__ */ h(so, { asChild: !0, children: /* @__PURE__ */ h("div", { className: e.className, children: /* @__PURE__ */ h(
      Ft,
      {
        label: e.label,
        error: e.error,
        disabled: !!e.disabled || void 0,
        className: e.className,
        children: /* @__PURE__ */ h(io, { children: /* @__PURE__ */ h(np, { ...e }) })
      }
    ) }) }),
    /* @__PURE__ */ h(vr, { renderOnBody: !1, className: "w-auto p-0", children: /* @__PURE__ */ h(
      Kd,
      {
        mode: "year",
        onChange: r,
        value: e.value,
        maxDate: e.maxDate,
        minDate: e.minDate
      }
    ) })
  ] });
}
function tz({
  loading: e,
  onChange: t,
  value: n,
  minDate: r,
  maxDate: o
}) {
  return /* @__PURE__ */ L("div", { className: "flex gap-2 relative items-center", children: [
    /* @__PURE__ */ h(
      Ee,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n && t(`${parseInt(n) - 1}`),
        disabled: !!r && n <= r,
        children: /* @__PURE__ */ h(Fo, { size: "18" })
      }
    ),
    /* @__PURE__ */ h(
      xB,
      {
        label: "Date",
        value: n,
        onChange: t,
        disabled: e,
        minDate: r,
        maxDate: o
      }
    ),
    /* @__PURE__ */ h(
      Ee,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n && t(`${parseInt(n) + 1}`),
        disabled: !!o && n >= o,
        children: /* @__PURE__ */ h(jr, { size: "18" })
      }
    ),
    e && /* @__PURE__ */ h(nr, { cover: !0 })
  ] });
}
const rp = ({ disabled: e, value: t, placeholder: n, isOpen: r }) => /* @__PURE__ */ h(
  Ee,
  {
    disabled: !!e,
    size: "sm",
    variant: r ? "default" : "outline",
    className: "group justify-center text-left w-full min-w-20",
    children: t || n || "Pick a year"
  }
);
function nz(e) {
  const { disabled: t, onChange: n, maxDate: r, minDate: o, value: i } = e, [s, a] = p.useState(!1), c = i || (/* @__PURE__ */ new Date()).getFullYear().toString();
  return t ? /* @__PURE__ */ L("div", { className: "flex items-center justify-center gap-1", children: [
    /* @__PURE__ */ h(
      Ee,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n(`${parseInt(c) - 1}`),
        disabled: !!o && `${i}` <= o,
        children: /* @__PURE__ */ h(Fo, { size: "18" })
      }
    ),
    /* @__PURE__ */ h(rp, { ...e, isOpen: s }),
    /* @__PURE__ */ h(
      Ee,
      {
        variant: "minimal",
        size: "sm",
        onClick: () => n(`${parseInt(c) + 1}`),
        disabled: !!r && `${parseInt(c) + 1}` > r,
        children: /* @__PURE__ */ h(jr, { size: "18" })
      }
    )
  ] }) : /* @__PURE__ */ L(lr, { open: s, onOpenChange: a, children: [
    /* @__PURE__ */ L("div", { className: "flex items-center justify-center gap-2 relative", children: [
      /* @__PURE__ */ h(
        Ee,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => n(`${parseInt(c) - 1}`),
          disabled: !!o && `${i}` <= o,
          children: /* @__PURE__ */ h(Fo, { size: "18" })
        }
      ),
      /* @__PURE__ */ h(so, { asChild: !0, children: /* @__PURE__ */ h(io, { children: /* @__PURE__ */ h(rp, { ...e, isOpen: s }) }) }),
      /* @__PURE__ */ h(
        Ee,
        {
          variant: "minimal",
          size: "sm",
          onClick: () => n(`${parseInt(c) + 1}`),
          disabled: !!r && `${parseInt(c) + 1}` > r,
          children: /* @__PURE__ */ h(jr, { size: "18" })
        }
      ),
      e.loading && /* @__PURE__ */ h(nr, { cover: !0, iconSize: 30 })
    ] }),
    /* @__PURE__ */ h(vr, { className: "w-auto p-0", children: /* @__PURE__ */ h(Kd, { mode: "year", ...e }) })
  ] });
}
const CB = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  da,
  {
    ref: n,
    className: X(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ h(Lu, { className: X("flex items-center justify-center text-current"), children: /* @__PURE__ */ h(Xc, { className: "h-4 w-4" }) })
  }
));
CB.displayName = da.displayName;
var Xd = "ToastProvider", [qd, SB, TB] = Qs("Toast"), [wx] = Bt("Toast", [TB]), [EB, Pa] = wx(Xd), xx = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: s
  } = e, [a, l] = p.useState(null), [c, u] = p.useState(0), d = p.useRef(!1), f = p.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Xd}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ h(qd.Provider, { scope: t, children: /* @__PURE__ */ h(
    EB,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: c,
      viewport: a,
      onViewportChange: l,
      onToastAdd: p.useCallback(() => u((m) => m + 1), []),
      onToastRemove: p.useCallback(() => u((m) => m - 1), []),
      isFocusedToastEscapeKeyDownRef: d,
      isClosePausedRef: f,
      children: s
    }
  ) });
};
xx.displayName = Xd;
var Cx = "ToastViewport", PB = ["F8"], Hc = "toast.viewportPause", Uc = "toast.viewportResume", Sx = p.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = PB,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, s = Pa(Cx, n), a = SB(n), l = p.useRef(null), c = p.useRef(null), u = p.useRef(null), d = p.useRef(null), f = ye(t, d, s.onViewportChange), m = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), v = s.toastCount > 0;
    p.useEffect(() => {
      const y = (b) => {
        var w;
        r.length !== 0 && r.every((C) => b[C] || b.code === C) && ((w = d.current) == null || w.focus());
      };
      return document.addEventListener("keydown", y), () => document.removeEventListener("keydown", y);
    }, [r]), p.useEffect(() => {
      const y = l.current, b = d.current;
      if (v && y && b) {
        const x = () => {
          if (!s.isClosePausedRef.current) {
            const S = new CustomEvent(Hc);
            b.dispatchEvent(S), s.isClosePausedRef.current = !0;
          }
        }, w = () => {
          if (s.isClosePausedRef.current) {
            const S = new CustomEvent(Uc);
            b.dispatchEvent(S), s.isClosePausedRef.current = !1;
          }
        }, C = (S) => {
          !y.contains(S.relatedTarget) && w();
        }, E = () => {
          y.contains(document.activeElement) || w();
        };
        return y.addEventListener("focusin", x), y.addEventListener("focusout", C), y.addEventListener("pointermove", x), y.addEventListener("pointerleave", E), window.addEventListener("blur", x), window.addEventListener("focus", w), () => {
          y.removeEventListener("focusin", x), y.removeEventListener("focusout", C), y.removeEventListener("pointermove", x), y.removeEventListener("pointerleave", E), window.removeEventListener("blur", x), window.removeEventListener("focus", w);
        };
      }
    }, [v, s.isClosePausedRef]);
    const g = p.useCallback(
      ({ tabbingDirection: y }) => {
        const x = a().map((w) => {
          const C = w.ref.current, E = [C, ...VB(C)];
          return y === "forwards" ? E : E.reverse();
        });
        return (y === "forwards" ? x.reverse() : x).flat();
      },
      [a]
    );
    return p.useEffect(() => {
      const y = d.current;
      if (y) {
        const b = (x) => {
          var E, S, T;
          const w = x.altKey || x.ctrlKey || x.metaKey;
          if (x.key === "Tab" && !w) {
            const P = document.activeElement, D = x.shiftKey;
            if (x.target === y && D) {
              (E = c.current) == null || E.focus();
              return;
            }
            const A = g({ tabbingDirection: D ? "backwards" : "forwards" }), F = A.findIndex((I) => I === P);
            El(A.slice(F + 1)) ? x.preventDefault() : D ? (S = c.current) == null || S.focus() : (T = u.current) == null || T.focus();
          }
        };
        return y.addEventListener("keydown", b), () => y.removeEventListener("keydown", b);
      }
    }, [a, g]), /* @__PURE__ */ L(
      NS,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: v ? void 0 : "none" },
        children: [
          v && /* @__PURE__ */ h(
            Yc,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const y = g({
                  tabbingDirection: "forwards"
                });
                El(y);
              }
            }
          ),
          /* @__PURE__ */ h(qd.Slot, { scope: n, children: /* @__PURE__ */ h(le.ol, { tabIndex: -1, ...i, ref: f }) }),
          v && /* @__PURE__ */ h(
            Yc,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const y = g({
                  tabbingDirection: "backwards"
                });
                El(y);
              }
            }
          )
        ]
      }
    );
  }
);
Sx.displayName = Cx;
var Tx = "ToastFocusProxy", Yc = p.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = Pa(Tx, n);
    return /* @__PURE__ */ h(
      Gs,
      {
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          var c;
          const a = s.relatedTarget;
          !((c = i.viewport) != null && c.contains(a)) && r();
        }
      }
    );
  }
);
Yc.displayName = Tx;
var Pi = "Toast", kB = "toast.swipeStart", DB = "toast.swipeMove", RB = "toast.swipeCancel", MB = "toast.swipeEnd", Ex = p.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...s } = e, [a, l] = _n({
      prop: r,
      defaultProp: o ?? !0,
      onChange: i,
      caller: Pi
    });
    return /* @__PURE__ */ h(ft, { present: n || a, children: /* @__PURE__ */ h(
      _B,
      {
        open: a,
        ...s,
        ref: t,
        onClose: () => l(!1),
        onPause: Qe(e.onPause),
        onResume: Qe(e.onResume),
        onSwipeStart: j(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: j(e.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: j(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: j(e.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
Ex.displayName = Pi;
var [NB, AB] = wx(Pi, {
  onClose() {
  }
}), _B = p.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: s,
      onEscapeKeyDown: a,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: f,
      onSwipeEnd: m,
      ...v
    } = e, g = Pa(Pi, n), [y, b] = p.useState(null), x = ye(t, (I) => b(I)), w = p.useRef(null), C = p.useRef(null), E = o || g.duration, S = p.useRef(0), T = p.useRef(E), P = p.useRef(0), { onToastAdd: D, onToastRemove: k } = g, R = Qe(() => {
      var B;
      (y == null ? void 0 : y.contains(document.activeElement)) && ((B = g.viewport) == null || B.focus()), s();
    }), A = p.useCallback(
      (I) => {
        !I || I === 1 / 0 || (window.clearTimeout(P.current), S.current = (/* @__PURE__ */ new Date()).getTime(), P.current = window.setTimeout(R, I));
      },
      [R]
    );
    p.useEffect(() => {
      const I = g.viewport;
      if (I) {
        const B = () => {
          A(T.current), c == null || c();
        }, V = () => {
          const N = (/* @__PURE__ */ new Date()).getTime() - S.current;
          T.current = T.current - N, window.clearTimeout(P.current), l == null || l();
        };
        return I.addEventListener(Hc, V), I.addEventListener(Uc, B), () => {
          I.removeEventListener(Hc, V), I.removeEventListener(Uc, B);
        };
      }
    }, [g.viewport, E, l, c, A]), p.useEffect(() => {
      i && !g.isClosePausedRef.current && A(E);
    }, [i, E, g.isClosePausedRef, A]), p.useEffect(() => (D(), () => k()), [D, k]);
    const F = p.useMemo(() => y ? Ax(y) : null, [y]);
    return g.viewport ? /* @__PURE__ */ L(ke, { children: [
      F && /* @__PURE__ */ h(
        OB,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          children: F
        }
      ),
      /* @__PURE__ */ h(NB, { scope: n, onClose: R, children: ti.createPortal(
        /* @__PURE__ */ h(qd.ItemSlot, { scope: n, children: /* @__PURE__ */ h(
          MS,
          {
            asChild: !0,
            onEscapeKeyDown: j(a, () => {
              g.isFocusedToastEscapeKeyDownRef.current || R(), g.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ h(
              le.li,
              {
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": g.swipeDirection,
                ...v,
                ref: x,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: j(e.onKeyDown, (I) => {
                  I.key === "Escape" && (a == null || a(I.nativeEvent), I.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, R()));
                }),
                onPointerDown: j(e.onPointerDown, (I) => {
                  I.button === 0 && (w.current = { x: I.clientX, y: I.clientY });
                }),
                onPointerMove: j(e.onPointerMove, (I) => {
                  if (!w.current) return;
                  const B = I.clientX - w.current.x, V = I.clientY - w.current.y, N = !!C.current, M = ["left", "right"].includes(g.swipeDirection), _ = ["left", "up"].includes(g.swipeDirection) ? Math.min : Math.max, W = M ? _(0, B) : 0, te = M ? 0 : _(0, V), O = I.pointerType === "touch" ? 10 : 2, z = { x: W, y: te }, Q = { originalEvent: I, delta: z };
                  N ? (C.current = z, Ki(DB, d, Q, {
                    discrete: !1
                  })) : op(z, g.swipeDirection, O) ? (C.current = z, Ki(kB, u, Q, {
                    discrete: !1
                  }), I.target.setPointerCapture(I.pointerId)) : (Math.abs(B) > O || Math.abs(V) > O) && (w.current = null);
                }),
                onPointerUp: j(e.onPointerUp, (I) => {
                  const B = C.current, V = I.target;
                  if (V.hasPointerCapture(I.pointerId) && V.releasePointerCapture(I.pointerId), C.current = null, w.current = null, B) {
                    const N = I.currentTarget, M = { originalEvent: I, delta: B };
                    op(B, g.swipeDirection, g.swipeThreshold) ? Ki(MB, m, M, {
                      discrete: !0
                    }) : Ki(
                      RB,
                      f,
                      M,
                      {
                        discrete: !0
                      }
                    ), N.addEventListener("click", (_) => _.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        g.viewport
      ) })
    ] }) : null;
  }
), OB = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Pa(Pi, t), [i, s] = p.useState(!1), [a, l] = p.useState(!1);
  return $B(() => s(!0)), p.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), a ? null : /* @__PURE__ */ h(to, { asChild: !0, children: /* @__PURE__ */ h(Gs, { ...r, children: i && /* @__PURE__ */ L(ke, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, IB = "ToastTitle", Px = p.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ h(le.div, { ...r, ref: t });
  }
);
Px.displayName = IB;
var LB = "ToastDescription", kx = p.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ h(le.div, { ...r, ref: t });
  }
);
kx.displayName = LB;
var Dx = "ToastAction", Rx = p.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ h(Nx, { altText: n, asChild: !0, children: /* @__PURE__ */ h(Zd, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Dx}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Rx.displayName = Dx;
var Mx = "ToastClose", Zd = p.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = AB(Mx, n);
    return /* @__PURE__ */ h(Nx, { asChild: !0, children: /* @__PURE__ */ h(
      le.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: j(e.onClick, o.onClose)
      }
    ) });
  }
);
Zd.displayName = Mx;
var Nx = p.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ h(
    le.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Ax(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), FB(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...Ax(r));
    }
  }), t;
}
function Ki(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Jc(o, i) : o.dispatchEvent(i);
}
var op = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function $B(e = () => {
}) {
  const t = Qe(e);
  it(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function FB(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function VB(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function El(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var BB = xx, _x = Sx, Ox = Ex, Ix = Px, Lx = kx, $x = Rx, Fx = Zd;
const WB = BB, Vx = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  _x,
  {
    ref: n,
    className: X(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
Vx.displayName = _x.displayName;
const zB = mr(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Bx = p.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ h(Ox, { ref: r, className: X(zB({ variant: t }), e), ...n }));
Bx.displayName = Ox.displayName;
const jB = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  $x,
  {
    ref: n,
    className: X(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
jB.displayName = $x.displayName;
const Wx = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Fx,
  {
    ref: n,
    className: X(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ h(Kc, { className: "h-4 w-4" })
  }
));
Wx.displayName = Fx.displayName;
const zx = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(Ix, { ref: n, className: X("text-sm font-semibold", e), ...t }));
zx.displayName = Ix.displayName;
const jx = p.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(Lx, { ref: n, className: X("text-sm opacity-90", e), ...t }));
jx.displayName = Lx.displayName;
const HB = 1, UB = 3e3;
let Pl = 0;
function YB() {
  return Pl = (Pl + 1) % Number.MAX_SAFE_INTEGER, Pl.toString();
}
const kl = /* @__PURE__ */ new Map(), ip = (e) => {
  if (kl.has(e))
    return;
  const t = setTimeout(() => {
    kl.delete(e), $o({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, UB);
  kl.set(e, t);
}, GB = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, HB)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? ip(n) : e.toasts.forEach((r) => {
        ip(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, os = [];
let is = { toasts: [] };
function $o(e) {
  is = GB(is, e), os.forEach((t) => {
    t(is);
  });
}
function KB({ ...e }) {
  const t = YB(), n = (o) => $o({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => $o({ type: "DISMISS_TOAST", toastId: t });
  return $o({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function XB() {
  const [e, t] = p.useState(is);
  return p.useEffect(() => (os.push(t), () => {
    const n = os.indexOf(t);
    n > -1 && os.splice(n, 1);
  }), [e]), {
    ...e,
    toast: KB,
    dismiss: (n) => $o({ type: "DISMISS_TOAST", toastId: n })
  };
}
function rz() {
  const { toasts: e } = XB();
  return /* @__PURE__ */ L(WB, { children: [
    e.map(function({ id: t, title: n, description: r, action: o, ...i }) {
      return /* @__PURE__ */ L(Bx, { ...i, children: [
        /* @__PURE__ */ L("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ h(zx, { children: n }),
          r && /* @__PURE__ */ h(jx, { children: r })
        ] }),
        o,
        /* @__PURE__ */ h(Wx, {})
      ] }, t);
    }),
    /* @__PURE__ */ h(Vx, {})
  ] });
}
export {
  ob as Alert,
  sb as AlertDescription,
  ib as AlertTitle,
  V0 as Badge,
  VW as BulkUpdateButton,
  KR as BulkUpdater,
  mR as BulkUpdaterColumnSelectBox,
  pR as BulkUpdaterOptionBox,
  Ee as Button,
  zd as Calendar,
  CB as Checkbox,
  gr as ClipedValueRenderer,
  cW as ColumnSplit,
  Yd as Command,
  GW as CommandDialog,
  lx as CommandEmpty,
  dB as CommandGroup,
  uB as CommandInput,
  cx as CommandItem,
  ax as CommandList,
  fB as CommandSeparator,
  hB as CommandShortcut,
  lW as ConfirmationModalProvider,
  GT as ContractExpandBar,
  Wg as CustomTooltip,
  z1 as DATATABLE_MARGIN,
  Dk as DEFAULT_COPY_OPTIONS,
  W1 as DEFAULT_MIN_COLUMN_WIDTH,
  bW as Datatable,
  xW as DatatableBooleanInput,
  Ck as DatatableColumnFilter,
  Ik as DatatableColumnSort,
  wW as DatatableFixedHeightLoader,
  TW as DatatableHeader,
  CW as DatatableHeaderLeft,
  SW as DatatableHeaderRight,
  DW as DatatableHideColumnButton,
  q1 as DatatableHideGroupButton,
  EW as DatatableInput,
  j1 as DatatableKeyAction,
  yW as DatatableLabelProvider,
  RW as DatatableMoveColumnButton,
  Lk as DatatableNumberInput,
  MW as DatatableOrderColumnButton,
  $k as DatatablePercentageInput,
  E1 as DatatableRow,
  vs as DatatableSelectInput,
  _k as DatatableSpacerRow,
  ty as DatatableStatus,
  NW as DatatableStickyToggle,
  Gf as DatatableTr,
  Kd as DatePickerContent,
  Jm as DatePickerContentButton,
  eg as Dialog,
  sW as DialogClose,
  uu as DialogContent,
  OT as DialogDescription,
  ng as DialogFooter,
  _T as DialogHeader,
  tg as DialogOverlay,
  AT as DialogPortal,
  rg as DialogTitle,
  iW as DialogTrigger,
  eb as Drawer,
  FW as DrawerClose,
  nb as DrawerContent,
  YR as DrawerDescription,
  UR as DrawerFooter,
  HR as DrawerHeader,
  tb as DrawerOverlay,
  jR as DrawerPortal,
  rb as DrawerTitle,
  $W as DrawerTrigger,
  HW as ExportTableButton,
  ey as FilterPopover,
  MP as GroupColumn,
  Sk as GroupTh,
  fk as HoverInfo,
  fi as Input,
  Yv as Label,
  Ft as LabeledContainer,
  UW as LabeledDatePicker,
  YW as LabeledDateRangePicker,
  Ou as LabeledInput,
  wB as LabeledMonthPicker,
  ez as LabeledMonthPickerWithButtons,
  KW as LabeledMultiselect,
  XW as LabeledOptionPopoverPicker,
  Xf as LabeledSelect,
  xB as LabeledYearPicker,
  tz as LabeledYearPickerWithButtons,
  ZW as LabelledFormDateInput,
  Gd as LabelledFormInput,
  QW as LabelledFormSelectInput,
  qW as LabelledFormTextInput,
  nr as LoadingOverlay,
  uW as LockedColumnSplit,
  mB as MultiSelector,
  hx as MultiSelectorContent,
  fx as MultiSelectorInput,
  px as MultiSelectorItem,
  mx as MultiSelectorList,
  dx as MultiSelectorTrigger,
  oy as NestedCheckbox,
  Fk as NestedCheckboxItem,
  Wy as NestedCheckboxes,
  P1 as NoopRender,
  lr as Popover,
  vr as PopoverContent,
  so as PopoverTrigger,
  PW as ResizeableTd,
  YP as ResizeableTh,
  $0 as ScrollArea,
  F0 as ScrollBar,
  na as Select,
  oa as SelectContent,
  xv as SelectGroup,
  ia as SelectItem,
  C1 as SelectLabel,
  Sv as SelectScrollDownButton,
  Cv as SelectScrollUpButton,
  S1 as SelectSeparator,
  ra as SelectTrigger,
  Ru as SelectValue,
  vB as SelectionLabelBox,
  Vo as Separator,
  jW as SortList,
  zW as SortableItem,
  Tk as SplitterTh,
  rW as TestBtn,
  Bx as Toast,
  jB as ToastAction,
  Wx as ToastClose,
  jx as ToastDescription,
  WB as ToastProvider,
  zx as ToastTitle,
  Vx as ToastViewport,
  rz as Toaster,
  qs as Tooltip,
  ci as TooltipContent,
  Cu as TooltipProvider,
  Zs as TooltipTrigger,
  $u as TriStateCheckbox,
  kW as ValueRenderer,
  nz as YearPicker,
  Y1 as areAllSubgroupsCollapsed,
  U1 as areGroupPathEquals,
  I2 as badgeVariants,
  nW as bigNumFormat,
  Uf as blockSelect,
  vW as buildFilterLoaderFromTable,
  Nl as buttonVariants,
  ny as cellsToChanges,
  X as cn,
  yk as filterTable,
  vx as filterUncheckedNodes,
  Rl as format,
  Kr as formatText,
  vo as generateChangesFromEditingCell,
  yB as getCheckboxesFromData,
  bk as getLength,
  zy as getMinHeightClass,
  JW as getPartialDataFromCheckboxes,
  Zl as getRow,
  Nv as getTopLevelCollapsedGroupPathIfExists,
  ck as inputVariants,
  go as isCellDisabledByValidation,
  RP as isCellRefEqual,
  DP as isCellRefEqualAtIndex,
  Jv as isRecordDisabledByValidation,
  gW as maskLookupFromColumns,
  mW as maxFn,
  pW as minFn,
  kr as moveSelectedCell,
  vk as onLoadFiltersByColumn,
  hW as onSortColumn,
  GB as reducer,
  xC as roundWithPrecision,
  wk as shouldCharEnableEditing,
  xk as shouldIgnoreGroupBecauseRowspan,
  KB as toast,
  Nk as useAdvancedCopy,
  kk as useCellValidations,
  aW as useConfirmationModal,
  dW as useDatableFilters,
  fW as useDatatable,
  Fu as useDatatableLabels,
  aR as useDebounceCallback,
  BW as usePersistentFilters,
  Ak as usePersistentSelection,
  XB as useToast
};
